import PropTypes from 'prop-types';
import React, { Component } from 'react';
import createEmotionStyled from 'create-emotion-styled';
import createEmotion from 'create-emotion';
import { withTheme } from 'emotion-theming';
import 'moment';
import styled$1 from 'react-emotion';

var context = typeof global !== 'undefined' ? global : {};

var _createEmotion = createEmotion(context, {
	nonce: btoa('web-ui-components')
}),
    caches = _createEmotion.caches,
    css = _createEmotion.css,
    cx = _createEmotion.cx,
    flush = _createEmotion.flush,
    getRegisteredStyles = _createEmotion.getRegisteredStyles,
    hydrate = _createEmotion.hydrate,
    injectGlobal = _createEmotion.injectGlobal,
    keyframes = _createEmotion.keyframes,
    merge = _createEmotion.merge,
    sheet = _createEmotion.sheet;

var emotion = /*#__PURE__*/Object.freeze({
	__proto__: null,
	caches: caches,
	css: css,
	cx: cx,
	flush: flush,
	getRegisteredStyles: getRegisteredStyles,
	hydrate: hydrate,
	injectGlobal: injectGlobal,
	keyframes: keyframes,
	merge: merge,
	sheet: sheet
});

var styled = createEmotionStyled(emotion, React);

var breakpoints = {
  xs1: '0',
  xs2: '480px',
  sm1: '540px',
  sm2: '640px',
  md1: '768px',
  md2: '960px',
  lg1: '1024px',
  lg2: '1280px',
  lg3: '1328px',
  xl1: '1420px',
  xl2: '1920px'
};

var breakpoint = function breakpoint(_breakpoint) {
  return breakpoints[_breakpoint];
};

var getMediaQuery = function getMediaQuery(css, breakpoint) {
  return '@media (min-width: ' + breakpoint + ') { ' + css + ' }';
};

var breakpointAndUp = {};

var _loop = function _loop(_breakpoint2) {
  if (breakpoints[_breakpoint2] !== '0') {
    breakpointAndUp[_breakpoint2] = function (css) {
      return getMediaQuery(css, breakpoints[_breakpoint2]);
    };
  }
};

for (var _breakpoint2 in breakpoints) {
  _loop(_breakpoint2);
}

var theme = { baseFontSize: 16 }; //DEBTxCYBG pull this from theme component or global?
var baseSpacing = 8;

var spacingHelper = function spacingHelper(value) {
    var fontMultiple = value * baseSpacing;
    var rems = fontMultiple / theme.baseFontSize;
    return rems + 'rem';
};

var spacing = {
    EIGHTH: spacingHelper(0.125),
    QUARTER: spacingHelper(0.25),
    HALF: spacingHelper(0.5),
    THREE_QUARTERS: spacingHelper(0.75),
    SINGLE: spacingHelper(1),
    ONE_AND_QUARTER: spacingHelper(1.25),
    ONE_AND_HALF: spacingHelper(1.5),
    ONE_AND_THREE_QUARTERS: spacingHelper(1.75),
    DOUBLE: spacingHelper(2),
    TWO_AND_HALF: spacingHelper(2.5),
    TRIPLE: spacingHelper(3),
    THREE_AND_HALF: spacingHelper(3.5),
    QUADRUPLE: spacingHelper(4),
    QUINTUPLE: spacingHelper(5),
    SEXTUPLE: spacingHelper(6),
    SEPTUPLE: spacingHelper(7),
    OCTUPLE: spacingHelper(8),
    NONUPLE: spacingHelper(9),
    DECUPLE: spacingHelper(10)
};

var externalMarginRegular = '\n    margin-right: ' + spacing.DOUBLE + ';\n    margin-bottom: ' + spacing.DOUBLE + ';\n';

var internalPaddingShell = '\n    overflow: auto;\n    padding-bottom: ' + spacing.SINGLE + '; \n    padding-left: ' + spacing.DOUBLE + '; \n    padding-right: 0; \n    padding-top: ' + spacing.DOUBLE + ';\n    ' + breakpointAndUp.md1('\n        padding-left: ' + spacing.TRIPLE + ';\n        padding-right: ' + spacing.SINGLE + ';\n    ') + '\n';

var internalPaddingRegular = '\n    overflow: auto;\n    padding-left: ' + spacing.DOUBLE + ';\n    padding-top: ' + spacing.DOUBLE + ';\n';

var classCallCheck = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

var createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var inherits = function (subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
};

var possibleConstructorReturn = function (self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
};

var slicedToArray = function () {
  function sliceIterator(arr, i) {
    var _arr = [];
    var _n = true;
    var _d = false;
    var _e = undefined;

    try {
      for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
        _arr.push(_s.value);

        if (i && _arr.length === i) break;
      }
    } catch (err) {
      _d = true;
      _e = err;
    } finally {
      try {
        if (!_n && _i["return"]) _i["return"]();
      } finally {
        if (_d) throw _e;
      }
    }

    return _arr;
  }

  return function (arr, i) {
    if (Array.isArray(arr)) {
      return arr;
    } else if (Symbol.iterator in Object(arr)) {
      return sliceIterator(arr, i);
    } else {
      throw new TypeError("Invalid attempt to destructure non-iterable instance");
    }
  };
}();

var taggedTemplateLiteral = function (strings, raw) {
  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
};

var toConsumableArray = function (arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) arr2[i] = arr[i];

    return arr2;
  } else {
    return Array.from(arr);
  }
};

var HSL_SLICE_START = 4;
var DEFAULT_AMOUNT = 5;

var hslAdjust = function hslAdjust(hslText) {
	var splitHSL = hslText.slice(HSL_SLICE_START, hslText.length - 1).split(',');

	var _splitHSL = slicedToArray(splitHSL, 3),
	    hueLabel = _splitHSL[0],
	    saturationLabel = _splitHSL[1],
	    lightnessLabel = _splitHSL[2];

	var hue = parseInt(hueLabel, 10);
	var saturation = parseInt(saturationLabel.slice(0, saturationLabel.length - 1), 10);
	var lightness = parseInt(lightnessLabel.slice(0, lightnessLabel.length - 1), 10);

	return {
		darken: function darken() {
			var amount = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : DEFAULT_AMOUNT;
			return 'hsl(' + hue + ', ' + saturation + '%, ' + (lightness - amount) + '%)';
		},
		lighten: function lighten() {
			var amount = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : DEFAULT_AMOUNT;
			return 'hsl(' + hue + ', ' + saturation + '%, ' + (lightness + amount) + '%)';
		},
		saturate: function saturate() {
			var amount = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : DEFAULT_AMOUNT;
			return 'hsl(' + hue + ', ' + (saturation + amount) + '%, ' + lightness + '%)';
		},
		desaturate: function desaturate() {
			var amount = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : DEFAULT_AMOUNT;
			return 'hsl(' + hue + ', ' + (saturation - amount) + '%, ' + lightness + '%)';
		}
	};
};

var _templateObject = taggedTemplateLiteral(['\n  0% {\n    box-shadow: 0 0 0 0 rgba(121, 0, 202, 0.8);\n  }\n  100% {\n    box-shadow: 0 0 0 ', ' rgba(121, 0, 202, 0);\n  }\n'], ['\n  0% {\n    box-shadow: 0 0 0 0 rgba(121, 0, 202, 0.8);\n  }\n  100% {\n    box-shadow: 0 0 0 ', ' rgba(121, 0, 202, 0);\n  }\n']),
    _templateObject2 = taggedTemplateLiteral(['\n  0% {\n    box-shadow: 0 0 0 0 rgba(248, 0, 0, 0.8);\n  }\n  100% {\n    box-shadow: 0 0 0 ', ' rgba(248, 0, 0, 0);\n  }\n'], ['\n  0% {\n    box-shadow: 0 0 0 0 rgba(248, 0, 0, 0.8);\n  }\n  100% {\n    box-shadow: 0 0 0 ', ' rgba(248, 0, 0, 0);\n  }\n']),
    _templateObject3 = taggedTemplateLiteral(['\n  0% {\n    box-shadow: 0 0 0 0 rgba(0, 148, 211, 0.8);\n  }\n  100% {\n    box-shadow: 0 0 0 ', ' rgba(0, 148, 211, 0);\n  }\n'], ['\n  0% {\n    box-shadow: 0 0 0 0 rgba(0, 148, 211, 0.8);\n  }\n  100% {\n    box-shadow: 0 0 0 ', ' rgba(0, 148, 211, 0);\n  }\n']),
    _templateObject4 = taggedTemplateLiteral(['\n  0% {\n    opacity: 0;\n  }\n  25% {\n    opacity: 0;\n  }\n  100% {\n    opacity: 1;\n  }\n'], ['\n  0% {\n    opacity: 0;\n  }\n  25% {\n    opacity: 0;\n  }\n  100% {\n    opacity: 1;\n  }\n']),
    _templateObject5 = taggedTemplateLiteral(['\n  0% {\n    opacity: 1;\n  }\n  25% {\n    opacity: 0;\n  }\n  100% {\n    opacity: 0;\n  }\n'], ['\n  0% {\n    opacity: 1;\n  }\n  25% {\n    opacity: 0;\n  }\n  100% {\n    opacity: 0;\n  }\n']),
    _templateObject6 = taggedTemplateLiteral(['\n  from {\n    fill: ', ';\n  }\n  to {\n    fill: ', ';\n  }\n'], ['\n  from {\n    fill: ', ';\n  }\n  to {\n    fill: ', ';\n  }\n']),
    _templateObject7 = taggedTemplateLiteral(['\n  from {\n    transform: rotate(0deg);\n  }\n  to {\n    transform: rotate(360deg);\n  }\n'], ['\n  from {\n    transform: rotate(0deg);\n  }\n  to {\n    transform: rotate(360deg);\n  }\n']),
    _templateObject8 = taggedTemplateLiteral(['\n  0% {\n    transform: scale(0.8);\n  }\n  65.5% {\n    transform: scale(1.03);\n  }\n  100% {\n    transform: scale(1);\n  }\n'], ['\n  0% {\n    transform: scale(0.8);\n  }\n  65.5% {\n    transform: scale(1.03);\n  }\n  100% {\n    transform: scale(1);\n  }\n']);

var circularPulseB = keyframes(_templateObject, spacing.QUADRUPLE);

var circularPulseCB = keyframes(_templateObject2, spacing.QUADRUPLE);

var circularPulseYB = keyframes(_templateObject3, spacing.QUADRUPLE);

var fadeIn = keyframes(_templateObject4);

var fadeOut = keyframes(_templateObject5);

var iconPulse = function iconPulse(colour) {
  return keyframes(_templateObject6, colour, hslAdjust(colour).lighten(0.2));
};

var rotate = keyframes(_templateObject7);

var scaleFadeIn = keyframes(_templateObject8);

var animations = {
  circularPulseB: circularPulseB,
  circularPulseCB: circularPulseCB,
  circularPulseYB: circularPulseYB,
  fadeIn: fadeIn,
  fadeOut: fadeOut,
  iconPulse: iconPulse,
  rotate: rotate,
  scaleFadeIn: scaleFadeIn
};

var generalPalette = {
  black: 'hsl(0, 0%, 0%)',
  blue: 'hsl(217,33%,38%)',
  blueLighter: 'hsl(210, 97%, 87%)',
  blueLightest: 'hsl(210, 100%, 95%)',
  green: 'hsl(135, 41%, 48%)',
  greenUpdated: 'hsl(67, 100%, 35%)',
  greenLighter: 'hsl(90, 53%, 70%)',
  greenLightest: 'hsl(90, 61%, 88%)',
  greenLightestUpdated: 'hsl(66, 75%, 75%)',
  greenFaint: 'hsl(135, 41%, 70%)',
  greyDarkest: 'hsl(0, 0%, 28%)',
  greyDarker: 'hsl(0, 0%, 45%)',
  grey: 'hsl(0, 0%, 60%)',
  greyUpdated: 'hsl(0, 0%, 55%)',
  greyLighter: 'hsl(0, 0%, 75%)',
  greyLightest: 'hsl(0, 0%, 85%)',
  greyLightestUpdated: 'hsl(0, 0%, 91%)',
  orange: 'hsl(29, 77%, 56%)',
  orangeUpdated: 'hsl(28, 100%, 54%)',
  orangeLighter: 'hsl(30, 45%, 89%)',
  orangeLightestUpdated: 'hsl(31, 100%, 63%)',
  red: 'hsl(360, 93%, 41%)',
  redUpdated: 'hsl(360, 91%, 46%)',
  redLighter: 'hsl(360, 97%, 77%)',
  redLightest: 'hsl(360, 60%, 96%)',
  redLightestUpdated: 'hsl(10, 94%, 80%)',
  yellowLighter: 'hsl(55, 92%, 69%)',
  yellowLightest: 'hsl(55, 100%, 88%)',
  white: 'hsl(0, 0%, 100%)',
  whiteOff: 'hsl(0, 0%, 95%)',
  pebble: 'hsl(210, 46%, 91%)'
};

var black = generalPalette.black,
    blue = generalPalette.blue,
    blueLighter = generalPalette.blueLighter,
    blueLightest = generalPalette.blueLightest,
    green = generalPalette.green,
    greenUpdated = generalPalette.greenUpdated,
    greenLighter = generalPalette.greenLighter,
    greenFaint = generalPalette.greenFaint,
    greenLightest = generalPalette.greenLightest,
    greenLightestUpdated = generalPalette.greenLightestUpdated,
    greyUpdated = generalPalette.greyUpdated,
    greyDarker = generalPalette.greyDarker,
    greyDarkest = generalPalette.greyDarkest,
    greyLightest = generalPalette.greyLightest,
    greyLightestUpdated = generalPalette.greyLightestUpdated,
    orange = generalPalette.orange,
    orangeLighter = generalPalette.orangeLighter,
    red = generalPalette.red,
    redUpdated = generalPalette.redUpdated,
    redLighter = generalPalette.redLighter,
    redLightest = generalPalette.redLightest,
    redLightestUpdated = generalPalette.redLightestUpdated,
    grey = generalPalette.grey,
    greyLighter = generalPalette.greyLighter,
    yellowLighter = generalPalette.yellowLighter,
    yellowLightest = generalPalette.yellowLightest,
    white = generalPalette.white,
    whiteOff = generalPalette.whiteOff,
    pebble = generalPalette.pebble;


var colours = {
  generalPalette: {
    black: black,
    blue: blue,
    blueLighter: blueLighter,
    blueLightest: blueLightest,
    green: green,
    greenUpdated: greenUpdated,
    greenLighter: greenLighter,
    greenLightest: greenLightest,
    greenLightestUpdated: greenLightestUpdated,
    greenFaint: greenFaint,
    greyDarkest: greyDarkest,
    greyDarker: greyDarker,
    grey: grey,
    greyUpdated: greyUpdated,
    greyLighter: greyLighter,
    greyLightest: greyLightest,
    greyLightestUpdated: greyLightestUpdated,
    orange: orange,
    orangeLighter: orangeLighter,
    pebble: pebble,
    red: red,
    redUpdated: redUpdated,
    redLighter: yellowLightest,
    redLightest: redLightest,
    redLightestUpdated: redLightestUpdated,
    yellowLighter: yellowLighter,
    yellowLightest: yellowLightest,
    white: white,
    whiteOff: whiteOff
  },
  component: {
    background: white,
    backgroundDisabled: greyLightest,
    border: greyLightest,
    borderDisabled: greyDarkest,
    focusOutline: 'hsl(208, 59%, 60%)',
    hover: greyLightest,
    locked: greyDarker,
    modalBackdrop: black,
    shell: whiteOff,
    tableCell: 'hsl(0, 0%, 97%)',
    tableHeader: 'hsl(0, 0%, 94%)',
    navigationButtonDisabled: 'hsl(215, 8%, 58%)',
    frame: {
      active: {
        background: 'repeating-linear-gradient(45deg, hsl(45, 0%, 85%),' + 'hsl(45, 0%, 85%) 28px, hsl(46, 0%, 95%) 28px, hsl(46, 0%, 95%) 56px)',
        content: 'hsl(45, 0%, 85%)',
        contentAlternate: 'hsl(46, 0%, 95%)'
      },
      bespoke: {
        background: 'repeating-linear-gradient(45deg, hsl(302, 44%, 70%), ' + 'hsl(302, 44%, 70%) 28px, hsl(302, 44%, 90%) 28px, hsl(302, 44%, 90%) 56px)',
        content: 'hsl(302, 44%, 70%)',
        contentAlternate: 'hsl(302, 44%, 90%)'
      },
      deprecated: {
        background: 'repeating-linear-gradient(45deg, hsl(45, 100%, 46%), ' + 'hsl(45, 100%, 46%) 28px, hsl(46, 100%, 64%) 28px, hsl(46, 100%, 64%) 56px)',
        content: 'hsl(45, 100%, 46%)',
        contentAlternate: 'hsl(46, 100%, 64%)'
      },
      draft: {
        background: 'repeating-linear-gradient(45deg, ' + blue + ', ' + (blue + ' 28px, hsl(205, 52%, 58%) 28px, hsl(205, 52%, 58%) 56px)'),
        content: blue,
        contentAlternate: 'hsl(205, 52%, 58%)'
      },
      outdated: {
        background: 'repeating-linear-gradient(45deg, hsl(269, 69%, 69%), ' + 'hsl(269, 69%, 69%) 28px, hsl(270, 69%, 79%) 28px, hsl(270, 69%, 79%) 56px)',
        content: 'hsl(269, 69%, 69%)',
        contentAlternate: 'hsl(270, 69%, 79%)'
      }
    }
  },
  telephony: {
    answerCallGradient: 'linear-gradient(hsl(54, 100%, 73%), hsl(49, 99%, 64%));',
    calledGradient: 'linear-gradient(hsl(159, 52%, 67%), hsl(153, 41%, 49%));',
    conferenceCallGradient: 'linear-gradient(hsl(193, 100%, 91%), hsl(196, 96%, 80%));',
    conferenceMaskGradient: 'linear-gradient(hsl(248, 86%, 83%), hsl(260, 94%, 72%));',
    dialingCallGradient: 'linear-gradient(hsl(54, 100%, 73%), hsl(49, 99%, 64%));',
    holdCallGradient: 'linear-gradient(hsl(45, 95%, 75%), hsl(37, 91%, 65%));',
    makeCallGradient: 'linear-gradient(hsl(33, 15%, 86%), hsl(180, 3%, 69%));',
    onCallGradient: 'linear-gradient(hsl(129, 80%, 82%), hsl(127, 67%, 63%));',
    answerCall: 'hsl(89, 91%, 40%)',
    closeCall: 'hsl(353, 98%, 41%)',
    dialCall: 'hsl(89, 91%, 40%)',
    endCall: 'hsl(353, 98%, 41%)',
    holdCall: 'hsl(37, 94%, 49%)',
    resumeCall: 'hsl(89, 91%, 40%)'
  },
  typography: {
    body: greyDarkest,
    secondaryBody: greyDarker,
    supplementaryBody: grey
  },
  utility: {
    error: red,
    errorUpdated: redUpdated,
    errorLighter: redLighter,
    errorLightest: redLightest,
    errorLightestUpdated: redLightestUpdated,
    guidance: blue,
    guidanceLighter: blueLighter,
    guidanceLightest: blueLightest,
    important: red,
    importantLighter: redLighter,
    importantLightest: redLightest,
    indicative: orange,
    information: blue,
    informationUpdated: greyUpdated,
    informationLightest: blueLightest,
    informationLightestUpdated: greyLightestUpdated,
    negative: red,
    positive: green,
    rememberLighter: yellowLighter,
    rememberLightest: yellowLightest,
    success: green,
    successUpdated: greenUpdated,
    successLighter: greenLighter,
    successLightest: greenLightest,
    successLightestUpdated: greenLightestUpdated,
    successDisabled: greenFaint,
    tip: green,
    tipLighter: greenLighter,
    tipLightest: greenLightest,
    warning: orange
  },
  state: {
    active: green,
    archived: greyLightest,
    inactive: red,
    notStarted: greyDarker,
    paused: blue,
    pending: orange
  }
};

/* Font size config: usage example ${fontSize('arran')} */

var fontConfig = {
	lewis: {
		xs1: { fontSize: 37, lineHeight: 1.189 },
		sm1: { fontSize: 37, lineHeight: 1.189 },
		md1: { fontSize: 45, lineHeight: 1.067 },
		lg1: { fontSize: 52, lineHeight: 1.154 },
		xl1: { fontSize: 52, lineHeight: 1.154 }
	},
	skye: {
		xs1: { fontSize: 32, lineHeight: 1.125 },
		sm1: { fontSize: 32, lineHeight: 1.125 },
		md1: { fontSize: 40, lineHeight: 1.1 },
		lg1: { fontSize: 45, lineHeight: 1.156 },
		xl1: { fontSize: 45, lineHeight: 1.156 }
	},
	shetland: {
		xs1: { fontSize: 29, lineHeight: 1.241 },
		sm1: { fontSize: 29, lineHeight: 1.241 },
		md1: { fontSize: 34, lineHeight: 1.176 },
		lg1: { fontSize: 39, lineHeight: 1.128 },
		xl1: { fontSize: 39, lineHeight: 1.128 }
	},
	mull: {
		xs1: { fontSize: 26, lineHeight: 1.231 },
		sm1: { fontSize: 26, lineHeight: 1.231 },
		md1: { fontSize: 29, lineHeight: 1.241 },
		lg1: { fontSize: 33, lineHeight: 1.212 },
		xl1: { fontSize: 33, lineHeight: 1.212 }
	},
	islay: {
		xs1: { fontSize: 23, lineHeight: 1.217 },
		sm1: { fontSize: 23, lineHeight: 1.217 },
		md1: { fontSize: 25, lineHeight: 1.28 },
		lg1: { fontSize: 28, lineHeight: 1.286 },
		xl1: { fontSize: 28, lineHeight: 1.286 }
	},
	orkney: {
		xs1: { fontSize: 20, lineHeight: 1.4 },
		sm1: { fontSize: 20, lineHeight: 1.4 },
		md1: { fontSize: 22, lineHeight: 1.273 },
		lg1: { fontSize: 25, lineHeight: 1.28 },
		xl1: { fontSize: 25, lineHeight: 1.28 }
	},
	arran: {
		xs1: { fontSize: 18, lineHeight: 1.333 },
		sm1: { fontSize: 18, lineHeight: 1.333 },
		md1: { fontSize: 19, lineHeight: 1.474 },
		lg1: { fontSize: 21, lineHeight: 1.333 },
		xl1: { fontSize: 21, lineHeight: 1.333 }
	},
	jura: {
		xs1: { fontSize: 16, lineHeight: 1.5 },
		sm1: { fontSize: 16, lineHeight: 1.5 },
		md1: { fontSize: 16, lineHeight: 1.5 },
		lg1: { fontSize: 18, lineHeight: 1.556 },
		xl1: { fontSize: 18, lineHeight: 1.556 }
	},
	uist: {
		xs1: { fontSize: 14, lineHeight: 1.429 },
		sm1: { fontSize: 14, lineHeight: 1.429 },
		md1: { fontSize: 14, lineHeight: 1.429 },
		lg1: { fontSize: 16, lineHeight: 1.5 },
		xl1: { fontSize: 16, lineHeight: 1.5 }
	},
	bute: {
		xs1: { fontSize: 12, lineHeight: 1.333 },
		sm1: { fontSize: 12, lineHeight: 1.333 },
		md1: { fontSize: 13, lineHeight: 1.538 },
		lg1: { fontSize: 13, lineHeight: 1.538 },
		xl1: { fontSize: 13, lineHeight: 1.538 }
	},
	cumbrae: {
		xs1: { fontSize: 11, lineHeight: 1.455 },
		sm1: { fontSize: 11, lineHeight: 1.455 },
		md1: { fontSize: 12, lineHeight: 1.333 },
		lg1: { fontSize: 12, lineHeight: 1.333 },
		xl1: { fontSize: 12, lineHeight: 1.333 }
	}
};

var generateSASS = function generateSASS(mqBreakpoint, size, lineHeight) {
	var styles = '';
	if (parseInt(mqBreakpoint) === 0) {
		styles = 'font-size: ' + size + 'px; line-height: ' + lineHeight + ';';
	} else {
		styles = '\n      @media (min-width: ' + mqBreakpoint + ') {\n        font-size: ' + size + 'px;\n        line-height: ' + lineHeight + ';\n      }\n    ';
	}
	return styles;
};

var fontSizes = {};

for (var fontSize in fontConfig) {
	if (fontConfig.hasOwnProperty(fontSize)) {
		var style = '';
		for (var breakpoint$1 in fontConfig[fontSize]) {
			if (fontConfig[fontSize].hasOwnProperty(breakpoint$1)) {
				var _fontConfig$fontSize$ = fontConfig[fontSize][breakpoint$1],
				    size = _fontConfig$fontSize$.fontSize,
				    lineHeight = _fontConfig$fontSize$.lineHeight;

				style += generateSASS(breakpoints[breakpoint$1], size, lineHeight);
			}
		}
		fontSizes[fontSize] = style;
	}
}

var useFontSize = {

	of: {
		lewis: function lewis() {
			return fontSizes['lewis'];
		},
		skye: function skye() {
			return fontSizes['skye'];
		},
		shetland: function shetland() {
			return fontSizes['shetland'];
		},
		mull: function mull() {
			return fontSizes['mull'];
		},
		islay: function islay() {
			return fontSizes['islay'];
		},
		orkney: function orkney() {
			return fontSizes['orkney'];
		},
		arran: function arran() {
			return fontSizes['arran'];
		},
		jura: function jura() {
			return fontSizes['jura'];
		},
		uist: function uist() {
			return fontSizes['uist'];
		},
		bute: function bute() {
			return fontSizes['bute'];
		},
		cumbrae: function cumbrae() {
			return fontSizes['cumbrae'];
		}
	},

	biggerThan: {
		lewis: function lewis() {
			throw new Error("lewis is the biggest font");
		},
		skye: function skye() {
			return fontSizes['lewis'];
		},
		shetland: function shetland() {
			return fontSizes['skye'];
		},
		mull: function mull() {
			return fontSizes['shetland'];
		},
		islay: function islay() {
			return fontSizes['mull'];
		},
		orkney: function orkney() {
			return fontSizes['islay'];
		},
		arran: function arran() {
			return fontSizes['orkney'];
		},
		jura: function jura() {
			return fontSizes['arran'];
		},
		uist: function uist() {
			return fontSizes['jura'];
		},
		bute: function bute() {
			return fontSizes['uist'];
		},
		cumbrae: function cumbrae() {
			return fontSizes['bute'];
		}
	},

	smallerThan: {
		lewis: function lewis() {
			return fontSizes['skye'];
		},
		skye: function skye() {
			return fontSizes['shetland'];
		},
		shetland: function shetland() {
			return fontSizes['mull'];
		},
		mull: function mull() {
			return fontSizes['islay'];
		},
		islay: function islay() {
			return fontSizes['orkney'];
		},
		orkney: function orkney() {
			return fontSizes['arran'];
		},
		arran: function arran() {
			return fontSizes['jura'];
		},
		jura: function jura() {
			return fontSizes['uist'];
		},
		uist: function uist() {
			return fontSizes['bute'];
		},
		bute: function bute() {
			return fontSizes['cumbrae'];
		},
		cumbrae: function cumbrae() {
			throw new Error("cumbrae is the smallest font");
		}
	}
};

var layers = {
  datepicker1: 2147483647,
  globalTakeoverContent: 1053,
  globalTakeoverTransparency: 1052,
  globalTakeover: 1051,
  loader: 1051,
  modal1: 1050,
  modal2: 1040,
  localTakeover: 1020,
  popper: 110,
  webchat: 110,
  multiButtonModal: 104,
  wideModal: 104,
  accountLegacyPanelDropdown: 100,
  modal3: 100,
  paymentAccountSelector1: 16,
  paymentAccountSelector2: 15,
  checkboxToggleOffIcon: 10,
  comparisonTable: 10,
  accountSelectDropdown: 10,
  currencySelectDropdown: 10,
  header: 10,
  listPayment: 10,
  payeeFooterBar: 9,
  payeeList: 9,
  datepicker2: 5,
  searchAndSelect2: 5,
  searchAndSelect1: 3,
  datepicker: 2,
  datepicker3: 2,
  fauxBlockLink: 2,
  sortCardGroup: 2,
  submittedTransactionTable: 2,
  tileButtonOverlay: 2,
  root: 1,
  sub: -1
};

var LIFE_CYCLE_STATUSES = {
	ACTIVE: 'active',
	BESPOKE: 'bespoke',
	DEPRECATED: 'deprecated',
	DRAFT: 'draft',
	OUTDATED: 'outdated'
};

var checkIsVariantDeprecatedFromPackageJson = function checkIsVariantDeprecatedFromPackageJson(packageJson, variant) {
	var deprecations = packageJson.deprecations;


	if (!deprecations) {
		return false;
	}

	var isDeprecated = false;
	deprecations.forEach(function (deprecationObj) {
		return deprecationObj.variants && deprecationObj.variants.forEach(function (deprecatedVariant) {
			if (deprecatedVariant === variant) {
				isDeprecated = true;
			}
		});
	});
	return isDeprecated;
};

var getComponentProminentStatusFromPackage = function getComponentProminentStatusFromPackage(packageJson, variant) {
	var isComponentDeprecated = packageJson['component-life-cycle'] === LIFE_CYCLE_STATUSES.DEPRECATED;
	var isVariantDeprecated = variant && checkIsVariantDeprecatedFromPackageJson(packageJson, variant);

	if (isComponentDeprecated || isVariantDeprecated) {
		return LIFE_CYCLE_STATUSES.DEPRECATED;
	}

	if (packageJson['is-bespoke']) {
		return LIFE_CYCLE_STATUSES.BESPOKE;
	}

	return packageJson['component-life-cycle'];
};

var addFullStop = function addFullStop(value) {
	return value.charAt(value.length - 1) === '.' ? value : value.replace(/([^.])$/, '$1.');
};

var capitaliseFirstLetter = function capitaliseFirstLetter(value) {
	return value.trim().charAt(0).toUpperCase() + value.trim().slice(1);
};

var WEE_WORDS = ['an', 'is', 'of', 'to'];

var capitaliseFirstLetterExceptWeeOnes = function capitaliseFirstLetterExceptWeeOnes(value) {
	if (WEE_WORDS.includes(value)) {
		return value;
	}

	return capitaliseFirstLetter(value);
};

var lowercaseFirstLetter = function lowercaseFirstLetter(value) {
	return value.charAt(0).toLowerCase() + value.slice(1);
};

var slugifyString = function slugifyString(name) {
	return ('' + name.toLowerCase()).replace(' ', '-');
};

var StringUtils = {
	addFullStop: addFullStop,
	capitaliseFirstLetter: capitaliseFirstLetter,
	capitaliseFirstLetterExceptWeeOnes: capitaliseFirstLetterExceptWeeOnes,
	lowercaseFirstLetter: lowercaseFirstLetter,
	slugifyString: slugifyString
};

var _templateObject$1 = taggedTemplateLiteral(['\n\t', ';\n\t', ';\n\n\t@media print {\n\t\tfont-size: 16px;\n\t}\n'], ['\n\t', ';\n\t', ';\n\n\t@media print {\n\t\tfont-size: 16px;\n\t}\n']);

var StyledInternalStandardBody = styled('div')(_templateObject$1, function (props) {
	return props.theme.isCompact ? useFontSize.of.bute() : useFontSize.of.jura();
}, function (props) {
	return !props.isFlush && '' + externalMarginRegular;
});

var InternalStandardBody = function InternalStandardBody(_ref) {
	var isFlush = _ref.isFlush,
	    children = _ref.children,
	    id = _ref.id,
	    dataTestId = _ref['data-test-id'];
	return React.createElement(
		StyledInternalStandardBody,
		{ isFlush: isFlush, id: id, 'data-test-id': dataTestId },
		children
	);
};

InternalStandardBody.propTypes = {
	/** Child content as node. Should be used to wrap bodies of textual content. This textual content
  * should contain appropriate HTML tagging and passing in orphan text child content should
  * be avoided. */
	children: PropTypes.node.isRequired,
	/** Removed margins. */
	isFlush: PropTypes.bool,
	/** A unique ID used to identify the element within the DOM. */
	id: PropTypes.string,
	/** Data attribute for automation test purposes. */
	'data-test-id': PropTypes.string
};

InternalStandardBody.defaultProps = {
	isFlush: false,
	'data-test-id': 'internal-standardbody'
};

var _templateObject$2 = taggedTemplateLiteral(['\n\tcolor: ', ';\n\tlist-style: none;\n\tmargin-left: ', ';\n\tmargin-bottom: 0;\n\tmargin-top: 0;\n\tpadding-left: ', ';\n\n\tul {\n\t\tpadding-left: ', ';\n\t}\n'], ['\n\tcolor: ', ';\n\tlist-style: none;\n\tmargin-left: ', ';\n\tmargin-bottom: 0;\n\tmargin-top: 0;\n\tpadding-left: ', ';\n\n\tul {\n\t\tpadding-left: ', ';\n\t}\n']),
    _templateObject2$1 = taggedTemplateLiteral(['\n\tmargin-bottom: ', ';\n\tposition: relative;\n\n\t:before {\n\t\tcontent: \'\';\n\t\tposition: absolute;\n\t\tleft: -26px;\n\t\ttop: 10px;\n\t\twidth: 8px;\n\t\theight: 8px;\n\t\tborder: 1px solid ', ';\n\t\tbackground-color: ', ';\n\t\tborder-radius: ', ';\n\t}\n'], ['\n\tmargin-bottom: ', ';\n\tposition: relative;\n\n\t:before {\n\t\tcontent: \'\';\n\t\tposition: absolute;\n\t\tleft: -26px;\n\t\ttop: 10px;\n\t\twidth: 8px;\n\t\theight: 8px;\n\t\tborder: 1px solid ', ';\n\t\tbackground-color: ', ';\n\t\tborder-radius: ', ';\n\t}\n']);

var StyledUL = styled('ul')(_templateObject$2, function (props) {
	return props.theme.colours.bodyText;
}, spacing.DOUBLE, spacing.TRIPLE, spacing.DOUBLE);

var BORDER_RADIUS_DIVIDER = 4;
var BORDER_RADIUS_REMAINDER = 3;

var StyledListItem = styled('li')(_templateObject2$1, spacing.SINGLE, colours.generalPalette.black, function (props) {
	return props.level % 2 > 0 ? colours.generalPalette.black : 'transparent';
}, function (props) {
	return props.level % BORDER_RADIUS_DIVIDER === BORDER_RADIUS_REMAINDER || props.level % BORDER_RADIUS_DIVIDER === 0 ? '0' : '100%';
});

var processItems = function processItems(items, level) {
	return items.map(function (item, index) {
		return Array.isArray(item) ? React.createElement(
			StyledUL,
			{ key: level + '.' + [index] },
			processItems(item, level + 1)
		) : React.createElement(
			StyledListItem,
			{ key: level + '.' + [index], level: level },
			React.createElement(
				InternalStandardBody,
				{ isFlush: true },
				React.createElement(
					'span',
					null,
					item
				)
			)
		);
	});
};

var InternalBulletList = function InternalBulletList(_ref) {
	var items = _ref.items;
	return items !== ( undefined) && React.createElement(
		StyledUL,
		null,
		processItems(items, 1)
	);
};

InternalBulletList.propTypes = {
	/** An array of strings for each item. Can include other arrays for sub items. */
	items: PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.node, PropTypes.string])).isRequired
};

var getThemeIcon = function getThemeIcon(vmIcon, generalIcon) {
  return function (themeName) {
    return themeName === 'vm' ? vmIcon : generalIcon;
  };
};

var _extends$1 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var GenericIcon = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement("svg", _extends$1({ width: "16", height: "16", viewBox: "0 0 16 16", xmlns: "http://www.w3.org/2000/svg" }, props), React.createElement("title", null, "icon-triangleright-large"), React.createElement("path", { d: "M16 8L0 16V0" }));
});

var _extends$2 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$1(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var VMIcon = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$1(_ref, ["styles"]);

  return React.createElement("svg", _extends$2({ height: "16", viewBox: "0 0 96 96", width: "16", xmlns: "http://www.w3.org/2000/svg" }, props), React.createElement("path", { d: "M13.75 1.849l68.847 45.515-67.217 47.89" }));
});

var getTriangleRightLarge = getThemeIcon(VMIcon, GenericIcon);

var _templateObject$3 = taggedTemplateLiteral(['\n\tbox-sizing: border-box;\n\tmargin-left: 6px;\n\tmax-height: 0;\n\toverflow: hidden;\n\tpadding-left: ', ';\n\tposition: relative;\n\ttransition: all 0.15s;\n\t', ';\n\n\t', ' p:last-child {\n\t\tmargin-bottom: 0;\n\t}\n\n\t:after {\n\t\tbackground-color: ', ';\n\t\tborder-radius: 4px;\n\t\tcontent: \'\';\n\t\tdisplay: block;\n\t\theight: 100%;\n\t\tleft: 0;\n\t\tposition: absolute;\n\t\ttop: 0;\n\t\twidth: 4px;\n\t}\n'], ['\n\tbox-sizing: border-box;\n\tmargin-left: 6px;\n\tmax-height: 0;\n\toverflow: hidden;\n\tpadding-left: ', ';\n\tposition: relative;\n\ttransition: all 0.15s;\n\t', ';\n\n\t', ' p:last-child {\n\t\tmargin-bottom: 0;\n\t}\n\n\t:after {\n\t\tbackground-color: ', ';\n\t\tborder-radius: 4px;\n\t\tcontent: \'\';\n\t\tdisplay: block;\n\t\theight: 100%;\n\t\tleft: 0;\n\t\tposition: absolute;\n\t\ttop: 0;\n\t\twidth: 4px;\n\t}\n']),
    _templateObject2$2 = taggedTemplateLiteral(['\n\talign-items: center;\n\tbackground: none;\n\tborder: none;\n\tcolor: ', ';\n\tdisplay: flex;\n\t', ';\n\tpadding: 0;\n\ttext-decoration: underline;\n\ttransition: margin 0.15s;\n\twidth: 100%;\n\tcursor: pointer;\n\n\t> svg {\n\t\tfill: ', ';\n\t\ttransition: transform 0.15s;\n\t}\n\n\t', ';\n\n\t.buttonLabel {\n\t\tdisplay: flex;\n\t\tmargin-left: ', 'px;\n\t\t', ';\n\n\t\t@media (max-width: ', ') {\n\t\t\twidth: 100%;\n\t\t}\n\t}\n\n\t:focus {\n\t\tbox-shadow: none;\n\n\t\t.buttonLabel {\n\t\t\tborder-radius: ', ';\n\t\t\tbox-shadow: 0 0 0 2px ', ';\n\t\t\toutline: 0;\n\t\t}\n\t}\n'], ['\n\talign-items: center;\n\tbackground: none;\n\tborder: none;\n\tcolor: ', ';\n\tdisplay: flex;\n\t', ';\n\tpadding: 0;\n\ttext-decoration: underline;\n\ttransition: margin 0.15s;\n\twidth: 100%;\n\tcursor: pointer;\n\n\t> svg {\n\t\tfill: ', ';\n\t\ttransition: transform 0.15s;\n\t}\n\n\t', ';\n\n\t.buttonLabel {\n\t\tdisplay: flex;\n\t\tmargin-left: ', 'px;\n\t\t', ';\n\n\t\t@media (max-width: ', ') {\n\t\t\twidth: 100%;\n\t\t}\n\t}\n\n\t:focus {\n\t\tbox-shadow: none;\n\n\t\t.buttonLabel {\n\t\t\tborder-radius: ', ';\n\t\t\tbox-shadow: 0 0 0 2px ', ';\n\t\t\toutline: 0;\n\t\t}\n\t}\n']),
    _templateObject3$1 = taggedTemplateLiteral(['\n\t', ';\n'], ['\n\t', ';\n']);

var StyledBodyContent = styled('div')(_templateObject$3, spacing.DOUBLE, function (props) {
	return props.isOpen ? '\n\t\t\t\tanimation: ' + animations.fadeIn + ' 0.7s linear;\n\t\t\t  ' : '\n\t\t\t\tanimation: ' + animations.fadeOut + ' 0.5s linear;\n\t\t\t  ';
}, function (props) {
	return props.isOpen && '\n\t\tmax-height: 4000px;\n\t\toverflow: visible;\n\t\tpadding-bottom: ' + spacing.SINGLE + ';\n\t\tpadding-left: ' + spacing.DOUBLE + ';\n\n\t';
}, function (props) {
	return props.panelColour;
});

var StyledButton = styled('button')(_templateObject2$2, function (props) {
	return props.panelColour;
}, useFontSize.of.jura, function (props) {
	return props.panelColour;
}, function (props) {
	return props.isOpen && !props.hasIconOverride && '\n\t\tmargin-bottom: ' + spacing.DOUBLE + ';\n\n\t\t> svg {\n\t\t\ttransform: rotate(90deg) !important;\n\t\t}\n\t';
}, function (props) {
	return props.isHeadingString ? '6' : '8';
}, function (props) {
	return props.isHeadingString && 'padding: 0 2px;';
}, breakpoints.md1, function (props) {
	return props.theme.borderRadius;
}, colours.component.focusOutline);

var StyledWrapper = styled('div')(_templateObject3$1, function (props) {
	return props.hasAdditionalMarginBottom && 'margin-bottom: ' + spacing.TRIPLE;
});

var InternalContentRevealPanel = function InternalContentRevealPanel(_ref) {
	var children = _ref.children,
	    hasAdditionalMarginBottom = _ref.hasAdditionalMarginBottom,
	    titleText = _ref.titleText,
	    icon = _ref.icon,
	    isOpen = _ref.isOpen,
	    onClick = _ref.onClick,
	    panelColour = _ref.panelColour,
	    theme = _ref.theme,
	    dataTestId = _ref['data-test-id'];

	var isHeadingString = typeof titleText === 'string';
	var ariaLabel = isHeadingString ? titleText.toLowerCase().replace(/\s+/g, '-') : 'content-reveal-panel';
	var TriangleRightLargeIcon = getTriangleRightLarge(theme.name);
	var hasIconOverride = icon !== undefined;
	var contentId = isHeadingString ? titleText.toLowerCase().replace(/\s+/g, '-') + '-content-id' : 'content-reveal-panel-id';
	return React.createElement(
		StyledWrapper,
		{ hasAdditionalMarginBottom: hasAdditionalMarginBottom },
		React.createElement(
			StyledButton,
			{
				'aria-labelledby': ariaLabel,
				isOpen: isOpen,
				hasIconOverride: hasIconOverride,
				onClick: onClick,
				panelColour: panelColour,
				type: 'button',
				'data-test-id': dataTestId + '-button',
				'aria-expanded': isOpen,
				'aria-controls': contentId
			},
			icon ? icon : React.createElement(TriangleRightLargeIcon, null),
			React.createElement(
				'div',
				{ className: 'buttonLabel' },
				isHeadingString ? React.createElement(
					InternalStandardBody,
					{ isFlush: true },
					React.createElement(
						'span',
						{ id: ariaLabel },
						titleText
					)
				) : titleText
			)
		),
		React.createElement(
			StyledBodyContent,
			{
				isOpen: isOpen,
				panelColour: panelColour,
				id: contentId,
				'data-test-id': dataTestId + '-content'
			},
			children
		)
	);
};

InternalContentRevealPanel.propTypes = {
	/** Content of the panel. */
	children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]).isRequired,
	/** Adds additional margin bottom. */
	hasAdditionalMarginBottom: PropTypes.bool,
	/** Set to true to open panel. */
	isOpen: PropTypes.bool,
	/** Callback function triggered on click. */
	onClick: PropTypes.func.isRequired,
	/** Sets panel colour. */
	panelColour: PropTypes.string.isRequired,
	/** Title text. */
	titleText: PropTypes.oneOfType([PropTypes.string, PropTypes.node]).isRequired,
	/** Optional icon  */
	icon: PropTypes.node,
	/** Data attribute targeting inner html button for automation test purposes. */
	'data-test-id': PropTypes.string
};

InternalContentRevealPanel.defaultProps = {
	hasAdditionalMarginBottom: false,
	isOpen: false,
	'data-test-id': 'content-reveal-panel'
};

var WrappedInternalContentRevealPanel = withTheme(InternalContentRevealPanel);

var _templateObject$4 = taggedTemplateLiteral(['\n\t', ';\n'], ['\n\t', ';\n']),
    _templateObject2$3 = taggedTemplateLiteral(['\n\t', ';\n\tdisplay: ', ';\n'], ['\n\t', ';\n\tdisplay: ', ';\n']),
    _templateObject3$2 = taggedTemplateLiteral(['\n\tbackground-color: ', ';\n\tborder-radius: ', ';\n\tcolor: ', ';\n\theight: min-content;\n\tdisplay: block;\n\tpadding: 0 ', ';\n\tfont-size: 14px;\n'], ['\n\tbackground-color: ', ';\n\tborder-radius: ', ';\n\tcolor: ', ';\n\theight: min-content;\n\tdisplay: block;\n\tpadding: 0 ', ';\n\tfont-size: 14px;\n']),
    _templateObject4$1 = taggedTemplateLiteral(['\n\talign-items: flex-end;\n\tbackground: ', ';\n\tdisplay: flex;\n\tpadding: ', ';\n\tmargin-bottom: ', ';\n\n\t& > div {\n\t\tmargin-bottom: 0;\n\t}\n\n\tbutton {\n\t\ttext-decoration: none;\n\t}\n\n\tul {\n\t\tmargin-bottom: ', ';\n\t\tmargin-right: ', ';\n\t\tpadding-left: 0;\n\t\tpadding-top: ', ';\n\n\t\tli {\n\t\t\tcolor: ', ';\n\t\t\ttransform: scale(0.8);\n\t\t}\n\t}\n'], ['\n\talign-items: flex-end;\n\tbackground: ', ';\n\tdisplay: flex;\n\tpadding: ', ';\n\tmargin-bottom: ', ';\n\n\t& > div {\n\t\tmargin-bottom: 0;\n\t}\n\n\tbutton {\n\t\ttext-decoration: none;\n\t}\n\n\tul {\n\t\tmargin-bottom: ', ';\n\t\tmargin-right: ', ';\n\t\tpadding-left: 0;\n\t\tpadding-top: ', ';\n\n\t\tli {\n\t\t\tcolor: ', ';\n\t\t\ttransform: scale(0.8);\n\t\t}\n\t}\n']),
    _templateObject5$1 = taggedTemplateLiteral(['\n\tpadding-top: ', ';\n\n\tp {\n\t\tcolor: ', ';\n\t\tmargin-bottom: ', ';\n\t}\n'], ['\n\tpadding-top: ', ';\n\n\tp {\n\t\tcolor: ', ';\n\t\tmargin-bottom: ', ';\n\t}\n']),
    _templateObject6$1 = taggedTemplateLiteral(['\n\tbackground: ', ';\n\toverflow: auto;\n\tpadding: ', ';\n'], ['\n\tbackground: ', ';\n\toverflow: auto;\n\tpadding: ', ';\n']);

var BasicBlockWrapper = styled('div')(_templateObject$4, function (props) {
	return !props.removeFrameMargins && externalMarginRegular;
});

var BasicInlineWrapper = styled('span')(_templateObject2$3, function (props) {
	return !props.removeFrameMargins && externalMarginRegular;
}, function (props) {
	return props.isInlineBlock ? 'inline-block' : 'inline';
});

var BasicDetails = styled('span')(_templateObject3$2, function (props) {
	return props.content;
}, spacing.HALF, colours.generalPalette.black, spacing.QUARTER);

var InfoContainer = styled('div')(_templateObject4$1, function (props) {
	return props.content;
}, spacing.SINGLE, spacing.SINGLE, spacing.DOUBLE, spacing.DOUBLE, spacing.SINGLE, colours.generalPalette.black);

var InfoContentWrapper = styled('div')(_templateObject5$1, spacing.SINGLE, colours.generalPalette.black, spacing.SINGLE);

var InnerComponentWrapper = styled('div')(_templateObject$4, function (props) {
	return props.isContainer && '\n\t\tbackground-color: hsla(0, 100%, 100%, 60%);\n\t\tpadding: ' + spacing.DOUBLE + ' ' + spacing.DOUBLE + ' ' + spacing.SINGLE + ';\n\t';
});

var XRayComponentWrapper = styled('div')(_templateObject6$1, function (props) {
	return props.background;
}, function (props) {
	return props.isContainer ? '0' : spacing.SINGLE + ' ' + spacing.DOUBLE + ' ' + spacing.DOUBLE + ' ' + spacing.SINGLE;
});

var revealContent = {
	active: React.createElement(
		'span',
		null,
		'Details on this component can be found in the Web UI Components the style guide.'
	),
	bespoke: React.createElement(
		'span',
		null,
		React.createElement(
			'p',
			null,
			'This component was built for a certainuse case and should not be used outside of that.'
		),
		React.createElement(
			'p',
			null,
			'Further details can be found in the Web UI Components style guide.'
		)
	),
	deprecated: React.createElement(
		'span',
		null,
		React.createElement(
			'p',
			null,
			'Deprecated components are no longer tested via:'
		),
		React.createElement(InternalBulletList, {
			items: ['Visual regression & brand testing.', 'Integration testing.', 'Manual input testing.', 'Accessibility testing.']
		}),
		React.createElement(
			'p',
			null,
			'Further details can be found in the Web UI Components style guide.'
		),
		React.createElement(
			'p',
			null,
			React.createElement(
				'b',
				null,
				React.createElement(
					'u',
					null,
					'Upgrade as soon as possible.'
				)
			)
		)
	),
	draft: React.createElement(
		'span',
		null,
		React.createElement(
			'p',
			null,
			'Do not log defects for:'
		),
		React.createElement(InternalBulletList, {
			items: ['Appearance or styles.', 'Keyboard or mouse behaviours.', 'Missing input validations.'],
			isFlush: true
		}),
		React.createElement(
			'p',
			null,
			'Upgrade before using in production.'
		)
	),
	outdated: React.createElement(
		'span',
		null,
		React.createElement(
			'p',
			null,
			'This component is outdated. Therefore, should not be used in newer project work.'
		),
		React.createElement(
			'p',
			null,
			'It may have issues with:'
		),
		React.createElement(InternalBulletList, { items: ['Accessibility.', 'Consistency.', 'Optimisation.'], isFlush: true }),
		React.createElement(
			'p',
			null,
			'Before adding to a new codebase, contact the UI team about seeking a replacement.'
		)
	)
};

var getComponentName = function getComponentName(packageJson) {
	return packageJson.main.split('.')[0];
};

var InternalComponentFrame = function (_Component) {
	inherits(InternalComponentFrame, _Component);

	function InternalComponentFrame(props) {
		classCallCheck(this, InternalComponentFrame);

		var _this = possibleConstructorReturn(this, (InternalComponentFrame.__proto__ || Object.getPrototypeOf(InternalComponentFrame)).call(this, props));

		_this.state = {
			isOpen: false
		};
		return _this;
	}

	createClass(InternalComponentFrame, [{
		key: 'render',
		value: function render() {
			var _this2 = this;

			// eslint-disable-next-line react/prop-types
			var _props = this.props,
			    children = _props.children,
			    hasCustomMargins = _props.hasCustomMargins,
			    layout = _props.layout,
			    isFlush = _props.isFlush,
			    packageJson = _props.packageJson,
			    variant = _props.variant,
			    xraySuppressed = _props.xraySuppressed;
			var isOpen = this.state.isOpen;
			var _window = window,
			    XrayHelper = _window.XrayHelper;


			var componentName = getComponentName(packageJson);
			var status = getComponentProminentStatusFromPackage(packageJson, variant);
			var formattedStatus = StringUtils.capitaliseFirstLetter(status);
			var variantSuffix = variant ? '.' + variant : '';

			var isContainer = layout === 'container';
			var isInline = layout === 'inline-block' || layout === 'inline';
			var isTypography = layout === 'typography';
			var isCompactLayout = isInline || isTypography;
			var _colours$component$fr = colours.component.frame[status],
			    background = _colours$component$fr.background,
			    content = _colours$component$fr.content;


			if (xraySuppressed || XrayHelper && XrayHelper.checkIsXrayMode() === false) {
				return isInline ? React.createElement(
					BasicInlineWrapper,
					{ isInlineBlock: layout === 'inline-block', removeFrameMargins: hasCustomMargins || isFlush },
					children
				) : React.createElement(
					BasicBlockWrapper,
					{ removeFrameMargins: hasCustomMargins || isFlush },
					children
				);
			}

			return isCompactLayout ? React.createElement(
				'div',
				null,
				children,
				React.createElement(
					BasicDetails,
					{ content: content },
					React.createElement(
						'b',
						null,
						formattedStatus,
						' component:'
					),
					' ',
					componentName,
					variantSuffix
				)
			) : React.createElement(
				'div',
				null,
				React.createElement(
					XRayComponentWrapper,
					{ background: background, isContainer: isContainer },
					React.createElement(
						InnerComponentWrapper,
						{ isContainer: isContainer },
						children
					)
				),
				React.createElement(
					InfoContainer,
					{ content: content },
					React.createElement(
						WrappedInternalContentRevealPanel,
						{
							panelColour: 'black',
							titleText: formattedStatus + ' component: ' + getComponentName(packageJson) + variantSuffix,
							isOpen: isOpen,
							onClick: function onClick() {
								return _this2.setState(function (prevState) {
									return { isOpen: !prevState.isOpen };
								});
							}
						},
						React.createElement(
							InfoContentWrapper,
							null,
							revealContent[status]
						)
					)
				)
			);
		}
	}]);
	return InternalComponentFrame;
}(Component);

InternalComponentFrame.propTypes = {
	children: PropTypes.node.isRequired,
	hasCustomMargins: PropTypes.bool,
	isFlush: PropTypes.bool,
	layout: PropTypes.oneOf(['block', 'container', 'inline', 'inline-block', 'typography']),
	packageJson: PropTypes.object.isRequired,
	variant: PropTypes.string,
	xraySuppressed: PropTypes.bool
};

InternalComponentFrame.defaultProps = {
	hasCustomMargins: false,
	isFlush: false,
	layout: 'block',
	xraySuppressed: false
};

var _extends$3 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$2(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var FavouriteIcon = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$2(_ref, ["styles"]);

  return React.createElement("svg", _extends$3({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 28 27" }, props), React.createElement("path", { d: "M14 21.565l-7.717 4.057 1.473-8.593-6.243-6.086 8.628-1.254L14 1.87l3.859 7.819 8.628 1.254-6.243 6.086 1.473 8.593L14 21.565z" }));
});

var CBPlaceholderCard = "data:image/png;base64,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";

var VMPlaceholderCard = "data:image/png;base64,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";

var YBPlaceholderCard = "data:image/png;base64,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";

var PlaceholderCard = "data:image/png;base64,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";

var _templateObject$5 = taggedTemplateLiteral(['\n\tbackground-image: url(', ');\n\tbackground-position: center;\n\tbackground-repeat: no-repeat;\n\tbackground-size: cover;\n\tdisplay: flex;\n\theight: ', 'px;\n\tmin-width: ', 'px;\n\twidth: ', 'px;\n'], ['\n\tbackground-image: url(', ');\n\tbackground-position: center;\n\tbackground-repeat: no-repeat;\n\tbackground-size: cover;\n\tdisplay: flex;\n\theight: ', 'px;\n\tmin-width: ', 'px;\n\twidth: ', 'px;\n']);

var StyledCard = styled('div')(_templateObject$5, function (props) {
	return props.imageInfo.imageUrl || placeholderImages[props.imageInfo.brandId];
}, function (props) {
	return props.height;
}, function (props) {
	return props.width;
}, function (props) {
	return props.width;
});

var placeholderImages = {
	cb: CBPlaceholderCard,
	yb: YBPlaceholderCard,
	b: PlaceholderCard,
	vm: VMPlaceholderCard
};

var InternalPlaceholderCard = function InternalPlaceholderCard(_ref) {
	var height = _ref.height,
	    imageInfo = _ref.imageInfo,
	    width = _ref.width;
	return React.createElement(StyledCard, {
		'aria-label': StringUtils.capitaliseFirstLetter(imageInfo.cardStatus) + ' card',
		height: height,
		imageInfo: imageInfo,
		role: 'img',
		width: width
	});
};

InternalPlaceholderCard.propTypes = {
	/* Height in pixels. */
	height: PropTypes.number,
	/* Card image information. */
	imageInfo: PropTypes.shape({
		/** Card brand. */
		brandId: PropTypes.oneOf(['cb', 'yb', 'vm']).isRequired,
		/** Image type. Used in the aria-label. */
		cardStatus: PropTypes.oneOf(['active', 'deactivated', 'frozen']).isRequired,
		/** Image url. */
		imageUrl: PropTypes.string.isRequired
	}).isRequired,
	/* Width in pixels. */
	width: PropTypes.number
};

InternalPlaceholderCard.defaultProps = {
	height: 126,
	width: 200
};

var _extends$4 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$3(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var CheckboxIcon = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$3(_ref, ["styles"]);

  return React.createElement("svg", _extends$4({ width: "96", height: "96", viewBox: "0 0 96 96", xmlns: "http://www.w3.org/2000/svg" }, props), React.createElement("path", { d: "M36.136 59.588L73.4 21l8.1 7.823-44.935 46.532-.157-.15-.15.155L14.5 54.35l7.823-8.1 13.813 13.338z" }));
});

var _templateObject$6 = taggedTemplateLiteral(['\n\twidth: 100%;\n\tdisplay: flex;\n\tflex-wrap: ', ';\n\talign-items: ', ';\n\tjustify-content: center;\n\n\t', ';\n'], ['\n\twidth: 100%;\n\tdisplay: flex;\n\tflex-wrap: ', ';\n\talign-items: ', ';\n\tjustify-content: center;\n\n\t', ';\n']),
    _templateObject2$4 = taggedTemplateLiteral(['\n\tdisplay: flex;\n\talign-self: stretch;\n\talign-items: ', ';\n\n\t', ';\n'], ['\n\tdisplay: flex;\n\talign-self: stretch;\n\talign-items: ', ';\n\n\t', ';\n']),
    _templateObject3$3 = taggedTemplateLiteral(['\n\tdisplay: flex;\n\tflex-wrap: ', ';\n\talign-items: ', ';\n\tjustify-content: space-between;\n\twidth: 100%;\n\n\t', ';\n'], ['\n\tdisplay: flex;\n\tflex-wrap: ', ';\n\talign-items: ', ';\n\tjustify-content: space-between;\n\twidth: 100%;\n\n\t', ';\n']),
    _templateObject4$2 = taggedTemplateLiteral(['\n\tdisplay: flex;\n\tflex-wrap: ', ';\n\talign-items: ', ';\n\twidth: 100%;\n\n\t', ';\n'], ['\n\tdisplay: flex;\n\tflex-wrap: ', ';\n\talign-items: ', ';\n\twidth: 100%;\n\n\t', ';\n']),
    _templateObject5$2 = taggedTemplateLiteral(['\n\tdisplay: flex;\n\tflex-wrap: ', ';\n\talign-items: ', ';\n\tjustify-content: flex-end;\n\twidth: 100%;\n\n\t', ';\n'], ['\n\tdisplay: flex;\n\tflex-wrap: ', ';\n\talign-items: ', ';\n\tjustify-content: flex-end;\n\twidth: 100%;\n\n\t', ';\n']),
    _templateObject6$2 = taggedTemplateLiteral(['\n\tdisplay: flex;\n\tflex-wrap: ', ';\n\talign-items: ', ';\n\tjustify-content: flex-start;\n\twidth: 100%;\n\n\t', ';\n'], ['\n\tdisplay: flex;\n\tflex-wrap: ', ';\n\talign-items: ', ';\n\tjustify-content: flex-start;\n\twidth: 100%;\n\n\t', ';\n']),
    _templateObject7$1 = taggedTemplateLiteral(['\n\tdisplay: flex;\n\twidth: 100%;\n\n\t> div {\n\t\tdisplay: flex;\n\t\twidth: 100%;\n\t}\n\n\t@media (min-width: ', ') {\n\t\tflex-basis: 33.33%;\n\t}\n\n\t', ';\n'], ['\n\tdisplay: flex;\n\twidth: 100%;\n\n\t> div {\n\t\tdisplay: flex;\n\t\twidth: 100%;\n\t}\n\n\t@media (min-width: ', ') {\n\t\tflex-basis: 33.33%;\n\t}\n\n\t', ';\n']);

var baseProps = {
	nodes: PropTypes.arrayOf(PropTypes.node).isRequired,
	isNonWrapping: PropTypes.bool,
	verticalAlignment: PropTypes.string,
	isNonFlexForPrint: PropTypes.bool,
	breakpointForNonStacked: PropTypes.oneOf(['480', '540', '640', '960', '1280'])
};

var defaultProps = {
	isNonWrapping: false,
	isNonFlexForPrint: false,
	verticalAlignment: 'stretch'
};

var CenteredWrapper = styled('div')(_templateObject$6, function (props) {
	return props.isNonWrapping ? 'nowrap' : 'wrap';
}, function (props) {
	return props.alignItems;
}, function (props) {
	return props.breakpointForNonStacked && '@media (max-width: ' + props.breakpointForNonStacked + 'px) {\n\t\t\tdisplay: block;\n\t\t}';
});

var verticalAlignmentToAlignItems = function verticalAlignmentToAlignItems(verticalAlignment) {
	switch (verticalAlignment) {
		case 'top':
			return 'flex-start';
		case 'bottom':
			return 'flex-end';
		case 'center':
			return 'center';
		case 'baseline':
			return 'baseline';
		case 'stretch':
		default:
			return 'stretch';
	}
};

var Centered = function Centered(_ref) {
	var nodes = _ref.nodes,
	    isNonWrapping = _ref.isNonWrapping,
	    verticalAlignment = _ref.verticalAlignment,
	    breakpointForNonStacked = _ref.breakpointForNonStacked;
	return React.createElement(
		CenteredWrapper,
		{
			alignItems: verticalAlignmentToAlignItems(verticalAlignment),
			isNonWrapping: isNonWrapping,
			breakpointForNonStacked: breakpointForNonStacked
		},
		nodes.map(function (x, index) {
			return React.createElement(
				'div',
				{ key: index },
				x
			);
		})
	);
};

Centered.propTypes = _extends({}, baseProps);

Centered.defaultProps = _extends({}, defaultProps);

var JustifiedNodeWrapper = styled('div')(_templateObject2$4, function (props) {
	return props.alignItems;
}, function (props) {
	return props.breakpointForNonStacked && '@media (max-width: ' + props.breakpointForNonStacked + 'px) {\n\t\t\tdisplay: block;\n\t\t}';
});

var JustifiedWrapper = styled('div')(_templateObject3$3, function (props) {
	return props.isNonWrapping ? 'nowrap' : 'wrap';
}, function (props) {
	return props.alignItems;
}, function (props) {
	return props.breakpointForNonStacked && '@media (max-width: ' + props.breakpointForNonStacked + 'px) {\n\t\t\tdisplay: block;\n\t\t}';
});

var Justified = function Justified(_ref2) {
	var nodes = _ref2.nodes,
	    isNonWrapping = _ref2.isNonWrapping,
	    verticalAlignment = _ref2.verticalAlignment,
	    breakpointForNonStacked = _ref2.breakpointForNonStacked;
	return React.createElement(
		JustifiedWrapper,
		{ isNonWrapping: isNonWrapping, breakpointForNonStacked: breakpointForNonStacked },
		nodes.map(function (x, index) {
			return React.createElement(
				JustifiedNodeWrapper,
				{
					alignItems: verticalAlignmentToAlignItems(verticalAlignment),
					breakpointForNonStacked: breakpointForNonStacked,
					key: index
				},
				x
			);
		})
	);
};

Justified.propTypes = _extends({}, baseProps);

Justified.defaultProps = _extends({}, defaultProps);

var LeftAlignedWrapper = styled('div')(_templateObject4$2, function (props) {
	return props.isNonWrapping ? 'nowrap' : 'wrap';
}, function (props) {
	return props.alignItems;
}, function (props) {
	return props.breakpointForNonStacked && '@media (max-width: ' + props.breakpointForNonStacked + 'px) {\n\t\t\tdisplay: block;\n\t\t}';
});

var LeftAligned = function LeftAligned(_ref3) {
	var nodes = _ref3.nodes,
	    isNonWrapping = _ref3.isNonWrapping,
	    verticalAlignment = _ref3.verticalAlignment,
	    breakpointForNonStacked = _ref3.breakpointForNonStacked;
	return React.createElement(
		LeftAlignedWrapper,
		{
			alignItems: verticalAlignmentToAlignItems(verticalAlignment),
			isNonWrapping: isNonWrapping,
			breakpointForNonStacked: breakpointForNonStacked
		},
		nodes.map(function (x, index) {
			return React.createElement(
				'div',
				{ key: index },
				x
			);
		})
	);
};

LeftAligned.propTypes = _extends({}, baseProps);

LeftAligned.defaultProps = _extends({}, defaultProps);

var RightAlignedWrapper = styled('div')(_templateObject5$2, function (props) {
	return props.isNonWrapping ? 'nowrap' : 'wrap';
}, function (props) {
	return props.alignItems;
}, function (props) {
	return props.breakpointForNonStacked && '@media (max-width: ' + props.breakpointForNonStacked + 'px) {\n\t\t\tdisplay: block;\n\t\t}';
});

var RightAligned = function RightAligned(_ref4) {
	var nodes = _ref4.nodes,
	    isNonWrapping = _ref4.isNonWrapping,
	    verticalAlignment = _ref4.verticalAlignment,
	    breakpointForNonStacked = _ref4.breakpointForNonStacked;
	return React.createElement(
		RightAlignedWrapper,
		{
			alignItems: verticalAlignmentToAlignItems(verticalAlignment),
			isNonWrapping: isNonWrapping,
			breakpointForNonStacked: breakpointForNonStacked
		},
		nodes.map(function (x, index) {
			return React.createElement(
				'div',
				{ key: index },
				x
			);
		})
	);
};

RightAligned.propTypes = _extends({}, baseProps);

RightAligned.defaultProps = _extends({}, defaultProps);

var ThirdsWrapper = styled('div')(_templateObject6$2, function (props) {
	return props.isNonWrapping ? 'nowrap' : 'wrap';
}, function (props) {
	return props.alignItems;
}, function (props) {
	return props.breakpointForNonStacked && '@media (max-width: ' + props.breakpointForNonStacked + 'px) {\n\t\t\tdisplay: block;\n\t\t}';
});

var NodeWrapper = styled('div')(_templateObject7$1, breakpoints.sm2, function (props) {
	return !props.isNonFlexForPrint && '@media print { flex-basis: 100%; }';
});

var Thirds = function Thirds(_ref5) {
	var nodes = _ref5.nodes,
	    isNonWrapping = _ref5.isNonWrapping,
	    verticalAlignment = _ref5.verticalAlignment,
	    isNonFlexForPrint = _ref5.isNonFlexForPrint,
	    breakpointForNonStacked = _ref5.breakpointForNonStacked;
	return React.createElement(
		ThirdsWrapper,
		{
			alignItems: verticalAlignmentToAlignItems(verticalAlignment),
			isNonWrapping: isNonWrapping,
			isNonFlexForPrint: isNonFlexForPrint,
			breakpointForNonStacked: breakpointForNonStacked
		},
		nodes.map(function (x, index) {
			return React.createElement(
				NodeWrapper,
				{ key: index },
				x
			);
		})
	);
};

Thirds.propTypes = _extends({}, baseProps);

Thirds.defaultProps = _extends({}, defaultProps);

var Inline = {
	Centered: Centered,
	Justified: Justified,
	LeftAligned: LeftAligned,
	RightAligned: RightAligned,
	Thirds: Thirds
};

var main = "LargeBody.js";
var packageJson = {
	main: main,
	"component-id": null,
	"component-life-cycle": "active",
	"is-bespoke": false
};

var _templateObject$7 = taggedTemplateLiteral(['\n\tmargin-right: ', ';\n\tmargin-left: ', ';\n\torder: ', ';\n'], ['\n\tmargin-right: ', ';\n\tmargin-left: ', ';\n\torder: ', ';\n']),
    _templateObject2$5 = taggedTemplateLiteral(['\n\t', ';\n\tmargin: 0;\n'], ['\n\t', ';\n\tmargin: 0;\n']),
    _templateObject3$4 = taggedTemplateLiteral(['\n\talign-items: center;\n\tdisplay: flex;\n\t', ';\n\n\t> div > .c-a-icon {\n\t\theight: ', ' !important;\n\t\twidth: ', ' !important;\n\t}\n'], ['\n\talign-items: center;\n\tdisplay: flex;\n\t', ';\n\n\t> div > .c-a-icon {\n\t\theight: ', ' !important;\n\t\twidth: ', ' !important;\n\t}\n']);

var StyledIcon = styled('div')(_templateObject$7, function (props) {
	return !props.hasIconAtRight && (props.theme.isCompact ? '8px' : '16px');
}, function (props) {
	return props.hasIconAtRight && (props.theme.isCompact ? '8px' : '16px');
}, function (props) {
	return props.hasIconAtRight ? 1 : 0;
});

var StyledLargeBody = styled('div')(_templateObject2$5, function (props) {
	return props.theme.isCompact ? useFontSize.of.uist() : useFontSize.of.arran();
});

var StyledWrapper$1 = styled('div')(_templateObject3$4, function (props) {
	return !props.isFlush && '' + externalMarginRegular;
}, function (props) {
	return props.theme.isCompact ? '27px' : '32px';
}, function (props) {
	return props.theme.isCompact ? '27px' : '32px';
});

/**
 * @example ./Design.md
 */
var LargeBody = function LargeBody(_ref) {
	var children = _ref.children,
	    icon = _ref.icon,
	    hasIconAtRight = _ref.hasIconAtRight,
	    isFlush = _ref.isFlush,
	    id = _ref.id,
	    dataTestId = _ref['data-test-id'];
	return React.createElement(
		InternalComponentFrame,
		{ packageJson: packageJson, hasCustomMargins: true, layout: 'typography' },
		React.createElement(
			StyledWrapper$1,
			{ isFlush: isFlush, id: id, 'data-test-id': dataTestId },
			icon && React.createElement(
				StyledIcon,
				{ hasIconAtRight: hasIconAtRight },
				icon
			),
			React.createElement(
				StyledLargeBody,
				null,
				children
			)
		)
	);
};

LargeBody.propTypes = {
	/** Allows for content to be text or node (for example IconTextDynamic). */
	children: PropTypes.node.isRequired,
	/** Optional icon with LargeBody. */
	icon: PropTypes.node,
	/** Congiruation of icon to be right aligned to LargeBody. */
	hasIconAtRight: PropTypes.bool,
	/** Removed margins. */
	isFlush: PropTypes.bool,
	/** A unique ID used to identify the element within the DOM. */
	id: PropTypes.string,
	/** Data attribute for automation test purposes. */
	'data-test-id': PropTypes.string
};

LargeBody.defaultProps = {
	hasIconAtRight: false,
	isFlush: false,
	'data-test-id': 'largebody'
};

var _templateObject$8 = taggedTemplateLiteral(['\n\tcolor: ', ';\n\t', ';\n\t', ';\n'], ['\n\tcolor: ', ';\n\t', ';\n\t', ';\n']);

var StyledInternalSecondaryBody = styled('div')(_templateObject$8, colours.typography.secondaryBody, function (props) {
	return props.theme.isCompact ? useFontSize.of.bute() : useFontSize.of.jura();
}, function (props) {
	return !props.isFlush && '' + externalMarginRegular;
});

var InternalSecondaryBody = function InternalSecondaryBody(_ref) {
	var isFlush = _ref.isFlush,
	    children = _ref.children,
	    id = _ref.id,
	    dataTestId = _ref['data-test-id'];
	return React.createElement(
		StyledInternalSecondaryBody,
		{ isFlush: isFlush, id: id, 'data-test-id': dataTestId },
		children
	);
};

InternalSecondaryBody.propTypes = {
	/** Child content as node. Should be used to wrap bodies of textual content. This textual content
  * should contain appropriate HTML tagging and passing in orphan text child content should
  * be avoided. */
	children: PropTypes.node.isRequired,
	/** Removed margins. */
	isFlush: PropTypes.bool,
	/** A unique ID used to identify the element within the DOM. */
	id: PropTypes.string,
	/** Data attribute for automation test purposes. */
	'data-test-id': PropTypes.string
};

InternalSecondaryBody.defaultProps = {
	isFlush: false,
	'data-test-id': 'internal-secondarybody'
};

var main$1 = "SecondaryBody.js";
var packageJson$1 = {
	main: main$1,
	"component-id": 1070,
	"component-life-cycle": "active",
	"is-bespoke": false
};

/**
 * @example ./Design.md
 */
var SecondaryBody = function SecondaryBody(_ref) {
	var isFlush = _ref.isFlush,
	    children = _ref.children,
	    id = _ref.id,
	    dataTestId = _ref['data-test-id'];
	return React.createElement(
		InternalComponentFrame,
		{ packageJson: packageJson$1, hasCustomMargins: true, layout: 'typography' },
		React.createElement(
			InternalSecondaryBody,
			{ isFlush: isFlush, id: id, 'data-test-id': dataTestId },
			children
		)
	);
};

SecondaryBody.propTypes = {
	/** Child content as node. Should be used to wrap bodies of textual content. This textual content
  * should contain appropriate HTML tagging and passing in orphan text child content should
  * be avoided. */
	children: PropTypes.node.isRequired,
	/** Removed margins. */
	isFlush: PropTypes.bool,
	/** A unique ID used to identify the element within the DOM. */
	id: PropTypes.string,
	/** Data attribute for automation test purposes. */
	'data-test-id': PropTypes.string
};

SecondaryBody.defaultProps = {
	isFlush: false,
	'data-test-id': 'secondarybody'
};

var main$2 = "SmallestBody.js";
var packageJson$2 = {
	main: main$2,
	"component-id": null,
	"component-life-cycle": "active",
	"is-bespoke": false
};

var _templateObject$9 = taggedTemplateLiteral(['\n\t', ';\n\t', ';\n\t', ';\n'], ['\n\t', ';\n\t', ';\n\t', ';\n']);

var StyledSmallestBody = styled('div')(_templateObject$9, useFontSize.of.cumbrae(), function (props) {
	return !props.isFlush && 'margin-bottom: ' + spacing.SINGLE;
}, function (props) {
	return !props.isFlush && 'margin-right: ' + spacing.DOUBLE;
});

/**
 * @example ./Design.md
 */
var SmallestBody = function SmallestBody(_ref) {
	var isFlush = _ref.isFlush,
	    children = _ref.children,
	    id = _ref.id,
	    dataTestId = _ref['data-test-id'];
	return React.createElement(
		InternalComponentFrame,
		{ packageJson: packageJson$2, hasCustomMargins: true, layout: 'typography' },
		React.createElement(
			StyledSmallestBody,
			{ isFlush: isFlush, id: id, 'data-test-id': dataTestId },
			children
		)
	);
};

SmallestBody.propTypes = {
	/** Allows for content to be text or node (for example IconTextDynamic). */
	children: PropTypes.node.isRequired,
	/** Removed margins. */
	isFlush: PropTypes.bool,
	/** A unique ID used to identify the element within the DOM. */
	id: PropTypes.string,
	/** Data attribute for automation test purposes. */
	'data-test-id': PropTypes.string
};

SmallestBody.defaultProps = {
	isFlush: false,
	'data-test-id': 'smallestbody'
};

var main$3 = "StandardBody.js";
var packageJson$3 = {
	main: main$3,
	"component-id": null,
	"component-life-cycle": "active",
	"is-bespoke": false
};

/**
 * @example ./Design.md
 */
var StandardBody = function StandardBody(_ref) {
	var isFlush = _ref.isFlush,
	    children = _ref.children,
	    id = _ref.id,
	    dataTestId = _ref['data-test-id'];
	return React.createElement(
		InternalComponentFrame,
		{ packageJson: packageJson$3, hasCustomMargins: true, layout: 'typography' },
		React.createElement(
			InternalStandardBody,
			{ isFlush: isFlush, id: id, 'data-test-id': dataTestId },
			children
		)
	);
};

StandardBody.propTypes = {
	/** Child content as node. Should be used to wrap bodies of textual content. This textual content
  * should contain appropriate HTML tagging and passing in orphan text child content should
  * be avoided. */
	children: PropTypes.node.isRequired,
	/** Removed margins. */
	isFlush: PropTypes.bool,
	/** A unique ID used to identify the element within the DOM. */
	id: PropTypes.string,
	/** Data attribute for automation test purposes. */
	'data-test-id': PropTypes.string
};

StandardBody.defaultProps = {
	isFlush: false,
	'data-test-id': 'standardbody'
};

var main$4 = "SubBody.js";
var packageJson$4 = {
	main: main$4,
	"component-id": null,
	"component-life-cycle": "active",
	"is-bespoke": false
};

var _templateObject$a = taggedTemplateLiteral(['\n\t', ';\n\t', ';\n'], ['\n\t', ';\n\t', ';\n']);

var StyledSubBody = styled('div')(_templateObject$a, function (props) {
	return props.theme.isCompact ? useFontSize.of.bute() : useFontSize.of.uist();
}, function (props) {
	return !props.isFlush && '' + externalMarginRegular;
});

/**
 * @example ./Design.md
 */
var SubBody = function SubBody(_ref) {
	var isFlush = _ref.isFlush,
	    children = _ref.children,
	    id = _ref.id,
	    dataTestId = _ref['data-test-id'];
	return React.createElement(
		InternalComponentFrame,
		{ packageJson: packageJson$4, hasCustomMargins: true, layout: 'typography' },
		React.createElement(
			StyledSubBody,
			{ isFlush: isFlush, id: id, 'data-test-id': dataTestId },
			children
		)
	);
};

SubBody.propTypes = {
	/** Allows for content to be text or node (for example IconTextDynamic). */
	children: PropTypes.node.isRequired,
	/** Removed margins. */
	isFlush: PropTypes.bool,
	/** A unique ID used to identify the element within the DOM. */
	id: PropTypes.string,
	/** Data attribute for automation test purposes. */
	'data-test-id': PropTypes.string
};

SubBody.defaultProps = {
	isFlush: false,
	'data-test-id': 'subbody'
};

var _templateObject$b = taggedTemplateLiteral(['\n\tclip: rect(1px, 1px, 1px, 1px) !important;\n\theight: 1px !important;\n\twidth: 1px !important;\n\toverflow: hidden !important;\n\tposition: absolute;\n'], ['\n\tclip: rect(1px, 1px, 1px, 1px) !important;\n\theight: 1px !important;\n\twidth: 1px !important;\n\toverflow: hidden !important;\n\tposition: absolute;\n']);

var StyledVisuallyHiddenText = styled('span')(_templateObject$b);

var VisuallyHiddenBody = function VisuallyHiddenBody(_ref) {
	var children = _ref.children,
	    id = _ref.id,
	    dataTestId = _ref['data-test-id'];
	return React.createElement(
		StyledVisuallyHiddenText,
		{ id: id, 'data-test-id': dataTestId },
		children
	);
};

VisuallyHiddenBody.propTypes = {
	/** The id of the component. */
	id: PropTypes.string,
	/** Content of the visually hidden span. */
	children: PropTypes.node,
	/** Data attribute for automation test purposes. */
	'data-test-id': PropTypes.string
};

var INTERNET_BANKING_CSS_OVERRIDE = '!important';

var main$5 = "SubHeading.js";
var packageJson$5 = {
	main: main$5,
	"component-id": null,
	"component-life-cycle": "active",
	"is-bespoke": false
};

var _templateObject$c = taggedTemplateLiteral(['\n\tcolor: ', ';\n\t', ';\n\tfont-family: ', ';\n\tmargin: 0;\n'], ['\n\tcolor: ', ';\n\t', ';\n\tfont-family: ', ';\n\tmargin: 0;\n']),
    _templateObject2$6 = taggedTemplateLiteral(['\n\talign-items: center;\n\tdisplay: flex;\n\t', ';\n\n\tdiv > svg {\n\t\tfill: ', ';\n\t\theight: ', ';\n\t\tmargin-right: ', ';\n\t\twidth: ', ';\n\t}\n'], ['\n\talign-items: center;\n\tdisplay: flex;\n\t', ';\n\n\tdiv > svg {\n\t\tfill: ', ';\n\t\theight: ', ';\n\t\tmargin-right: ', ';\n\t\twidth: ', ';\n\t}\n']);

var StyledSubHeading = styled('h2')(_templateObject$c, function (props) {
	return props.theme.colours.heading;
}, function (props) {
	return props.theme.isCompact ? useFontSize.of.arran() : useFontSize.of.islay();
}, function (props) {
	return props.theme.fonts.display.bold;
});

var StyledWrapper$2 = styled('div')(_templateObject2$6, function (props) {
	return props.isFlush && 'margin-bottom: 0;';
}, function (props) {
	return props.theme.colours.heading;
}, function (props) {
	return props.theme.isCompact ? '14px' : '28px';
}, function (props) {
	return props.theme.isCompact ? '8px' : '16px';
}, function (props) {
	return props.theme.isCompact ? '14px' : '28px';
});

/**
 * Uses `<h2>` tag internally.
 * @example ./Design.md
 */
var SubHeading = function SubHeading(_ref) {
	var children = _ref.children,
	    icon = _ref.icon,
	    isFlush = _ref.isFlush,
	    id = _ref.id,
	    dataTestId = _ref['data-test-id'];
	return React.createElement(
		InternalComponentFrame,
		{ packageJson: packageJson$5, isFlush: isFlush, layout: 'typography' },
		React.createElement(
			StyledWrapper$2,
			{ isFlush: isFlush },
			icon,
			React.createElement(
				StyledSubHeading,
				{ id: id, 'data-test-id': dataTestId },
				children
			)
		)
	);
};

SubHeading.propTypes = {
	/** Allows for content to be text or node (for example IconTextDynamic). */
	children: PropTypes.node.isRequired,
	/** Optional Left aligned icon with SubHeading. */
	icon: PropTypes.node,
	/** Removed margins. */
	isFlush: PropTypes.bool,
	/** A unique ID used to identify the element within the DOM. */
	id: PropTypes.string,
	/** Data attribute for automation test purposes. */
	'data-test-id': PropTypes.string
};

SubHeading.defaultProps = {
	isFlush: false,
	'data-test-id': 'sub-heading'
};

var main$6 = "IndicativeHighlight.js";
var variants = ["Value", "Description"];
var packageJson$6 = {
	main: main$6,
	variants: variants,
	"component-id": null,
	"component-life-cycle": "active",
	"is-bespoke": false
};

var _templateObject$d = taggedTemplateLiteral(['\n\tcolor: ', ';\n'], ['\n\tcolor: ', ';\n']);

var StyledWrapper$3 = styled('span')(_templateObject$d, colours.utility.indicative);

var Value = function Value(_ref) {
	var children = _ref.children;
	return React.createElement(
		InternalComponentFrame,
		{ variant: 'Value', packageJson: packageJson$6, hasCustomMargins: true, layout: 'inline-block' },
		React.createElement(
			StyledWrapper$3,
			null,
			children,
			'*'
		)
	);
};

var Description = function Description(_ref2) {
	var children = _ref2.children;
	return React.createElement(
		InternalComponentFrame,
		{ variant: 'Description', packageJson: packageJson$6, hasCustomMargins: true, layout: 'inline-block' },
		React.createElement(
			StyledWrapper$3,
			null,
			children
		)
	);
};

var commonProps = {
	/** child nodes */
	children: PropTypes.node.isRequired
};

Value.propTypes = commonProps;
Description.propTypes = commonProps;

Value.defaultProps = {};
Description.defaultProps = {};

var IndicativeHighlight = {
	Value: Value,
	Description: Description
};

IndicativeHighlight.value = Value; // keep for legacy support only.
IndicativeHighlight.description = Description; // keep below for legacy support only.

var main$7 = "ProminentLabel.js";
var packageJson$7 = {
	main: main$7,
	"component-id": null,
	"component-life-cycle": "active",
	"is-bespoke": false
};

var _templateObject$e = taggedTemplateLiteral(['\n\t', ';\n\tfont-family: ', ';\n\t', ';\n\n\t@media print {\n\t\tfont-size: 16px;\n\t}\n'], ['\n\t', ';\n\tfont-family: ', ';\n\t', ';\n\n\t@media print {\n\t\tfont-size: 16px;\n\t}\n']);

var StyledProminentLabel = styled('div')(_templateObject$e, function (props) {
	return props.theme.isCompact ? useFontSize.of.jura() : useFontSize.of.arran();
}, function (props) {
	return props.theme.fonts.display.bold;
}, function (props) {
	return !props.isFlush && '' + externalMarginRegular;
});

var ProminentLabel = function ProminentLabel(_ref) {
	var isFlush = _ref.isFlush,
	    children = _ref.children;
	return React.createElement(
		InternalComponentFrame,
		{ packageJson: packageJson$7, hasCustomMargins: true, layout: 'typography' },
		React.createElement(
			StyledProminentLabel,
			{ isFlush: isFlush },
			children
		)
	);
};

ProminentLabel.propTypes = {
	/** Allows for content to be text or node (for example IconTextDynamic). */
	children: PropTypes.node.isRequired,
	/** Removed margins. */
	isFlush: PropTypes.bool
};

ProminentLabel.defaultProps = {
	isFlush: false
};

var main$8 = "StandardLabel.js";
var packageJson$8 = {
	main: main$8,
	"component-id": null,
	"component-life-cycle": "active",
	"is-bespoke": false
};

var _templateObject$f = taggedTemplateLiteral(['\n\t', ';\n\tfont-family: ', ';\n\t', ';\n\n\t@media print {\n\t\tfont-size: 16px;\n\t}\n'], ['\n\t', ';\n\tfont-family: ', ';\n\t', ';\n\n\t@media print {\n\t\tfont-size: 16px;\n\t}\n']);

var StyledStandardLabel = styled('div')(_templateObject$f, function (props) {
	return props.theme.isCompact ? useFontSize.of.bute() : useFontSize.of.jura();
}, function (props) {
	return props.theme.fonts.standardLabel;
}, function (props) {
	return !props.isFlush && '' + externalMarginRegular;
});

var StandardLabel = function StandardLabel(_ref) {
	var isFlush = _ref.isFlush,
	    children = _ref.children,
	    dataTestId = _ref['data-test-id'],
	    id = _ref.id;
	return React.createElement(
		InternalComponentFrame,
		{ packageJson: packageJson$8, hasCustomMargins: true, layout: 'typography' },
		React.createElement(
			StyledStandardLabel,
			{ isFlush: isFlush, 'data-test-id': dataTestId, id: id },
			children
		)
	);
};

StandardLabel.propTypes = {
	/** Allows for content to be text or node (for example IconTextDynamic). */
	children: PropTypes.node.isRequired,
	/** Removed margins. */
	isFlush: PropTypes.bool,
	/** Data attribute targeting modal container for automation test purposes. */
	'data-test-id': PropTypes.string,
	/** String id passed to underlying html element. */
	id: PropTypes.string
};

StandardLabel.defaultProps = {
	isFlush: false,
	'data-test-id': 'standard-label'
};

var _extends$5 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$4(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var GenericIcon$1 = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$4(_ref, ["styles"]);

  return React.createElement("svg", _extends$5({ width: "16", height: "16", viewBox: "0 0 96 96", xmlns: "http://www.w3.org/2000/svg" }, props), React.createElement("path", { d: "M6.63 6.631a9.378 9.378 0 0 0 0 13.263l28.1 28.102-28.103 28.12A9.377 9.377 0 0 0 19.89 89.371l28.102-28.105L76.106 89.37a9.38 9.38 0 0 0 13.263-.001 9.378 9.378 0 0 0 0-13.263L61.253 47.987l28.108-28.11a9.373 9.373 0 0 0 .004-13.25 9.359 9.359 0 0 0-13.24-.004l-28.108 28.11L19.894 6.63a9.38 9.38 0 0 0-13.263.002z" }));
});

var _extends$6 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$5(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var VMIcon$1 = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$5(_ref, ["styles"]);

  return React.createElement("svg", _extends$6({ height: "96", viewBox: "0 0 96 96", width: "96", xmlns: "http://www.w3.org/2000/svg" }, props), React.createElement("path", { d: "M84.562 2.58l9.696 9.697-36.295 36.295 36.295 36.295-9.696 9.696-36.295-36.294-36.295 36.294-9.696-9.696L38.57 48.572 2.276 12.277l9.696-9.696 36.295 36.295z" }));
});

var getCrossSolidLarge = getThemeIcon(VMIcon$1, GenericIcon$1);

var _extends$7 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$6(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var VMIcon$2 = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$6(_ref, ["styles"]);

  return React.createElement("svg", _extends$7({ height: "96", viewBox: "0 0 96 96", width: "96", xmlns: "http://www.w3.org/2000/svg" }, props), React.createElement("path", { d: "M11.429 37c6.311 0 11.428 5.117 11.428 11.429S17.74 59.857 11.43 59.857C5.117 59.857 0 54.74 0 48.43S5.117 37 11.429 37zM48 37c6.312 0 11.429 5.117 11.429 11.429S54.312 59.857 48 59.857 36.571 54.74 36.571 48.43 41.688 37 48 37zm36.571 0C90.883 37 96 42.117 96 48.429s-5.117 11.428-11.429 11.428S73.143 54.74 73.143 48.43 78.26 37 84.57 37z" }));
});

var _extends$8 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$7(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var GenericIcon$2 = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$7(_ref, ["styles"]);

  return React.createElement("svg", _extends$8({ width: "16", height: "16", viewBox: "0 0 16 16", xmlns: "http://www.w3.org/2000/svg" }, props), React.createElement("path", { d: "M2 10a2 2 0 1 1 0-4 2 2 0 0 1 0 4zm6 0a2 2 0 1 1 0-4 2 2 0 0 1 0 4zm6 0a2 2 0 1 1 0-4 2 2 0 0 1 0 4z" }));
});

var getEllipsisLarge = getThemeIcon(VMIcon$2, GenericIcon$2);

var main$9 = "Identifier.js";
var variants$1 = ["Breaking", "NonWrapping", "Truncated"];
var packageJson$9 = {
	main: main$9,
	variants: variants$1,
	"component-id": null,
	"component-life-cycle": "active",
	"is-bespoke": false
};

var _templateObject$g = taggedTemplateLiteral(['\n\tmargin: 0;\n\tword-wrap: break-word;\n\tword-break: break-word;\n'], ['\n\tmargin: 0;\n\tword-wrap: break-word;\n\tword-break: break-word;\n']),
    _templateObject2$7 = taggedTemplateLiteral(['\n\talign-items: center;\n\tdisplay: inline-flex;\n\twhite-space: nowrap;\n\tword-break: keep-all;\n'], ['\n\talign-items: center;\n\tdisplay: inline-flex;\n\twhite-space: nowrap;\n\tword-break: keep-all;\n']),
    _templateObject3$5 = taggedTemplateLiteral(['\n\talign-items: center;\n\tborder: 1px solid ', ';\n\tborder-radius: 100%;\n\tdisplay: inline-flex;\n\theight: 22px;\n\tjustify-content: center;\n\tmargin-left: ', ';\n\tpadding: 0;\n\twidth: 22px;\n\n\tsvg {\n\t\tfill: ', ';\n\t\theight: ', ';\n\t\twidth: ', ';\n\t}\n'], ['\n\talign-items: center;\n\tborder: 1px solid ', ';\n\tborder-radius: 100%;\n\tdisplay: inline-flex;\n\theight: 22px;\n\tjustify-content: center;\n\tmargin-left: ', ';\n\tpadding: 0;\n\twidth: 22px;\n\n\tsvg {\n\t\tfill: ', ';\n\t\theight: ', ';\n\t\twidth: ', ';\n\t}\n']);

var StyledIdentifierBreaking = styled('div')(_templateObject$g);

var Breaking = function Breaking(_ref) {
	var children = _ref.children;
	return React.createElement(
		InternalComponentFrame,
		{ variant: 'Breaking', packageJson: packageJson$9, hasCustomMargins: true, layout: 'inline-block' },
		React.createElement(
			StyledIdentifierBreaking,
			null,
			children
		)
	);
};

Breaking.propTypes = {
	/** Allows for content to be text or node (for example IconTextDynamic). */
	children: PropTypes.node.isRequired
};

var StyledIdentifierNonWrapping = styled('span')(_templateObject2$7);

var NonWrapping = function NonWrapping(_ref2) {
	var children = _ref2.children;
	return React.createElement(
		InternalComponentFrame,
		{ variant: 'NonWrapping', packageJson: packageJson$9, hasCustomMargins: true, layout: 'inline-block' },
		React.createElement(
			StyledIdentifierNonWrapping,
			null,
			children
		)
	);
};

NonWrapping.propTypes = {
	/** Allows for content to be text or node (for example IconTextDynamic). */
	children: PropTypes.node.isRequired
};

var StyledEllipsisButton = styled('button')(_templateObject3$5, colours.generalPalette.greyDarker, spacing.HALF, colours.generalPalette.greyDarker, function (props) {
	return props.isCross ? '12px' : '14px';
}, function (props) {
	return props.isCross ? '12px' : '14px';
});

var BUTTON_WIDTH_IN_CHARS = 3;

var UnwrappedTruncated = function (_Component) {
	inherits(UnwrappedTruncated, _Component);

	function UnwrappedTruncated(props) {
		classCallCheck(this, UnwrappedTruncated);

		var _this = possibleConstructorReturn(this, (UnwrappedTruncated.__proto__ || Object.getPrototypeOf(UnwrappedTruncated)).call(this, props));

		_this.state = {
			isExpanded: false
		};
		_this.onExpandClick = _this.onExpandClick.bind(_this);
		return _this;
	}

	createClass(UnwrappedTruncated, [{
		key: 'onExpandClick',
		value: function onExpandClick() {
			this.setState(function (state) {
				return { isExpanded: !state.isExpanded };
			});
		}
	}, {
		key: 'render',
		value: function render() {
			var _this2 = this;

			var _props = this.props,
			    characterCount = _props.characterCount,
			    theme = _props.theme,
			    value = _props.value;
			var isExpanded = this.state.isExpanded;


			var CrossSolidLargeIcon = getCrossSolidLarge(theme.name);
			var EllipsisLargeIcon = getEllipsisLarge(theme.name);

			if (!value || value.length <= characterCount + BUTTON_WIDTH_IN_CHARS) {
				return React.createElement(
					StyledIdentifierBreaking,
					null,
					value
				);
			}

			if (isExpanded) {
				return React.createElement(
					InternalComponentFrame,
					{ variant: 'Truncated', packageJson: packageJson$9, hasCustomMargins: true, layout: 'inline-block' },
					React.createElement(
						StyledIdentifierBreaking,
						null,
						value,
						React.createElement(
							StyledEllipsisButton,
							{ isCross: true, onClick: function onClick() {
									return _this2.onExpandClick();
								} },
							React.createElement(
								VisuallyHiddenBody,
								null,
								'Truncate Text'
							),
							React.createElement(CrossSolidLargeIcon, null)
						)
					)
				);
			}

			return React.createElement(
				InternalComponentFrame,
				{ variant: 'Truncated', packageJson: packageJson$9, hasCustomMargins: true, layout: 'inline-block' },
				React.createElement(
					StyledIdentifierNonWrapping,
					null,
					value.slice(0, characterCount),
					React.createElement(
						StyledEllipsisButton,
						{ onClick: function onClick() {
								return _this2.onExpandClick();
							} },
						React.createElement(
							VisuallyHiddenBody,
							null,
							'Show Full Text'
						),
						React.createElement(EllipsisLargeIcon, null)
					)
				)
			);
		}
	}]);
	return UnwrappedTruncated;
}(Component);

UnwrappedTruncated.propTypes = {
	/** Specifies the default size to be displayed before truncation */
	characterCount: PropTypes.number.isRequired,
	/** The value to be displayed */
	value: PropTypes.string.isRequired
};

var Truncated = withTheme(UnwrappedTruncated);

var Identifier = {
	Breaking: Breaking,
	NonWrapping: NonWrapping,
	Truncated: Truncated
};

var main$a = "ProminentValue.js";
var packageJson$a = {
	main: main$a,
	"component-id": null,
	"component-life-cycle": "active",
	"is-bespoke": false
};

var _templateObject$h = taggedTemplateLiteral(['\n\tfont-family: ', ';\n\t', ';\n'], ['\n\tfont-family: ', ';\n\t', ';\n']);

var StyledProminentValue = styled('span')(_templateObject$h, function (props) {
	return props.theme.fonts.text.bold;
}, function (props) {
	return props.theme.isCompact ? useFontSize.of.bute() : useFontSize.of.jura();
});

/**
 * Uses `<span>` tag internally
 * @example ./Design.md
 */
var ProminentValue = function ProminentValue(_ref) {
	var children = _ref.children;
	return React.createElement(
		InternalComponentFrame,
		{ packageJson: packageJson$a, hasCustomMargins: true, layout: 'inline-block' },
		React.createElement(
			StyledProminentValue,
			null,
			children
		)
	);
};

ProminentValue.propTypes = {
	/** Allows for content to be text or node (for example IconTextDynamic). */
	children: PropTypes.node.isRequired
};

ProminentValue.defaultProps = {};

var main$b = "StandardValue.js";
var packageJson$b = {
	main: main$b,
	"component-id": null,
	"component-life-cycle": "active",
	"is-bespoke": false
};

var _templateObject$i = taggedTemplateLiteral(['\n\t', ';\n'], ['\n\t', ';\n']);

var StyledStandardValue = styled('span')(_templateObject$i, function (props) {
	return props.theme.isCompact ? useFontSize.of.bute() : useFontSize.of.jura();
});

var StandardValue = function StandardValue(_ref) {
	var children = _ref.children,
	    dataTestId = _ref['data-test-id'];
	return React.createElement(
		InternalComponentFrame,
		{ packageJson: packageJson$b, hasCustomMargins: true, layout: 'inline-block' },
		React.createElement(
			StyledStandardValue,
			{ 'data-test-id': dataTestId },
			children
		)
	);
};

StandardValue.propTypes = {
	/** Allows for content to be text or node (for example IconTextDynamic). */
	children: PropTypes.node.isRequired,
	/** Data attribute for automation test purposes. */
	'data-test-id': PropTypes.string
};

StandardValue.defaultProps = {};

var inputStyles = 'input {\n\t\tclip: rect(0, 0, 0, 0);\n\t\theight: 0;\n\t\twidth: 0;\n\t\toverflow: hidden;\n\t\tposition: absolute;\n\n\t\t:focus {\n\t\t\t~ label {\n\t\t\t\toutline-color: ' + colours.component.focusOutline + ';\n\t\t\t\toutline-offset: 2px;\n\t\t\t\toutline-style: auto;\n\t\t\t\toutline-width: 5px;\n\t\t\t}\n\t\t}\n\t}';

var _templateObject$j = taggedTemplateLiteral(['\n\tdisplay: inline-flex;\n\tposition: relative;\n\n\t@media screen and (-ms-high-contrast: active), (-ms-high-contrast: none) {\n\t\ttable & {\n\t\t\tflex: 1;\n\t\t}\n\t}\n\n\t', ';\n\n\t', ';\n'], ['\n\tdisplay: inline-flex;\n\tposition: relative;\n\n\t@media screen and (-ms-high-contrast: active), (-ms-high-contrast: none) {\n\t\ttable & {\n\t\t\tflex: 1;\n\t\t}\n\t}\n\n\t', ';\n\n\t', ';\n']),
    _templateObject2$8 = taggedTemplateLiteral(['\n\tmargin-right: ', ';\n'], ['\n\tmargin-right: ', ';\n']),
    _templateObject3$6 = taggedTemplateLiteral(['\n\tbox-sizing: border-box;\n\tcolor: ', ';\n\tcursor: ', ';\n\tdisplay: inline-flex;\n\tmin-width: 98px;\n\t', ';\n\n\t// IE11 Solution to content stress test\n\t&:after {\n\t\tdisplay: block;\n\t\tcontent: \'\';\n\t\tmin-height: inherit;\n\t\tfont-size: 0;\n\t}\n'], ['\n\tbox-sizing: border-box;\n\tcolor: ', ';\n\tcursor: ', ';\n\tdisplay: inline-flex;\n\tmin-width: 98px;\n\t', ';\n\n\t// IE11 Solution to content stress test\n\t&:after {\n\t\tdisplay: block;\n\t\tcontent: \'\';\n\t\tmin-height: inherit;\n\t\tfont-size: 0;\n\t}\n']),
    _templateObject4$3 = taggedTemplateLiteral(['\n\tflex-shrink: 0;\n\t', ';\n\t', ';\n\theight: ', ';\n\twidth: ', ';\n\n\tsvg {\n\t\tbackground-color: ', ';\n\t\tborder: 2px solid ', ';\n\t\tborder-radius: 2px;\n\t\tmargin-top: 1px;\n\t\theight: ', ';\n\t\twidth: ', ';\n\t\t', ';\n\t}\n'], ['\n\tflex-shrink: 0;\n\t', ';\n\t', ';\n\theight: ', ';\n\twidth: ', ';\n\n\tsvg {\n\t\tbackground-color: ', ';\n\t\tborder: 2px solid ', ';\n\t\tborder-radius: 2px;\n\t\tmargin-top: 1px;\n\t\theight: ', ';\n\t\twidth: ', ';\n\t\t', ';\n\t}\n']);

var getIconFillColour = function getIconFillColour(isChecked, isStacked, isDisabled, hasError, theme) {
	if (isChecked && isDisabled) {
		return colours.component.borderDisabled;
	}
	if (isDisabled) {
		return colours.component.backgroundDisabled;
	}
	if (isStacked && isChecked) {
		return colours.generalPalette.white;
	}
	if (isChecked) {
		return hasError ? colours.utility.error : theme.colours.interaction;
	}
	return 'transparent';
};

var getIconBackgroundColour = function getIconBackgroundColour(isChecked, isStacked, isDisabled, hasError, theme) {
	if (isDisabled) {
		return colours.component.backgroundDisabled;
	}
	if (isStacked && isChecked) {
		return hasError ? colours.utility.error : theme.colours.interaction;
	}
	return colours.component.background;
};

var StyledWrapper$4 = styled('div')(_templateObject$j, inputStyles, function (props) {
	return props.isStacked && '\n\t\twidth: 100%;\n        input {\n            :focus {\n                ~ label {\n                    z-index: 3000\n                }\n            }\n        }\n    ';
});

var StyledLabelContent = styled('div')(_templateObject2$8, spacing.SINGLE);

var StyledLabel = styled('label')(_templateObject3$6, function (props) {
	return props.theme.colours.bodyText;
}, function (props) {
	return props.isDisabled ? 'not-allowed' : 'pointer';
}, function (props) {
	return props.isStacked && '\n\t\twidth: 100%;\n\t\tpadding: ' + spacing.DOUBLE + ';\n\t\talign-items: center;\n\t\tflex-direction: row-reverse;\n\t\tbackground-color: ' + colours.generalPalette.white + ';\n\t';
});

var StyledIconWrapper = styled('div')(_templateObject4$3, function (props) {
	return props.isStacked && 'padding-left: ' + spacing.SINGLE;
}, function (props) {
	return props.isStacked ? 'margin-left: auto;' : 'margin-right: ' + spacing.SINGLE;
}, function (props) {
	return props.theme.isCompact ? '18px' : '24px';
}, function (props) {
	return props.theme.isCompact ? '18px' : '24px';
}, function (props) {
	return getIconBackgroundColour(props.isChecked, props.isStacked, props.isDisabled, props.hasError, props.theme);
}, function (props) {
	return props.hasError ? colours.utility.error : props.theme.colours.interaction;
}, function (props) {
	return props.theme.isCompact ? '18px' : '24px';
}, function (props) {
	return props.theme.isCompact ? '18px' : '24px';
}, function (props) {
	return props.isDisabled && 'border-color: ' + colours.component.borderDisabled + ';';
});

var UnwrappedBaseInternalCheckbox = function (_Component) {
	inherits(UnwrappedBaseInternalCheckbox, _Component);

	function UnwrappedBaseInternalCheckbox(props) {
		classCallCheck(this, UnwrappedBaseInternalCheckbox);

		var _this = possibleConstructorReturn(this, (UnwrappedBaseInternalCheckbox.__proto__ || Object.getPrototypeOf(UnwrappedBaseInternalCheckbox)).call(this, props));

		_this.refInput = null;
		return _this;
	}

	createClass(UnwrappedBaseInternalCheckbox, [{
		key: 'focus',
		value: function focus() {
			if (this.refInput) {
				this.refInput.focus();
			}
		}
	}, {
		key: 'render',
		value: function render() {
			var _this2 = this;

			var _props = this.props,
			    hasError = _props.hasError,
			    id = _props.id,
			    isChecked = _props.isChecked,
			    isDisabled = _props.isDisabled,
			    innerRef = _props.innerRef,
			    label = _props.label,
			    name = _props.name,
			    onBlur = _props.onBlur,
			    onChange = _props.onChange,
			    onFocus = _props.onFocus,
			    theme = _props.theme,
			    hasSubLabelStyling = _props.hasSubLabelStyling,
			    subLabelText = _props.subLabelText,
			    isStacked = _props.isStacked;


			if (innerRef) {
				innerRef(this);
			}

			return React.createElement(
				StyledWrapper$4,
				{
					hasError: hasError,
					isChecked: isChecked,
					isStacked: isStacked,
					isDisabled: isDisabled,
					hasSubLabel: !!subLabelText
				},
				React.createElement('input', {
					checked: isChecked,
					disabled: isDisabled,
					id: id,
					name: name,
					onBlur: onBlur,
					onChange: onChange,
					onFocus: onFocus,
					ref: function ref(element) {
						_this2.refInput = element;
					},
					type: 'checkbox',
					value: label
				}),
				React.createElement(
					StyledLabel,
					{ htmlFor: id, isStacked: isStacked, isDisabled: isDisabled },
					React.createElement(
						StyledIconWrapper,
						{ hasError: hasError, isChecked: isChecked, isStacked: isStacked, isDisabled: isDisabled },
						React.createElement(CheckboxIcon, { fill: getIconFillColour(isChecked, isStacked, isDisabled, hasError, theme) })
					),
					React.createElement(
						InternalStandardBody,
						{ isFlush: true },
						hasSubLabelStyling && subLabelText ? React.createElement(Inline.LeftAligned, {
							nodes: [React.createElement(
								StyledLabelContent,
								null,
								React.createElement(
									ProminentValue,
									null,
									label
								)
							), React.createElement(
								SecondaryBody,
								{ isFlush: true },
								React.createElement(
									'span',
									null,
									' - ',
									subLabelText
								)
							)]
						}) : React.createElement(
							'span',
							null,
							label
						)
					)
				)
			);
		}
	}]);
	return UnwrappedBaseInternalCheckbox;
}(Component);

var baseProps$1 = {
	/** Changes radio colour when set to true. */
	hasError: PropTypes.bool,
	/** An ID HTML attribute for the checkbox element. Must be unique on any individual page. */
	id: PropTypes.string.isRequired,
	/** Boolean controlling whether checkbox input is checked. */
	isChecked: PropTypes.bool.isRequired,
	/** Boolean controlling whether checkbox input is disabled. */
	isDisabled: PropTypes.bool,
	/** Used to access the internal input inside the theme wrapper. */
	innerRef: PropTypes.func,
	/** The checkbox input label. */
	label: PropTypes.oneOfType([PropTypes.string, PropTypes.node]).isRequired,
	/** HTML name attribute value that this checkbox option belongs to. */
	name: PropTypes.string,
	/** Callback function triggered on blur. */
	onBlur: PropTypes.func,
	/** Callback function triggered on change. */
	onChange: PropTypes.func.isRequired,
	/** Callback function triggered on focus. */
	onFocus: PropTypes.func,
	/** Boolean determined from items passed whether sub level styling should be applied. */
	hasSubLabelStyling: PropTypes.bool
};

var baseDefaultProps = {
	hasError: false,
	isDisabled: false
};

UnwrappedBaseInternalCheckbox.propTypes = baseProps$1;
UnwrappedBaseInternalCheckbox.defaultProps = baseDefaultProps;

var BaseInternalCheckbox = withTheme(UnwrappedBaseInternalCheckbox);

var Default = function Default(_ref) {
	var hasError = _ref.hasError,
	    id = _ref.id,
	    isChecked = _ref.isChecked,
	    isDisabled = _ref.isDisabled,
	    innerRef = _ref.innerRef,
	    label = _ref.label,
	    name = _ref.name,
	    onBlur = _ref.onBlur,
	    onChange = _ref.onChange,
	    onFocus = _ref.onFocus;
	return React.createElement(BaseInternalCheckbox, {
		hasError: hasError,
		id: id,
		isChecked: isChecked,
		isDisabled: isDisabled,
		innerRef: innerRef,
		label: label,
		name: name,
		onBlur: onBlur,
		onChange: onChange,
		onFocus: onFocus
	});
};

Default.propTypes = _extends({}, baseProps$1);

var Stacked = function Stacked(_ref) {
	var hasError = _ref.hasError,
	    id = _ref.id,
	    isChecked = _ref.isChecked,
	    isDisabled = _ref.isDisabled,
	    innerRef = _ref.innerRef,
	    label = _ref.label,
	    name = _ref.name,
	    onBlur = _ref.onBlur,
	    onChange = _ref.onChange,
	    onFocus = _ref.onFocus,
	    hasSubLabelStyling = _ref.hasSubLabelStyling,
	    subLabelText = _ref.subLabelText,
	    isStacked = _ref.isStacked;
	return React.createElement(BaseInternalCheckbox, {
		hasError: hasError,
		id: id,
		isChecked: isChecked,
		isDisabled: isDisabled,
		innerRef: innerRef,
		label: label,
		name: name,
		onBlur: onBlur,
		onChange: onChange,
		onFocus: onFocus,
		hasSubLabelStyling: hasSubLabelStyling,
		subLabelText: subLabelText,
		isStacked: isStacked
	});
};

Stacked.propTypes = _extends({}, baseProps$1);

var InternalCheckbox = {
	Default: Default,
	Stacked: Stacked
};

var _templateObject$k = taggedTemplateLiteral(['\n\tdisplay: flex;\n\tbackground-color: ', ' ', ';\n\tborder-radius: ', ';\n\tborder-color: ', ';\n\tborder-style: solid ', ';\n\tborder-width: ', ' ', ';\n\tpadding: ', ' ', ';\n\t', ' text-align: left;\n\twidth: 100%;\n'], ['\n\tdisplay: flex;\n\tbackground-color: ', ' ', ';\n\tborder-radius: ', ';\n\tborder-color: ', ';\n\tborder-style: solid ', ';\n\tborder-width: ', ' ', ';\n\tpadding: ', ' ', ';\n\t', ' text-align: left;\n\twidth: 100%;\n']);

var StyledAccountCard = styled('div')(_templateObject$k, colours.generalPalette.white, INTERNET_BANKING_CSS_OVERRIDE, function (props) {
	return props.theme.borderRadiusLarger;
}, colours.component.locked, INTERNET_BANKING_CSS_OVERRIDE, function (props) {
	return props.theme.components.accountCardBase.root.borderWidth;
}, INTERNET_BANKING_CSS_OVERRIDE, function (props) {
	return props.theme.components.accountCardBase.root.padding;
}, INTERNET_BANKING_CSS_OVERRIDE, function (props) {
	return props.onFavouriteChange && 'padding-right: ' + spacing.SEXTUPLE + ';';
});

var InternalAccountCard = function InternalAccountCard(_ref) {
	var imageInfo = _ref.imageInfo,
	    children = _ref.children;
	return React.createElement(
		StyledAccountCard,
		{ imageInfo: imageInfo },
		children
	);
};
InternalAccountCard.propTypes = {
	/* Card image information. */
	imageInfo: PropTypes.shape({
		/** Card brand. */
		brandId: PropTypes.oneOf(['cb', 'yb', 'vm']).isRequired,
		/** Image type. Used in the aria-label. */
		cardStatus: PropTypes.oneOf(['active', 'deactivated', 'frozen']).isRequired,
		/** Image url. */
		imageUrl: PropTypes.string.isRequired
	}),
	/** Content of the panel. */
	children: PropTypes.node.isRequired
};

var _templateObject$l = taggedTemplateLiteral(['\n\tdisplay: flex;\n\tbackground-color: ', ' ', ';\n\tborder-radius: ', ';\n\tborder-color: ', ';\n\tborder-style: solid ', ';\n\tborder-width: ', ' ', ';\n\tpadding: ', ' ', ';\n\t', ' text-align: left;\n\twidth: 100%;\n\n\t:hover {\n\t\tbackground-color: ', '\n\t\t\t', ';\n\t\tcolor: ', ';\n\t\th3,\n\t\tbutton {\n\t\t\tcolor: ', ';\n\t\t}\n\t\tbutton {\n\t\t\ttransition: none;\n\t\t}\n\t}\n'], ['\n\tdisplay: flex;\n\tbackground-color: ', ' ', ';\n\tborder-radius: ', ';\n\tborder-color: ', ';\n\tborder-style: solid ', ';\n\tborder-width: ', ' ', ';\n\tpadding: ', ' ', ';\n\t', ' text-align: left;\n\twidth: 100%;\n\n\t:hover {\n\t\tbackground-color: ', '\n\t\t\t', ';\n\t\tcolor: ', ';\n\t\th3,\n\t\tbutton {\n\t\t\tcolor: ', ';\n\t\t}\n\t\tbutton {\n\t\t\ttransition: none;\n\t\t}\n\t}\n']);

var StyledAccountCardButton = styled('button')(_templateObject$l, colours.generalPalette.white, INTERNET_BANKING_CSS_OVERRIDE, function (props) {
	return props.theme.borderRadiusLarger;
}, function (props) {
	return props.chosen ? props.theme.colours.interaction + ' ' + INTERNET_BANKING_CSS_OVERRIDE : props.theme.components.accountCardBase.colours.borderColour + ' ' + INTERNET_BANKING_CSS_OVERRIDE;
}, INTERNET_BANKING_CSS_OVERRIDE, function (props) {
	return props.theme.components.accountCardBase.root.borderWidth;
}, INTERNET_BANKING_CSS_OVERRIDE, function (props) {
	return props.theme.components.accountCardBase.root.padding;
}, INTERNET_BANKING_CSS_OVERRIDE, function (props) {
	return props.onFavouriteChange && 'padding-right: ' + spacing.SEXTUPLE + ';';
}, function (props) {
	return props.theme.components.accountCardBase.colours.hoverColour;
}, INTERNET_BANKING_CSS_OVERRIDE, function (props) {
	return props.theme.components.accountCardBase.colours.hoverBodyColour;
}, function (props) {
	return props.theme.components.accountCardBase.colours.hoverBodyColour;
});

var InternalAccountCardButton = function InternalAccountCardButton(_ref) {
	var imageInfo = _ref.imageInfo,
	    onClick = _ref.onClick,
	    isSelected = _ref.isSelected,
	    children = _ref.children;
	return React.createElement(
		StyledAccountCardButton,
		{ imageInfo: imageInfo, onClick: onClick, isSelected: isSelected },
		children
	);
};

InternalAccountCardButton.propTypes = {
	/* Card image information. */
	imageInfo: PropTypes.shape({
		/** Card brand. */
		brandId: PropTypes.oneOf(['cb', 'yb', 'vm']).isRequired,
		/** Image type. Used in the aria-label. */
		cardStatus: PropTypes.oneOf(['active', 'deactivated', 'frozen']).isRequired,
		/** Image url. */
		imageUrl: PropTypes.string.isRequired
	}),
	/** Callback function triggered on click. */
	onClick: PropTypes.func.isRequired,
	/** Callback function invoked when the card is clicked .*/
	isSelected: PropTypes.bool,
	/** Content of the panel. */
	children: PropTypes.node.isRequired
};

var regexes = {
	alphanumericOrSpace: /^[A-Z0-9\s]*$/,
	bfpo: /^BF\d ?\d[A-Z]{2}|BFPO ?\d{1,4}$/,
	legacyEmail: /^[_a-zA-Z0-9-]+(\.[_a-zA-Z0-9-]+)*@[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)*(\.[a-zA-Z]{2,})$/,
	newEmail: /^[!#%$&'*+/=_a-z0-9-]+(\.[!#%$&'*+/=_a-z0-9-]+)*@[a-z0-9-]+(\.[a-z0-9-]+)*(\.[a-z]{2,})$/i,
	moneyFormatter: /\B(?=(\d{3})+(?!\d))/g,
	postcode: /^(([A-Z]{1,2}\d[A-Z\d]?|ASCN|STHL|TDCU|BBND|[BFS]IQQ|PCRN|TKCA) ?\d[A-Z]{2}|(KY\d|MSR|VG|AI)[ -]?\d{4}|[A-Z]{2} ?\d{2}|GE ?CX)$/,
	postcodeAlt: /^([a-zA-Z]){1}([0-9][0-9]|[0-9]|[a-zA-Z][0-9][a-zA-Z]|[a-zA-Z][0-9][0-9]|[a-zA-Z][0-9]){1}([ ]?)([0-9][a-zA-z][a-zA-z]){1}$/,
	simplifiedAlpha: /([a-z])+/i,
	simplifiedNumeric: /([0-9])+/,
	specialCharacters: /([@!#%&'*+-/=?^_`{|}~])+/i
};

var moneyFormatter = regexes.moneyFormatter;


function lengthCalc(value, targetLength) {
	var newValue = value;
	var i = void 0;

	if (value.length < targetLength) {
		for (i = 0; i < targetLength - value.length; i += 1) {
			newValue = '0'.concat(newValue);
		}
	}
	return newValue;
}

var ACCOUNT_NUMBER_TARGET_LENGTH = 8;
var accountNumberFormat = function accountNumberFormat(value) {
	return '' + lengthCalc(value.toString(), ACCOUNT_NUMBER_TARGET_LENGTH);
};

var CARD_NUMBER_TARGET_LENGTH = 16;
var cardNumberFormat = function cardNumberFormat(value) {
	return '' + lengthCalc(value.toString(), CARD_NUMBER_TARGET_LENGTH).replace(/\B(?=(\d{4})+(?!\d))/g, ' ');
};

var PENCE_DIVIDER = 100;
var penceCurrencyFormat = function penceCurrencyFormat(value, removePrefix) {
	return '' + (Math.sign(value) === -1 ? '-' : '') + (!removePrefix ? '£' : '') + (Math.abs(value) / PENCE_DIVIDER).toFixed(2).toString().replace(moneyFormatter, ',');
};

var poundCurrencyFormat = function poundCurrencyFormat(value) {
	return '\xA3' + value.toString().replace(moneyFormatter, ',');
};

var PRODUCT_NUMBER_TARGET_LENGTH = 3;
var productNumberFormat = function productNumberFormat(value) {
	return '' + lengthCalc(value.toString(), PRODUCT_NUMBER_TARGET_LENGTH);
};

var SORT_CODE_TARGET_LENGTH = 6;
var sortCodeFormat = function sortCodeFormat(value) {
	return '' + lengthCalc(value.toString(), SORT_CODE_TARGET_LENGTH).replace(/\B(?=(\d{2})+(?!\d))/g, '-');
};

var BankingUtils = {
	accountNumberFormat: accountNumberFormat,
	cardNumberFormat: cardNumberFormat,
	lengthCalc: lengthCalc,
	penceCurrencyFormat: penceCurrencyFormat,
	poundCurrencyFormat: poundCurrencyFormat,
	productNumberFormat: productNumberFormat,
	sortCodeFormat: sortCodeFormat
};

var _templateObject$m = taggedTemplateLiteral(['\n\tdisplay: inline-flex;\n'], ['\n\tdisplay: inline-flex;\n']),
    _templateObject2$9 = taggedTemplateLiteral(['\n\tpadding-right: ', ';\n\twhite-space: nowrap;\n'], ['\n\tpadding-right: ', ';\n\twhite-space: nowrap;\n']);

var StyledDetails = styled('div')(_templateObject$m);

var StyledSortCode = styled('div')(_templateObject2$9, spacing.SINGLE);

var SortCodeAndAccountNumber = function SortCodeAndAccountNumber(_ref) {
	var accountNumber = _ref.accountNumber,
	    sortCode = _ref.sortCode;

	var accountNumberString = typeof accountNumber === 'number' ? BankingUtils.accountNumberFormat(accountNumber) : accountNumber;
	var sortCodeString = typeof sortCode === 'number' ? BankingUtils.sortCodeFormat(sortCode) : sortCode;

	var sortcodeLabel = React.createElement(
		StyledSortCode,
		{ 'aria-label': 'Sortcode: ' + sortCodeString },
		React.createElement(
			'span',
			null,
			sortCodeString
		)
	);

	var accountNumberLabel = React.createElement(
		'div',
		{ 'aria-label': 'Account Number: ' + accountNumberString },
		React.createElement(
			'span',
			null,
			accountNumberString
		)
	);

	return React.createElement(
		StyledDetails,
		null,
		sortcodeLabel,
		accountNumberLabel
	);
};

SortCodeAndAccountNumber.propTypes = {
	/** Account number */
	accountNumber: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
	/** Account sort code */
	sortCode: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired
};

SortCodeAndAccountNumber.defaultProps = {};

var _templateObject$n = taggedTemplateLiteral(['\n\t', ';\n\t', ';\n\n\t@media print {\n\t\tmargin-right: ', ';\n\t}\n'], ['\n\t', ';\n\t', ';\n\n\t@media print {\n\t\tmargin-right: ', ';\n\t}\n']),
    _templateObject2$a = taggedTemplateLiteral(['\n\tdisplay: flex;\n\tflex-direction: column;\n'], ['\n\tdisplay: flex;\n\tflex-direction: column;\n']),
    _templateObject3$7 = taggedTemplateLiteral(['\n\tmargin-bottom: ', ';\n'], ['\n\tmargin-bottom: ', ';\n']);

var StyledAccountNumber = styled('div')(_templateObject$n, function (props) {
	return !props.isListView && 'margin-bottom: ' + spacing.HALF + ';';
}, function (props) {
	return props.isListView && 'margin-right: ' + spacing.DOUBLE + ';';
}, spacing.DOUBLE);

var StyledDebitDetails = styled('div')(_templateObject2$a);

var StyledSortCodeAndAccountNumber = styled('span')(_templateObject3$7, spacing.SINGLE);

var InternalAccountNumberValue = function InternalAccountNumberValue(_ref) {
	var accountNumber = _ref.accountNumber,
	    cardNumber = _ref.cardNumber,
	    cardType = _ref.cardType,
	    IBAN = _ref.IBAN,
	    sortCode = _ref.sortCode,
	    imageInfo = _ref.imageInfo,
	    dataTestId = _ref['data-test-id'],
	    theme = _ref.theme,
	    viewType = _ref.viewType;

	var accountNumberData = '';

	var LAST_FOUR_DIGITS = 4;

	switch (cardType) {
		case 'account':
			if (accountNumber !== undefined) {
				accountNumberData = React.createElement(SortCodeAndAccountNumber, { accountNumber: accountNumber, sortCode: sortCode });
			}
			break;
		case 'credit':
			accountNumberData = React.createElement(
				'span',
				null,
				BankingUtils.cardNumberFormat(cardNumber)
			);
			break;
		case 'debit':
			if (cardNumber.toString().length === LAST_FOUR_DIGITS) {
				accountNumberData = React.createElement(
					StandardLabel,
					null,
					'Card Ending ',
					cardNumber
				);
			} else {
				accountNumberData = React.createElement(
					'span',
					null,
					BankingUtils.cardNumberFormat(cardNumber)
				);
			}
			if (accountNumber !== undefined) {
				accountNumberData = React.createElement(
					StyledDebitDetails,
					null,
					React.createElement(
						StyledSortCodeAndAccountNumber,
						null,
						React.createElement(SortCodeAndAccountNumber, { accountNumber: accountNumber, sortCode: sortCode })
					),
					accountNumberData
				);
			}
			break;
		case 'international':
			accountNumberData = React.createElement(
				'span',
				null,
				IBAN
			);
			break;
		default:
			accountNumberData = '';
	}

	var accountNumberDataFont = theme.components.accountCardBase.fonts.accountNumberData;

	return React.createElement(
		StyledAccountNumber,
		{ isListView: viewType === 'list', 'data-test-id': dataTestId },
		accountNumberDataFont(imageInfo !== undefined, React.createElement(
			'span',
			null,
			accountNumberData
		))
	);
};

InternalAccountNumberValue.propTypes = {
	/** Account number. */
	accountNumber: PropTypes.number,
	/** Credit card number. */
	cardNumber: PropTypes.number,
	/** The type of card - used to determine what account number format. */
	cardType: PropTypes.oneOf(['account', 'credit', 'debit', 'international']).isRequired,
	/** International Bank Account Number (IBAN). */
	IBAN: PropTypes.string,
	/** Account sort code. */
	sortCode: PropTypes.number,
	/** Holds what view type. */
	viewType: PropTypes.oneOf(['grid', 'list']),
	/** Partial Data attribute targeting accountCard for automation test purposes - appended by internal components. */
	'data-test-id': PropTypes.string
};

InternalAccountNumberValue.defaultProps = {
	viewType: 'grid'
};

var WrappedInternalAccountNumberValue = withTheme(InternalAccountNumberValue);

var main$c = "MoneyValue.js";
var variants$2 = ["PoundsOnly", "WithPence"];
var packageJson$c = {
	main: main$c,
	variants: variants$2,
	"component-id": null,
	"component-life-cycle": "active",
	"is-bespoke": false
};

var moneyFormatter$1 = regexes.moneyFormatter;


var PoundsOnly = function PoundsOnly(_ref) {
	var balance = _ref.balance;
	return React.createElement(
		InternalComponentFrame,
		{ isFlush: true, layout: 'inline', packageJson: packageJson$c },
		React.createElement(
			'span',
			null,
			(balance < 0 ? '-' : '') + '\xA3' + Math.abs(balance).toString().replace(moneyFormatter$1, ',')
		)
	);
};

PoundsOnly.propTypes = {
	/** Balance to be formatted and displayed, as a number. */
	balance: PropTypes.number.isRequired
};

PoundsOnly.defaultProps = {};

var moneyFormatter$2 = regexes.moneyFormatter;

var PENCE_DIVIDER$1 = 100;

var WithPence = function WithPence(_ref) {
	var balance = _ref.balance;
	return React.createElement(
		InternalComponentFrame,
		{ isFlush: true, layout: 'inline', packageJson: packageJson$c },
		React.createElement(
			'span',
			null,
			(balance < 0 ? '-' : '') + '\xA3' + (Math.abs(balance) / PENCE_DIVIDER$1).toFixed(2).toString().replace(moneyFormatter$2, ',')
		)
	);
};

WithPence.propTypes = {
	/** Balance to be formatted and displayed, as a number. */
	balance: PropTypes.number.isRequired
};

WithPence.defaultProps = {};

var MoneyValue = {
	PoundsOnly: PoundsOnly,
	WithPence: WithPence
};

var _templateObject$o = taggedTemplateLiteral(['\n\t@media screen {\n\t\t', ';\n\n\t\t', ';\n\t}\n\n\t@media print {\n\t\tflex-grow: 0;\n\t\tmin-width: 10%;\n\t}\n'], ['\n\t@media screen {\n\t\t', ';\n\n\t\t', ';\n\t}\n\n\t@media print {\n\t\tflex-grow: 0;\n\t\tmin-width: 10%;\n\t}\n']),
    _templateObject2$b = taggedTemplateLiteral(['\n\t', ';\n\t', ';\n\n\t@media print {\n\t\tmargin-bottom: ', ';\n\t}\n'], ['\n\t', ';\n\t', ';\n\n\t@media print {\n\t\tmargin-bottom: ', ';\n\t}\n']),
    _templateObject3$8 = taggedTemplateLiteral(['\n\tflex-basis: 100%;\n\theight: 0;\n'], ['\n\tflex-basis: 100%;\n\theight: 0;\n']);

var StyledBalanceWrapper = styled('div')(_templateObject$o, function (props) {
	return !props.isListView && '\n\t\t\talign-items: flex-end;\n\t\t\tdisplay: flex;\n\t\t\tflex-grow: 1;\n\t\t\tflex-wrap: wrap;\n\t\t\talign-content: flex-end;\n\t\t';
}, function (props) {
	return props.isListView && 'flex-grow: 0';
});

var StyledBalance = styled('div')(_templateObject2$b, function (props) {
	return !props.isListView && 'margin-bottom: ' + spacing.SINGLE + ';';
}, function (props) {
	return props.isListView && 'margin-right: ' + spacing.DOUBLE + '; width: 190px';
}, spacing.SINGLE);

var StyledBalanceBreak = styled('div')(_templateObject3$8);

var InternalBalanceValue = function InternalBalanceValue(_ref) {
	var viewType = _ref.viewType,
	    balance = _ref.balance,
	    internationalBalance = _ref.internationalBalance,
	    availableBalance = _ref.availableBalance,
	    availableInternationalBalance = _ref.availableInternationalBalance,
	    dataTestId = _ref['data-test-id'];
	return React.createElement(
		StyledBalanceWrapper,
		{ isListView: viewType === 'list' },
		internationalBalance && React.createElement(
			StyledBalance,
			{ isListView: viewType === 'list', 'data-test-id': dataTestId + '-internationalBalance' },
			React.createElement(
				ProminentLabel,
				{ isFlush: true },
				internationalBalance
			)
		),
		React.createElement(StyledBalanceBreak, null),
		!internationalBalance && typeof balance === 'number' && React.createElement(
			StyledBalance,
			{ isListView: viewType === 'list', 'data-test-id': dataTestId + '-balance' },
			React.createElement(
				ProminentLabel,
				{ isFlush: true },
				React.createElement(MoneyValue.WithPence, { balance: balance })
			)
		),
		React.createElement(StyledBalanceBreak, null),
		availableInternationalBalance && React.createElement(
			StyledBalance,
			{ isListView: viewType === 'list', 'data-test-id': dataTestId + '-availableInternationalBalance' },
			React.createElement(
				SubBody,
				{ isFlush: true },
				availableInternationalBalance,
				' available'
			)
		),
		React.createElement(StyledBalanceBreak, null),
		!availableInternationalBalance && typeof availableBalance === 'number' && React.createElement(
			StyledBalance,
			{ isListView: viewType === 'list', 'data-test-id': dataTestId + '-availableBalance' },
			React.createElement(
				SubBody,
				{ isFlush: true },
				React.createElement(MoneyValue.WithPence, { balance: availableBalance })
			)
		)
	);
};

InternalBalanceValue.propTypes = {
	/** The available balance of the account in pence. */
	availableBalance: PropTypes.number,
	/** Provide an available international balance as string. Overrides availableBalance prop. */
	availableInternationalBalance: PropTypes.string,
	/** The balance of the account in pence. */
	balance: PropTypes.number,
	/** Provide an international balance as string. Overrides balance prop. */
	internationalBalance: PropTypes.string,
	/** Holds what view type. */
	viewType: PropTypes.oneOf(['grid', 'list']),
	/** Partial Data attribute targeting accountCard for automation test purposes - appended by internal components. */
	'data-test-id': PropTypes.string
};

var _templateObject$p = taggedTemplateLiteral(['\n\talign-items: center;\n\tbackground: none;\n\tborder: none;\n\tborder-top-right-radius: ', ';\n\tborder-bottom-left-radius: ', ';\n\t', ' display: flex;\n\theight: ', ';\n\tjustify-content: center;\n\tpadding: 0;\n\tposition: absolute;\n\ttop: 2px;\n\tright: 2px;\n\twidth: 48px;\n\t', ' svg {\n\t\twidth: 24px;\n\t\theight: 24px;\n\t\tstroke: ', ';\n\t\tfill: ', ';\n\t\t', ';\n\t}\n\n\t:hover {\n\t\tsvg {\n\t\t\tstroke: gold;\n\t\t}\n\t}\n\n\t:focus {\n\t\tsvg {\n\t\t\tstroke: gold;\n\t\t}\n\t}\n'], ['\n\talign-items: center;\n\tbackground: none;\n\tborder: none;\n\tborder-top-right-radius: ', ';\n\tborder-bottom-left-radius: ', ';\n\t', ' display: flex;\n\theight: ', ';\n\tjustify-content: center;\n\tpadding: 0;\n\tposition: absolute;\n\ttop: 2px;\n\tright: 2px;\n\twidth: 48px;\n\t', ' svg {\n\t\twidth: 24px;\n\t\theight: 24px;\n\t\tstroke: ', ';\n\t\tfill: ', ';\n\t\t', ';\n\t}\n\n\t:hover {\n\t\tsvg {\n\t\t\tstroke: gold;\n\t\t}\n\t}\n\n\t:focus {\n\t\tsvg {\n\t\t\tstroke: gold;\n\t\t}\n\t}\n']);

var starBorderRadius = function starBorderRadius(outerBorderRadius) {
	return 'calc(' + outerBorderRadius + ' - 2px)';
};

var StyledFavButton = styled('button')(_templateObject$p, function (props) {
	return starBorderRadius(props.theme.borderRadiusLarger);
}, function (props) {
	return starBorderRadius(props.theme.borderRadiusLarger);
}, function (props) {
	return props.isListView && '\n\t\tborder-bottom-right-radius: ' + starBorderRadius(props.theme.borderRadiusLarger) + ';\n\t\tborder-bottom-left-radius: 0;\n\t';
}, function (props) {
	return props.isListView ? 'calc(100% - 4px)' : '48px';
}, function (props) {
	return props.isListView && 'top: 50%; transform: translateY(-50%);';
}, colours.generalPalette.greyLighter, colours.generalPalette.white, function (props) {
	return props.setAsFavourite && 'stroke: gold; fill: gold;';
});

var InternalFavouriteButton = function InternalFavouriteButton(_ref) {
	var viewType = _ref.viewType,
	    onClick = _ref.onClick,
	    setAsFavourite = _ref.setAsFavourite;
	return React.createElement(
		StyledFavButton,
		{ isListView: viewType === 'list', onClick: onClick, setAsFavourite: setAsFavourite },
		React.createElement(FavouriteIcon, null),
		React.createElement(
			VisuallyHiddenBody,
			null,
			'Set account as favourite'
		)
	);
};

InternalFavouriteButton.propTypes = {
	/** Holds whether the account is currently favourited. */
	isFavourite: PropTypes.bool,
	/** Callback function triggered on click. */
	onClick: PropTypes.func.isRequired,
	/** Holds what view type. */
	viewType: PropTypes.oneOf(['grid', 'list'])
};

var _templateObject$q = taggedTemplateLiteral(['\n\t', ';\n\n\t', ';\n\n\t@media print {\n\t\t', ';\n\t\twidth: 30%;\n\t}\n'], ['\n\t', ';\n\n\t', ';\n\n\t@media print {\n\t\t', ';\n\t\twidth: 30%;\n\t}\n']);

var listProductNickNameStyles = '\n\tmargin-right: ' + spacing.DOUBLE + ';\n\t> div {\n\t\tmargin: 0;\n\t}\n';

var StyledProductNameOrNickname = styled('div')(_templateObject$q, function (props) {
	return !props.isListView && '\n\t\tmargin-bottom: ' + spacing.SINGLE + ';\n\t\t@media (min-width: ' + breakpoints.md1 + ') {\n\t\t\tmin-height: ' + (props.hasImageInfo ? '94' : '0') + 'px;\n\t\t}\n\t';
}, function (props) {
	return props.isListView && listProductNickNameStyles + '\n\t\twidth: 100%;\n\n\t\t@media (min-width: ' + breakpoints.md2 + ') {\n\t\t\twidth: 30%;\n\t\t}';
}, listProductNickNameStyles);

var InternalProductNameOrNicknameValue = function InternalProductNameOrNicknameValue(_ref) {
	var imageInfo = _ref.imageInfo,
	    productNameOrNickname = _ref.productNameOrNickname,
	    dataTestId = _ref['data-test-id'],
	    theme = _ref.theme,
	    viewType = _ref.viewType;

	var productNameOrNicknameFont = theme.components.accountCardBase.fonts.productNameOrNickname;

	return React.createElement(
		StyledProductNameOrNickname,
		{
			hasImageInfo: imageInfo !== undefined,
			isListView: viewType === 'list',
			'data-test-id': dataTestId
		},
		React.createElement(
			Identifier.Breaking,
			null,
			productNameOrNicknameFont(React.createElement(
				'span',
				null,
				productNameOrNickname
			))
		)
	);
};

InternalProductNameOrNicknameValue.propTypes = {
	/* Card image information. */
	imageInfo: PropTypes.shape({
		/** Card brand. */
		brandId: PropTypes.oneOf(['cb', 'yb', 'vm']).isRequired,
		/** Image type. Used in the aria-label. */
		cardStatus: PropTypes.oneOf(['active', 'deactivated', 'frozen']).isRequired,
		/** Image url. */
		imageUrl: PropTypes.string.isRequired
	}),
	/** The product name. */
	productNameOrNickname: PropTypes.string,
	/** Partial Data attribute targeting accountCard for automation test purposes - appended by internal components. */
	'data-test-id': PropTypes.string,
	/** Holds what view type. */
	viewType: PropTypes.oneOf(['grid', 'list'])
};

var WrappedInternalProductNameOrNicknameValue = withTheme(InternalProductNameOrNicknameValue);

var _templateObject$r = taggedTemplateLiteral(['\n\tdisplay: flex;\n\tposition: relative;\n\n\t', ';\n\n\t@media print {\n\t\t', ';\n\t}\n'], ['\n\tdisplay: flex;\n\tposition: relative;\n\n\t', ';\n\n\t@media print {\n\t\t', ';\n\t}\n']),
    _templateObject2$c = taggedTemplateLiteral(['\n\t@media (min-width: ', '), print {\n\t\tdisplay: flex;\n\t}\n\twidth: 100%;\n\t', ';\n\t', ';\n\t', ';\n\t', ';\n\n\t@media print {\n\t\t', ';\n\t}\n'], ['\n\t@media (min-width: ', '), print {\n\t\tdisplay: flex;\n\t}\n\twidth: 100%;\n\t', ';\n\t', ';\n\t', ';\n\t', ';\n\n\t@media print {\n\t\t', ';\n\t}\n']),
    _templateObject3$9 = taggedTemplateLiteral(['\n\t', ';\n\n\t@media print {\n\t\t', ';\n\t}\n'], ['\n\t', ';\n\n\t@media print {\n\t\t', ';\n\t}\n']),
    _templateObject4$4 = taggedTemplateLiteral(['\n\tdisplay: flex;\n\tmargin-left: ', ';\n\tpointer-events: none;\n\tposition: absolute;\n\ttop: 50%;\n\ttransform: translateY(-50%);\n'], ['\n\tdisplay: flex;\n\tmargin-left: ', ';\n\tpointer-events: none;\n\tposition: absolute;\n\ttop: 50%;\n\ttransform: translateY(-50%);\n']),
    _templateObject5$3 = taggedTemplateLiteral(['\n\t', ' button {\n\t\tmargin-bottom: 0 !important;\n\t}\n'], ['\n\t', ' button {\n\t\tmargin-bottom: 0 !important;\n\t}\n']),
    _templateObject6$3 = taggedTemplateLiteral(['\n\tdisplay: none;\n\tmargin-right: ', ';\n\n\t@media (min-width: ', ') {\n\t\tdisplay: block;\n\t}\n'], ['\n\tdisplay: none;\n\tmargin-right: ', ';\n\n\t@media (min-width: ', ') {\n\t\tdisplay: block;\n\t}\n']);

var listStyles = '\n\tflex-direction: row;\n\tjustify-content: space-between;\n\talign-items: center;\n';

var listWrapperStyles = '\n\twidth: 100%;\n\tmargin-right: 0;\n\tmargin-bottom: ' + spacing.QUARTER + ';\n';

var listAccountNameStyles = 'width: 20%; margin-right: ' + spacing.DOUBLE;

var listReferenceStyles = 'overflow: hidden; width: 240px; margin-right: ' + spacing.DOUBLE;

var StyledWrapper$5 = styled('div')(_templateObject$r, function (props) {
	return props.isListView ? '' + listWrapperStyles : '\n\t\t\tmax-width: 100%;\n\t\t\twidth: ' + (props.isStatic ? 'auto' : '288px') + ';\n\t\t\t@media (min-width: ' + breakpoints.xs2 + ') {\n\t\t\t\twidth: ' + (props.isStatic ? '286px' : '405px') + '\n\t\t\t}\n\t';
}, listWrapperStyles);

var StyledCardDetails = styled('div')(_templateObject2$c, breakpoints.md2, function (props) {
	return props.hasCheckbox && 'margin-left: ' + spacing.SEXTUPLE + ';';
}, function (props) {
	return props.isListView && '\n\t\t\t@media (min-width: ' + breakpoints.md2 + ') {\n\t\t\t\t' + listStyles + '\n\t\t\t}\n\t\t';
}, function (props) {
	return !props.isListView && '\n\t\t\t@media (min-width: ' + breakpoints.md2 + ') {\n\t\t\t\tflex-direction: column;\n\t\t\t\tflex-grow: 2;\n\t\t\t\talign-self: stretch;\n\t\t\t}\n\t\t';
}, function (props) {
	return props.hasStar && 'margin-right: ' + spacing.QUADRUPLE + ';';
}, listStyles);

var StyledAccountName = styled('div')(_templateObject3$9, function (props) {
	return props.isListView ? '' + listAccountNameStyles : 'margin-bottom: ' + spacing.SINGLE;
}, listAccountNameStyles);

var StyledReference = styled('div')(_templateObject3$9, function (props) {
	return props.isListView ? '' + listReferenceStyles : 'margin-bottom: ' + spacing.DOUBLE;
}, listReferenceStyles);

var StyledCheckboxSection = styled('div')(_templateObject4$4, spacing.ONE_AND_HALF);

var StyledChildrenWrapper = styled('div')(_templateObject5$3, function (props) {
	return !props.isListView && 'margin-top: ' + spacing.SINGLE + ';';
});

var StyledCardPNG = styled('div')(_templateObject6$3, spacing.DOUBLE, breakpoints.md1);

var AccountCardBase = function AccountCardBase(_ref) {
	var accountName = _ref.accountName,
	    accountNumber = _ref.accountNumber,
	    availableBalance = _ref.availableBalance,
	    availableInternationalBalance = _ref.availableInternationalBalance,
	    balance = _ref.balance,
	    cardNumber = _ref.cardNumber,
	    cardType = _ref.cardType,
	    children = _ref.children,
	    IBAN = _ref.IBAN,
	    id = _ref.id,
	    imageInfo = _ref.imageInfo,
	    internationalBalance = _ref.internationalBalance,
	    isFavourite = _ref.isFavourite,
	    isSelected = _ref.isSelected,
	    isSelectable = _ref.isSelectable,
	    _onClick = _ref.onClick,
	    onFavouriteChange = _ref.onFavouriteChange,
	    productNameOrNickname = _ref.productNameOrNickname,
	    regulatoryText = _ref.regulatoryText,
	    reference = _ref.reference,
	    sortCode = _ref.sortCode,
	    dataTestId = _ref['data-test-id'],
	    isStatic = _ref.isStatic,
	    viewType = _ref.viewType;

	var getStyledCard = React.createElement(
		StyledCardDetails,
		{ hasCheckbox: isSelectable, hasStar: onFavouriteChange, isListView: viewType === 'list' },
		accountName && React.createElement(
			StyledAccountName,
			{ isListView: viewType === 'list', 'data-test-id': dataTestId + '-accountName' },
			React.createElement(
				StandardBody,
				{ isFlush: true },
				React.createElement(
					Identifier.Breaking,
					null,
					accountName
				)
			)
		),
		productNameOrNickname && React.createElement(WrappedInternalProductNameOrNicknameValue, {
			imageInfo: imageInfo,
			viewType: viewType,
			'data-test-id': dataTestId + '-productNameOrNickname',
			productNameOrNickname: productNameOrNickname
		}),
		React.createElement(WrappedInternalAccountNumberValue, {
			viewType: viewType,
			'data-test-id': dataTestId + '-accountNumberData',
			accountNumber: accountNumber,
			cardNumber: cardNumber,
			IBAN: IBAN,
			cardType: cardType,
			sortCode: sortCode
		}),
		reference && React.createElement(
			StyledReference,
			{ isListView: viewType === 'list', 'data-test-id': dataTestId + '-reference' },
			React.createElement(
				SubBody,
				{ isFlush: true },
				React.createElement(
					Identifier.Breaking,
					null,
					reference
				)
			)
		),
		React.createElement(InternalBalanceValue, {
			viewType: viewType,
			balance: balance,
			internationalBalance: internationalBalance,
			availableBalance: availableBalance,
			availableInternationalBalance: availableInternationalBalance,
			'data-test-id': dataTestId
		}),
		regulatoryText && React.createElement(
			SmallestBody,
			{ isFlush: true, 'data-test-id': dataTestId + '-regulatoryText' },
			React.createElement(
				'span',
				null,
				regulatoryText
			)
		),
		children && React.createElement(
			StyledChildrenWrapper,
			{ isListView: viewType === 'list', 'data-test-id': dataTestId + '-children' },
			children
		)
	);

	var getInternalAccountCardButton = React.createElement(
		InternalAccountCardButton,
		{ imageInfo: imageInfo, onClick: function onClick() {
				return _onClick(id);
			}, chosen: isSelected },
		imageInfo && React.createElement(
			StyledCardPNG,
			null,
			React.createElement(InternalPlaceholderCard, { height: 94, imageInfo: imageInfo, width: 150 })
		),
		getStyledCard
	);

	var getInternalAccountCard = React.createElement(
		InternalAccountCard,
		{ imageInfo: imageInfo },
		imageInfo && React.createElement(
			StyledCardPNG,
			null,
			React.createElement(InternalPlaceholderCard, { height: 94, imageInfo: imageInfo, width: 150 })
		),
		getStyledCard
	);

	var getAccountCardType = isStatic ? getInternalAccountCard : getInternalAccountCardButton;

	var getLabel = function getLabel() {
		return (accountName || productNameOrNickname) && React.createElement(
			VisuallyHiddenBody,
			null,
			accountName,
			' ',
			productNameOrNickname
		);
	};

	return React.createElement(
		StyledWrapper$5,
		{ isListView: viewType === 'list', isStatic: isStatic, 'data-test-id': dataTestId + '-container' },
		isSelectable && React.createElement(
			StyledCheckboxSection,
			null,
			React.createElement(InternalCheckbox.Default, {
				isChecked: isSelected,
				id: id,
				label: getLabel(),
				onChange: function onChange() {
					return _onClick(id);
				},
				name: id,
				'data-test-id': dataTestId + '-checkbox'
			})
		),
		getAccountCardType,
		onFavouriteChange && React.createElement(
			InternalFavouriteButton,
			{
				viewType: viewType,
				onClick: function onClick() {
					return onFavouriteChange(id);
				},
				setAsFavourite: isFavourite,
				'data-test-id': dataTestId + '-favouriteButton'
			},
			React.createElement(FavouriteIcon, null)
		)
	);
};

AccountCardBase.propTypes = {
	/** Account name. */
	accountName: PropTypes.string,
	/** Account number. */
	accountNumber: PropTypes.number,
	/** The available balance of the account in pence. */
	availableBalance: PropTypes.number,
	/** Provide an available international balance as string. Overrides availableBalance prop. */
	availableInternationalBalance: PropTypes.string,
	/** The balance of the account in pence. */
	balance: PropTypes.number,
	/** Credit card number. */
	cardNumber: PropTypes.number,
	/** The type of card - used to determine what account number format. */
	cardType: PropTypes.oneOf(['account', 'credit', 'debit', 'international']).isRequired,
	/** Child content as nodes. */
	children: PropTypes.node,
	/** International Bank Account Number (IBAN). */
	IBAN: PropTypes.string,
	/** An id for the card.  Must be unique on any individual page. */
	id: PropTypes.string.isRequired,
	/* Card image information. */
	imageInfo: PropTypes.shape({
		/** Card brand. */
		brandId: PropTypes.oneOf(['cb', 'yb', 'vm']).isRequired,
		/** Image type. Used in the aria-label. */
		cardStatus: PropTypes.oneOf(['active', 'deactivated', 'frozen']).isRequired,
		/** Image url. */
		imageUrl: PropTypes.string.isRequired
	}),
	/** Provide an international balance as string. Overrides balance prop. */
	internationalBalance: PropTypes.string,
	/** Holds whether the account is currently favourited. */
	isFavourite: PropTypes.bool,
	/** Holds whether the card has a checkbox. */
	isSelectable: PropTypes.bool,
	/** Callback function invoked when the card is clicked .*/
	isSelected: PropTypes.bool,
	/** Callback function triggered on click. */
	onClick: PropTypes.func,
	/** Callback function invoked when favourite button is clicked. */
	onFavouriteChange: PropTypes.func,
	/** The product name. */
	productNameOrNickname: PropTypes.string,
	/** Reference value. */
	reference: PropTypes.string,
	/** Regulatory text to display at the bottom of the card. */
	regulatoryText: PropTypes.string,
	/** Account sort code. */
	sortCode: PropTypes.number,
	/** Holds what view type. */
	viewType: PropTypes.oneOf(['grid', 'list']),
	/** Partial Data attribute targeting accountCard for automation test purposes - appended by internal components. */
	'data-test-id': PropTypes.string
};

AccountCardBase.defaultProps = {
	isFavourite: false
};

var WrappedAccountCardBase = withTheme(AccountCardBase);

var main$d = "AccountCheckboxCard.js";
var variants$3 = ["BankAccount", "CreditCard", "International"];
var packageJson$d = {
	main: main$d,
	variants: variants$3,
	"component-id": null,
	"component-life-cycle": "active",
	"is-bespoke": true
};

var baseProps$2 = {
	/** Account name (used in Large Customer Views). */
	accountName: PropTypes.string,
	/** The balance of the account in pence. */
	balance: PropTypes.number,
	/** Unique card id. */
	id: PropTypes.string.isRequired,
	/** Set to true when card is favourited. */
	isFavourite: PropTypes.bool,
	/** Set to true when card is selected. */
	isSelected: PropTypes.bool,
	/** Callback function triggered on click. */
	onClick: PropTypes.func.isRequired,
	/** Callback function invoked when favourite button is clicked. */
	onFavouriteChange: PropTypes.func,
	/** The product name. */
	productNameOrNickname: PropTypes.string.isRequired,
	/** Reference value. */
	reference: PropTypes.string,
	/** Changes the view type. */
	viewType: PropTypes.oneOf(['grid', 'list']),
	/** Partial Data attribute targeting accountCheckboxCard for automation test purposes - appended by internal components. */
	'data-test-id': PropTypes.string
};

var baseDefaults = {
	isFavourite: false,
	isSelected: false,
	'data-test-id': 'account-checkbox-card'
};

var BankAccount = function BankAccount(_ref) {
	var accountName = _ref.accountName,
	    accountNumber = _ref.accountNumber,
	    balance = _ref.balance,
	    id = _ref.id,
	    isFavourite = _ref.isFavourite,
	    isSelected = _ref.isSelected,
	    onClick = _ref.onClick,
	    onFavouriteChange = _ref.onFavouriteChange,
	    productNameOrNickname = _ref.productNameOrNickname,
	    reference = _ref.reference,
	    sortCode = _ref.sortCode,
	    viewType = _ref.viewType,
	    dataTestId = _ref['data-test-id'];
	return React.createElement(
		InternalComponentFrame,
		{ variant: 'BankAccount', packageJson: packageJson$d },
		React.createElement(WrappedAccountCardBase, {
			accountName: accountName,
			accountNumber: accountNumber,
			balance: balance,
			cardType: 'account',
			id: id,
			isFavourite: isFavourite,
			isSelectable: true,
			isSelected: isSelected,
			onClick: onClick,
			onFavouriteChange: onFavouriteChange,
			productNameOrNickname: productNameOrNickname,
			reference: reference,
			sortCode: sortCode,
			viewType: viewType,
			'data-test-id': dataTestId
		})
	);
};

BankAccount.propTypes = _extends({}, baseProps$2, {
	/** Account number */
	accountNumber: PropTypes.number.isRequired,
	/** Account sort code */
	sortCode: PropTypes.number.isRequired
});

BankAccount.defaultProps = baseDefaults;

var CreditCard = function CreditCard(_ref2) {
	var accountName = _ref2.accountName,
	    balance = _ref2.balance,
	    cardNumber = _ref2.cardNumber,
	    id = _ref2.id,
	    isFavourite = _ref2.isFavourite,
	    isSelected = _ref2.isSelected,
	    onClick = _ref2.onClick,
	    onFavouriteChange = _ref2.onFavouriteChange,
	    productNameOrNickname = _ref2.productNameOrNickname,
	    reference = _ref2.reference,
	    viewType = _ref2.viewType,
	    dataTestId = _ref2['data-test-id'];
	return React.createElement(
		InternalComponentFrame,
		{ variant: 'CreditCard', packageJson: packageJson$d },
		React.createElement(WrappedAccountCardBase, {
			accountName: accountName,
			balance: balance,
			cardNumber: cardNumber,
			cardType: 'credit',
			id: id,
			isFavourite: isFavourite,
			isSelectable: true,
			isSelected: isSelected,
			onClick: onClick,
			onFavouriteChange: onFavouriteChange,
			productNameOrNickname: productNameOrNickname,
			reference: reference,
			viewType: viewType,
			'data-test-id': dataTestId
		})
	);
};

CreditCard.propTypes = _extends({}, baseProps$2, {
	/** Credit card number */
	cardNumber: PropTypes.number.isRequired
});

CreditCard.defaultProps = baseDefaults;

var International = function International(_ref3) {
	var accountName = _ref3.accountName,
	    balance = _ref3.balance,
	    IBAN = _ref3.IBAN,
	    id = _ref3.id,
	    isFavourite = _ref3.isFavourite,
	    isSelected = _ref3.isSelected,
	    onClick = _ref3.onClick,
	    onFavouriteChange = _ref3.onFavouriteChange,
	    productNameOrNickname = _ref3.productNameOrNickname,
	    reference = _ref3.reference,
	    viewType = _ref3.viewType,
	    dataTestId = _ref3['data-test-id'];
	return React.createElement(
		InternalComponentFrame,
		{ variant: 'International', packageJson: packageJson$d },
		React.createElement(WrappedAccountCardBase, {
			accountName: accountName,
			balance: balance,
			cardType: 'international',
			id: id,
			isFavourite: isFavourite,
			isSelectable: true,
			isSelected: isSelected,
			IBAN: IBAN,
			onClick: onClick,
			onFavouriteChange: onFavouriteChange,
			productNameOrNickname: productNameOrNickname,
			reference: reference,
			viewType: viewType,
			'data-test-id': dataTestId
		})
	);
};

International.propTypes = _extends({}, baseProps$2, {
	/** International Bank Account Number (IBAN) */
	IBAN: PropTypes.string.isRequired
});

International.defaultProps = baseDefaults;

var AccountCheckboxCard = {
	BankAccount: BankAccount,
	CreditCard: CreditCard,
	International: International
};

var getCardHoverStyles = function getCardHoverStyles(theme) {
  return ':hover {\n\t\tborder-color: ' + theme.colours.interaction + ';\n\t}';
};

var getCardStripeStyles = function getCardStripeStyles(theme) {
  return '&:before {\n        background: ' + theme.colours.interaction + ';\n        border-bottom-left-radius: ' + theme.borderRadiusLarger + ';\n        border-top-left-radius: ' + theme.borderRadiusLarger + ';\n        content: \'\';\n        display: block;\n        height: calc(100% + 2px);\n        left: -1px;\n        position: absolute;\n        top: -1px;\n        width: ' + theme.styles.stripeWidth + ';\n    }';
};

var main$e = "AccountLegacyUpdateCard.js";
var packageJson$e = {
	main: main$e,
	"component-id": null,
	"component-life-cycle": "outdated",
	"is-bespoke": true
};

var _templateObject$s = taggedTemplateLiteral(['\n\tborder-radius: ', ';\n\tpadding: ', ';\n\tpadding-bottom: ', ';\n\ttext-align: left;\n\n\t', ';\n'], ['\n\tborder-radius: ', ';\n\tpadding: ', ';\n\tpadding-bottom: ', ';\n\ttext-align: left;\n\n\t', ';\n']),
    _templateObject2$d = taggedTemplateLiteral(['\n\tmargin-bottom: ', ';\n'], ['\n\tmargin-bottom: ', ';\n']),
    _templateObject3$a = taggedTemplateLiteral(['\n\tbottom: ', ';\n\tdisplay: inline-flex;\n\tposition: absolute;\n\tleft: ', ';\n'], ['\n\tbottom: ', ';\n\tdisplay: inline-flex;\n\tposition: absolute;\n\tleft: ', ';\n']),
    _templateObject4$5 = taggedTemplateLiteral(['\n\tdisplay: inline-flex;\n\tpadding-left: ', ';\n'], ['\n\tdisplay: inline-flex;\n\tpadding-left: ', ';\n']),
    _templateObject5$4 = taggedTemplateLiteral(['\n\tdisplay: inline-flex;\n\tpadding-right: ', ';\n'], ['\n\tdisplay: inline-flex;\n\tpadding-right: ', ';\n']),
    _templateObject6$4 = taggedTemplateLiteral(['\n\tcolor: ', ';\n\tdisplay: inline-flex;\n\ttext-decoration: ', ';\n\twhite-space: nowrap;\n\n\t:hover {\n\t\ttext-decoration: underline;\n\t}\n'], ['\n\tcolor: ', ';\n\tdisplay: inline-flex;\n\ttext-decoration: ', ';\n\twhite-space: nowrap;\n\n\t:hover {\n\t\ttext-decoration: underline;\n\t}\n']),
    _templateObject7$2 = taggedTemplateLiteral(['\n\talign-items: center;\n\tbackground: none;\n\tborder: none;\n\tborder-top-right-radius: ', ';\n\tborder-bottom-left-radius: ', ';\n\tdisplay: flex;\n\theight: 48px;\n\tjustify-content: center;\n\tpadding: 0;\n\tposition: absolute;\n\ttop: 1px;\n\tright: 1px;\n\twidth: 48px;\n\t', ';\n\n\tsvg {\n\t\twidth: 24px;\n\t\theight: 24px;\n\t\tstroke: ', ';\n\t\tfill: ', ';\n\t\t', ';\n\t}\n\n\t:hover {\n\t\tsvg {\n\t\t\tstroke: gold;\n\t\t}\n\t}\n\n\t:focus {\n\t\tsvg {\n\t\t\tstroke: gold;\n\t\t}\n\t}\n'], ['\n\talign-items: center;\n\tbackground: none;\n\tborder: none;\n\tborder-top-right-radius: ', ';\n\tborder-bottom-left-radius: ', ';\n\tdisplay: flex;\n\theight: 48px;\n\tjustify-content: center;\n\tpadding: 0;\n\tposition: absolute;\n\ttop: 1px;\n\tright: 1px;\n\twidth: 48px;\n\t', ';\n\n\tsvg {\n\t\twidth: 24px;\n\t\theight: 24px;\n\t\tstroke: ', ';\n\t\tfill: ', ';\n\t\t', ';\n\t}\n\n\t:hover {\n\t\tsvg {\n\t\t\tstroke: gold;\n\t\t}\n\t}\n\n\t:focus {\n\t\tsvg {\n\t\t\tstroke: gold;\n\t\t}\n\t}\n']),
    _templateObject8$1 = taggedTemplateLiteral(['\n\tbackground-color: ', ';\n\tborder: ', ';\n\tborder-radius: ', ';\n\tbox-shadow: ', ';\n\tcolor: ', ';\n\tdisplay: flex;\n\tflex-direction: column;\n\tposition: relative;\n'], ['\n\tbackground-color: ', ';\n\tborder: ', ';\n\tborder-radius: ', ';\n\tbox-shadow: ', ';\n\tcolor: ', ';\n\tdisplay: flex;\n\tflex-direction: column;\n\tposition: relative;\n']);

var StyledAccountCard$1 = styled('button')(_templateObject$s, function (props) {
	return props.theme.borderRadiusLarger;
}, function (props) {
	return props.theme.components.accountLegacyUpdateCard.root.padding;
}, function (props) {
	return props.theme.components.accountLegacyUpdateCard.root.buttonSpacer;
}, function (props) {
	return props.theme.name === 'vm' && getCardStripeStyles(props.theme);
});

var StyledAccountName$1 = styled('div')(_templateObject2$d, function (props) {
	return props.theme.components.accountLegacyUpdateCard.root.marginBottom;
});

var StyledAccountDetails = styled('div')(_templateObject2$d, function (props) {
	return props.theme.components.accountLegacyUpdateCard.root.marginBottomLarger;
});

var StyledAccountReference = styled('div')(_templateObject2$d, function (props) {
	return props.theme.components.accountLegacyUpdateCard.root.marginBottom;
});

var StyledAnchorGroup = styled('div')(_templateObject3$a, function (props) {
	return props.theme.components.accountLegacyUpdateCard.root.buttonBottom;
}, function (props) {
	return props.theme.components.accountLegacyUpdateCard.root.buttonLeft;
});

var StyledDelete = styled('div')(_templateObject4$5, spacing.SINGLE);

var StyledEdit = styled('div')(_templateObject5$4, spacing.SINGLE);

var StyledButton$1 = styled('button')(_templateObject6$4, function (props) {
	return props.theme.colours.primary;
}, function (props) {
	return props.theme.components.accountLegacyUpdateCard.root.textDecoration;
});

var starBorderRadius$1 = function starBorderRadius(outerBorderRadius) {
	return 'calc(' + outerBorderRadius + ' - 3px)';
};

var StyledFavButton$1 = styled('button')(_templateObject7$2, function (props) {
	return starBorderRadius$1(props.theme.borderRadiusLarger);
}, function (props) {
	return starBorderRadius$1(props.theme.borderRadiusLarger);
}, function (props) {
	return props.isListView && 'top: 50%; transform: translateY(-50%);';
}, colours.generalPalette.greyLighter, colours.generalPalette.white, function (props) {
	return props.setAsFavourite && 'stroke: gold; fill: gold;';
});

var StyledWrapper$6 = styled('div')(_templateObject8$1, colours.component.background, function (props) {
	return props.theme.components.accountLegacyUpdateCard.root.border;
}, function (props) {
	return props.theme.borderRadiusLarger;
}, function (props) {
	return props.theme.boxShadow;
}, function (props) {
	return props.theme.colours.bodyText;
});

var AccountLegacyUpdateCard = function AccountLegacyUpdateCard(_ref) {
	var accountHolder = _ref.accountHolder,
	    accountName = _ref.accountName,
	    accountNumber = _ref.accountNumber,
	    deleteOnClick = _ref.deleteOnClick,
	    editOnClick = _ref.editOnClick,
	    cardOnClick = _ref.cardOnClick,
	    id = _ref.id,
	    isFavourite = _ref.isFavourite,
	    onFavouriteChange = _ref.onFavouriteChange,
	    reference = _ref.reference,
	    sortCode = _ref.sortCode,
	    theme = _ref.theme;

	var accountDetailsFont = theme.components.accountLegacyUpdateCard.fonts.accountDetails;
	var accountNameFont = theme.components.accountLegacyUpdateCard.fonts.accountName;
	var accountButtonFont = theme.components.accountLegacyUpdateCard.fonts.button;
	var transactionsFont = theme.components.accountLegacyUpdateCard.fonts.transactionReference;

	var accountNumberAsString = accountNumber !== undefined && accountNumber.toString();

	return React.createElement(
		InternalComponentFrame,
		{ packageJson: packageJson$e },
		React.createElement(
			StyledWrapper$6,
			null,
			React.createElement(
				StyledAccountCard$1,
				{ onClick: cardOnClick },
				accountHolder && React.createElement(
					StyledAccountName$1,
					null,
					accountNameFont(React.createElement(
						Identifier.Breaking,
						null,
						accountHolder
					))
				),
				accountName && React.createElement(
					StyledAccountName$1,
					null,
					accountNameFont(React.createElement(
						Identifier.Breaking,
						null,
						accountName
					))
				),
				accountNumberAsString && React.createElement(
					StyledAccountDetails,
					null,
					accountDetailsFont(React.createElement(
						'span',
						null,
						React.createElement(SortCodeAndAccountNumber, { accountNumber: accountNumber, sortCode: sortCode })
					))
				),
				reference && React.createElement(
					StyledAccountReference,
					{ 'aria-label': 'Reference: ' + reference },
					transactionsFont(React.createElement(
						Identifier.Breaking,
						null,
						reference
					))
				)
			),
			React.createElement(
				StyledAnchorGroup,
				null,
				React.createElement(
					StyledEdit,
					null,
					React.createElement(
						StyledButton$1,
						{ onClick: editOnClick },
						accountButtonFont(React.createElement(
							'span',
							null,
							'Edit'
						))
					)
				),
				React.createElement(
					StyledDelete,
					null,
					React.createElement(
						StyledButton$1,
						{ onClick: deleteOnClick },
						accountButtonFont(React.createElement(
							'span',
							null,
							'Delete'
						))
					)
				)
			),
			onFavouriteChange && React.createElement(
				StyledFavButton$1,
				{ onClick: function onClick() {
						return onFavouriteChange(id);
					}, setAsFavourite: isFavourite },
				React.createElement(FavouriteIcon, null)
			)
		)
	);
};

AccountLegacyUpdateCard.propTypes = {
	/** Account holder. */
	accountHolder: PropTypes.string,
	/** Account name. */
	accountName: PropTypes.string.isRequired,
	/** Account number. */
	accountNumber: PropTypes.number,
	/** Callback function invoked when the card is clicked. */
	cardOnClick: PropTypes.func.isRequired,
	/** Callback function invoked when the delete button is clicked. */
	deleteOnClick: PropTypes.func.isRequired,
	/** Callback function invoked when the edit button is clicked. */
	editOnClick: PropTypes.func.isRequired,
	/** Id for the card. */
	id: PropTypes.string,
	/** Holds whether the account is currently favourited. */
	isFavourite: PropTypes.bool,
	/** Callback function invoked when favourite button is clicked.
  * Setting this prop will show the favourite star button in the top right of the card.
  */
	onFavouriteChange: PropTypes.func,
	/** Transfer reference. */
	reference: PropTypes.string,
	/** Account sort code. */
	sortCode: PropTypes.number
};

AccountLegacyUpdateCard.defaultProps = {};

var WrappedAccountLegacyUpdateCard = withTheme(AccountLegacyUpdateCard);

var main$f = "AccountLinkCard.js";
var variants$4 = ["BankAccount", "CreditCard", "DebitCard", "International"];
var packageJson$f = {
	main: main$f,
	variants: variants$4,
	"component-id": null,
	"component-life-cycle": "active",
	"is-bespoke": true
};

var baseProps$3 = {
	/** Account name. */
	accountName: PropTypes.string,
	/** The available balance of the account in pence. */
	availableBalance: PropTypes.number,
	/** The available international balance of the account in pence. Overrides the availableBalance prop. */
	availableInternationalBalance: PropTypes.string,
	/** The balance of the account in pence. */
	balance: PropTypes.number,
	/** Child content as nodes. */
	children: PropTypes.node,
	/** Account id. */
	id: PropTypes.string.isRequired,
	/** Provide an international balance as string. Overrides balance prop. */
	internationalBalance: PropTypes.string,
	/** Sets whether the account is currently favourited. */
	isFavourite: PropTypes.bool,
	/** Callback function triggered on click. */
	onClick: PropTypes.func.isRequired,
	/** Callback function invoked when favourite button is clicked.
  * Setting this prop will show the favourite star button in the top right of the card.
  */
	onFavouriteChange: PropTypes.func,
	/** Product name. */
	productNameOrNickname: PropTypes.string.isRequired,
	/** Reference value. */
	reference: PropTypes.string,
	/** Regulatory text to display at the bottom of the card. */
	regulatoryText: PropTypes.string,
	/** View type. */
	viewType: PropTypes.oneOf(['grid', 'list']),
	/** Partial Data attribute targeting accountLinkCard for automation test purposes - appended by internal components. */
	'data-test-id': PropTypes.string
};

var baseDefaults$1 = {
	isFavourite: false,
	'data-test-id': 'account-link-card'
};

var BankAccount$1 = function BankAccount(_ref) {
	var accountName = _ref.accountName,
	    accountNumber = _ref.accountNumber,
	    availableBalance = _ref.availableBalance,
	    availableInternationalBalance = _ref.availableInternationalBalance,
	    balance = _ref.balance,
	    children = _ref.children,
	    id = _ref.id,
	    internationalBalance = _ref.internationalBalance,
	    isFavourite = _ref.isFavourite,
	    onClick = _ref.onClick,
	    onFavouriteChange = _ref.onFavouriteChange,
	    productNameOrNickname = _ref.productNameOrNickname,
	    reference = _ref.reference,
	    regulatoryText = _ref.regulatoryText,
	    sortCode = _ref.sortCode,
	    viewType = _ref.viewType,
	    dataTestId = _ref['data-test-id'];
	return React.createElement(
		InternalComponentFrame,
		{ variant: 'BankAccount', packageJson: packageJson$f },
		React.createElement(
			WrappedAccountCardBase,
			{
				accountName: accountName,
				accountNumber: accountNumber,
				availableBalance: availableBalance,
				availableInternationalBalance: availableInternationalBalance,
				balance: balance,
				cardType: 'account',
				id: id,
				internationalBalance: internationalBalance,
				isFavourite: isFavourite,
				onClick: onClick,
				onFavouriteChange: onFavouriteChange,
				productNameOrNickname: productNameOrNickname,
				reference: reference,
				regulatoryText: regulatoryText,
				sortCode: sortCode,
				viewType: viewType,
				'data-test-id': dataTestId
			},
			children
		)
	);
};

BankAccount$1.propTypes = _extends({}, baseProps$3, {
	/** Account number. */
	accountNumber: PropTypes.number.isRequired,
	/** Sort code. */
	sortCode: PropTypes.number.isRequired
});

BankAccount$1.defaultProps = baseDefaults$1;

var CreditCard$1 = function CreditCard(_ref2) {
	var accountName = _ref2.accountName,
	    availableBalance = _ref2.availableBalance,
	    availableInternationalBalance = _ref2.availableInternationalBalance,
	    balance = _ref2.balance,
	    cardNumber = _ref2.cardNumber,
	    children = _ref2.children,
	    id = _ref2.id,
	    internationalBalance = _ref2.internationalBalance,
	    isFavourite = _ref2.isFavourite,
	    onClick = _ref2.onClick,
	    onFavouriteChange = _ref2.onFavouriteChange,
	    productNameOrNickname = _ref2.productNameOrNickname,
	    reference = _ref2.reference,
	    regulatoryText = _ref2.regulatoryText,
	    viewType = _ref2.viewType,
	    dataTestId = _ref2['data-test-id'];
	return React.createElement(
		InternalComponentFrame,
		{ variant: 'CreditCard', packageJson: packageJson$f },
		React.createElement(
			WrappedAccountCardBase,
			{
				accountName: accountName,
				availableBalance: availableBalance,
				availableInternationalBalance: availableInternationalBalance,
				balance: balance,
				cardNumber: cardNumber,
				cardType: 'credit',
				id: id,
				internationalBalance: internationalBalance,
				isFavourite: isFavourite,
				onClick: onClick,
				onFavouriteChange: onFavouriteChange,
				productNameOrNickname: productNameOrNickname,
				reference: reference,
				regulatoryText: regulatoryText,
				viewType: viewType,
				'data-test-id': dataTestId
			},
			children
		)
	);
};

CreditCard$1.propTypes = _extends({}, baseProps$3, {
	/** Credit card number. */
	cardNumber: PropTypes.number.isRequired
});

CreditCard$1.defaultProps = baseDefaults$1;

var DebitCard = function DebitCard(_ref3) {
	var accountName = _ref3.accountName,
	    accountNumber = _ref3.accountNumber,
	    availableBalance = _ref3.availableBalance,
	    availableInternationalBalance = _ref3.availableInternationalBalance,
	    balance = _ref3.balance,
	    cardNumber = _ref3.cardNumber,
	    children = _ref3.children,
	    id = _ref3.id,
	    internationalBalance = _ref3.internationalBalance,
	    imageInfo = _ref3.imageInfo,
	    isFavourite = _ref3.isFavourite,
	    onClick = _ref3.onClick,
	    onFavouriteChange = _ref3.onFavouriteChange,
	    productNameOrNickname = _ref3.productNameOrNickname,
	    reference = _ref3.reference,
	    regulatoryText = _ref3.regulatoryText,
	    sortCode = _ref3.sortCode,
	    viewType = _ref3.viewType,
	    dataTestId = _ref3['data-test-id'];
	return React.createElement(
		InternalComponentFrame,
		{ variant: 'DebitCard', packageJson: packageJson$f },
		React.createElement(
			WrappedAccountCardBase,
			{
				accountName: accountName,
				accountNumber: accountNumber,
				availableBalance: availableBalance,
				availableInternationalBalance: availableInternationalBalance,
				balance: balance,
				cardNumber: cardNumber,
				cardType: 'debit',
				id: id,
				internationalBalance: internationalBalance,
				isFavourite: isFavourite,
				imageInfo: imageInfo,
				onClick: onClick,
				onFavouriteChange: onFavouriteChange,
				productNameOrNickname: productNameOrNickname,
				reference: reference,
				regulatoryText: regulatoryText,
				sortCode: sortCode,
				viewType: viewType,
				'data-test-id': dataTestId
			},
			children
		)
	);
};

DebitCard.propTypes = _extends({}, baseProps$3, {
	/** Account number. */
	accountNumber: PropTypes.number,
	/** Debit card number. */
	cardNumber: PropTypes.number.isRequired,
	/* Card image information. */
	imageInfo: PropTypes.shape({
		/** Card brand. */
		brandId: PropTypes.oneOf(['b', 'cb', 'yb', 'vm']).isRequired,
		/** Image type. Used in the aria-label. */
		cardStatus: PropTypes.oneOf(['active', 'deactivated', 'frozen']).isRequired,
		/** Image url. */
		imageUrl: PropTypes.string
	}),
	/** Sort code. */
	sortCode: PropTypes.number
});

DebitCard.defaultProps = baseDefaults$1;

var International$1 = function International(_ref4) {
	var accountName = _ref4.accountName,
	    availableBalance = _ref4.availableBalance,
	    availableInternationalBalance = _ref4.availableInternationalBalance,
	    balance = _ref4.balance,
	    children = _ref4.children,
	    IBAN = _ref4.IBAN,
	    id = _ref4.id,
	    internationalBalance = _ref4.internationalBalance,
	    isFavourite = _ref4.isFavourite,
	    onClick = _ref4.onClick,
	    onFavouriteChange = _ref4.onFavouriteChange,
	    productNameOrNickname = _ref4.productNameOrNickname,
	    reference = _ref4.reference,
	    regulatoryText = _ref4.regulatoryText,
	    viewType = _ref4.viewType,
	    dataTestId = _ref4['data-test-id'];
	return React.createElement(
		InternalComponentFrame,
		{ variant: 'International', packageJson: packageJson$f },
		React.createElement(
			WrappedAccountCardBase,
			{
				accountName: accountName,
				availableBalance: availableBalance,
				availableInternationalBalance: availableInternationalBalance,
				balance: balance,
				cardType: 'international',
				id: id,
				internationalBalance: internationalBalance,
				isFavourite: isFavourite,
				IBAN: IBAN,
				onClick: onClick,
				onFavouriteChange: onFavouriteChange,
				productNameOrNickname: productNameOrNickname,
				reference: reference,
				regulatoryText: regulatoryText,
				viewType: viewType,
				'data-test-id': dataTestId
			},
			children
		)
	);
};

International$1.propTypes = _extends({}, baseProps$3, {
	/** International Bank Account Number (IBAN). */
	IBAN: PropTypes.string.isRequired
});

International$1.defaultProps = baseDefaults$1;

var AccountLinkCard = {
	BankAccount: BankAccount$1,
	CreditCard: CreditCard$1,
	DebitCard: DebitCard,
	International: International$1
};

var main$g = "AccountPoolCard.js";
var packageJson$g = {
	main: main$g,
	"component-id": 1058,
	"component-life-cycle": "active",
	"is-bespoke": true
};

var _templateObject$t = taggedTemplateLiteral(['\n\tbackground: ', ';\n\tborder: 1px solid ', ';\n\tborder-left: 0 !important;\n\tborder-radius: ', ';\n\tbox-sizing: border-box;\n\tcolor: ', ';\n\tdisplay: flex;\n\tflex-direction: column;\n\tpadding: ', ' ', ' ', ' 20px;\n\tposition: relative;\n\ttext-align: left;\n\ttransition: all 0.2s ease-in-out;\n\twidth: 100%;\n\n\t', ';\n\t', ';\n'], ['\n\tbackground: ', ';\n\tborder: 1px solid ', ';\n\tborder-left: 0 !important;\n\tborder-radius: ', ';\n\tbox-sizing: border-box;\n\tcolor: ', ';\n\tdisplay: flex;\n\tflex-direction: column;\n\tpadding: ', ' ', ' ', ' 20px;\n\tposition: relative;\n\ttext-align: left;\n\ttransition: all 0.2s ease-in-out;\n\twidth: 100%;\n\n\t', ';\n\t', ';\n']),
    _templateObject2$e = taggedTemplateLiteral(['\n\tmargin-bottom: ', ';\n'], ['\n\tmargin-bottom: ', ';\n']),
    _templateObject3$b = taggedTemplateLiteral([''], ['']);

var StyledButton$2 = styled('button')(_templateObject$t, colours.component.background, colours.component.border, function (props) {
	return props.theme.borderRadiusLarger;
}, function (props) {
	return props.theme.bodyColour;
}, spacing.DOUBLE, spacing.DOUBLE, spacing.DOUBLE, function (props) {
	return getCardHoverStyles(props.theme);
}, function (props) {
	return getCardStripeStyles(props.theme);
});

var StyledAccountCount = styled('div')(_templateObject2$e, spacing.TRIPLE);

var StyledCurrencyCode = styled('div')(_templateObject3$b);

var StyledNotionalCurrency = styled('div')(_templateObject3$b);

var StyledPoolName = styled('div')(_templateObject2$e, spacing.SINGLE);

var AccountPoolCard = function AccountPoolCard(_ref) {
	var accountCount = _ref.accountCount,
	    currencyCode = _ref.currencyCode,
	    onClick = _ref.onClick,
	    poolName = _ref.poolName;
	return React.createElement(
		InternalComponentFrame,
		{ packageJson: packageJson$g },
		React.createElement(
			StyledButton$2,
			{ onClick: onClick, type: 'button' },
			React.createElement(
				StyledPoolName,
				null,
				React.createElement(
					ProminentLabel,
					{ isFlush: true },
					React.createElement(
						'span',
						null,
						poolName
					)
				)
			),
			React.createElement(
				StyledAccountCount,
				null,
				React.createElement(
					StandardValue,
					{ isFlush: true },
					React.createElement(
						'span',
						null,
						accountCount,
						' accounts'
					)
				)
			),
			React.createElement(
				StyledNotionalCurrency,
				null,
				React.createElement(
					StandardLabel,
					{ isFlush: true },
					React.createElement(
						'span',
						null,
						'Notional Currency'
					)
				)
			),
			React.createElement(
				StyledCurrencyCode,
				null,
				React.createElement(
					StandardValue,
					{ isFlush: true },
					React.createElement(
						'span',
						null,
						currencyCode
					)
				)
			)
		)
	);
};

AccountPoolCard.propTypes = {
	/** Total number of account in the pool. */
	accountCount: PropTypes.number.isRequired,
	/** Currency code. */
	currencyCode: PropTypes.string.isRequired,
	/** Callback function triggered on click. */
	onClick: PropTypes.func.isRequired,
	/** Pool name. */
	poolName: PropTypes.string.isRequired
};

var main$h = "AccountSelectCard.js";
var packageJson$h = {
	main: main$h,
	"component-id": null,
	"component-life-cycle": "active",
	"is-bespoke": true
};

var _templateObject$u = taggedTemplateLiteral(['\n\tbackground-color: ', ';\n\tborder: 1px solid ', ';\n\tborder-radius: ', ';\n\t', '\n\tpadding: ', ';\n\tposition: relative;\n\ttext-align: left;\n\ttransition: all 0.2s ease-in-out;\n\twidth: 100%;\n\n\t', '\n\t', '\n'], ['\n\tbackground-color: ', ';\n\tborder: 1px solid ', ';\n\tborder-radius: ', ';\n\t', '\n\tpadding: ', ';\n\tposition: relative;\n\ttext-align: left;\n\ttransition: all 0.2s ease-in-out;\n\twidth: 100%;\n\n\t', '\n\t', '\n']),
    _templateObject2$f = taggedTemplateLiteral(['\n\t', ';\n'], ['\n\t', ';\n']),
    _templateObject3$c = taggedTemplateLiteral(['\n\tmargin-bottom: ', ';\n'], ['\n\tmargin-bottom: ', ';\n']);

var StyledAccountCard$2 = styled('button')(_templateObject$u, function (props) {
	return props.isSelected ? props.theme.colours.interaction : colours.component.background;
}, function (props) {
	return props.isSelected ? props.theme.colours.interaction : colours.component.border;
}, function (props) {
	return props.theme.borderRadiusLarger;
}, function (props) {
	return props.isSelected && 'color: ' + colours.generalPalette.white + ';';
}, function (props) {
	return props.theme.components.accountSelectCard.root.padding;
}, function (props) {
	return getCardHoverStyles(props.theme);
}, function (props) {
	return getCardStripeStyles(props.theme);
});

var StyledAccountAvailableAndBalance = styled('div')(_templateObject2$f, function (props) {
	return props.isStacked && '\n\t\t> div {\n\t\t\tdiv:last-child {\n\t\t\t\talign-items: flex-start;\n\t\t\t\tdisplay: flex;\n\t\t\t}\n\t\t}\n\t';
});

var StyledAccountDetails$1 = styled('div')(_templateObject3$c, function (props) {
	return props.theme.components.accountRadioCard.root.marginBottomLarger;
});

var StyledAccountHolder = styled('div')(_templateObject3$c, function (props) {
	return props.theme.components.accountRadioCard.root.marginBottom;
});

var StyledAccountName$2 = styled('div')(_templateObject3$c, function (props) {
	return props.theme.components.accountRadioCard.root.marginBottom;
});

var AccountSelectCard = function AccountSelectCard(_ref) {
	var accountAvailable = _ref.accountAvailable,
	    accountInternationalAvailable = _ref.accountInternationalAvailable,
	    accountBalance = _ref.accountBalance,
	    accountInternationalBalance = _ref.accountInternationalBalance,
	    accountHolder = _ref.accountHolder,
	    accountName = _ref.accountName,
	    accountNumber = _ref.accountNumber,
	    isSelected = _ref.isSelected,
	    onClick = _ref.onClick,
	    sortCode = _ref.sortCode,
	    theme = _ref.theme;

	var accountAvailableFont = theme.components.accountSelectCard.fonts.accountAvailable;
	var accountBalanceFont = theme.components.accountSelectCard.fonts.accountBalance;
	var accountDetailsFont = theme.components.accountSelectCard.fonts.accountDetails;
	var accountHolderFont = theme.components.accountSelectCard.fonts.accountHolder;
	var accountNameFont = theme.components.accountSelectCard.fonts.accountName;

	var specifiedAccountBalance = accountInternationalBalance ? accountBalanceFont(React.createElement(
		'span',
		null,
		accountInternationalBalance
	)) : accountBalanceFont(BankingUtils.penceCurrencyFormat(accountBalance));

	var specifiedAccountAvailable = accountInternationalAvailable ? accountAvailableFont(React.createElement(
		'span',
		null,
		accountInternationalAvailable,
		' available'
	)) : accountAvailableFont(BankingUtils.penceCurrencyFormat(accountAvailable) + ' available');

	return React.createElement(
		InternalComponentFrame,
		{ packageJson: packageJson$h },
		React.createElement(
			StyledAccountCard$2,
			{ isSelected: isSelected, onClick: onClick },
			React.createElement(
				StyledAccountHolder,
				{ isSelected: isSelected },
				accountHolderFont(React.createElement(
					'span',
					null,
					accountHolder
				))
			),
			React.createElement(
				StyledAccountName$2,
				{ isSelected: isSelected },
				accountNameFont(React.createElement(
					'span',
					null,
					accountName
				))
			),
			React.createElement(
				StyledAccountDetails$1,
				{ isSelected: isSelected },
				accountDetailsFont(React.createElement(
					'span',
					null,
					React.createElement(SortCodeAndAccountNumber, { accountNumber: accountNumber, sortCode: sortCode })
				))
			),
			React.createElement(
				StyledAccountAvailableAndBalance,
				{ isSelected: isSelected, isStacked: theme.name === 'vm' },
				React.createElement(Inline.Justified, { isNonWrapping: true, nodes: [specifiedAccountBalance, specifiedAccountAvailable] })
			)
		)
	);
};

AccountSelectCard.propTypes = {
	/** Account available funds amount in pence. */
	accountAvailable: PropTypes.number.isRequired,
	/** Account balance in pence. */
	accountBalance: PropTypes.number.isRequired,
	/** Account available funds amount in international currency, as string. Overrides the accountAvailable prop. */
	accountInternationalAvailable: PropTypes.string,
	/** Account balance in international currency, as string. Overrides the accountBalance prop. */
	accountInternationalBalance: PropTypes.string,
	/** Name of account holder or owner. */
	accountHolder: PropTypes.string.isRequired,
	/** Account name. */
	accountName: PropTypes.string,
	/** Account number. */
	accountNumber: PropTypes.number.isRequired,
	/** Callback function triggered on click. */
	onClick: PropTypes.func.isRequired,
	/** Holds whether the account is currently selected. */
	isSelected: PropTypes.bool,
	/** Sort code. */
	sortCode: PropTypes.number.isRequired
};

AccountSelectCard.defaultProps = {
	isSelected: false
};

var WrappedAccountSelectCard = withTheme(AccountSelectCard);

var main$i = "AccountStaticCard.js";
var variants$5 = ["BankAccount", "CreditCard", "DebitCard", "International"];
var packageJson$i = {
	main: main$i,
	variants: variants$5,
	"component-id": null,
	"component-life-cycle": "active",
	"is-bespoke": false
};

var baseProps$4 = {
	/** Account name. */
	accountName: PropTypes.string,
	/** The available balance of the account in pence. */
	availableBalance: PropTypes.number,
	/** The available international balance of the account in pence. Overrides the availableBalance prop. */
	availableInternationalBalance: PropTypes.string,
	/** The balance of the account in pence. */
	balance: PropTypes.number,
	/** Child content as nodes. */
	children: PropTypes.node,
	/** Account id. */
	id: PropTypes.string.isRequired,
	/** Provide an international balance as string. Overrides balance prop. */
	internationalBalance: PropTypes.string,
	/** Product name. */
	productNameOrNickname: PropTypes.string.isRequired,
	/** Reference value. */
	reference: PropTypes.string,
	/** Regulatory text to display at the bottom of the card. */
	regulatoryText: PropTypes.string,
	/** View type. */
	viewType: PropTypes.oneOf(['grid', 'list']),
	/** Partial Data attribute targeting AccountStaticCard for automation test purposes - appended by internal components. */
	'data-test-id': PropTypes.string
};

var baseDefaults$2 = {
	isFavourite: false,
	'data-test-id': 'account-link-card'
};

var BankAccount$2 = function BankAccount(_ref) {
	var accountName = _ref.accountName,
	    accountNumber = _ref.accountNumber,
	    availableBalance = _ref.availableBalance,
	    availableInternationalBalance = _ref.availableInternationalBalance,
	    balance = _ref.balance,
	    children = _ref.children,
	    id = _ref.id,
	    internationalBalance = _ref.internationalBalance,
	    productNameOrNickname = _ref.productNameOrNickname,
	    reference = _ref.reference,
	    regulatoryText = _ref.regulatoryText,
	    sortCode = _ref.sortCode,
	    viewType = _ref.viewType,
	    dataTestId = _ref['data-test-id'];
	return React.createElement(
		InternalComponentFrame,
		{ variant: 'BankAccount', packageJson: packageJson$i },
		React.createElement(
			WrappedAccountCardBase,
			{
				accountName: accountName,
				accountNumber: accountNumber,
				availableBalance: availableBalance,
				availableInternationalBalance: availableInternationalBalance,
				balance: balance,
				cardType: 'account',
				id: id,
				internationalBalance: internationalBalance,
				productNameOrNickname: productNameOrNickname,
				reference: reference,
				regulatoryText: regulatoryText,
				sortCode: sortCode,
				viewType: viewType,
				'data-test-id': dataTestId,
				isStatic: true
			},
			children
		)
	);
};

BankAccount$2.propTypes = _extends({}, baseProps$4, {
	/** Account number. */
	accountNumber: PropTypes.number.isRequired,
	/** Sort code. */
	sortCode: PropTypes.number.isRequired
});

BankAccount$2.defaultProps = baseDefaults$2;

var CreditCard$2 = function CreditCard(_ref2) {
	var accountName = _ref2.accountName,
	    availableBalance = _ref2.availableBalance,
	    availableInternationalBalance = _ref2.availableInternationalBalance,
	    balance = _ref2.balance,
	    cardNumber = _ref2.cardNumber,
	    children = _ref2.children,
	    id = _ref2.id,
	    internationalBalance = _ref2.internationalBalance,
	    productNameOrNickname = _ref2.productNameOrNickname,
	    reference = _ref2.reference,
	    regulatoryText = _ref2.regulatoryText,
	    viewType = _ref2.viewType,
	    dataTestId = _ref2['data-test-id'];
	return React.createElement(
		InternalComponentFrame,
		{ variant: 'CreditCard', packageJson: packageJson$i },
		React.createElement(
			WrappedAccountCardBase,
			{
				accountName: accountName,
				availableBalance: availableBalance,
				availableInternationalBalance: availableInternationalBalance,
				balance: balance,
				cardNumber: cardNumber,
				cardType: 'credit',
				id: id,
				internationalBalance: internationalBalance,
				productNameOrNickname: productNameOrNickname,
				reference: reference,
				regulatoryText: regulatoryText,
				viewType: viewType,
				'data-test-id': dataTestId,
				isStatic: true
			},
			children
		)
	);
};

CreditCard$2.propTypes = _extends({}, baseProps$4, {
	/** Credit card number. */
	cardNumber: PropTypes.number.isRequired
});

CreditCard$2.defaultProps = baseDefaults$2;

var DebitCard$1 = function DebitCard(_ref3) {
	var accountName = _ref3.accountName,
	    accountNumber = _ref3.accountNumber,
	    availableBalance = _ref3.availableBalance,
	    availableInternationalBalance = _ref3.availableInternationalBalance,
	    balance = _ref3.balance,
	    cardNumber = _ref3.cardNumber,
	    children = _ref3.children,
	    id = _ref3.id,
	    internationalBalance = _ref3.internationalBalance,
	    imageInfo = _ref3.imageInfo,
	    productNameOrNickname = _ref3.productNameOrNickname,
	    reference = _ref3.reference,
	    regulatoryText = _ref3.regulatoryText,
	    sortCode = _ref3.sortCode,
	    viewType = _ref3.viewType,
	    dataTestId = _ref3['data-test-id'];
	return React.createElement(
		InternalComponentFrame,
		{ variant: 'DebitCard', packageJson: packageJson$i },
		React.createElement(
			WrappedAccountCardBase,
			{
				accountName: accountName,
				accountNumber: accountNumber,
				availableBalance: availableBalance,
				availableInternationalBalance: availableInternationalBalance,
				balance: balance,
				cardNumber: cardNumber,
				cardType: 'debit',
				id: id,
				internationalBalance: internationalBalance,
				imageInfo: imageInfo,
				productNameOrNickname: productNameOrNickname,
				reference: reference,
				regulatoryText: regulatoryText,
				sortCode: sortCode,
				viewType: viewType,
				'data-test-id': dataTestId,
				isStatic: true
			},
			children
		)
	);
};

DebitCard$1.propTypes = _extends({}, baseProps$4, {
	/** Account number. */
	accountNumber: PropTypes.number,
	/** Debit card number. */
	cardNumber: PropTypes.number.isRequired,
	/* Card image information. */
	imageInfo: PropTypes.shape({
		/** Card brand. */
		brandId: PropTypes.oneOf(['b', 'cb', 'yb', 'vm']).isRequired,
		/** Image type. Used in the aria-label. */
		cardStatus: PropTypes.oneOf(['active', 'deactivated', 'frozen']).isRequired,
		/** Image url. */
		imageUrl: PropTypes.string
	}),
	/** Sort code. */
	sortCode: PropTypes.number
});

DebitCard$1.defaultProps = baseDefaults$2;

var International$2 = function International(_ref4) {
	var accountName = _ref4.accountName,
	    availableBalance = _ref4.availableBalance,
	    availableInternationalBalance = _ref4.availableInternationalBalance,
	    balance = _ref4.balance,
	    children = _ref4.children,
	    IBAN = _ref4.IBAN,
	    id = _ref4.id,
	    internationalBalance = _ref4.internationalBalance,
	    productNameOrNickname = _ref4.productNameOrNickname,
	    reference = _ref4.reference,
	    regulatoryText = _ref4.regulatoryText,
	    viewType = _ref4.viewType,
	    dataTestId = _ref4['data-test-id'];
	return React.createElement(
		InternalComponentFrame,
		{ variant: 'International', packageJson: packageJson$i },
		React.createElement(
			WrappedAccountCardBase,
			{
				accountName: accountName,
				availableBalance: availableBalance,
				availableInternationalBalance: availableInternationalBalance,
				balance: balance,
				cardType: 'international',
				id: id,
				internationalBalance: internationalBalance,
				IBAN: IBAN,
				productNameOrNickname: productNameOrNickname,
				reference: reference,
				regulatoryText: regulatoryText,
				viewType: viewType,
				'data-test-id': dataTestId,
				isStatic: true
			},
			children
		)
	);
};

International$2.propTypes = _extends({}, baseProps$4, {
	/** International Bank Account Number (IBAN). */
	IBAN: PropTypes.string.isRequired
});

International$2.defaultProps = baseDefaults$2;

var AccountStaticCard = {
	BankAccount: BankAccount$2,
	CreditCard: CreditCard$2,
	DebitCard: DebitCard$1,
	International: International$2
};

var _extends$9 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$8(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var AuthorisationLarge = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$8(_ref, ["styles"]);

  return React.createElement("svg", _extends$9({ width: "96", height: "96", viewBox: "0 0 96 96", xmlns: "http://www.w3.org/2000/svg" }, props), React.createElement("path", { d: "M89.977 36.744c0 5.985-.069 11.97.016 17.955.131 9.132-3.816 16.446-10.205 22.695-8.719 8.527-19.322 14.043-30.618 18.404-.686.262-1.656.274-2.336.008-12.2-4.75-23.614-10.738-32.59-20.479-5.442-5.905-8.304-12.757-8.239-20.83.1-12.48.056-24.963-.005-37.444-.01-1.966.636-3.007 2.6-3.683C21.12 9.063 33.59 4.606 46.113.3c1.13-.39 2.633-.404 3.76-.016 12.593 4.33 25.134 8.806 37.718 13.159 1.773.613 2.422 1.588 2.408 3.374-.057 6.643-.023 13.285-.023 19.927zM76.748 71.928C71.541 61.31 60.624 54 48 54c-12.616 0-23.527 7.3-28.738 17.908C26.34 79.354 35.4 84.814 47.995 89.815c11.743-4.626 20.537-9.805 27.597-16.71.4-.391.785-.783 1.156-1.177zM48 48c8.284 0 15-6.716 15-15 0-8.284-6.716-15-15-15-8.284 0-15 6.716-15 15 0 8.284 6.716 15 15 15z" }));
});

var componentPaths = [
	{
		name: "ActionAnchor",
		path: "actions/anchors/ActionAnchor",
		styleguidePath: "Actions/Anchors/ActionAnchor",
		importPath: "web-ui-components/lib/actions/anchors"
	},
	{
		name: "ActionButton",
		path: "actions/buttons/ActionButton",
		styleguidePath: "Actions/Buttons/ActionButton",
		importPath: "web-ui-components/lib/actions/buttons"
	},
	{
		name: "SwitchButton",
		path: "actions/buttons/SwitchButton",
		styleguidePath: "Actions/Buttons/SwitchButton",
		importPath: "web-ui-components/lib/actions/buttons"
	},
	{
		name: "EmailLink",
		path: "actions/links/EmailLink",
		styleguidePath: "Actions/Links/EmailLink",
		importPath: "web-ui-components/lib/actions/links"
	},
	{
		name: "PhoneLink",
		path: "actions/links/PhoneLink",
		styleguidePath: "Actions/Links/PhoneLink",
		importPath: "web-ui-components/lib/actions/links"
	},
	{
		name: "WebsiteLink",
		path: "actions/links/WebsiteLink",
		styleguidePath: "Actions/Links/WebsiteLink",
		importPath: "web-ui-components/lib/actions/links"
	},
	{
		name: "InputRadio",
		path: "actions/radios/InputRadio",
		styleguidePath: "Actions/Radios/InputRadio",
		importPath: "web-ui-components/lib/actions/radios"
	},
	{
		name: "InputRadioGroup",
		path: "actions/radios/InputRadioGroup",
		styleguidePath: "Actions/Radios/InputRadioGroup",
		importPath: "web-ui-components/lib/actions/radios"
	},
	{
		name: "TallRadioCard",
		path: "actions/radios/TallRadioCard",
		styleguidePath: "Actions/Radios/TallRadioCard",
		importPath: "web-ui-components/lib/actions/radios"
	},
	{
		name: "WideRadioCard",
		path: "actions/radios/WideRadioCard",
		styleguidePath: "Actions/Radios/WideRadioCard",
		importPath: "web-ui-components/lib/actions/radios"
	},
	{
		name: "NewWindowAction",
		path: "advisor/actions/NewWindowAction",
		styleguidePath: "Advisor/Actions/NewWindowAction",
		importPath: "web-ui-components/lib/advisor/actions"
	},
	{
		name: "CustomerAlert",
		path: "advisor/alerts/CustomerAlert",
		styleguidePath: "Advisor/Alerts/CustomerAlert",
		importPath: "web-ui-components/lib/advisor/alerts"
	},
	{
		name: "ClickableContentFrame",
		path: "advisor/layout/ClickableContentFrame",
		styleguidePath: "Advisor/Layout/ClickableContentFrame",
		importPath: "web-ui-components/lib/advisor/layout"
	},
	{
		name: "DashboardGrid",
		path: "advisor/layout/DashboardGrid",
		styleguidePath: "Advisor/Layout/DashboardGrid",
		importPath: "web-ui-components/lib/advisor/layout"
	},
	{
		name: "WideModal",
		path: "advisor/layout/WideModal",
		styleguidePath: "Advisor/Layout/WideModal",
		importPath: "web-ui-components/lib/advisor/layout"
	},
	{
		name: "WindowFrame",
		path: "advisor/layout/WindowFrame",
		styleguidePath: "Advisor/Layout/WindowFrame",
		importPath: "web-ui-components/lib/advisor/layout"
	},
	{
		name: "ProductRadioCard",
		path: "advisor/radios/ProductRadioCard",
		styleguidePath: "Advisor/Radios/ProductRadioCard",
		importPath: "web-ui-components/lib/advisor/radios"
	},
	{
		name: "AccountSelect",
		path: "advisor/selects/AccountSelect",
		styleguidePath: "Advisor/Selects/AccountSelect",
		importPath: "web-ui-components/lib/advisor/selects"
	},
	{
		name: "SessionTimeoutTakeover",
		path: "advisor/takeovers/SessionTimeoutTakeover",
		styleguidePath: "Advisor/Takeovers/SessionTimeoutTakeover",
		importPath: "web-ui-components/lib/advisor/takeovers"
	},
	{
		name: "Anchor",
		path: "atoms/buttons/Anchor",
		styleguidePath: "Atoms/Buttons/Anchor",
		importPath: "web-ui-components/lib/atoms/buttons"
	},
	{
		name: "Button",
		path: "atoms/buttons/Button",
		styleguidePath: "Atoms/Buttons/Button",
		importPath: "web-ui-components/lib/atoms/buttons"
	},
	{
		name: "ButtonTitle",
		path: "atoms/buttons/ButtonTitle",
		styleguidePath: "Atoms/Buttons/ButtonTitle",
		importPath: "web-ui-components/lib/atoms/buttons"
	},
	{
		name: "Calendar",
		path: "atoms/forms/Calendar",
		styleguidePath: "Atoms/Forms/Calendar",
		importPath: "web-ui-components/lib/atoms/forms"
	},
	{
		name: "Checkbox",
		path: "atoms/forms/Checkbox",
		styleguidePath: "Atoms/Forms/Checkbox",
		importPath: "web-ui-components/lib/atoms/forms"
	},
	{
		name: "CheckboxToggle",
		path: "atoms/forms/CheckboxToggle",
		styleguidePath: "Atoms/Forms/CheckboxToggle",
		importPath: "web-ui-components/lib/atoms/forms"
	},
	{
		name: "Datepicker",
		path: "atoms/forms/Datepicker",
		styleguidePath: "Atoms/Forms/Datepicker",
		importPath: "web-ui-components/lib/atoms/forms"
	},
	{
		name: "FieldDescription",
		path: "atoms/forms/FieldDescription",
		styleguidePath: "Atoms/Forms/FieldDescription",
		importPath: "web-ui-components/lib/atoms/forms"
	},
	{
		name: "Input",
		path: "atoms/forms/Input/Input",
		styleguidePath: "Atoms/Forms/Input/Input",
		importPath: "web-ui-components/lib/atoms/forms/input"
	},
	{
		name: "Prefix",
		path: "atoms/forms/Input/Prefix",
		styleguidePath: "Atoms/Forms/Input/Prefix",
		importPath: "web-ui-components/lib/atoms/forms/input"
	},
	{
		name: "Suffix",
		path: "atoms/forms/Input/Suffix",
		styleguidePath: "Atoms/Forms/Input/Suffix",
		importPath: "web-ui-components/lib/atoms/forms/input"
	},
	{
		name: "TextPrompt",
		path: "atoms/forms/Input/TextPrompt",
		styleguidePath: "Atoms/Forms/Input/TextPrompt",
		importPath: "web-ui-components/lib/atoms/forms/input"
	},
	{
		name: "InputClickable",
		path: "atoms/forms/InputClickable",
		styleguidePath: "Atoms/Forms/InputClickable",
		importPath: "web-ui-components/lib/atoms/forms"
	},
	{
		name: "InputRange",
		path: "atoms/forms/InputRange",
		styleguidePath: "Atoms/Forms/InputRange",
		importPath: "web-ui-components/lib/atoms/forms"
	},
	{
		name: "LabelTitle",
		path: "atoms/forms/Label/LabelTitle",
		styleguidePath: "Atoms/Forms/Label/LabelTitle",
		importPath: "web-ui-components/lib/atoms/forms/label"
	},
	{
		name: "Label",
		path: "atoms/forms/Label",
		styleguidePath: "Atoms/Forms/Label",
		importPath: "web-ui-components/lib/atoms/forms"
	},
	{
		name: "MediaCheckbox",
		path: "atoms/forms/MediaCheckbox",
		styleguidePath: "Atoms/Forms/MediaCheckbox",
		importPath: "web-ui-components/lib/atoms/forms"
	},
	{
		name: "MediaRadio",
		path: "atoms/forms/MediaRadio",
		styleguidePath: "Atoms/Forms/MediaRadio",
		importPath: "web-ui-components/lib/atoms/forms"
	},
	{
		name: "MultiSelect",
		path: "atoms/forms/MultiSelect",
		styleguidePath: "Atoms/Forms/MultiSelect",
		importPath: "web-ui-components/lib/atoms/forms"
	},
	{
		name: "Radio",
		path: "atoms/forms/Radio",
		styleguidePath: "Atoms/Forms/Radio",
		importPath: "web-ui-components/lib/atoms/forms"
	},
	{
		name: "RadioCard",
		path: "atoms/forms/RadioCard",
		styleguidePath: "Atoms/Forms/RadioCard",
		importPath: "web-ui-components/lib/atoms/forms"
	},
	{
		name: "Select",
		path: "atoms/forms/Select",
		styleguidePath: "Atoms/Forms/Select",
		importPath: "web-ui-components/lib/atoms/forms"
	},
	{
		name: "Textarea",
		path: "atoms/forms/Textarea",
		styleguidePath: "Atoms/Forms/Textarea",
		importPath: "web-ui-components/lib/atoms/forms"
	},
	{
		name: "TextAreaCharacterCount",
		path: "atoms/forms/TextAreaCharacterCount",
		styleguidePath: "Atoms/Forms/TextAreaCharacterCount",
		importPath: "web-ui-components/lib/atoms/forms"
	},
	{
		name: "TimeEstimationIcon",
		path: "atoms/forms/TimeEstimationIcon",
		styleguidePath: "Atoms/Forms/TimeEstimationIcon",
		importPath: "web-ui-components/lib/atoms/forms"
	},
	{
		name: "AnimatedIcon",
		path: "atoms/iconography/AnimatedIcon",
		styleguidePath: "Atoms/Iconography/AnimatedIcon",
		importPath: "web-ui-components/lib/atoms/iconography"
	},
	{
		name: "DistinctiveGeneratedSymbol",
		path: "atoms/iconography/DistinctiveGeneratedSymbol",
		styleguidePath: "Atoms/Iconography/DistinctiveGeneratedSymbol",
		importPath: "web-ui-components/lib/atoms/iconography"
	},
	{
		name: "Icon",
		path: "atoms/iconography/Icon",
		styleguidePath: "Atoms/Iconography/Icon",
		importPath: "web-ui-components/lib/atoms/iconography"
	},
	{
		name: "Divider",
		path: "atoms/layout/Divider",
		styleguidePath: "Atoms/Layout/Divider",
		importPath: "web-ui-components/lib/atoms/layout"
	},
	{
		name: "UploadPreviewContainer",
		path: "atoms/layout/UploadPreviewContainer",
		styleguidePath: "Atoms/Layout/UploadPreviewContainer",
		importPath: "web-ui-components/lib/atoms/layout"
	},
	{
		name: "AndroidStoreLogo",
		path: "atoms/logo/AndroidStoreLogo",
		styleguidePath: "Atoms/Logo/AndroidStoreLogo",
		importPath: "web-ui-components/lib/atoms/logo"
	},
	{
		name: "AppleStoreLogo",
		path: "atoms/logo/AppleStoreLogo",
		styleguidePath: "Atoms/Logo/AppleStoreLogo",
		importPath: "web-ui-components/lib/atoms/logo"
	},
	{
		name: "BankHeader",
		path: "atoms/logo/BankHeader",
		styleguidePath: "Atoms/Logo/BankHeader",
		importPath: "web-ui-components/lib/atoms/logo"
	},
	{
		name: "BLogo",
		path: "atoms/logo/BLogo",
		styleguidePath: "Atoms/Logo/BLogo",
		importPath: "web-ui-components/lib/atoms/logo"
	},
	{
		name: "BLogoCircular",
		path: "atoms/logo/BLogoCircular",
		styleguidePath: "Atoms/Logo/BLogoCircular",
		importPath: "web-ui-components/lib/atoms/logo"
	},
	{
		name: "CBLogo",
		path: "atoms/logo/CBLogo",
		styleguidePath: "Atoms/Logo/CBLogo",
		importPath: "web-ui-components/lib/atoms/logo"
	},
	{
		name: "CBLogoCircular",
		path: "atoms/logo/CBLogoCircular",
		styleguidePath: "Atoms/Logo/CBLogoCircular",
		importPath: "web-ui-components/lib/atoms/logo"
	},
	{
		name: "Header",
		path: "atoms/logo/Header",
		styleguidePath: "Atoms/Logo/Header",
		importPath: "web-ui-components/lib/atoms/logo"
	},
	{
		name: "SwitchGuaranteeLogo",
		path: "atoms/logo/SwitchGuaranteeLogo",
		styleguidePath: "Atoms/Logo/SwitchGuaranteeLogo",
		importPath: "web-ui-components/lib/atoms/logo"
	},
	{
		name: "VMSecondaryRedLogo",
		path: "atoms/logo/VMSecondaryRedLogo",
		styleguidePath: "Atoms/Logo/VMSecondaryRedLogo",
		importPath: "web-ui-components/lib/atoms/logo"
	},
	{
		name: "YBLogo",
		path: "atoms/logo/YBLogo",
		styleguidePath: "Atoms/Logo/YBLogo",
		importPath: "web-ui-components/lib/atoms/logo"
	},
	{
		name: "YBLogoCircular",
		path: "atoms/logo/YBLogoCircular",
		styleguidePath: "Atoms/Logo/YBLogoCircular",
		importPath: "web-ui-components/lib/atoms/logo"
	},
	{
		name: "Popover",
		path: "atoms/popovers/Popover",
		styleguidePath: "Atoms/Popovers/Popover",
		importPath: "web-ui-components/lib/atoms/popovers"
	},
	{
		name: "IdentityProcessingSignal",
		path: "atoms/signals/IdentityProcessingSignal",
		styleguidePath: "Atoms/Signals/IdentityProcessingSignal",
		importPath: "web-ui-components/lib/atoms/signals"
	},
	{
		name: "UploadProcessingSignal",
		path: "atoms/signals/UploadProcessingSignal",
		styleguidePath: "Atoms/Signals/UploadProcessingSignal",
		importPath: "web-ui-components/lib/atoms/signals"
	},
	{
		name: "BadgeLabel",
		path: "atoms/text/BadgeLabel",
		styleguidePath: "Atoms/Text/BadgeLabel",
		importPath: "web-ui-components/lib/atoms/text"
	},
	{
		name: "BulletedList",
		path: "atoms/text/BulletedList",
		styleguidePath: "Atoms/Text/BulletedList",
		importPath: "web-ui-components/lib/atoms/text"
	},
	{
		name: "Callout",
		path: "atoms/text/Callout",
		styleguidePath: "Atoms/Text/Callout",
		importPath: "web-ui-components/lib/atoms/text"
	},
	{
		name: "List",
		path: "atoms/text/List",
		styleguidePath: "Atoms/Text/List",
		importPath: "web-ui-components/lib/atoms/text"
	},
	{
		name: "NumberedList",
		path: "atoms/text/NumberedList",
		styleguidePath: "Atoms/Text/NumberedList",
		importPath: "web-ui-components/lib/atoms/text"
	},
	{
		name: "StatusBadge",
		path: "atoms/text/StatusBadge",
		styleguidePath: "Atoms/Text/StatusBadge",
		importPath: "web-ui-components/lib/atoms/text"
	},
	{
		name: "TextBody",
		path: "atoms/text/TextBody",
		styleguidePath: "Atoms/Text/TextBody",
		importPath: "web-ui-components/lib/atoms/text"
	},
	{
		name: "TextStyled",
		path: "atoms/text/TextStyled",
		styleguidePath: "Atoms/Text/TextStyled",
		importPath: "web-ui-components/lib/atoms/text"
	},
	{
		name: "TheSmallPrint",
		path: "atoms/text/TheSmallPrint",
		styleguidePath: "Atoms/Text/TheSmallPrint",
		importPath: "web-ui-components/lib/atoms/text"
	},
	{
		name: "Title",
		path: "atoms/text/Title",
		styleguidePath: "Atoms/Text/Title",
		importPath: "web-ui-components/lib/atoms/text"
	},
	{
		name: "TransitionBlock",
		path: "atoms/transitions/TransitionBlock",
		styleguidePath: "Atoms/Transitions/TransitionBlock",
		importPath: "web-ui-components/lib/atoms/transitions"
	},
	{
		name: "EmailInput",
		path: "communication/email/text-inputs/EmailInput",
		styleguidePath: "Communication/Email/Text-inputs/EmailInput",
		importPath: "web-ui-components/lib/communication/email/text-inputs"
	},
	{
		name: "Mail",
		path: "communication/messaging/Mail",
		styleguidePath: "Communication/Messaging/Mail",
		importPath: "web-ui-components/lib/communication/messaging"
	},
	{
		name: "Webchat",
		path: "communication/support/Webchat",
		styleguidePath: "Communication/Support/Webchat",
		importPath: "web-ui-components/lib/communication/support"
	},
	{
		name: "CheckboxContainer",
		path: "data/capture/checkboxes/CheckboxContainer",
		styleguidePath: "Data/Capture/Checkboxes/CheckboxContainer",
		importPath: "web-ui-components/lib/data/capture/checkboxes"
	},
	{
		name: "GenericCheckbox",
		path: "data/capture/checkboxes/GenericCheckbox",
		styleguidePath: "Data/Capture/Checkboxes/GenericCheckbox",
		importPath: "web-ui-components/lib/data/capture/checkboxes"
	},
	{
		name: "StandaloneCheckbox",
		path: "data/capture/checkboxes/StandaloneCheckbox",
		styleguidePath: "Data/Capture/Checkboxes/StandaloneCheckbox",
		importPath: "web-ui-components/lib/data/capture/checkboxes"
	},
	{
		name: "AccountNumberInput",
		path: "data/capture/inputs/AccountNumberInput",
		styleguidePath: "Data/Capture/Inputs/AccountNumberInput",
		importPath: "web-ui-components/lib/data/capture/inputs"
	},
	{
		name: "DateOfBirthInput",
		path: "data/capture/inputs/DateOfBirthInput",
		styleguidePath: "Data/Capture/Inputs/DateOfBirthInput",
		importPath: "web-ui-components/lib/data/capture/inputs"
	},
	{
		name: "FileUploadInput",
		path: "data/capture/inputs/FileUploadInput",
		styleguidePath: "Data/Capture/Inputs/FileUploadInput",
		importPath: "web-ui-components/lib/data/capture/inputs"
	},
	{
		name: "GenericAlphaNumericInput",
		path: "data/capture/inputs/GenericAlphaNumericInput",
		styleguidePath: "Data/Capture/Inputs/GenericAlphaNumericInput",
		importPath: "web-ui-components/lib/data/capture/inputs"
	},
	{
		name: "GenericIntegerInput",
		path: "data/capture/inputs/GenericIntegerInput",
		styleguidePath: "Data/Capture/Inputs/GenericIntegerInput",
		importPath: "web-ui-components/lib/data/capture/inputs"
	},
	{
		name: "GenericTextInput",
		path: "data/capture/inputs/GenericTextInput",
		styleguidePath: "Data/Capture/Inputs/GenericTextInput",
		importPath: "web-ui-components/lib/data/capture/inputs"
	},
	{
		name: "LandlineNumberInput",
		path: "data/capture/inputs/LandlineNumberInput",
		styleguidePath: "Data/Capture/Inputs/LandlineNumberInput",
		importPath: "web-ui-components/lib/data/capture/inputs"
	},
	{
		name: "MoneyInput",
		path: "data/capture/inputs/MoneyInput",
		styleguidePath: "Data/Capture/Inputs/MoneyInput",
		importPath: "web-ui-components/lib/data/capture/inputs"
	},
	{
		name: "MonthAndYearDateInput",
		path: "data/capture/inputs/MonthAndYearDateInput",
		styleguidePath: "Data/Capture/Inputs/MonthAndYearDateInput",
		importPath: "web-ui-components/lib/data/capture/inputs"
	},
	{
		name: "PasscodeNumberInput",
		path: "data/capture/inputs/PasscodeNumberInput",
		styleguidePath: "Data/Capture/Inputs/PasscodeNumberInput",
		importPath: "web-ui-components/lib/data/capture/inputs"
	},
	{
		name: "SliderInput",
		path: "data/capture/inputs/SliderInput",
		styleguidePath: "Data/Capture/Inputs/SliderInput",
		importPath: "web-ui-components/lib/data/capture/inputs"
	},
	{
		name: "SortcodeInput",
		path: "data/capture/inputs/SortcodeInput",
		styleguidePath: "Data/Capture/Inputs/SortcodeInput",
		importPath: "web-ui-components/lib/data/capture/inputs"
	},
	{
		name: "UKOnlyMobileNumberInput",
		path: "data/capture/inputs/UKOnlyMobileNumberInput",
		styleguidePath: "Data/Capture/Inputs/UKOnlyMobileNumberInput",
		importPath: "web-ui-components/lib/data/capture/inputs"
	},
	{
		name: "UKOnlyPostcodeInput",
		path: "data/capture/inputs/UKOnlyPostcodeInput",
		styleguidePath: "Data/Capture/Inputs/UKOnlyPostcodeInput",
		importPath: "web-ui-components/lib/data/capture/inputs"
	},
	{
		name: "WorldwideMobileNumberInput",
		path: "data/capture/inputs/WorldwideMobileNumberInput",
		styleguidePath: "Data/Capture/Inputs/WorldwideMobileNumberInput",
		importPath: "web-ui-components/lib/data/capture/inputs"
	},
	{
		name: "YearsAndMonthsCountInput",
		path: "data/capture/inputs/YearsAndMonthsCountInput",
		styleguidePath: "Data/Capture/Inputs/YearsAndMonthsCountInput",
		importPath: "web-ui-components/lib/data/capture/inputs"
	},
	{
		name: "DayOfMonthPicker",
		path: "data/capture/pickers/DayOfMonthPicker",
		styleguidePath: "Data/Capture/Pickers/DayOfMonthPicker",
		importPath: "web-ui-components/lib/data/capture/pickers"
	},
	{
		name: "FileProgressTakeover",
		path: "data/capture/progress/FileProgressTakeover",
		styleguidePath: "Data/Capture/Progress/FileProgressTakeover",
		importPath: "web-ui-components/lib/data/capture/progress"
	},
	{
		name: "GenericRadio",
		path: "data/capture/radios/GenericRadio",
		styleguidePath: "Data/Capture/Radios/GenericRadio",
		importPath: "web-ui-components/lib/data/capture/radios"
	},
	{
		name: "IconifiedRadio",
		path: "data/capture/radios/IconifiedRadio",
		styleguidePath: "Data/Capture/Radios/IconifiedRadio",
		importPath: "web-ui-components/lib/data/capture/radios"
	},
	{
		name: "RadioContainer",
		path: "data/capture/radios/RadioContainer",
		styleguidePath: "Data/Capture/Radios/RadioContainer",
		importPath: "web-ui-components/lib/data/capture/radios"
	},
	{
		name: "AccountCardSelect",
		path: "data/capture/selects/AccountCardSelect",
		styleguidePath: "Data/Capture/Selects/AccountCardSelect",
		importPath: "web-ui-components/lib/data/capture/selects"
	},
	{
		name: "GenericSelect",
		path: "data/capture/selects/GenericSelect",
		styleguidePath: "Data/Capture/Selects/GenericSelect",
		importPath: "web-ui-components/lib/data/capture/selects"
	},
	{
		name: "GenericTextArea",
		path: "data/capture/text-areas/GenericTextArea",
		styleguidePath: "Data/Capture/Text-areas/GenericTextArea",
		importPath: "web-ui-components/lib/data/capture/text-areas"
	},
	{
		name: "InternationalMoneyValue",
		path: "data/display/values/InternationalMoneyValue",
		styleguidePath: "Data/Display/Values/InternationalMoneyValue",
		importPath: "web-ui-components/lib/data/display/values"
	},
	{
		name: "MoneyValue",
		path: "data/display/values/MoneyValue",
		styleguidePath: "Data/Display/Values/MoneyValue",
		importPath: "web-ui-components/lib/data/display/values"
	},
	{
		name: "GenericPaginator",
		path: "data/filter-and-search/paginators/GenericPaginator",
		styleguidePath: "Data/Filter-and-search/Paginators/GenericPaginator",
		importPath: "web-ui-components/lib/data/filter-and-search/paginators"
	},
	{
		name: "SearchSelectInput",
		path: "data/filter-and-search/text-inputs/SearchSelectInput",
		styleguidePath: "Data/Filter-and-search/Text-inputs/SearchSelectInput",
		importPath: "web-ui-components/lib/data/filter-and-search/text-inputs"
	},
	{
		name: "SearchTextInput",
		path: "data/filter-and-search/text-inputs/SearchTextInput",
		styleguidePath: "Data/Filter-and-search/Text-inputs/SearchTextInput",
		importPath: "web-ui-components/lib/data/filter-and-search/text-inputs"
	},
	{
		name: "CompactDescriptionList",
		path: "data/lists/description-lists/CompactDescriptionList",
		styleguidePath: "Data/Lists/Description-lists/CompactDescriptionList",
		importPath: "web-ui-components/lib/data/lists/description-lists"
	},
	{
		name: "GenericDescriptionList",
		path: "data/lists/description-lists/GenericDescriptionList",
		styleguidePath: "Data/Lists/Description-lists/GenericDescriptionList",
		importPath: "web-ui-components/lib/data/lists/description-lists"
	},
	{
		name: "NoResultsTile",
		path: "data/results/tiles/NoResultsTile",
		styleguidePath: "Data/Results/Tiles/NoResultsTile",
		importPath: "web-ui-components/lib/data/results/tiles"
	},
	{
		name: "DocumentLink",
		path: "documents/navigation/links/DocumentLink",
		styleguidePath: "Documents/Navigation/Links/DocumentLink",
		importPath: "web-ui-components/lib/documents/navigation/links"
	},
	{
		name: "DocumentLinkPlate",
		path: "documents/navigation/plates/DocumentLinkPlate",
		styleguidePath: "Documents/Navigation/Plates/DocumentLinkPlate",
		importPath: "web-ui-components/lib/documents/navigation/plates"
	},
	{
		name: "PrintButton",
		path: "documents/printing/buttons/PrintButton",
		styleguidePath: "Documents/Printing/Buttons/PrintButton",
		importPath: "web-ui-components/lib/documents/printing/buttons"
	},
	{
		name: "DocumentStatusBandCard",
		path: "documents/statuses/cards/DocumentStatusBandCard",
		styleguidePath: "Documents/Statuses/Cards/DocumentStatusBandCard",
		importPath: "web-ui-components/lib/documents/statuses/cards"
	},
	{
		name: "FileInput",
		path: "documents/upload/FileInput",
		styleguidePath: "Documents/Upload/FileInput",
		importPath: "web-ui-components/lib/documents/upload"
	},
	{
		name: "AccountCheckboxCard",
		path: "finance/accounts/cards/AccountCheckboxCard",
		styleguidePath: "Finance/Accounts/Cards/AccountCheckboxCard",
		importPath: "web-ui-components/lib/finance/accounts/cards"
	},
	{
		name: "AccountLegacyUpdateCard",
		path: "finance/accounts/cards/AccountLegacyUpdateCard",
		styleguidePath: "Finance/Accounts/Cards/AccountLegacyUpdateCard",
		importPath: "web-ui-components/lib/finance/accounts/cards"
	},
	{
		name: "AccountLinkCard",
		path: "finance/accounts/cards/AccountLinkCard",
		styleguidePath: "Finance/Accounts/Cards/AccountLinkCard",
		importPath: "web-ui-components/lib/finance/accounts/cards"
	},
	{
		name: "AccountPoolCard",
		path: "finance/accounts/cards/AccountPoolCard",
		styleguidePath: "Finance/Accounts/Cards/AccountPoolCard",
		importPath: "web-ui-components/lib/finance/accounts/cards"
	},
	{
		name: "AccountSelectCard",
		path: "finance/accounts/cards/AccountSelectCard",
		styleguidePath: "Finance/Accounts/Cards/AccountSelectCard",
		importPath: "web-ui-components/lib/finance/accounts/cards"
	},
	{
		name: "AccountStaticCard",
		path: "finance/accounts/cards/AccountStaticCard",
		styleguidePath: "Finance/Accounts/Cards/AccountStaticCard",
		importPath: "web-ui-components/lib/finance/accounts/cards"
	},
	{
		name: "AccountAuthorisationPanel",
		path: "finance/accounts/panels/AccountAuthorisationPanel",
		styleguidePath: "Finance/Accounts/Panels/AccountAuthorisationPanel",
		importPath: "web-ui-components/lib/finance/accounts/panels"
	},
	{
		name: "AccountBalancesSelectPanel",
		path: "finance/accounts/panels/AccountBalancesSelectPanel",
		styleguidePath: "Finance/Accounts/Panels/AccountBalancesSelectPanel",
		importPath: "web-ui-components/lib/finance/accounts/panels"
	},
	{
		name: "AccountLegacyPanel",
		path: "finance/accounts/panels/AccountLegacyPanel",
		styleguidePath: "Finance/Accounts/Panels/AccountLegacyPanel",
		importPath: "web-ui-components/lib/finance/accounts/panels"
	},
	{
		name: "AccountPaymentStatusPanel",
		path: "finance/accounts/panels/AccountPaymentStatusPanel",
		styleguidePath: "Finance/Accounts/Panels/AccountPaymentStatusPanel",
		importPath: "web-ui-components/lib/finance/accounts/panels"
	},
	{
		name: "AccountPoolTablePanel",
		path: "finance/accounts/panels/AccountPoolTablePanel",
		styleguidePath: "Finance/Accounts/Panels/AccountPoolTablePanel",
		importPath: "web-ui-components/lib/finance/accounts/panels"
	},
	{
		name: "AccountRadioCard",
		path: "finance/accounts/radios/AccountRadioCard",
		styleguidePath: "Finance/Accounts/Radios/AccountRadioCard",
		importPath: "web-ui-components/lib/finance/accounts/radios"
	},
	{
		name: "AccountPaymentReviewTable",
		path: "finance/accounts/tables/AccountPaymentReviewTable",
		styleguidePath: "Finance/Accounts/Tables/AccountPaymentReviewTable",
		importPath: "web-ui-components/lib/finance/accounts/tables"
	},
	{
		name: "AccountPaymentSubmittedTable",
		path: "finance/accounts/tables/AccountPaymentSubmittedTable",
		styleguidePath: "Finance/Accounts/Tables/AccountPaymentSubmittedTable",
		importPath: "web-ui-components/lib/finance/accounts/tables"
	},
	{
		name: "AccountPaymentTable",
		path: "finance/accounts/tables/AccountPaymentTable",
		styleguidePath: "Finance/Accounts/Tables/AccountPaymentTable",
		importPath: "web-ui-components/lib/finance/accounts/tables"
	},
	{
		name: "AccountSummaryTile",
		path: "finance/accounts/tiles/AccountSummaryTile",
		styleguidePath: "Finance/Accounts/Tiles/AccountSummaryTile",
		importPath: "web-ui-components/lib/finance/accounts/tiles"
	},
	{
		name: "CurrencySelect",
		path: "finance/currency/selects/CurrencySelect",
		styleguidePath: "Finance/Currency/Selects/CurrencySelect",
		importPath: "web-ui-components/lib/finance/currency/selects"
	},
	{
		name: "BlockField",
		path: "global/layout/BlockField",
		styleguidePath: "Global/Layout/BlockField",
		importPath: "web-ui-components/lib/global/layout"
	},
	{
		name: "BlockFieldColumn",
		path: "global/layout/BlockFieldColumn",
		styleguidePath: "Global/Layout/BlockFieldColumn",
		importPath: "web-ui-components/lib/global/layout"
	},
	{
		name: "CenterImageContainer",
		path: "global/layout/CenterImageContainer",
		styleguidePath: "Global/Layout/CenterImageContainer",
		importPath: "web-ui-components/lib/global/layout"
	},
	{
		name: "Column",
		path: "global/layout/Column",
		styleguidePath: "Global/Layout/Column",
		importPath: "web-ui-components/lib/global/layout"
	},
	{
		name: "Container",
		path: "global/layout/Container",
		styleguidePath: "Global/Layout/Container",
		importPath: "web-ui-components/lib/global/layout"
	},
	{
		name: "FlexColumn",
		path: "global/layout/FlexColumn",
		styleguidePath: "Global/Layout/FlexColumn",
		importPath: "web-ui-components/lib/global/layout"
	},
	{
		name: "FlexRow",
		path: "global/layout/FlexRow",
		styleguidePath: "Global/Layout/FlexRow",
		importPath: "web-ui-components/lib/global/layout"
	},
	{
		name: "Frame",
		path: "global/layout/Frame",
		styleguidePath: "Global/Layout/Frame",
		importPath: "web-ui-components/lib/global/layout"
	},
	{
		name: "InternalSlot",
		path: "global/layout/InternalSlot",
		styleguidePath: "Global/Layout/InternalSlot",
		importPath: "web-ui-components/lib/global/layout"
	},
	{
		name: "LeftAndRightAlignment",
		path: "global/layout/LeftAndRightAlignment",
		styleguidePath: "Global/Layout/LeftAndRightAlignment",
		importPath: "web-ui-components/lib/global/layout"
	},
	{
		name: "PageLayout",
		path: "global/layout/PageLayout",
		styleguidePath: "Global/Layout/PageLayout",
		importPath: "web-ui-components/lib/global/layout"
	},
	{
		name: "HeaderSection",
		path: "global/layout/Pages/HeaderSection",
		styleguidePath: "Global/Layout/Pages/HeaderSection",
		importPath: "web-ui-components/lib/global/layout/pages"
	},
	{
		name: "ServicingSection",
		path: "global/layout/Pages/ServicingSection",
		styleguidePath: "Global/Layout/Pages/ServicingSection",
		importPath: "web-ui-components/lib/global/layout/pages"
	},
	{
		name: "WorkflowSection",
		path: "global/layout/Pages/WorkflowSection",
		styleguidePath: "Global/Layout/Pages/WorkflowSection",
		importPath: "web-ui-components/lib/global/layout/pages"
	},
	{
		name: "ResponsiveLayoutPair",
		path: "global/layout/ResponsiveLayoutPair",
		styleguidePath: "Global/Layout/ResponsiveLayoutPair",
		importPath: "web-ui-components/lib/global/layout"
	},
	{
		name: "Row",
		path: "global/layout/Row",
		styleguidePath: "Global/Layout/Row",
		importPath: "web-ui-components/lib/global/layout"
	},
	{
		name: "ContentContainer",
		path: "layout/containers/ContentContainer",
		styleguidePath: "Layout/Containers/ContentContainer",
		importPath: "web-ui-components/lib/layout/containers"
	},
	{
		name: "Main",
		path: "layout/containers/Main",
		styleguidePath: "Layout/Containers/Main",
		importPath: "web-ui-components/lib/layout/containers"
	},
	{
		name: "GenericAccordion",
		path: "layout/content/accordions/GenericAccordion",
		styleguidePath: "Layout/Content/Accordions/GenericAccordion",
		importPath: "web-ui-components/lib/layout/content/accordions"
	},
	{
		name: "StatusBanner",
		path: "layout/content/banners/StatusBanner",
		styleguidePath: "Layout/Content/Banners/StatusBanner",
		importPath: "web-ui-components/lib/layout/content/banners"
	},
	{
		name: "GenericDivider",
		path: "layout/content/breaks/GenericDivider",
		styleguidePath: "Layout/Content/Breaks/GenericDivider",
		importPath: "web-ui-components/lib/layout/content/breaks"
	},
	{
		name: "GenericModal",
		path: "layout/content/modals/GenericModal",
		styleguidePath: "Layout/Content/Modals/GenericModal",
		importPath: "web-ui-components/lib/layout/content/modals"
	},
	{
		name: "InformationModal",
		path: "layout/content/modals/InformationModal",
		styleguidePath: "Layout/Content/Modals/InformationModal",
		importPath: "web-ui-components/lib/layout/content/modals"
	},
	{
		name: "MultiButtonModal",
		path: "layout/content/modals/MultiButtonModal",
		styleguidePath: "Layout/Content/Modals/MultiButtonModal",
		importPath: "web-ui-components/lib/layout/content/modals"
	},
	{
		name: "BrandedPanel",
		path: "layout/content/panels/BrandedPanel",
		styleguidePath: "Layout/Content/Panels/BrandedPanel",
		importPath: "web-ui-components/lib/layout/content/panels"
	},
	{
		name: "ConditionalPanel",
		path: "layout/content/panels/ConditionalPanel",
		styleguidePath: "Layout/Content/Panels/ConditionalPanel",
		importPath: "web-ui-components/lib/layout/content/panels"
	},
	{
		name: "ContentRevealPanel",
		path: "layout/content/panels/ContentRevealPanel",
		styleguidePath: "Layout/Content/Panels/ContentRevealPanel",
		importPath: "web-ui-components/lib/layout/content/panels"
	},
	{
		name: "GenericPanel",
		path: "layout/content/panels/GenericPanel",
		styleguidePath: "Layout/Content/Panels/GenericPanel",
		importPath: "web-ui-components/lib/layout/content/panels"
	},
	{
		name: "InformationRevealPanel",
		path: "layout/content/panels/InformationRevealPanel",
		styleguidePath: "Layout/Content/Panels/InformationRevealPanel",
		importPath: "web-ui-components/lib/layout/content/panels"
	},
	{
		name: "ShellPanel",
		path: "layout/content/panels/ShellPanel",
		styleguidePath: "Layout/Content/Panels/ShellPanel",
		importPath: "web-ui-components/lib/layout/content/panels"
	},
	{
		name: "ShellSidebarPanel",
		path: "layout/content/panels/ShellSidebarPanel",
		styleguidePath: "Layout/Content/Panels/ShellSidebarPanel",
		importPath: "web-ui-components/lib/layout/content/panels"
	},
	{
		name: "SimplePanel",
		path: "layout/content/panels/SimplePanel",
		styleguidePath: "Layout/Content/Panels/SimplePanel",
		importPath: "web-ui-components/lib/layout/content/panels"
	},
	{
		name: "StatusPanel",
		path: "layout/content/panels/StatusPanel",
		styleguidePath: "Layout/Content/Panels/StatusPanel",
		importPath: "web-ui-components/lib/layout/content/panels"
	},
	{
		name: "SubformRevealPanel",
		path: "layout/content/panels/SubformRevealPanel",
		styleguidePath: "Layout/Content/Panels/SubformRevealPanel",
		importPath: "web-ui-components/lib/layout/content/panels"
	},
	{
		name: "ToggleButtonPanel",
		path: "layout/content/panels/ToggleButtonPanel",
		styleguidePath: "Layout/Content/Panels/ToggleButtonPanel",
		importPath: "web-ui-components/lib/layout/content/panels"
	},
	{
		name: "ProcessingScreenTakeover",
		path: "layout/content/takeovers/ProcessingScreenTakeover",
		styleguidePath: "Layout/Content/Takeovers/ProcessingScreenTakeover",
		importPath: "web-ui-components/lib/layout/content/takeovers"
	},
	{
		name: "AttentionTile",
		path: "layout/content/tiles/AttentionTile",
		styleguidePath: "Layout/Content/Tiles/AttentionTile",
		importPath: "web-ui-components/lib/layout/content/tiles"
	},
	{
		name: "GuidanceTile",
		path: "layout/content/tiles/GuidanceTile",
		styleguidePath: "Layout/Content/Tiles/GuidanceTile",
		importPath: "web-ui-components/lib/layout/content/tiles"
	},
	{
		name: "OutcomeTile",
		path: "layout/content/tiles/OutcomeTile",
		styleguidePath: "Layout/Content/Tiles/OutcomeTile",
		importPath: "web-ui-components/lib/layout/content/tiles"
	},
	{
		name: "RecapTile",
		path: "layout/content/tiles/RecapTile",
		styleguidePath: "Layout/Content/Tiles/RecapTile",
		importPath: "web-ui-components/lib/layout/content/tiles"
	},
	{
		name: "StandoutTile",
		path: "layout/content/tiles/StandoutTile",
		styleguidePath: "Layout/Content/Tiles/StandoutTile",
		importPath: "web-ui-components/lib/layout/content/tiles"
	},
	{
		name: "ValidationMessageTile",
		path: "layout/content/tiles/ValidationMessageTile",
		styleguidePath: "Layout/Content/Tiles/ValidationMessageTile",
		importPath: "web-ui-components/lib/layout/content/tiles"
	},
	{
		name: "GridListToggle",
		path: "layout/content/views/GridListToggle",
		styleguidePath: "Layout/Content/Views/GridListToggle",
		importPath: "web-ui-components/lib/layout/content/views"
	},
	{
		name: "GridViewToggle",
		path: "layout/content/views/GridViewToggle",
		styleguidePath: "Layout/Content/Views/GridViewToggle",
		importPath: "web-ui-components/lib/layout/content/views"
	},
	{
		name: "GenericFieldWrapper",
		path: "layout/fieldWrappers/GenericFieldWrapper",
		styleguidePath: "Layout/Field-wrappers/GenericFieldWrapper",
		importPath: "web-ui-components/lib/layout/fieldWrappers"
	},
	{
		name: "GroupFieldWrapper",
		path: "layout/fieldWrappers/GroupFieldWrapper",
		styleguidePath: "Layout/Field-wrappers/GroupFieldWrapper",
		importPath: "web-ui-components/lib/layout/fieldWrappers"
	},
	{
		name: "MainFixedFooter",
		path: "layout/footers/MainFixedFooter",
		styleguidePath: "Layout/Footers/MainFixedFooter",
		importPath: "web-ui-components/lib/layout/footers"
	},
	{
		name: "Grid",
		path: "layout/grids/Grid",
		styleguidePath: "Layout/Grids/Grid",
		importPath: "web-ui-components/lib/layout/grids"
	},
	{
		name: "Inline",
		path: "layout/grids/Inline",
		styleguidePath: "Layout/Grids/Inline",
		importPath: "web-ui-components/lib/layout/grids"
	},
	{
		name: "ContainedHeader",
		path: "layout/headers/ContainedHeader",
		styleguidePath: "Layout/Headers/ContainedHeader",
		importPath: "web-ui-components/lib/layout/headers"
	},
	{
		name: "FixedFooter",
		path: "layout/sections/footers/FixedFooter",
		styleguidePath: "Layout/Sections/Footers/FixedFooter",
		importPath: "web-ui-components/lib/layout/sections/footers"
	},
	{
		name: "ApplicationFormShell",
		path: "layout/shells/ApplicationFormShell",
		styleguidePath: "Layout/Shells/ApplicationFormShell",
		importPath: "web-ui-components/lib/layout/shells"
	},
	{
		name: "DataManagementShell",
		path: "layout/shells/DataManagementShell",
		styleguidePath: "Layout/Shells/DataManagementShell",
		importPath: "web-ui-components/lib/layout/shells"
	},
	{
		name: "ShellInnerSpacer",
		path: "layout/shells/ShellInnerSpacer",
		styleguidePath: "Layout/Shells/ShellInnerSpacer",
		importPath: "web-ui-components/lib/layout/shells"
	},
	{
		name: "VerticalReviewTable",
		path: "layout/tables/VerticalReviewTable",
		styleguidePath: "Layout/Tables/VerticalReviewTable",
		importPath: "web-ui-components/lib/layout/tables"
	},
	{
		name: "NonUKAddressFieldset",
		path: "location/addresses/fieldsets/NonUKAddressFieldset",
		styleguidePath: "Location/Addresses/Fieldsets/NonUKAddressFieldset",
		importPath: "web-ui-components/lib/location/addresses/fieldsets"
	},
	{
		name: "UKAddressFieldset",
		path: "location/addresses/fieldsets/UKAddressFieldset",
		styleguidePath: "Location/Addresses/Fieldsets/UKAddressFieldset",
		importPath: "web-ui-components/lib/location/addresses/fieldsets"
	},
	{
		name: "UKAddressCaptureModule",
		path: "location/addresses/modules/UKAddressCaptureModule",
		styleguidePath: "Location/Addresses/Modules/UKAddressCaptureModule",
		importPath: "web-ui-components/lib/location/addresses/modules"
	},
	{
		name: "UKAddressCaptureModule2",
		path: "location/addresses/modules/UKAddressCaptureModule2",
		styleguidePath: "Location/Addresses/Modules/UKAddressCaptureModule2",
		importPath: "web-ui-components/lib/location/addresses/modules"
	},
	{
		name: "BaseSelect",
		path: "location/places/selects/BaseSelect",
		styleguidePath: "Location/Places/Selects/BaseSelect",
		importPath: "web-ui-components/lib/location/places/selects"
	},
	{
		name: "CountrySelect",
		path: "location/places/selects/CountrySelect",
		styleguidePath: "Location/Places/Selects/CountrySelect",
		importPath: "web-ui-components/lib/location/places/selects"
	},
	{
		name: "UKCitySelect",
		path: "location/places/selects/UKCitySelect",
		styleguidePath: "Location/Places/Selects/UKCitySelect",
		importPath: "web-ui-components/lib/location/places/selects"
	},
	{
		name: "AccordionItem",
		path: "molecules/accordions/Accordion/AccordionItem",
		styleguidePath: "Molecules/Accordions/Accordion/AccordionItem",
		importPath: "web-ui-components/lib/molecules/accordions/accordion"
	},
	{
		name: "Accordion",
		path: "molecules/accordions/Accordion",
		styleguidePath: "Molecules/Accordions/Accordion",
		importPath: "web-ui-components/lib/molecules/accordions"
	},
	{
		name: "AccordionTable",
		path: "molecules/accordions/AccordionTable",
		styleguidePath: "Molecules/Accordions/AccordionTable",
		importPath: "web-ui-components/lib/molecules/accordions"
	},
	{
		name: "ContentReveal",
		path: "molecules/accordions/ContentReveal",
		styleguidePath: "Molecules/Accordions/ContentReveal",
		importPath: "web-ui-components/lib/molecules/accordions"
	},
	{
		name: "ExpansionPanel",
		path: "molecules/accordions/ExpansionPanel",
		styleguidePath: "Molecules/Accordions/ExpansionPanel",
		importPath: "web-ui-components/lib/molecules/accordions"
	},
	{
		name: "ExpansionTable",
		path: "molecules/accordions/ExpansionTable",
		styleguidePath: "Molecules/Accordions/ExpansionTable",
		importPath: "web-ui-components/lib/molecules/accordions"
	},
	{
		name: "ButtonGroup",
		path: "molecules/buttons/ButtonGroup",
		styleguidePath: "Molecules/Buttons/ButtonGroup",
		importPath: "web-ui-components/lib/molecules/buttons"
	},
	{
		name: "SortingCardGroup",
		path: "molecules/card-groups/SortingCardGroup",
		styleguidePath: "Molecules/Card-groups/SortingCardGroup",
		importPath: "web-ui-components/lib/molecules/card-groups"
	},
	{
		name: "AccountCard",
		path: "molecules/cards/AccountCard",
		styleguidePath: "Molecules/Cards/AccountCard",
		importPath: "web-ui-components/lib/molecules/cards"
	},
	{
		name: "AccountSummaryLinkCard",
		path: "molecules/cards/AccountSummaryLinkCard",
		styleguidePath: "Molecules/Cards/AccountSummaryLinkCard",
		importPath: "web-ui-components/lib/molecules/cards"
	},
	{
		name: "DateCard",
		path: "molecules/cards/DateCard",
		styleguidePath: "Molecules/Cards/DateCard",
		importPath: "web-ui-components/lib/molecules/cards"
	},
	{
		name: "PromoCard",
		path: "molecules/cards/PromoCard",
		styleguidePath: "Molecules/Cards/PromoCard",
		importPath: "web-ui-components/lib/molecules/cards"
	},
	{
		name: "StackingCard",
		path: "molecules/cards/StackingCard",
		styleguidePath: "Molecules/Cards/StackingCard",
		importPath: "web-ui-components/lib/molecules/cards"
	},
	{
		name: "Autocomplete",
		path: "molecules/forms/Autocomplete",
		styleguidePath: "Molecules/Forms/Autocomplete",
		importPath: "web-ui-components/lib/molecules/forms"
	},
	{
		name: "ConfirmationCheckbox",
		path: "molecules/forms/ConfirmationCheckbox",
		styleguidePath: "Molecules/Forms/ConfirmationCheckbox",
		importPath: "web-ui-components/lib/molecules/forms"
	},
	{
		name: "DaySelector",
		path: "molecules/forms/DaySelector",
		styleguidePath: "Molecules/Forms/DaySelector",
		importPath: "web-ui-components/lib/molecules/forms"
	},
	{
		name: "FieldBody",
		path: "molecules/forms/Field/FieldBody",
		styleguidePath: "Molecules/Forms/Field/FieldBody",
		importPath: "web-ui-components/lib/molecules/forms/field"
	},
	{
		name: "FieldHeader",
		path: "molecules/forms/Field/FieldHeader",
		styleguidePath: "Molecules/Forms/Field/FieldHeader",
		importPath: "web-ui-components/lib/molecules/forms/field"
	},
	{
		name: "FormField",
		path: "molecules/forms/Field/FormField",
		styleguidePath: "Molecules/Forms/Field/FormField",
		importPath: "web-ui-components/lib/molecules/forms/field"
	},
	{
		name: "Field",
		path: "molecules/forms/Field",
		styleguidePath: "Molecules/Forms/Field",
		importPath: "web-ui-components/lib/molecules/forms"
	},
	{
		name: "PasswordReveal",
		path: "molecules/forms/PasswordReveal",
		styleguidePath: "Molecules/Forms/PasswordReveal",
		importPath: "web-ui-components/lib/molecules/forms"
	},
	{
		name: "RadioCardGroup",
		path: "molecules/forms/RadioCardGroup",
		styleguidePath: "Molecules/Forms/RadioCardGroup",
		importPath: "web-ui-components/lib/molecules/forms"
	},
	{
		name: "Search",
		path: "molecules/forms/Search",
		styleguidePath: "Molecules/Forms/Search",
		importPath: "web-ui-components/lib/molecules/forms"
	},
	{
		name: "SearchForm",
		path: "molecules/forms/SearchForm",
		styleguidePath: "Molecules/Forms/SearchForm",
		importPath: "web-ui-components/lib/molecules/forms"
	},
	{
		name: "SegmentedControl",
		path: "molecules/forms/SegmentedControl",
		styleguidePath: "Molecules/Forms/SegmentedControl",
		importPath: "web-ui-components/lib/molecules/forms"
	},
	{
		name: "SegmentedControlItem",
		path: "molecules/forms/SegmentedControl/SegmentedControlItem",
		styleguidePath: "Molecules/Forms/SegmentedControl/SegmentedControlItem",
		importPath: "web-ui-components/lib/molecules/forms/segmentedControl"
	},
	{
		name: "SegmentedSlider",
		path: "molecules/forms/SegmentedSlider",
		styleguidePath: "Molecules/Forms/SegmentedSlider",
		importPath: "web-ui-components/lib/molecules/forms"
	},
	{
		name: "ValidationMessage",
		path: "molecules/forms/ValidationMessage",
		styleguidePath: "Molecules/Forms/ValidationMessage",
		importPath: "web-ui-components/lib/molecules/forms"
	},
	{
		name: "IconTextDynamic",
		path: "molecules/icon-text-dynamic/IconTextDynamic",
		styleguidePath: "Molecules/IconTextDynamic/IconTextDynamic",
		importPath: "web-ui-components/lib/molecules/icon-text-dynamic"
	},
	{
		name: "IconText",
		path: "molecules/icon-text/IconText",
		styleguidePath: "Molecules/IconText/IconText",
		importPath: "web-ui-components/lib/molecules/icon-text"
	},
	{
		name: "BackAnchor",
		path: "molecules/navigation/BackAnchor",
		styleguidePath: "Molecules/Navigation/BackAnchor",
		importPath: "web-ui-components/lib/molecules/navigation"
	},
	{
		name: "BackButton",
		path: "molecules/navigation/BackButton",
		styleguidePath: "Molecules/Navigation/BackButton",
		importPath: "web-ui-components/lib/molecules/navigation"
	},
	{
		name: "Utility",
		path: "molecules/navigation/Utility",
		styleguidePath: "Molecules/Navigation/Utility",
		importPath: "web-ui-components/lib/molecules/navigation"
	},
	{
		name: "Alert",
		path: "molecules/nbas/Alert",
		styleguidePath: "Molecules/NBAS/Alert",
		importPath: "web-ui-components/lib/molecules/nbas"
	},
	{
		name: "Promo",
		path: "molecules/nbas/Promo",
		styleguidePath: "Molecules/NBAS/Promo",
		importPath: "web-ui-components/lib/molecules/nbas"
	},
	{
		name: "ContrastingFormPanel",
		path: "molecules/panels/ContrastingFormPanel",
		styleguidePath: "Molecules/Panels/ContrastingFormPanel",
		importPath: "web-ui-components/lib/molecules/panels"
	},
	{
		name: "DocumentAction",
		path: "molecules/panels/DocumentAction",
		styleguidePath: "Molecules/Panels/DocumentAction",
		importPath: "web-ui-components/lib/molecules/panels"
	},
	{
		name: "IconifiedBulletPoint",
		path: "molecules/panels/IconifiedBulletPoint",
		styleguidePath: "Molecules/Panels/IconifiedBulletPoint",
		importPath: "web-ui-components/lib/molecules/panels"
	},
	{
		name: "Panel",
		path: "molecules/panels/Panel",
		styleguidePath: "Molecules/Panels/Panel",
		importPath: "web-ui-components/lib/molecules/panels"
	},
	{
		name: "PanelBody",
		path: "molecules/panels/Panel/PanelBody",
		styleguidePath: "Molecules/Panels/Panel/PanelBody",
		importPath: "web-ui-components/lib/molecules/panels/panel"
	},
	{
		name: "PanelFooter",
		path: "molecules/panels/Panel/PanelFooter",
		styleguidePath: "Molecules/Panels/Panel/PanelFooter",
		importPath: "web-ui-components/lib/molecules/panels/panel"
	},
	{
		name: "PanelHeader",
		path: "molecules/panels/Panel/PanelHeader",
		styleguidePath: "Molecules/Panels/Panel/PanelHeader",
		importPath: "web-ui-components/lib/molecules/panels/panel"
	},
	{
		name: "PanelSector",
		path: "molecules/panels/Panel/PanelSector",
		styleguidePath: "Molecules/Panels/Panel/PanelSector",
		importPath: "web-ui-components/lib/molecules/panels/panel"
	},
	{
		name: "SettingLink",
		path: "molecules/panels/SettingLink",
		styleguidePath: "Molecules/Panels/SettingLink",
		importPath: "web-ui-components/lib/molecules/panels"
	},
	{
		name: "SubordinatePanel",
		path: "molecules/panels/SubordinatePanel",
		styleguidePath: "Molecules/Panels/SubordinatePanel",
		importPath: "web-ui-components/lib/molecules/panels"
	},
	{
		name: "TogglePanel",
		path: "molecules/panels/TogglePanel",
		styleguidePath: "Molecules/Panels/TogglePanel",
		importPath: "web-ui-components/lib/molecules/panels"
	},
	{
		name: "PayeeCard",
		path: "molecules/payee-cards/PayeeCard",
		styleguidePath: "Molecules/PayeeCard/PayeeCard",
		importPath: "web-ui-components/lib/molecules/payee-cards"
	},
	{
		name: "PaymentReview",
		path: "molecules/payments/PaymentReview",
		styleguidePath: "Molecules/Payments/PaymentReview",
		importPath: "web-ui-components/lib/molecules/payments"
	},
	{
		name: "ProgressIndicator",
		path: "molecules/progress/ProgressIndicator",
		styleguidePath: "Molecules/Progress/ProgressIndicator",
		importPath: "web-ui-components/lib/molecules/progress"
	},
	{
		name: "ProgressIndicatorItem",
		path: "molecules/progress/ProgressIndicator/ProgressIndicatorItem",
		styleguidePath: "Molecules/Progress/ProgressIndicator/ProgressIndicatorItem",
		importPath: "web-ui-components/lib/molecules/progress/progressIndicator"
	},
	{
		name: "ComparisonTable",
		path: "molecules/tables/ComparisonTable",
		styleguidePath: "Molecules/Tables/ComparisonTable",
		importPath: "web-ui-components/lib/molecules/tables"
	},
	{
		name: "DataTable",
		path: "molecules/tables/Table/DataTable",
		styleguidePath: "Molecules/Tables/Table/DataTable",
		importPath: "web-ui-components/lib/molecules/tables/table"
	},
	{
		name: "Table",
		path: "molecules/tables/Table/Table",
		styleguidePath: "Molecules/Tables/Table/Table",
		importPath: "web-ui-components/lib/molecules/tables/table"
	},
	{
		name: "TableBody",
		path: "molecules/tables/Table/TableBody",
		styleguidePath: "Molecules/Tables/Table/TableBody",
		importPath: "web-ui-components/lib/molecules/tables/table"
	},
	{
		name: "TableBodyData",
		path: "molecules/tables/Table/TableBodyData",
		styleguidePath: "Molecules/Tables/Table/TableBodyData",
		importPath: "web-ui-components/lib/molecules/tables/table"
	},
	{
		name: "TableHead",
		path: "molecules/tables/Table/TableHead",
		styleguidePath: "Molecules/Tables/Table/TableHead",
		importPath: "web-ui-components/lib/molecules/tables/table"
	},
	{
		name: "TableHeadData",
		path: "molecules/tables/Table/TableHeadData",
		styleguidePath: "Molecules/Tables/Table/TableHeadData",
		importPath: "web-ui-components/lib/molecules/tables/table"
	},
	{
		name: "TableRow",
		path: "molecules/tables/Table/TableRow",
		styleguidePath: "Molecules/Tables/Table/TableRow",
		importPath: "web-ui-components/lib/molecules/tables/table"
	},
	{
		name: "SectionHeading",
		path: "molecules/text/SectionHeading",
		styleguidePath: "Molecules/Text/SectionHeading",
		importPath: "web-ui-components/lib/molecules/text"
	},
	{
		name: "ConfirmationTile",
		path: "molecules/tile/ConfirmationTile",
		styleguidePath: "Molecules/Tile/ConfirmationTile",
		importPath: "web-ui-components/lib/molecules/tile"
	},
	{
		name: "ExclamationTile",
		path: "molecules/tile/ExclamationTile",
		styleguidePath: "Molecules/Tile/ExclamationTile",
		importPath: "web-ui-components/lib/molecules/tile"
	},
	{
		name: "HighlightTile",
		path: "molecules/tile/HighlightTile",
		styleguidePath: "Molecules/Tile/HighlightTile",
		importPath: "web-ui-components/lib/molecules/tile"
	},
	{
		name: "IconTile",
		path: "molecules/tile/IconTile",
		styleguidePath: "Molecules/Tile/IconTile",
		importPath: "web-ui-components/lib/molecules/tile"
	},
	{
		name: "NumberedTile",
		path: "molecules/tile/NumberedTile",
		styleguidePath: "Molecules/Tile/NumberedTile",
		importPath: "web-ui-components/lib/molecules/tile"
	},
	{
		name: "Tile",
		path: "molecules/tile/Tile",
		styleguidePath: "Molecules/Tile/Tile",
		importPath: "web-ui-components/lib/molecules/tile"
	},
	{
		name: "TileSector",
		path: "molecules/tile/Tile/TileSector",
		styleguidePath: "Molecules/Tile/Tile/TileSector",
		importPath: "web-ui-components/lib/molecules/tile/tile"
	},
	{
		name: "TileSegment",
		path: "molecules/tile/Tile/TileSegment",
		styleguidePath: "Molecules/Tile/Tile/TileSegment",
		importPath: "web-ui-components/lib/molecules/tile/tile"
	},
	{
		name: "ToggleOption",
		path: "molecules/toggle/ToggleOption",
		styleguidePath: "Molecules/Toggle/ToggleOption",
		importPath: "web-ui-components/lib/molecules/toggle"
	},
	{
		name: "PromoAnchor",
		path: "navigation/anchors/PromoAnchor",
		styleguidePath: "Navigation/Anchors/PromoAnchor",
		importPath: "web-ui-components/lib/navigation/anchors"
	},
	{
		name: "NavigationButton",
		path: "navigation/buttons/NavigationButton",
		styleguidePath: "Navigation/Buttons/NavigationButton",
		importPath: "web-ui-components/lib/navigation/buttons"
	},
	{
		name: "NavigationButtonGroup",
		path: "navigation/buttons/NavigationButtonGroup",
		styleguidePath: "Navigation/Buttons/NavigationButtonGroup",
		importPath: "web-ui-components/lib/navigation/buttons"
	},
	{
		name: "PromoButton",
		path: "navigation/buttons/PromoButton",
		styleguidePath: "Navigation/Buttons/PromoButton",
		importPath: "web-ui-components/lib/navigation/buttons"
	},
	{
		name: "ProgressStepper",
		path: "navigation/indicators/ProgressStepper",
		styleguidePath: "Navigation/Indicators/ProgressStepper",
		importPath: "web-ui-components/lib/navigation/indicators"
	},
	{
		name: "VerticalMenu",
		path: "navigation/menus/VerticalMenu",
		styleguidePath: "Navigation/Menus/VerticalMenu",
		importPath: "web-ui-components/lib/navigation/menus"
	},
	{
		name: "MainNavLink",
		path: "navigation/nav-links/MainNavLink",
		styleguidePath: "Navigation/Nav-links/MainNavLink",
		importPath: "web-ui-components/lib/navigation/nav-links"
	},
	{
		name: "Paginator",
		path: "navigation/pagination/Paginator",
		styleguidePath: "Navigation/Pagination/Paginator",
		importPath: "web-ui-components/lib/navigation/pagination"
	},
	{
		name: "PaginatorNextButton",
		path: "navigation/pagination/Paginator/PaginatorNextButton",
		styleguidePath: "Navigation/Pagination/Paginator/PaginatorNextButton",
		importPath: "web-ui-components/lib/navigation/pagination/paginator"
	},
	{
		name: "PaginatorPageButton",
		path: "navigation/pagination/Paginator/PaginatorPageButton",
		styleguidePath: "Navigation/Pagination/Paginator/PaginatorPageButton",
		importPath: "web-ui-components/lib/navigation/pagination/paginator"
	},
	{
		name: "PaginatorPreviousButton",
		path: "navigation/pagination/Paginator/PaginatorPreviousButton",
		styleguidePath: "Navigation/Pagination/Paginator/PaginatorPreviousButton",
		importPath: "web-ui-components/lib/navigation/pagination/paginator"
	},
	{
		name: "MainSiteNav",
		path: "navigation/site-navs/MainSiteNav",
		styleguidePath: "Navigation/Site-navs/MainSiteNav",
		importPath: "web-ui-components/lib/navigation/site-navs"
	},
	{
		name: "MobileMainSiteNav",
		path: "navigation/site-navs/MobileMainSiteNav",
		styleguidePath: "Navigation/Site-navs/MobileMainSiteNav",
		importPath: "web-ui-components/lib/navigation/site-navs"
	},
	{
		name: "UtilityNav",
		path: "navigation/site-navs/UtilityNav",
		styleguidePath: "Navigation/Site-navs/UtilityNav",
		importPath: "web-ui-components/lib/navigation/site-navs"
	},
	{
		name: "UtilityNavButton",
		path: "navigation/site-navs/UtilityNavButton",
		styleguidePath: "Navigation/Site-navs/UtilityNavButton",
		importPath: "web-ui-components/lib/navigation/site-navs"
	},
	{
		name: "TabCard",
		path: "navigation/tab-cards/TabCard",
		styleguidePath: "Navigation/Tab-cards/TabCard",
		importPath: "web-ui-components/lib/navigation/tab-cards"
	},
	{
		name: "TabCardBlock",
		path: "navigation/tab-cards/TabCardBlock",
		styleguidePath: "Navigation/Tab-cards/TabCardBlock",
		importPath: "web-ui-components/lib/navigation/tab-cards"
	},
	{
		name: "TabCardSmall",
		path: "navigation/tab-cards/TabCardSmall",
		styleguidePath: "Navigation/Tab-cards/TabCardSmall",
		importPath: "web-ui-components/lib/navigation/tab-cards"
	},
	{
		name: "TabGroup",
		path: "navigation/tab-group/TabGroup",
		styleguidePath: "Navigation/Tab-group/TabGroup",
		importPath: "web-ui-components/lib/navigation/tab-group"
	},
	{
		name: "TransferTakeover",
		path: "navigation/takeovers/TransferTakeover",
		styleguidePath: "Navigation/Takeovers/TransferTakeover",
		importPath: "web-ui-components/lib/navigation/takeovers"
	},
	{
		name: "Card",
		path: "organisms/cards/Card",
		styleguidePath: "Organisms/Cards/Card",
		importPath: "web-ui-components/lib/organisms/cards"
	},
	{
		name: "DistinctiveLinkCard",
		path: "organisms/cards/DistinctiveLinkCard",
		styleguidePath: "Organisms/Cards/DistinctiveLinkCard",
		importPath: "web-ui-components/lib/organisms/cards"
	},
	{
		name: "FilterAction",
		path: "organisms/filters/Filter/FilterActionGroup/FilterAction",
		styleguidePath: "Organisms/Filters/Filter/FilterActionGroup/FilterAction",
		importPath: "web-ui-components/lib/organisms/filters/filter/filterActionGroup"
	},
	{
		name: "FilterActionGroup",
		path: "organisms/filters/Filter/FilterActionGroup",
		styleguidePath: "Organisms/Filters/Filter/FilterActionGroup",
		importPath: "web-ui-components/lib/organisms/filters/filter"
	},
	{
		name: "FilterSector",
		path: "organisms/filters/Filter/FilterSector",
		styleguidePath: "Organisms/Filters/Filter/FilterSector",
		importPath: "web-ui-components/lib/organisms/filters/filter"
	},
	{
		name: "FilterSegment",
		path: "organisms/filters/Filter/FilterSegmentGroup/FilterSegment",
		styleguidePath: "Organisms/Filters/Filter/FilterSegmentGroup/FilterSegment",
		importPath: "web-ui-components/lib/organisms/filters/filter/filterSegmentGroup"
	},
	{
		name: "FilterSegmentGroup",
		path: "organisms/filters/Filter/FilterSegmentGroup",
		styleguidePath: "Organisms/Filters/Filter/FilterSegmentGroup",
		importPath: "web-ui-components/lib/organisms/filters/filter"
	},
	{
		name: "FilterSubSegment",
		path: "organisms/filters/Filter/FilterSubSegmentGroup/FilterSubSegment",
		styleguidePath: "Organisms/Filters/Filter/FilterSubSegmentGroup/FilterSubSegment",
		importPath: "web-ui-components/lib/organisms/filters/filter/filterSubSegmentGroup"
	},
	{
		name: "FilterSubSegmentGroup",
		path: "organisms/filters/Filter/FilterSubSegmentGroup",
		styleguidePath: "Organisms/Filters/Filter/FilterSubSegmentGroup",
		importPath: "web-ui-components/lib/organisms/filters/filter"
	},
	{
		name: "Filter",
		path: "organisms/filters/Filter",
		styleguidePath: "Organisms/Filters/Filter",
		importPath: "web-ui-components/lib/organisms/filters"
	},
	{
		name: "GlobalHeader",
		path: "organisms/global/GlobalHeader",
		styleguidePath: "Organisms/Global/GlobalHeader",
		importPath: "web-ui-components/lib/organisms/global"
	},
	{
		name: "HeroHeader",
		path: "organisms/global/HeroHeader",
		styleguidePath: "Organisms/Global/HeroHeader",
		importPath: "web-ui-components/lib/organisms/global"
	},
	{
		name: "CentredModal",
		path: "organisms/modals/CentredModal",
		styleguidePath: "Organisms/Modals/CentredModal",
		importPath: "web-ui-components/lib/organisms/modals"
	},
	{
		name: "ConfirmationModal",
		path: "organisms/modals/ConfirmationModal",
		styleguidePath: "Organisms/Modals/ConfirmationModal",
		importPath: "web-ui-components/lib/organisms/modals"
	},
	{
		name: "Loader",
		path: "organisms/modals/Loader",
		styleguidePath: "Organisms/Modals/Loader",
		importPath: "web-ui-components/lib/organisms/modals"
	},
	{
		name: "ModalBody",
		path: "organisms/modals/Modal/ModalBody",
		styleguidePath: "Organisms/Modals/Modal/ModalBody",
		importPath: "web-ui-components/lib/organisms/modals/modal"
	},
	{
		name: "ModalContainer",
		path: "organisms/modals/Modal/ModalContainer",
		styleguidePath: "Organisms/Modals/Modal/ModalContainer",
		importPath: "web-ui-components/lib/organisms/modals/modal"
	},
	{
		name: "ModalHeader",
		path: "organisms/modals/Modal/ModalHeader",
		styleguidePath: "Organisms/Modals/Modal/ModalHeader",
		importPath: "web-ui-components/lib/organisms/modals/modal"
	},
	{
		name: "Modal",
		path: "organisms/modals/Modal",
		styleguidePath: "Organisms/Modals/Modal",
		importPath: "web-ui-components/lib/organisms/modals"
	},
	{
		name: "UnfinishedWorkModal",
		path: "organisms/modals/UnfinishedWorkModal",
		styleguidePath: "Organisms/Modals/UnfinishedWorkModal",
		importPath: "web-ui-components/lib/organisms/modals"
	},
	{
		name: "DisableTakeover",
		path: "organisms/takeovers/DisableTakeover",
		styleguidePath: "Organisms/Takeovers/DisableTakeover",
		importPath: "web-ui-components/lib/organisms/takeovers"
	},
	{
		name: "LoadingLocalTakeover",
		path: "organisms/takeovers/LoadingLocalTakeover",
		styleguidePath: "Organisms/Takeovers/LoadingLocalTakeover",
		importPath: "web-ui-components/lib/organisms/takeovers"
	},
	{
		name: "Timeline",
		path: "organisms/timelines/Timeline",
		styleguidePath: "Organisms/Timeline/Timeline",
		importPath: "web-ui-components/lib/organisms/timelines"
	},
	{
		name: "ProductSelector",
		path: "products/selection/ProductSelector",
		styleguidePath: "Products/Selection/ProductSelector",
		importPath: "web-ui-components/lib/products/selection"
	},
	{
		name: "EmailCreationInput",
		path: "security/authentication/inputs/EmailCreationInput",
		styleguidePath: "Security/Authentication/Inputs/EmailCreationInput",
		importPath: "web-ui-components/lib/security/authentication/inputs"
	},
	{
		name: "PasswordCreationInput",
		path: "security/authentication/inputs/PasswordCreationInput",
		styleguidePath: "Security/Authentication/Inputs/PasswordCreationInput",
		importPath: "web-ui-components/lib/security/authentication/inputs"
	},
	{
		name: "CallButton",
		path: "telephony/Buttons/CallButton",
		styleguidePath: "Telephony/Buttons/CallButton",
		importPath: "web-ui-components/lib/telephony/buttons"
	},
	{
		name: "CallStatus",
		path: "telephony/Statuses/CallStatus",
		styleguidePath: "Telephony/Statuses/CallStatus",
		importPath: "web-ui-components/lib/telephony/statuses"
	},
	{
		name: "LogoDisplay",
		path: "transactions/logo/LogoDisplay",
		styleguidePath: "Transactions/Logo/LogoDisplay",
		importPath: "web-ui-components/lib/transactions/logo"
	},
	{
		name: "Footer",
		path: "typography/ancillary/Footer",
		styleguidePath: "Typography/Ancillary/Footer",
		importPath: "web-ui-components/lib/typography/ancillary"
	},
	{
		name: "LargeBody",
		path: "typography/body/LargeBody",
		styleguidePath: "Typography/Body/LargeBody",
		importPath: "web-ui-components/lib/typography/body"
	},
	{
		name: "SecondaryBody",
		path: "typography/body/SecondaryBody",
		styleguidePath: "Typography/Body/SecondaryBody",
		importPath: "web-ui-components/lib/typography/body"
	},
	{
		name: "SignificantBody",
		path: "typography/body/SignificantBody",
		styleguidePath: "Typography/Body/SignificantBody",
		importPath: "web-ui-components/lib/typography/body"
	},
	{
		name: "SmallestBody",
		path: "typography/body/SmallestBody",
		styleguidePath: "Typography/Body/SmallestBody",
		importPath: "web-ui-components/lib/typography/body"
	},
	{
		name: "StandardBody",
		path: "typography/body/StandardBody",
		styleguidePath: "Typography/Body/StandardBody",
		importPath: "web-ui-components/lib/typography/body"
	},
	{
		name: "SubBody",
		path: "typography/body/SubBody",
		styleguidePath: "Typography/Body/SubBody",
		importPath: "web-ui-components/lib/typography/body"
	},
	{
		name: "VisuallyHiddenBody",
		path: "typography/body/VisuallyHiddenBody",
		styleguidePath: "Typography/Body/VisuallyHiddenBody",
		importPath: "web-ui-components/lib/typography/body"
	},
	{
		name: "PageHeading",
		path: "typography/headings/PageHeading",
		styleguidePath: "Typography/Headings/PageHeading",
		importPath: "web-ui-components/lib/typography/headings"
	},
	{
		name: "SectionHeading",
		path: "typography/headings/SectionHeading",
		styleguidePath: "Typography/Headings/SectionHeading",
		importPath: "web-ui-components/lib/typography/headings"
	},
	{
		name: "SubHeading",
		path: "typography/headings/SubHeading",
		styleguidePath: "Typography/Headings/SubHeading",
		importPath: "web-ui-components/lib/typography/headings"
	},
	{
		name: "SubsectionHeading",
		path: "typography/headings/SubsectionHeading",
		styleguidePath: "Typography/Headings/SubsectionHeading",
		importPath: "web-ui-components/lib/typography/headings"
	},
	{
		name: "LargeHero",
		path: "typography/heros/LargeHero",
		styleguidePath: "Typography/Heros/LargeHero",
		importPath: "web-ui-components/lib/typography/heros"
	},
	{
		name: "StandardHero",
		path: "typography/heros/StandardHero",
		styleguidePath: "Typography/Heros/StandardHero",
		importPath: "web-ui-components/lib/typography/heros"
	},
	{
		name: "IndicativeHighlight",
		path: "typography/highlights/IndicativeHighlight",
		styleguidePath: "Typography/Highlights/IndicativeHighlight",
		importPath: "web-ui-components/lib/typography/highlights"
	},
	{
		name: "StateIndicator",
		path: "typography/indicators/StateIndicator",
		styleguidePath: "Typography/Indicators/StateIndicator",
		importPath: "web-ui-components/lib/typography/indicators"
	},
	{
		name: "StepIndicator",
		path: "typography/indicators/StepIndicator",
		styleguidePath: "Typography/Indicators/StepIndicator",
		importPath: "web-ui-components/lib/typography/indicators"
	},
	{
		name: "FieldLabel",
		path: "typography/labels/FieldLabel",
		styleguidePath: "Typography/Labels/FieldLabel",
		importPath: "web-ui-components/lib/typography/labels"
	},
	{
		name: "ProminentLabel",
		path: "typography/labels/ProminentLabel",
		styleguidePath: "Typography/Labels/ProminentLabel",
		importPath: "web-ui-components/lib/typography/labels"
	},
	{
		name: "StandardLabel",
		path: "typography/labels/StandardLabel",
		styleguidePath: "Typography/Labels/StandardLabel",
		importPath: "web-ui-components/lib/typography/labels"
	},
	{
		name: "SubLabel",
		path: "typography/labels/SubLabel",
		styleguidePath: "Typography/Labels/SubLabel",
		importPath: "web-ui-components/lib/typography/labels"
	},
	{
		name: "BulletList",
		path: "typography/lists/BulletList",
		styleguidePath: "Typography/Lists/BulletList",
		importPath: "web-ui-components/lib/typography/lists"
	},
	{
		name: "NegativeList",
		path: "typography/lists/NegativeList",
		styleguidePath: "Typography/Lists/NegativeList",
		importPath: "web-ui-components/lib/typography/lists"
	},
	{
		name: "NumberList",
		path: "typography/lists/NumberList",
		styleguidePath: "Typography/Lists/NumberList",
		importPath: "web-ui-components/lib/typography/lists"
	},
	{
		name: "PositiveList",
		path: "typography/lists/PositiveList",
		styleguidePath: "Typography/Lists/PositiveList",
		importPath: "web-ui-components/lib/typography/lists"
	},
	{
		name: "TickList",
		path: "typography/lists/TickList",
		styleguidePath: "Typography/Lists/TickList",
		importPath: "web-ui-components/lib/typography/lists"
	},
	{
		name: "Identifier",
		path: "typography/modifiers/Identifier",
		styleguidePath: "Typography/Modifiers/Identifier",
		importPath: "web-ui-components/lib/typography/modifiers"
	},
	{
		name: "AbbreviatedTag",
		path: "typography/tags/AbbreviatedTag",
		styleguidePath: "Typography/Tags/AbbreviatedTag",
		importPath: "web-ui-components/lib/typography/tags"
	},
	{
		name: "StatusTag",
		path: "typography/tags/StatusTag",
		styleguidePath: "Typography/Tags/StatusTag",
		importPath: "web-ui-components/lib/typography/tags"
	},
	{
		name: "ValueTag",
		path: "typography/tags/ValueTag",
		styleguidePath: "Typography/Tags/ValueTag",
		importPath: "web-ui-components/lib/typography/tags"
	},
	{
		name: "MostProminentValue",
		path: "typography/values/MostProminentValue",
		styleguidePath: "Typography/Values/MostProminentValue",
		importPath: "web-ui-components/lib/typography/values"
	},
	{
		name: "ProminentValue",
		path: "typography/values/ProminentValue",
		styleguidePath: "Typography/Values/ProminentValue",
		importPath: "web-ui-components/lib/typography/values"
	},
	{
		name: "StandardValue",
		path: "typography/values/StandardValue",
		styleguidePath: "Typography/Values/StandardValue",
		importPath: "web-ui-components/lib/typography/values"
	},
	{
		name: "VeryProminentValue",
		path: "typography/values/VeryProminentValue",
		styleguidePath: "Typography/Values/VeryProminentValue",
		importPath: "web-ui-components/lib/typography/values"
	},
	{
		name: "UserStatusBandCard",
		path: "users/business-users/cards/UserStatusBandCard",
		styleguidePath: "Users/Business-users/Cards/UserStatusBandCard",
		importPath: "web-ui-components/lib/users/business-users/cards"
	}
];

var deprecated = [{
	name: "InputRadio",
	path: "src/actions/radios/InputRadio/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "GenericRadio",
			path: "Data/Capture/Radios"
		}
	}],
	deprecationVersion: "23.4.0",
	deprecationDate: "February 17 2020"
}, {
	name: "InputRadioGroup",
	path: "src/actions/radios/InputRadioGroup/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "GenericRadio",
			path: "Data/Capture/Radios"
		}
	}],
	deprecationVersion: "23.4.0",
	deprecationDate: "February 17 2020"
}, {
	name: "TallRadioCard",
	path: "src/actions/radios/TallRadioCard/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "GenericRadio",
			path: "Data/Capture/Radios"
		}
	}],
	deprecationVersion: "27.13.0",
	deprecationDate: "September 9 2021"
}, {
	name: "WideRadioCard",
	path: "src/actions/radios/WideRadioCard/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "GenericRadio",
			path: "Data/Capture/Radios"
		}
	}],
	deprecationVersion: "27.13.0",
	deprecationDate: "September 9 2021"
}, {
	name: "Anchor",
	path: "src/atoms/buttons/Anchor/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "WebsiteLink",
			path: "Actions/Links"
		}
	}],
	deprecationVersion: "25.4.0",
	deprecationDate: "May 01 2020"
}, {
	name: "Button",
	path: "src/atoms/buttons/Button/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: [{
			name: "ActionButton",
			path: "Actions/Buttons"
		}, {
			name: "NavigationButton",
			path: "Navigation/Buttons"
		}]
	}],
	deprecationVersion: "27.4.1",
	deprecationDate: "September 10 2020"
}, {
	name: "Checkbox",
	path: "src/atoms/forms/Checkbox/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "GenericCheckbox",
			path: "Data/Capture/Checkboxes"
		}
	}],
	deprecationVersion: "25.4.0",
	deprecationDate: "May 01 2020"
}, {
	name: "Datepicker",
	path: "src/atoms/forms/Datepicker/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "Calendar",
			path: "Atoms/Forms"
		}
	}],
	deprecationVersion: "7.3.0",
	deprecationDate: "August 30 2018"
}, {
	name: "LabelTitle",
	path: "src/atoms/forms/Label/LabelTitle/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "GenericFieldWrapper",
			path: "Layout/Field-wrappers"
		}
	}],
	deprecationVersion: "27.6.0",
	deprecationDate: "November 20 2020"
}, {
	name: "Label",
	path: "src/atoms/forms/Label/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "GenericFieldWrapper",
			path: "Layout/Field-wrappers"
		}
	}],
	deprecationVersion: "27.6.0",
	deprecationDate: "November 20 2020"
}, {
	name: "Radio",
	path: "src/atoms/forms/Radio/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "GenericRadio",
			path: "Data/Capture/Radios"
		}
	}],
	deprecationVersion: "23.2.0",
	deprecationDate: "February 06 2020"
}, {
	name: "RadioCard",
	path: "src/atoms/forms/RadioCard/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "GenericRadio",
			path: "Data/Capture/Radios"
		}
	}],
	deprecationVersion: "25.4.0",
	deprecationDate: "May 01 2020"
}, {
	name: "Select",
	path: "src/atoms/forms/Select/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "GenericSelect",
			path: "Data/Capture/Selects"
		}
	}],
	deprecationVersion: "24.0.0",
	deprecationDate: "February 27 2020"
}, {
	name: "Textarea",
	path: "src/atoms/forms/Textarea/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "GenericTextArea",
			path: "Data/Capture/TextAreas"
		}
	}],
	deprecationVersion: "19.0.0",
	deprecationDate: "May 03 2019"
}, {
	name: "TextAreaCharacterCount",
	path: "src/atoms/forms/TextAreaCharacterCount/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "GenericTextArea",
			path: "Data/Capture/TextAreas"
		}
	}],
	deprecationVersion: "20.0.0",
	deprecationDate: "May 15 2019"
}, {
	name: "Icon",
	path: "src/atoms/iconography/Icon/package.json",
	"component-life-cycle": "active",
	deprecations: [{
		replacements: {
			name: "ChevronLeftSmall",
			replacement: "ChevronLeftSolidSmall",
			path: "Atoms/Iconography"
		}
	}, {
		replacements: {
			name: "crossOutlineLarge",
			replacement: "CrossOutlineLarge",
			path: "Atoms/Iconography"
		}
	}, {
		replacements: {
			name: "crossOutlineSmall",
			replacement: "CrossOutlineSmall",
			path: "Atoms/Iconography"
		}
	}, {
		replacements: {
			name: "crossOutlineSmall",
			replacement: "CrossOutlineSmall",
			path: "Atoms/Iconography"
		}
	}, {
		replacements: {
			name: "CrossRoundedSolidLarge",
			replacement: "CrossSolidLarge",
			path: "Atoms/Iconography"
		}
	}, {
		replacements: {
			name: "CrossRoundedSolidSmall",
			replacement: "CrossSolidSmall",
			path: "Atoms/Iconography"
		}
	}, {
		replacements: {
			name: "CycleSolidLarge",
			replacement: "CycleLarge",
			path: "Atoms/Iconography"
		}
	}, {
		replacements: {
			name: "CycleSolidSmall",
			replacement: "CycleSmall",
			path: "Atoms/Iconography"
		}
	}]
}, {
	name: "Divider",
	path: "src/atoms/layout/Divider/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "GenericDivider",
			path: "Layout/Content/Breaks"
		}
	}],
	deprecationVersion: "23.1.0",
	deprecationDate: "January 31 2020"
}, {
	name: "BankHeader",
	path: "src/atoms/logo/BankHeader/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "ContainedHeader",
			path: "Layout/Headers"
		}
	}],
	deprecationVersion: "23.1.0",
	deprecationDate: "January 31 2020"
}, {
	name: "Header",
	path: "src/atoms/logo/Header/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "ContainedHeader",
			path: "Layout/Headers"
		}
	}],
	deprecationVersion: "23.1.0",
	deprecationDate: "January 31 2020"
}, {
	name: "BulletedList",
	path: "src/atoms/text/BulletedList/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "BulletList",
			path: "Typography/Lists"
		}
	}],
	deprecationVersion: "23.1.0",
	deprecationDate: "January 31 2020"
}, {
	name: "Callout",
	path: "src/atoms/text/Callout/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "ConditionalPanel",
			path: "Layout/Content/Panels"
		}
	}],
	deprecationVersion: "25.4.0",
	deprecationDate: "May 01 2020"
}, {
	name: "NumberedList",
	path: "src/atoms/text/NumberedList/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "NumberList",
			path: "Typography/Lists"
		}
	}],
	deprecationVersion: "24.0.0",
	deprecationDate: "February 27 2020"
}, {
	name: "TextBody",
	path: "src/atoms/text/TextBody/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "StandardBody",
			path: "Typography/Body"
		}
	}],
	deprecationVersion: "22.3.0",
	deprecationDate: "August 05 2019"
}, {
	name: "TextStyled",
	path: "src/atoms/text/TextStyled/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "Typography",
			path: "Typography"
		}
	}],
	deprecationVersion: "22.3.0",
	deprecationDate: "August 05 2019"
}, {
	name: "TheSmallPrint",
	path: "src/atoms/text/TheSmallPrint/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "SmallestBody",
			path: "Typography/Body"
		}
	}],
	deprecationVersion: "25.4.0",
	deprecationDate: "May 01 2020"
}, {
	name: "Title",
	path: "src/atoms/text/Title/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "Headings",
			path: "Typography"
		}
	}],
	deprecationVersion: "25.4.0",
	deprecationDate: "May 01 2020"
}, {
	name: "GenericTextInput",
	path: "src/data/capture/inputs/GenericTextInput/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "GenericAlphaNumericInput",
			path: "Data/Capture/Inputs"
		}
	}],
	deprecationVersion: "25.1.0",
	deprecationDate: "March 23 2020"
}, {
	name: "DocumentLink",
	path: "src/documents/navigation/links/DocumentLink/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "ActionButton",
			path: "Actions/Buttons"
		}
	}],
	deprecationVersion: "27.3.0",
	deprecationDate: "September 01 2020"
}, {
	name: "DocumentLinkPlate",
	path: "src/documents/navigation/plates/DocumentLinkPlate/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "Inline",
			path: "Layout/Grids"
		}
	}],
	deprecationVersion: "27.3.0",
	deprecationDate: "September 01 2020"
}, {
	name: "PrintButton",
	path: "src/documents/printing/buttons/PrintButton/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "ActionButton",
			path: "Actions/Buttons/ActionButton"
		}
	}],
	deprecationVersion: "25.4.0",
	deprecationDate: "May 01 2020"
}, {
	name: "FileInput",
	path: "src/documents/upload/FileInput/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "FileUploadInput",
			path: "Data/Capture/Inputs"
		}
	}],
	deprecationVersion: "27.6.0",
	deprecationDate: "November 20 2020"
}, {
	name: "AccountLegacyPanel",
	path: "src/finance/accounts/panels/AccountLegacyPanel/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "AccountBalancesSelectPanel",
			path: "Finance/Accounts/Panels"
		}
	}],
	deprecationVersion: "22.1.0",
	deprecationDate: "July 17 2019"
}, {
	name: "CenterImageContainer",
	path: "src/global/layout/CenterImageContainer/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "Inline",
			path: "Layout/Grids",
			variant: "Centered"
		}
	}],
	deprecationVersion: "27.9.0",
	deprecationDate: "March 24 2021"
}, {
	name: "Column",
	path: "src/global/layout/Column/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "Inline",
			path: "Layout/Grids"
		}
	}],
	deprecationVersion: "27.5.0",
	deprecationDate: "October 30 2020"
}, {
	name: "Container",
	path: "src/global/layout/Container/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "ContentContainer",
			path: "Layout/Sections"
		}
	}],
	deprecationVersion: "23.1.0",
	deprecationDate: "January 31 2020"
}, {
	name: "FlexColumn",
	path: "src/global/layout/FlexColumn/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "Inline",
			path: "Layout/Grids"
		}
	}],
	deprecationVersion: "27.5.0",
	deprecationDate: "October 30 2020"
}, {
	name: "FlexRow",
	path: "src/global/layout/FlexRow/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "Inline",
			path: "Layout/Grids"
		}
	}],
	deprecationVersion: "27.5.0",
	deprecationDate: "October 30 2020"
}, {
	name: "Frame",
	path: "src/global/layout/Frame/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "ApplicationFormShell",
			path: "Layout/Shells"
		}
	}],
	deprecationVersion: "27.4.0",
	deprecationDate: "September 07 2020"
}, {
	name: "LeftAndRightAlignment",
	path: "src/global/layout/LeftAndRightAlignment/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "Inline",
			path: "Layout/Grids"
		}
	}],
	deprecationVersion: "27.4.0",
	deprecationDate: "September 07 2020"
}, {
	name: "PageLayout",
	path: "src/global/layout/PageLayout/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "ApplicationFormShell",
			path: "Layout/Shells"
		}
	}],
	deprecationVersion: "27.4.0",
	deprecationDate: "September 07 2020"
}, {
	name: "HeaderSection",
	path: "src/global/layout/Pages/HeaderSection/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "ContainedHeader",
			path: "Layout/Headers"
		}
	}],
	deprecationVersion: "23.1.0",
	deprecationDate: "January 31 2020"
}, {
	name: "ServicingSection",
	path: "src/global/layout/Pages/ServicingSection/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "DataManagementShell",
			path: "Layout/Shells"
		}
	}],
	deprecationVersion: "25.4.0",
	deprecationDate: "May 01 2020"
}, {
	name: "WorkflowSection",
	path: "src/global/layout/Pages/WorkflowSection/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "ApplicationFormShell",
			path: "Layout/Shells"
		}
	}],
	deprecationVersion: "25.4.0",
	deprecationDate: "May 01 2020"
}, {
	name: "ResponsiveLayoutPair",
	path: "src/global/layout/ResponsiveLayoutPair/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "Inline",
			path: "Layout/Grids"
		}
	}],
	deprecationVersion: "27.2.2",
	deprecationDate: "July 31 2020"
}, {
	name: "Row",
	path: "src/global/layout/Row/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "Inline",
			path: "Layout/Grids"
		}
	}],
	deprecationVersion: "27.5.0",
	deprecationDate: "October 30 2020"
}, {
	name: "ContentContainer",
	path: "src/layout/containers/ContentContainer/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "ApplicationFormShell",
			path: "Layout/Shells"
		}
	}],
	deprecationVersion: "25.4.0",
	deprecationDate: "May 01 2020"
}, {
	name: "Main",
	path: "src/layout/containers/Main/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "ApplicationFormShell",
			path: "Layout/Shells/ApplicationFormShell"
		}
	}],
	deprecationVersion: "23.1.0",
	deprecationDate: "January 31 2020"
}, {
	name: "ContentRevealPanel",
	path: "src/layout/content/panels/ContentRevealPanel/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "SubformRevealPanel",
			path: "Layout/Content/Panels"
		}
	}],
	deprecationVersion: "27.7.0",
	deprecationDate: "December 16 2020"
}, {
	name: "ShellSidebarPanel",
	path: "src/layout/content/panels/ShellSidebarPanel/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "ShellPanel",
			path: "Layout/Content/Panels"
		}
	}],
	deprecationVersion: "27.9.0",
	deprecationDate: "March 24 2021"
}, {
	name: "GuidanceTile",
	path: "src/layout/content/tiles/GuidanceTile/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "StandoutTile",
			path: "Layout/Content/Tiles"
		}
	}],
	deprecationVersion: "25.4.0",
	deprecationDate: "May 01 2020"
}, {
	name: "RecapTile",
	path: "src/layout/content/tiles/RecapTile/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "StandoutTile",
			path: "Layout/Content/Tiles"
		}
	}],
	deprecationVersion: "25.4.0",
	deprecationDate: "May 01 2020"
}, {
	name: "GridViewToggle",
	path: "src/layout/content/views/GridViewToggle/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "GridListToggle",
			path: "Layout/Content/Views"
		}
	}],
	deprecationVersion: "28.3.0",
	deprecationDate: "January 21 2022"
}, {
	name: "FixedFooter",
	path: "src/layout/sections/footers/FixedFooter/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "MainFixedFooter",
			path: "Layout/Footers"
		}
	}],
	deprecationVersion: "23.1.0",
	deprecationDate: "January 31 2020"
}, {
	name: "AccordionItem",
	path: "src/molecules/accordions/Accordion/AccordionItem/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "GenericAccordion",
			path: "Layout/Content/Accordions"
		}
	}],
	deprecationVersion: "25.4.0",
	deprecationDate: "May 01 2020"
}, {
	name: "Accordion",
	path: "src/molecules/accordions/Accordion/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "GenericAccordion",
			path: "Layout/Content/Accordions"
		}
	}],
	deprecationVersion: "25.4.0",
	deprecationDate: "May 01 2020"
}, {
	name: "AccordionTable",
	path: "src/molecules/accordions/AccordionTable/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "GenericAccordion",
			path: "Layout/Content/Accordions"
		}
	}],
	deprecationVersion: "25.4.0",
	deprecationDate: "May 01 2020"
}, {
	name: "ContentReveal",
	path: "src/molecules/accordions/ContentReveal/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "ContentRevealPanel",
			path: "Layout/Content/Panels"
		}
	}],
	deprecationVersion: "24.1.0",
	deprecationDate: "March 05 2020"
}, {
	name: "ExpansionPanel",
	path: "src/molecules/accordions/ExpansionPanel/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: [{
			name: "SubformRevealPanel",
			path: "Layout/Content/Panels"
		}, {
			name: "GenericAccordion",
			path: "Layout/Content/Accordions/GenericAccordion"
		}, {
			name: "InformationRevealPanel",
			path: "Layout/Content/Panels"
		}]
	}],
	deprecationVersion: "27.3.0",
	deprecationDate: "September 01 2020"
}, {
	name: "ExpansionTable",
	path: "src/molecules/accordions/ExpansionTable/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "ContentRevealPanel",
			path: "Layout/Content/Panels"
		}
	}],
	deprecationVersion: "27.3.0",
	deprecationDate: "September 01 2020"
}, {
	name: "ButtonGroup",
	path: "src/molecules/buttons/ButtonGroup/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: [{
			name: "NavigationButtonGroup",
			path: "Navigation/Buttons"
		}, {
			name: "Inline",
			path: "Layout/Grids"
		}]
	}],
	deprecationVersion: "27.4.1",
	deprecationDate: "September 10 2020"
}, {
	name: "ConfirmationCheckbox",
	path: "src/molecules/forms/ConfirmationCheckbox/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "StandaloneCheckbox",
			path: "Data/Capture/Checkboxes"
		}
	}],
	deprecationVersion: "25.4.0",
	deprecationDate: "May 01 2020"
}, {
	name: "DaySelector",
	path: "src/molecules/forms/DaySelector/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "GenericRadio",
			path: "Data/Capture/Radios"
		}
	}],
	deprecationVersion: "25.4.0",
	deprecationDate: "May 01 2020"
}, {
	name: "FieldBody",
	path: "src/molecules/forms/Field/FieldBody/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "GenericFieldWrapper",
			path: "Layout/Field-wrappers"
		}
	}],
	deprecationVersion: "27.4.0",
	deprecationDate: "September 07 2020"
}, {
	name: "FieldHeader",
	path: "src/molecules/forms/Field/FieldHeader/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "GenericFieldWrapper",
			path: "Layout/Field-wrappers"
		}
	}],
	deprecationVersion: "27.4.0",
	deprecationDate: "September 07 2020"
}, {
	name: "Field",
	path: "src/molecules/forms/Field/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "GenericFieldWrapper",
			path: "Layout/Field-wrappers"
		}
	}],
	deprecationVersion: "27.4.0",
	deprecationDate: "September 07 2020"
}, {
	name: "RadioCardGroup",
	path: "src/molecules/forms/RadioCardGroup/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "GenericRadio",
			path: "Data/Capture/Radios"
		}
	}],
	deprecationVersion: "25.4.0",
	deprecationDate: "May 01 2020"
}, {
	name: "SegmentedSlider",
	path: "src/molecules/forms/SegmentedSlider/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "SliderInput",
			path: "Data/Capture/Inputs"
		}
	}],
	deprecationVersion: "28.4.0",
	deprecationDate: "June 21 2022"
}, {
	name: "ValidationMessage",
	path: "src/molecules/forms/ValidationMessage/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "ValidationMessageTile",
			path: "Layout/Tiles"
		}
	}],
	deprecationVersion: "22.22.0",
	deprecationDate: "January 20 2020"
}, {
	name: "IconText",
	path: "src/molecules/icon-text/IconText/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "IconTextDynamic",
			path: "Molecules/IconTextDynamic"
		}
	}],
	deprecationVersion: "6.4.0",
	deprecationDate: "August 03 2018"
}, {
	name: "BackAnchor",
	path: "src/molecules/navigation/BackAnchor/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "WebsiteLink",
			path: "Actions/Links"
		}
	}],
	deprecationVersion: "25.4.0",
	deprecationDate: "May 01 2020"
}, {
	name: "BackButton",
	path: "src/molecules/navigation/BackButton/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "UtilityNavButton",
			path: "Navigation/Site-navs"
		}
	}],
	deprecationVersion: "25.5.0",
	deprecationDate: "May 13 2020"
}, {
	name: "Utility",
	path: "src/molecules/navigation/Utility/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "UtilityNav",
			path: "Navigation/Site-Navs/UtilityNav"
		}
	}],
	deprecationVersion: "22.12.0",
	deprecationDate: "September 27 2019"
}, {
	name: "ContrastingFormPanel",
	path: "src/molecules/panels/ContrastingFormPanel/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "GenericPanel",
			path: "Layout/Content/Panels",
			variant: "Interaction"
		}
	}],
	deprecationVersion: "33.3.0",
	deprecationDate: "April 03 2024"
}, {
	name: "SubordinatePanel",
	path: "src/molecules/panels/SubordinatePanel/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "ConditionalPanel",
			path: "Layout/Content/Panels"
		}
	}],
	deprecationVersion: "23.1.0",
	deprecationDate: "January 31 2020"
}, {
	name: "ProgressIndicator",
	path: "src/molecules/progress/ProgressIndicator/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "ProgressStepper",
			path: "Navigation/Indicators"
		}
	}],
	deprecationVersion: "26.0.0",
	deprecationDate: "May 22 2020"
}, {
	name: "ProgressIndicatorItem",
	path: "src/molecules/progress/ProgressIndicator/ProgressIndicatorItem/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "ProgressStepper",
			path: "Navigation/Indicators"
		}
	}],
	deprecationVersion: "26.0.0",
	deprecationDate: "May 22 2020"
}, {
	name: "SectionHeading",
	path: "src/molecules/text/SectionHeading/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "SectionHeading",
			path: "Typography/Headings"
		}
	}],
	deprecationVersion: "23.2.0",
	deprecationDate: "February 06 2020"
}, {
	name: "ConfirmationTile",
	path: "src/molecules/tile/ConfirmationTile/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "OutcomeTile",
			path: "Layout/Content/Tiles"
		}
	}],
	deprecationVersion: "25.4.0",
	deprecationDate: "May 01 2020"
}, {
	name: "HighlightTile",
	path: "src/molecules/tile/HighlightTile/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "StandoutTile",
			path: "Layout/Content/Tiles"
		}
	}],
	deprecationVersion: "25.4.0",
	deprecationDate: "May 01 2020"
}, {
	name: "IconTile",
	path: "src/molecules/tile/IconTile/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "OutcomeTile",
			path: "Layout/Content/Tiles"
		}
	}],
	deprecationVersion: "25.4.0",
	deprecationDate: "May 01 2020"
}, {
	name: "NavigationButton",
	path: "src/navigation/buttons/NavigationButton/package.json",
	"component-life-cycle": "active",
	deprecations: [{
		variants: ["Confirm", "Continue", "Next", "Submit"],
		replacements: {
			name: "NavigationButton",
			path: "Navigation/Buttons",
			variant: "Primary"
		}
	}, {
		variants: ["Back"],
		replacements: {
			name: "NavigationButton",
			path: "Navigation/Buttons",
			variant: "Secondary"
		}
	}, {
		variants: ["Cancel"],
		replacements: {
			name: "NavigationButton",
			path: "Navigation/Buttons",
			variant: "Tertiary"
		}
	}],
	deprecationVersion: "NO RELEASE VERSION FOUND",
	deprecationDate: "NO RELEASE DATE FOUND"
}, {
	name: "GlobalHeader",
	path: "src/organisms/global/GlobalHeader/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "ContainedHeader",
			path: "Layout/Headers"
		}
	}],
	deprecationVersion: "25.4.0",
	deprecationDate: "May 01 2020"
}, {
	name: "CentredModal",
	path: "src/organisms/modals/CentredModal/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "ConfirmationModal",
			path: "Organisms/Modals"
		}
	}],
	deprecationVersion: "22.0.0",
	deprecationDate: "July 04 2019"
}, {
	name: "ConfirmationModal",
	path: "src/organisms/modals/ConfirmationModal/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "GenericModal",
			path: "Layout/Content/Modals"
		}
	}],
	deprecationVersion: "27.8.0",
	deprecationDate: "January 29 2021"
}, {
	name: "Modal",
	path: "src/organisms/modals/Modal/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "ConfirmationModal",
			path: "Organisms/Modals"
		}
	}],
	deprecationVersion: "22.0.0",
	deprecationDate: "July 04 2019"
}, {
	name: "LargeHero",
	path: "src/typography/heros/LargeHero/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "Typography",
			path: "Typography"
		}
	}],
	deprecationVersion: "24.0.0",
	deprecationDate: "February 27 2020"
}, {
	name: "StandardHero",
	path: "src/typography/heros/StandardHero/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "Typography",
			path: "Typography"
		}
	}],
	deprecationVersion: "24.0.0",
	deprecationDate: "February 27 2020"
}];

/* eslint-disable no-console */

var deprecatedDictComponents = {};
var deprecatedDictProps = {};
var timeoutDelay = 100;

var CONSOLE_DEPRECATION_MESSAGE_START = 'Deprecation: web-ui-components';

var DeprecationWarnings = {
	logComponent: function logComponent(componentName) {
		var deprecatedComponentObj = componentPaths.find(function (_ref) {
			var name = _ref.name;
			return name === componentName;
		});
		var oldPath = deprecatedComponentObj.styleguidePath;
		deprecatedComponentObj = deprecated.find(function (_ref2) {
			var name = _ref2.name;
			return name.includes(componentName);
		});

		var depreactionReplacements = deprecatedComponentObj.deprecations[0].replacements;
		var hasMultipleReplacements = Array.isArray(depreactionReplacements);
		var newPath = hasMultipleReplacements ? depreactionReplacements.map(function (replacement) {
			return replacement.path + '/' + replacement.name;
		}) : depreactionReplacements.path + '/' + depreactionReplacements.name;

		deprecatedDictComponents[componentName] = { oldPath: oldPath, newPath: newPath };
	},
	logIcon: function logIcon(componentName, deprecatedIcon) {
		var deprecatedComponentObj = componentPaths.find(function (_ref3) {
			var name = _ref3.name;
			return name.includes(componentName);
		});
		var path = deprecatedComponentObj.styleguidePath;
		var oldPath = path + ': ' + deprecatedIcon;
		var newPath = path + ': ' + deprecatedIcon;
		var iconName = componentName + ': ' + deprecatedIcon;

		deprecatedDictComponents[iconName] = { oldPath: oldPath, newPath: newPath };
	},
	logProp: function logProp(packageJson, description) {
		var _packageJson$main$spl = packageJson.main.split('.'),
		    _packageJson$main$spl2 = slicedToArray(_packageJson$main$spl, 1),
		    componentName = _packageJson$main$spl2[0];

		var deprecatedComponentObj = componentPaths.find(function (_ref4) {
			var name = _ref4.name;
			return name.includes(componentName);
		});
		var path = deprecatedComponentObj.styleguidePath;
		deprecatedDictProps[componentName] = { path: path, description: description };
	},
	report: function report() {
		setTimeout(function () {
			var numberOfDeprecations = Object.keys(deprecatedDictComponents).length + Object.keys(deprecatedDictProps).length;
			if (numberOfDeprecations > 0) {
				console.groupCollapsed('Web UI Components Deprecation Warnings. Total: ' + numberOfDeprecations);

				console.groupCollapsed('Components. Total: ' + Object.keys(deprecatedDictComponents).length);
				Object.entries(deprecatedDictComponents).forEach(function (_ref5) {
					var _ref6 = slicedToArray(_ref5, 2),
					    componentName = _ref6[0],
					    info = _ref6[1];

					var oldPath = info.oldPath,
					    newPath = info.newPath;

					console.groupCollapsed(componentName);
					console.warn('Deprecated:', oldPath);

					var hasMultipleReplacements = Array.isArray(newPath);
					if (hasMultipleReplacements) {
						newPath.map(function (replacement, index) {
							return console.warn('Replacement ' + (index + 1) + ':', replacement);
						});
					} else {
						console.warn('Replacement:', newPath);
					}
					console.groupEnd();
				});
				console.groupEnd();

				console.groupCollapsed('Props. Total: ' + Object.keys(deprecatedDictProps).length);
				Object.entries(deprecatedDictProps).forEach(function (_ref7) {
					var _ref8 = slicedToArray(_ref7, 2),
					    componentName = _ref8[0],
					    info = _ref8[1];

					var path = info.path,
					    description = info.description;

					console.groupCollapsed(componentName);
					console.warn('Deprecated:', path);
					console.warn('Reason:', description);
					console.groupEnd();
				});
				console.groupEnd();

				console.groupEnd();
				deprecatedDictComponents = {};
				deprecatedDictProps = {};
			}
		}, timeoutDelay);
	},
	warn: function warn(message) {
		return console.warn(CONSOLE_DEPRECATION_MESSAGE_START + ' -> ' + message);
	}
};

Object.freeze(DeprecationWarnings);

var main$j = "AccountAuthorisationPanel.js";
var packageJson$j = {
	main: main$j,
	"component-id": null,
	"component-life-cycle": "active",
	"is-bespoke": true
};

var _templateObject$v = taggedTemplateLiteral(['\n\tbackground-color: ', ';\n\tborder-radius: ', ';\n\t', ';\n\n\tsvg {\n\t\tdisplay: block;\n\t\tfill: ', ';\n\t\theight: 40px;\n\t\tmargin: 0 auto ', ' auto;\n\t\twidth: 40px;\n\t}\n\n\th2 {\n\t\tcolor: ', ';\n\t\tmargin-left: auto;\n\t\tmargin-right: auto;\n\t\tmax-width: 50%;\n\t\ttext-align: center;\n\t}\n'], ['\n\tbackground-color: ', ';\n\tborder-radius: ', ';\n\t', ';\n\n\tsvg {\n\t\tdisplay: block;\n\t\tfill: ', ';\n\t\theight: 40px;\n\t\tmargin: 0 auto ', ' auto;\n\t\twidth: 40px;\n\t}\n\n\th2 {\n\t\tcolor: ', ';\n\t\tmargin-left: auto;\n\t\tmargin-right: auto;\n\t\tmax-width: 50%;\n\t\ttext-align: center;\n\t}\n']);

var StyledWrapper$7 = styled('div')(_templateObject$v, colours.component.tableCell, function (props) {
	return props.theme.borderRadius;
}, internalPaddingRegular, function (props) {
	return props.theme.colours.primary;
}, spacing.SINGLE, function (props) {
	return props.theme.colours.primary;
});

var AccountAuthorisationPanel = function AccountAuthorisationPanel(_ref) {
	var children = _ref.children,
	    title = _ref.title,
	    titleText = _ref.titleText,
	    dataTestId = _ref['data-test-id'];

	if (title !== undefined) {
		DeprecationWarnings.logProp(packageJson$j, 'title prop deprecated in favour of titleText prop.');
	}

	return React.createElement(
		InternalComponentFrame,
		{ packageJson: packageJson$j },
		React.createElement(
			StyledWrapper$7,
			{ 'data-test-id': dataTestId },
			React.createElement(AuthorisationLarge, null),
			React.createElement(
				SubHeading,
				null,
				titleText || title
			),
			React.createElement(
				StandardBody,
				null,
				React.createElement(
					'span',
					null,
					children
				)
			)
		)
	);
};

AccountAuthorisationPanel.propTypes = {
	/** Child content as nodes. */
	children: PropTypes.node.isRequired,
	/** DEPRECATED: Use titleText prop. */
	title: PropTypes.string,
	/** Title text. */
	titleText: PropTypes.string,
	/** Partial Data attribute targeting component for automation test purposes. */
	'data-test-id': PropTypes.string
};

AccountAuthorisationPanel.defaultProps = {
	title: 'Authorisation required',
	'data-test-id': 'account-authorisation-panel'
};

var _extends$a = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$9(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var GenericIcon$3 = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$9(_ref, ["styles"]);

  return React.createElement("svg", _extends$a({ width: "96", height: "96", viewBox: "0 0 96 96", xmlns: "http://www.w3.org/2000/svg" }, props), React.createElement("path", { d: "M48 62.862l39.413-40.354a4.972 4.972 0 0 1 7.114 0l.144.148a5 5 0 0 1 0 6.988L51.845 73.492A4.96 4.96 0 0 1 48 74.982a4.959 4.959 0 0 1-3.845-1.49L1.329 29.644a5 5 0 0 1 0-6.988l.144-.148a4.972 4.972 0 0 1 7.114 0L48 62.862z" }));
});

var _extends$b = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$a(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var VMIcon$3 = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$a(_ref, ["styles"]);

  return React.createElement("svg", _extends$b({ height: "96", viewBox: "0 0 96 96", width: "96", xmlns: "http://www.w3.org/2000/svg" }, props), React.createElement("path", { d: "M48.799 76.174a7.134 7.134 0 0 1-5.06-2.097L.8 31.137l10.12-10.12 37.88 37.88 37.88-37.88 10.12 10.12-42.94 42.94a7.134 7.134 0 0 1-5.06 2.097z" }));
});

var getChevronDownSolidLarge = getThemeIcon(VMIcon$3, GenericIcon$3);

var main$k = "AccountBalancesSelectPanel.js";
var packageJson$k = {
	main: main$k,
	"component-id": null,
	"component-life-cycle": "active",
	"is-bespoke": true
};

var _templateObject$w = taggedTemplateLiteral(['\n\tmargin-bottom: ', ';\n'], ['\n\tmargin-bottom: ', ';\n']),
    _templateObject2$g = taggedTemplateLiteral(['\n\talign-items: center;\n\tbackground: none;\n\tborder: none;\n\tdisplay: inline-flex;\n\tpadding: 0;\n\n\tsvg {\n\t\tmargin-left: ', ';\n\t}\n'], ['\n\talign-items: center;\n\tbackground: none;\n\tborder: none;\n\tdisplay: inline-flex;\n\tpadding: 0;\n\n\tsvg {\n\t\tmargin-left: ', ';\n\t}\n']),
    _templateObject3$d = taggedTemplateLiteral(['\n\t', ';\n'], ['\n\t', ';\n']),
    _templateObject4$6 = taggedTemplateLiteral(['\n\tbackground-color: ', ';\n\tborder: 1px solid ', ';\n\tborder-radius: ', ';\n\tbox-shadow: ', ';\n\tposition: absolute;\n\tmax-height: 380px;\n\tmin-width: 300px;\n\toverflow: scroll;\n\tz-index: ', ';\n'], ['\n\tbackground-color: ', ';\n\tborder: 1px solid ', ';\n\tborder-radius: ', ';\n\tbox-shadow: ', ';\n\tposition: absolute;\n\tmax-height: 380px;\n\tmin-width: 300px;\n\toverflow: scroll;\n\tz-index: ', ';\n']),
    _templateObject5$5 = taggedTemplateLiteral(['\n\tborder-bottom: 1px solid ', ';\n\tpadding: ', ' ', ';\n\tdisplay: block;\n\ttext-align: left;\n\twidth: 100%;\n\n\t&:hover {\n\t\tbackground-color: ', ';\n\t}\n\n\t&:last-child {\n\t\tborder-bottom: none;\n\t}\n'], ['\n\tborder-bottom: 1px solid ', ';\n\tpadding: ', ' ', ';\n\tdisplay: block;\n\ttext-align: left;\n\twidth: 100%;\n\n\t&:hover {\n\t\tbackground-color: ', ';\n\t}\n\n\t&:last-child {\n\t\tborder-bottom: none;\n\t}\n']),
    _templateObject6$5 = taggedTemplateLiteral(['\n\talign-items: center;\n\tbackground: none;\n\tborder: none;\n\tborder-radius: ', ';\n\tcolor: ', ';\n\tdisplay: inline-flex;\n\tjustify-content: space-between;\n\tpadding: 0 ', ';\n\ttext-decoration: ', ';\n\n\tsvg {\n\t\tfill: ', ';\n\t\theight: 16px;\n\t\tmargin-left: ', ';\n\t\t', ' transition: transform 0.15s;\n\t\twidth: 16px;\n\t}\n'], ['\n\talign-items: center;\n\tbackground: none;\n\tborder: none;\n\tborder-radius: ', ';\n\tcolor: ', ';\n\tdisplay: inline-flex;\n\tjustify-content: space-between;\n\tpadding: 0 ', ';\n\ttext-decoration: ', ';\n\n\tsvg {\n\t\tfill: ', ';\n\t\theight: 16px;\n\t\tmargin-left: ', ';\n\t\t', ' transition: transform 0.15s;\n\t\twidth: 16px;\n\t}\n']),
    _templateObject7$3 = taggedTemplateLiteral(['\n\tfont-family: ', ';\n'], ['\n\tfont-family: ', ';\n']),
    _templateObject8$2 = taggedTemplateLiteral(['\n\ttext-align: right;\n\tpadding: ', ';\n\twidth: 50%;\n\tmargin-left: 50%;\n'], ['\n\ttext-align: right;\n\tpadding: ', ';\n\twidth: 50%;\n\tmargin-left: 50%;\n']),
    _templateObject9 = taggedTemplateLiteral(['\n\t', ' text-align: left;\n\tsvg {\n\t\theight: 16px;\n\t\twidth: 16px;\n\t}\n'], ['\n\t', ' text-align: left;\n\tsvg {\n\t\theight: 16px;\n\t\twidth: 16px;\n\t}\n']),
    _templateObject10 = taggedTemplateLiteral(['\n\tmargin: ', ';\n\ttext-align: right;\n\t> span {\n\t\tdisplay: block;\n\t}\n\n\tsvg {\n\t\theight: 16px;\n\t\twidth: 16px;\n\t}\n'], ['\n\tmargin: ', ';\n\ttext-align: right;\n\t> span {\n\t\tdisplay: block;\n\t}\n\n\tsvg {\n\t\theight: 16px;\n\t\twidth: 16px;\n\t}\n']),
    _templateObject11 = taggedTemplateLiteral(['\n\tfont-size: ', ';\n\tpadding-right: ', ';\n'], ['\n\tfont-size: ', ';\n\tpadding-right: ', ';\n']),
    _templateObject12 = taggedTemplateLiteral(['\n\tbackground: ', ';\n\tborder: 1px solid ', ';\n\tborder-radius: ', ';\n\tbox-sizing: border-box;\n\tcolor: ', ';\n\tpadding-left: ', ';\n\tpadding-top: ', ';\n\tposition: relative;\n\n\t> div {\n\t\t> div:nth-child(2) {\n\t\t\tmargin: 0;\n\t\t}\n\t}\n\n\t', ';\n'], ['\n\tbackground: ', ';\n\tborder: 1px solid ', ';\n\tborder-radius: ', ';\n\tbox-sizing: border-box;\n\tcolor: ', ';\n\tpadding-left: ', ';\n\tpadding-top: ', ';\n\tposition: relative;\n\n\t> div {\n\t\t> div:nth-child(2) {\n\t\t\tmargin: 0;\n\t\t}\n\t}\n\n\t', ';\n']);

var StyledAccountBalance = styled('div')(_templateObject$w, function (props) {
	return props.theme.components.accountBalancesSelectPanel.root.marginBottom;
});

var StyledAccountButton = styled('button')(_templateObject2$g, spacing.HALF);

var StyledAccountDetails$2 = styled('div')(_templateObject$w, function (props) {
	return props.theme.components.accountBalancesSelectPanel.root.marginBottom;
});

var StyledAccountName$3 = styled('div')(_templateObject3$d, function (props) {
	return !props.dropDownIsOpen && 'margin-bottom: ' + props.theme.components.accountBalancesSelectPanel.root.marginBottom + ';';
});

var StyledDropDown = styled('div')(_templateObject4$6, colours.component.background, colours.component.border, function (props) {
	return props.theme.borderRadius;
}, function (props) {
	return props.theme.boxShadow;
}, layers.accountLegacyPanelDropdown);

var StyledDropDownButton = styled('button')(_templateObject5$5, colours.component.border, spacing.SINGLE, spacing.DOUBLE, colours.component.hover);

var StyledMoreButton = styled('button')(_templateObject6$5, function (props) {
	return props.theme.borderRadius;
}, function (props) {
	return props.theme.colours.primary;
}, spacing.HALF, function (props) {
	return props.theme.components.accountPoolTablePanel.root.textDecoration;
}, function (props) {
	return props.theme.colours.primary;
}, spacing.HALF, function (props) {
	return props.isExpanded && 'transform: rotate(180deg);';
});

var StyledMoreText = styled('span')(_templateObject7$3, function (props) {
	return props.theme.fonts.display.bold;
});

var StyledMoreContainer = styled('div')(_templateObject8$2, spacing.SINGLE);

var StyledStartContainer = styled('div')(_templateObject9, externalMarginRegular);

var StyledEndContainer = styled('div')(_templateObject10, function (props) {
	return props.moreIsOpen ? props.theme.components.accountBalancesSelectPanel.root.endContainerMarginExpanded : props.theme.components.accountBalancesSelectPanel.root.endContainerMargin;
});

var StyledFooterText = styled('div')(_templateObject11, spacing.ONE_AND_THREE_QUARTERS, spacing.SINGLE);

var StyledWrapper$8 = styled('div')(_templateObject12, colours.component.background, function (props) {
	return props.theme.colours.nonInteractive;
}, function (props) {
	return props.theme.borderRadiusLarger;
}, function (props) {
	return props.theme.colours.bodyText;
}, function (props) {
	return props.theme.components.accountBalancesSelectPanel.root.padding;
}, function (props) {
	return props.theme.components.accountBalancesSelectPanel.root.padding;
}, function (props) {
	return getCardStripeStyles(props.theme);
});

var AccountBalancesSelectPanel = function AccountBalancesSelectPanel(_ref) {
	var nameOnClick = _ref.nameOnClick,
	    moreOnClick = _ref.moreOnClick,
	    accountSelected = _ref.accountSelected,
	    dropDownIsOpen = _ref.dropDownIsOpen,
	    moreIsOpen = _ref.moreIsOpen,
	    accountData = _ref.accountData,
	    accountId = _ref.accountId,
	    children = _ref.children,
	    theme = _ref.theme;

	var accountBalanceFont = theme.components.accountBalancesSelectPanel.fonts.accountBalance;
	var accountDetailsFont = theme.components.accountBalancesSelectPanel.fonts.accountDetails;
	var accountHolderFont = theme.components.accountBalancesSelectPanel.fonts.accountHolder;
	var accountNameFont = theme.components.accountBalancesSelectPanel.fonts.accountName;
	var accountOverdraftFont = theme.components.accountBalancesSelectPanel.fonts.accountOverdraft;

	var DropDown = function DropDown() {
		return React.createElement(
			StyledDropDown,
			null,
			accountData.map(function (accountItem) {
				var hasAccountBalance = typeof accountItem.accountBalanceInPence === 'number';
				return React.createElement(
					StyledDropDownButton,
					{ key: accountItem.id, onClick: function onClick() {
							return accountSelected(accountItem.id);
						} },
					accountItem.accountHolder && accountHolderFont(React.createElement(
						'span',
						null,
						accountItem.accountHolder
					)),
					accountNameFont(React.createElement(
						'span',
						null,
						accountItem.accountName
					)),
					accountDetailsFont(React.createElement(
						'span',
						null,
						React.createElement(SortCodeAndAccountNumber, { accountNumber: accountItem.accountNumber, sortCode: accountItem.sortCode })
					)),
					hasAccountBalance && accountBalanceFont(React.createElement(MoneyValue.WithPence, { balance: accountItem.accountBalanceInPence }))
				);
			})
		);
	};

	var hasMultipleAccounts = accountData.length > 1;
	var selectedAccount = accountData.find(function (accountItem) {
		return accountItem.id === accountId;
	});
	var hasAccountBalance = typeof selectedAccount.accountBalanceInPence === 'number';
	var hasOverdraftAmount = typeof selectedAccount.overdraftAmountInPence === 'number';
	var ChevronDownIcon = getChevronDownSolidLarge(theme.name);

	var accountTitle = hasMultipleAccounts ? React.createElement(
		StyledAccountName$3,
		{ dropDownIsOpen: dropDownIsOpen },
		React.createElement(
			StyledAccountButton,
			{ type: 'button', onClick: nameOnClick },
			accountNameFont(React.createElement(
				'span',
				null,
				selectedAccount.accountName
			)),
			React.createElement(ChevronDownIcon, null)
		)
	) : React.createElement(
		StyledAccountName$3,
		null,
		accountNameFont(React.createElement(
			'span',
			null,
			selectedAccount.accountName
		))
	);

	var getStartContent = function getStartContent() {
		return React.createElement(
			StyledStartContainer,
			null,
			selectedAccount.accountHolder && accountHolderFont(React.createElement(
				'span',
				null,
				selectedAccount.accountHolder
			)),
			accountTitle,
			dropDownIsOpen && React.createElement(DropDown, null),
			React.createElement(
				StyledAccountDetails$2,
				null,
				accountDetailsFont(React.createElement(
					'span',
					null,
					React.createElement(SortCodeAndAccountNumber, {
						accountNumber: selectedAccount.accountNumber,
						sortCode: selectedAccount.sortCode
					})
				))
			)
		);
	};
	var getEndContent = function getEndContent() {
		return React.createElement(
			StyledEndContainer,
			{ moreIsOpen: moreIsOpen },
			hasAccountBalance && React.createElement(
				StyledAccountBalance,
				null,
				accountBalanceFont(React.createElement(MoneyValue.WithPence, { balance: selectedAccount.accountBalanceInPence }))
			),
			hasOverdraftAmount && accountOverdraftFont(React.createElement(
				'span',
				null,
				React.createElement(MoneyValue.WithPence, { balance: selectedAccount.overdraftAmountInPence }),
				' overdraft'
			)),
			selectedAccount.extraInfo,
			React.createElement(
				StyledMoreButton,
				{ isExpanded: moreIsOpen, onClick: moreOnClick },
				React.createElement(
					StyledMoreText,
					null,
					moreIsOpen ? 'Hide' : 'More Information'
				),
				React.createElement(ChevronDownIcon, null)
			)
		);
	};

	return React.createElement(
		InternalComponentFrame,
		{ packageJson: packageJson$k },
		React.createElement(
			StyledWrapper$8,
			null,
			React.createElement(Inline.Justified, { nodes: [getStartContent(), getEndContent()] }),
			moreIsOpen && React.createElement(
				StyledMoreContainer,
				null,
				React.createElement(
					StandardBody,
					null,
					React.createElement(
						'span',
						null,
						children
					)
				)
			),
			selectedAccount.footerText && React.createElement(
				StyledFooterText,
				null,
				selectedAccount.footerText
			)
		)
	);
};

AccountBalancesSelectPanel.propTypes = {
	/** Array of account data to populate the account drop down */
	accountData: PropTypes.arrayOf(PropTypes.shape({
		/** unique identifier */
		id: PropTypes.string.isRequired,
		/** The value should be unformatted and given in pence. E.g. 1000000 = £10,000.00. */
		accountBalanceInPence: PropTypes.number,
		/** Displays above the account name in panel and drop down.. Not shown if blank. */
		accountHolder: PropTypes.string,
		/** Displayed account name in panel and drop down. */
		accountName: PropTypes.string,
		/** Account number can eithe be number or string format */
		accountNumber: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
		/** The value should be unformatted and given in pence. E.g. 1000000 = £10,000.00. */
		overdraftAmountInPence: PropTypes.number,
		/** Account sortcode can eithe be number or string format */
		sortCode: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
		/** Extra information section conetent */
		extraInfo: PropTypes.node,
		/** Footer section conetent */
		footerText: PropTypes.node
	})),
	/** ID of the selected account */
	accountId: PropTypes.string.isRequired,
	/** Callback function invoked when account selected in drop down */
	accountSelected: PropTypes.func.isRequired,
	/** Determines if the account drop down is visible */
	dropDownIsOpen: PropTypes.bool,
	/** Children that will appear when more is clicked */
	children: PropTypes.oneOfType([PropTypes.element, PropTypes.arrayOf(PropTypes.element)]),
	/** Determines if the contents of more container will be shown or not */
	moreIsOpen: PropTypes.bool,
	/** Callback function triggered on click of 'More' buttom. */
	moreOnClick: PropTypes.func.isRequired,
	/** Callback function triggered on click of 'Account Name'. */
	nameOnClick: PropTypes.func.isRequired
};

AccountBalancesSelectPanel.defaultProps = {
	dropDownIsOpen: false,
	moreIsOpen: false
};

var WrappedAccountBalancesSelectPanel = withTheme(AccountBalancesSelectPanel);

var _extends$c = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$b(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var GenericIcon$4 = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$b(_ref, ["styles"]);

  return React.createElement("svg", _extends$c({ height: "96", viewBox: "0 0 96 96", width: "96", xmlns: "http://www.w3.org/2000/svg" }, props), React.createElement("path", { d: "M48 33.138L8.587 73.492a4.972 4.972 0 0 1-7.114 0l-.144-.148a5 5 0 0 1 0-6.988l42.826-43.848A4.96 4.96 0 0 1 48 21.018a4.959 4.959 0 0 1 3.845 1.49l42.826 43.848a5 5 0 0 1 0 6.988l-.144.148a4.972 4.972 0 0 1-7.114 0z" }));
});

var _extends$d = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$c(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var VMIcon$4 = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$c(_ref, ["styles"]);

  return React.createElement("svg", _extends$d({ height: "96", viewBox: "0 0 96 96", width: "96", xmlns: "http://www.w3.org/2000/svg" }, props), React.createElement("path", { d: "M48.36 20.662a7.134 7.134 0 0 0-5.06 2.097L.36 65.7l10.12 10.12 37.88-37.88 37.881 37.88 10.12-10.12-42.94-42.94a7.134 7.134 0 0 0-5.06-2.097z" }));
});

var getChevronUpSolidLarge = getThemeIcon(VMIcon$4, GenericIcon$4);

var main$l = "AccountLegacyPanel.js";
var deprecations = [{
	replacements: {
		name: "AccountBalancesSelectPanel",
		path: "Finance/Accounts/Panels"
	}
}];
var packageJson$l = {
	main: main$l,
	"component-id": null,
	"component-life-cycle": "deprecated",
	"is-bespoke": true,
	deprecations: deprecations
};

var _templateObject$x = taggedTemplateLiteral(['\n\talign-items: center;\n\tdisplay: inline-flex;\n\n\tsvg {\n\t\tmargin-left: 4px;\n\t}\n'], ['\n\talign-items: center;\n\tdisplay: inline-flex;\n\n\tsvg {\n\t\tmargin-left: 4px;\n\t}\n']),
    _templateObject2$h = taggedTemplateLiteral(['\n\tbackground-color: ', ';\n\tborder: 1px solid ', ';\n\tborder-radius: ', ';\n\tbox-shadow: ', ';\n\tposition: absolute;\n\tmax-height: 380px;\n\tmin-width: 300px;\n\toverflow: scroll;\n\tz-index: ', ';\n'], ['\n\tbackground-color: ', ';\n\tborder: 1px solid ', ';\n\tborder-radius: ', ';\n\tbox-shadow: ', ';\n\tposition: absolute;\n\tmax-height: 380px;\n\tmin-width: 300px;\n\toverflow: scroll;\n\tz-index: ', ';\n']),
    _templateObject3$e = taggedTemplateLiteral(['\n\tborder-bottom: 1px solid ', ';\n\tpadding: ', ' ', ';\n\tdisplay: block;\n\ttext-align: left;\n\twidth: 100%;\n\n\t&:hover {\n\t\tbackground-color: ', ';\n\t}\n\n\t&:last-child {\n\t\tborder-bottom: none;\n\t}\n'], ['\n\tborder-bottom: 1px solid ', ';\n\tpadding: ', ' ', ';\n\tdisplay: block;\n\ttext-align: left;\n\twidth: 100%;\n\n\t&:hover {\n\t\tbackground-color: ', ';\n\t}\n\n\t&:last-child {\n\t\tborder-bottom: none;\n\t}\n']),
    _templateObject4$7 = taggedTemplateLiteral(['\n\talign-items: center;\n\tcolor: ', ';\n\tdisplay: inline-flex;\n\tmargin-top: ', ';\n\n\tsvg {\n\t\tfill: ', ';\n\t\tmargin-left: 4px;\n\t}\n'], ['\n\talign-items: center;\n\tcolor: ', ';\n\tdisplay: inline-flex;\n\tmargin-top: ', ';\n\n\tsvg {\n\t\tfill: ', ';\n\t\tmargin-left: 4px;\n\t}\n']),
    _templateObject5$6 = taggedTemplateLiteral(['\n\tfont-family: ', ';\n'], ['\n\tfont-family: ', ';\n']),
    _templateObject6$6 = taggedTemplateLiteral(['\n\ttext-align: right;\n\tpadding: ', ';\n\twidth: 50%;\n\tmargin-left: 50%;\n'], ['\n\ttext-align: right;\n\tpadding: ', ';\n\twidth: 50%;\n\tmargin-left: 50%;\n']),
    _templateObject7$4 = taggedTemplateLiteral(['\n\t', ' text-align: left;\n\tsvg {\n\t\theight: 16px;\n\t\twidth: 16px;\n\t}\n'], ['\n\t', ' text-align: left;\n\tsvg {\n\t\theight: 16px;\n\t\twidth: 16px;\n\t}\n']),
    _templateObject8$3 = taggedTemplateLiteral(['\n\tmargin: 0 ', ' ', ' 0;\n\ttext-align: right;\n\t> span {\n\t\tdisplay: block;\n\t}\n\n\tsvg {\n\t\theight: 16px;\n\t\twidth: 16px;\n\t}\n'], ['\n\tmargin: 0 ', ' ', ' 0;\n\ttext-align: right;\n\t> span {\n\t\tdisplay: block;\n\t}\n\n\tsvg {\n\t\theight: 16px;\n\t\twidth: 16px;\n\t}\n']),
    _templateObject9$1 = taggedTemplateLiteral(['\n\tfont-size: ', ';\n\tpadding-right: ', ';\n'], ['\n\tfont-size: ', ';\n\tpadding-right: ', ';\n']),
    _templateObject10$1 = taggedTemplateLiteral(['\n\tbackground: ', ';\n\tdisplay: block;\n\t', ' width: 100%;\n'], ['\n\tbackground: ', ';\n\tdisplay: block;\n\t', ' width: 100%;\n']),
    _templateObject11$1 = taggedTemplateLiteral(['\n\tbackground: ', ';\n\tborder: 1px solid ', ';\n\tborder-left: 0 !important;\n\tborder-radius: ', ';\n\tbox-sizing: border-box;\n\tcolor: ', ';\n\tposition: relative;\n\t&:before {\n\t\tbackground: ', ';\n\t\tborder-bottom-left-radius: ', ';\n\t\tborder-top-left-radius: ', ';\n\t\tcontent: \'\';\n\t\tdisplay: block;\n\t\theight: calc(100% + 2px);\n\t\tleft: 0;\n\t\tposition: absolute;\n\t\ttop: -1px;\n\t\twidth: ', ';\n'], ['\n\tbackground: ', ';\n\tborder: 1px solid ', ';\n\tborder-left: 0 !important;\n\tborder-radius: ', ';\n\tbox-sizing: border-box;\n\tcolor: ', ';\n\tposition: relative;\n\t&:before {\n\t\tbackground: ', ';\n\t\tborder-bottom-left-radius: ', ';\n\t\tborder-top-left-radius: ', ';\n\t\tcontent: \'\';\n\t\tdisplay: block;\n\t\theight: calc(100% + 2px);\n\t\tleft: 0;\n\t\tposition: absolute;\n\t\ttop: -1px;\n\t\twidth: ', ';\n']);

var StyledAccountButton$1 = styled('button')(_templateObject$x);

var StyledDropDown$1 = styled('div')(_templateObject2$h, colours.component.background, colours.component.border, function (props) {
	return props.theme.borderRadius;
}, function (props) {
	return props.theme.boxShadow;
}, layers.accountLegacyPanelDropdown);

var StyledDropDownButton$1 = styled('button')(_templateObject3$e, colours.component.border, spacing.SINGLE, spacing.DOUBLE, colours.component.hover);

var StyledMoreButton$1 = styled('button')(_templateObject4$7, function (props) {
	return props.theme.colours.primary;
}, spacing.SINGLE, function (props) {
	return props.theme.colours.primary;
});

var StyledMoreText$1 = styled('span')(_templateObject5$6, function (props) {
	return props.theme.fonts.display.bold;
});

var StyledMoreContainer$1 = styled('div')(_templateObject6$6, spacing.SINGLE);

var StyledStartContainer$1 = styled('div')(_templateObject7$4, externalMarginRegular);

var StyledEndContainer$1 = styled('div')(_templateObject8$3, spacing.DOUBLE, spacing.SINGLE);

var StyledFooterText$1 = styled('div')(_templateObject9$1, spacing.ONE_AND_THREE_QUARTERS, spacing.SINGLE);

var StyledPanel = styled('div')(_templateObject10$1, colours.component.background, internalPaddingRegular);

var StyledWrapper$9 = styled('div')(_templateObject11$1, colours.component.background, colours.component.border, function (props) {
	return props.theme.borderRadius;
}, function (props) {
	return props.theme.colours.bodyText;
}, function (props) {
	return props.theme.colours.primary;
}, function (props) {
	return props.theme.borderRadius;
}, function (props) {
	return props.theme.borderRadius;
}, spacing.THREE_QUARTERS);

var AccountLegacyPanel = function AccountLegacyPanel(_ref) {
	var nameOnClick = _ref.nameOnClick,
	    moreOnClick = _ref.moreOnClick,
	    accountSelected = _ref.accountSelected,
	    dropDownIsOpen = _ref.dropDownIsOpen,
	    moreIsOpen = _ref.moreIsOpen,
	    accountData = _ref.accountData,
	    accountId = _ref.accountId,
	    children = _ref.children,
	    theme = _ref.theme;

	var DropDown = function DropDown() {
		return React.createElement(
			StyledDropDown$1,
			null,
			accountData.map(function (accountItem) {
				var hasAccountBalance = typeof accountItem.accountBalanceInPence === 'number';
				return React.createElement(
					StyledDropDownButton$1,
					{ key: accountItem.id, onClick: function onClick() {
							return accountSelected(accountItem.id);
						} },
					accountItem.accountHolder && React.createElement(
						StandardBody,
						{ isFlush: true },
						React.createElement(
							'span',
							null,
							accountItem.accountHolder
						)
					),
					React.createElement(
						ProminentLabel,
						{ isFlush: true },
						React.createElement(
							'span',
							null,
							accountItem.accountName
						)
					),
					React.createElement(
						SubBody,
						{ isFlush: true },
						React.createElement(
							'span',
							null,
							React.createElement(SortCodeAndAccountNumber, { accountNumber: accountItem.accountNumber, sortCode: accountItem.sortCode })
						)
					),
					hasAccountBalance && React.createElement(
						ProminentLabel,
						{ isFlush: true },
						React.createElement(MoneyValue.WithPence, { balance: accountItem.accountBalanceInPence })
					)
				);
			})
		);
	};

	var hasMultipleAccounts = accountData.length > 1;
	var selectedAccount = accountData.find(function (accountItem) {
		return accountItem.id === accountId;
	});
	var hasAccountBalance = typeof selectedAccount.accountBalanceInPence === 'number';
	var hasAccountAvailable = typeof selectedAccount.accountAvailableInPence === 'number';
	var hasOverdraftAmount = typeof selectedAccount.overdraftAmountInPence === 'number';
	var ChevronDownIcon = getChevronDownSolidLarge(theme.name);
	var ChevronUpIcon = getChevronUpSolidLarge(theme.name);

	var accountTitle = hasMultipleAccounts ? React.createElement(
		StyledAccountButton$1,
		{ onClick: nameOnClick },
		React.createElement(
			ProminentLabel,
			{ isFlush: true },
			React.createElement(
				'span',
				null,
				selectedAccount.accountName
			)
		),
		React.createElement(ChevronDownIcon, null)
	) : React.createElement(
		ProminentLabel,
		{ isFlush: true },
		React.createElement(
			'span',
			null,
			selectedAccount.accountName
		)
	);

	var getStartContent = function getStartContent() {
		return React.createElement(
			StyledStartContainer$1,
			null,
			selectedAccount.accountHolder && React.createElement(
				StandardBody,
				{ isFlush: true },
				React.createElement(
					'span',
					null,
					selectedAccount.accountHolder
				)
			),
			accountTitle,
			dropDownIsOpen && React.createElement(DropDown, null),
			React.createElement(
				SubBody,
				{ isFlush: true },
				React.createElement(
					'span',
					null,
					React.createElement(SortCodeAndAccountNumber, { accountNumber: selectedAccount.accountNumber, sortCode: selectedAccount.sortCode })
				)
			)
		);
	};
	var getEndContent = function getEndContent() {
		return React.createElement(
			StyledEndContainer$1,
			null,
			hasAccountBalance && React.createElement(
				ProminentLabel,
				{ isFlush: true },
				React.createElement(MoneyValue.WithPence, { balance: selectedAccount.accountBalanceInPence })
			),
			hasAccountAvailable && React.createElement(
				SubBody,
				{ isFlush: true },
				React.createElement(MoneyValue.WithPence, { balance: selectedAccount.accountAvailableInPence }),
				' available'
			),
			hasOverdraftAmount && React.createElement(
				SubBody,
				{ isFlush: true },
				'Including ',
				React.createElement(MoneyValue.WithPence, { balance: selectedAccount.overdraftAmountInPence }),
				' overdraft'
			),
			selectedAccount.extraInfo,
			React.createElement(
				StyledMoreButton$1,
				{ onClick: moreOnClick },
				React.createElement(
					StyledMoreText$1,
					null,
					moreIsOpen ? 'Hide' : 'More'
				),
				moreIsOpen ? React.createElement(ChevronUpIcon, null) : React.createElement(ChevronDownIcon, null)
			)
		);
	};

	return React.createElement(
		InternalComponentFrame,
		{ packageJson: packageJson$l },
		React.createElement(
			StyledWrapper$9,
			null,
			React.createElement(
				StyledPanel,
				null,
				React.createElement(Inline.Justified, { nodes: [getStartContent(), getEndContent()] }),
				moreIsOpen && React.createElement(
					StyledMoreContainer$1,
					null,
					React.createElement(
						StandardBody,
						null,
						React.createElement(
							'span',
							null,
							children
						)
					)
				),
				selectedAccount.footerText && React.createElement(
					StyledFooterText$1,
					null,
					selectedAccount.footerText
				)
			)
		)
	);
};

AccountLegacyPanel.propTypes = {
	/** Array of account data to populate the account drop down */
	accountData: PropTypes.arrayOf(PropTypes.shape({
		/** Unique identifier. */
		id: PropTypes.string.isRequired,
		/** The value should be unformatted and given in pence. E.g. 1000000 = £10,000.00. */
		accountBalanceInPence: PropTypes.number,
		/** The value should be unformatted and given in pence. E.g. 1000000 = £10,000.00. */
		accountAvailableInPence: PropTypes.number,
		/** Displays above the account name in panel and drop down.. Not shown if blank. */
		accountHolder: PropTypes.string,
		/** Displayed account name in panel and drop down. */
		accountName: PropTypes.string,
		/** Account number can eithe be number or string format. */
		accountNumber: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
		/** The value should be unformatted and given in pence. E.g. 1000000 = £10,000.00. */
		overdraftAmountInPence: PropTypes.number,
		/** Account sortcode can eithe be number or string format. */
		sortCode: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
		/** Extra information section content. */
		extraInfo: PropTypes.node,
		/** Footer section content. */
		footerText: PropTypes.node
	})),
	/** ID of the selected account */
	accountId: PropTypes.string.isRequired,
	/** Callback function invoked when account selected in drop down */
	accountSelected: PropTypes.func.isRequired,
	/** Determines if the account drop down is visible */
	dropDownIsOpen: PropTypes.bool,
	/** Children that will appear when more is clicked */
	children: PropTypes.oneOfType([PropTypes.element, PropTypes.arrayOf(PropTypes.element)]),
	/** Determines if the contents of more container will be shown or not */
	moreIsOpen: PropTypes.bool,
	/** Callback function triggered on click of 'More' button. */
	moreOnClick: PropTypes.func.isRequired,
	/** Callback function triggered on click of 'Account Name'. */
	nameOnClick: PropTypes.func.isRequired
};

AccountLegacyPanel.defaultProps = {
	dropDownIsOpen: false,
	moreIsOpen: false
};

var WrappedAccountLegacyPanel = withTheme(AccountLegacyPanel);

var _extends$e = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$d(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var BlockedIcon = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$d(_ref, ["styles"]);

  return React.createElement("svg", _extends$e({ width: "96", height: "96", viewBox: "0 0 96 96", xmlns: "http://www.w3.org/2000/svg" }, props), React.createElement("rect", { width: "96", height: "96", rx: "48" }), React.createElement("path", { fill: "#FFF", d: "M48 39.515l12.728-12.728 8.485 8.485L56.485 48l12.728 12.728-8.485 8.485L48 56.485 35.272 69.213l-8.485-8.485L39.515 48 26.787 35.272l8.485-8.485L48 39.515z" }));
});

var _extends$f = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$e(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var ExclamationCircleLarge = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$e(_ref, ["styles"]);

  return React.createElement("svg", _extends$f({ xmlns: "http://www.w3.org/2000/svg", width: "16", height: "16", viewBox: "0 0 16 16" }, props), React.createElement("path", { d: "M8 16A8 8 0 1 1 8 0a8 8 0 0 1 0 16zm0-1A7 7 0 1 0 8 1a7 7 0 0 0 0 14zm-.932-9.452L7 4h2l-.068 1.548L8.65 9H7.35l-.283-3.452zM7 11.005c0-.288.096-.528.287-.719A.968.968 0 0 1 8 10a.975.975 0 0 1 1 1.005.962.962 0 0 1-.287.709A.968.968 0 0 1 8 12a.968.968 0 0 1-.713-.286.962.962 0 0 1-.287-.709z", fillRule: "evenodd" }));
});

var _extends$g = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$f(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var TickOutlineCircleLarge = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$f(_ref, ["styles"]);

  return React.createElement("svg", _extends$g({ xmlns: "http://www.w3.org/2000/svg", width: "16", height: "16", viewBox: "0 0 16 16" }, props), React.createElement("path", { fillRule: "evenodd", d: "M8 16A8 8 0 1 1 8 0a8 8 0 0 1 0 16zm0-1A7 7 0 1 0 8 1a7 7 0 0 0 0 14zm-1.023-3a.85.85 0 0 1-.666-.316L4.17 8.986a.77.77 0 0 1 .161-1.115.86.86 0 0 1 1.17.155L6.911 9.8l3.544-5.425a.861.861 0 0 1 1.15-.255.775.775 0 0 1 .268 1.098l-4.186 6.406a.84.84 0 0 1-.672.374C7.003 12 6.99 12 6.977 12z" }));
});

var main$m = "AccountPaymentStatusPanel.js";
var variants$6 = ["Authorisation", "Failure", "Information", "Success"];
var packageJson$m = {
	main: main$m,
	variants: variants$6,
	"component-id": null,
	"component-life-cycle": "active",
	"is-bespoke": false
};

var _templateObject$y = taggedTemplateLiteral(['\n\tborder-radius: 8px;\n\tbackground-color: ', ';\n\tpadding:  ', ';\n\ttext-align: center;\n\theight: 100%;\n\n\tsvg {\n\t\tdisplay: block;\n\t\t', '\n\t\t', '\n\t\t', '\n\t\t', '\n\t\twidth: 24px;\n\t\theight: 24px;\n\t\tmargin-bottom: ', ';\n\t\t@media (min-width: 768px) {\n\t\t\tmargin-left: auto;\n\t\t\tmargin-right: auto;\n\t\t}\n'], ['\n\tborder-radius: 8px;\n\tbackground-color: ', ';\n\tpadding:  ', ';\n\ttext-align: center;\n\theight: 100%;\n\n\tsvg {\n\t\tdisplay: block;\n\t\t', '\n\t\t', '\n\t\t', '\n\t\t', '\n\t\twidth: 24px;\n\t\theight: 24px;\n\t\tmargin-bottom: ', ';\n\t\t@media (min-width: 768px) {\n\t\t\tmargin-left: auto;\n\t\t\tmargin-right: auto;\n\t\t}\n']);

var StyledWrapper$a = styled('div')(_templateObject$y, colours.generalPalette.white, spacing.DOUBLE, function (props) {
	return props.paymentStatus === 'authorisation' && 'fill: ' + colours.utility.guidance + ';';
}, function (props) {
	return props.paymentStatus === 'failure' && 'fill: ' + colours.utility.errorUpdated + ';';
}, function (props) {
	return props.paymentStatus === 'information' && 'fill: ' + colours.utility.informationUpdated + ';';
}, function (props) {
	return props.paymentStatus === 'success' && 'fill: ' + colours.utility.success + ';';
}, spacing.THREE_QUARTERS);

var getStatusIcon = function getStatusIcon(paymentStatus) {
	if (paymentStatus === 'authorisation') {
		return React.createElement(AuthorisationLarge, null);
	}
	if (paymentStatus === 'failure') {
		return React.createElement(BlockedIcon, null);
	}
	if (paymentStatus === 'information') {
		return React.createElement(ExclamationCircleLarge, null);
	}
	if (paymentStatus === 'success') {
		return React.createElement(TickOutlineCircleLarge, null);
	}
};

var BaseAccountPaymentStatusPanel = function BaseAccountPaymentStatusPanel(_ref) {
	var paymentStatus = _ref.paymentStatus,
	    titleText = _ref.titleText,
	    children = _ref.children,
	    dataTestId = _ref.dataTestId;
	return React.createElement(
		StyledWrapper$a,
		{ 'data-test-id': dataTestId + '-wrapper', paymentStatus: paymentStatus },
		getStatusIcon(paymentStatus),
		React.createElement(
			StandardLabel,
			{ 'data-test-id': dataTestId + '-label', isFlush: true },
			titleText
		),
		React.createElement(
			'div',
			{ 'data-test-id': dataTestId + '-content' },
			children
		)
	);
};

var baseProps$5 = {
	/** Content of the wrapper. */
	children: PropTypes.node,
	/** Title text. */
	titleText: PropTypes.string,
	/** Partial Data attribute targeting modal for automation test purposes - appended by -wrapper, -label and -content. */
	'data-test-id': PropTypes.string
};

BaseAccountPaymentStatusPanel.propTypes = {};

var Authorisation = function Authorisation(_ref2) {
	var children = _ref2.children,
	    titleText = _ref2.titleText,
	    dataTestId = _ref2['data-test-id'];
	return React.createElement(
		InternalComponentFrame,
		{ packageJson: packageJson$m },
		React.createElement(
			BaseAccountPaymentStatusPanel,
			{ paymentStatus: 'authorisation', titleText: titleText, dataTestId: dataTestId },
			children
		)
	);
};

Authorisation.propTypes = _extends({}, baseProps$5);

Authorisation.defaultProps = {
	titleText: 'Authorisation Required',
	'data-test-id': 'authorisation-status-panel'
};

var Failure = function Failure(_ref3) {
	var children = _ref3.children,
	    titleText = _ref3.titleText,
	    dataTestId = _ref3['data-test-id'];
	return React.createElement(
		InternalComponentFrame,
		{ packageJson: packageJson$m },
		React.createElement(
			BaseAccountPaymentStatusPanel,
			{ paymentStatus: 'failure', titleText: titleText, dataTestId: dataTestId },
			children
		)
	);
};

Failure.propTypes = _extends({}, baseProps$5);

Failure.defaultProps = {
	titleText: 'Payment Failed',
	'data-test-id': 'failure-status-panel'
};

var Information = function Information(_ref4) {
	var children = _ref4.children,
	    titleText = _ref4.titleText,
	    dataTestId = _ref4['data-test-id'];
	return React.createElement(
		InternalComponentFrame,
		{ packageJson: packageJson$m },
		React.createElement(
			BaseAccountPaymentStatusPanel,
			{ paymentStatus: 'information', titleText: titleText, dataTestId: dataTestId },
			children
		)
	);
};

Information.propTypes = _extends({}, baseProps$5);

Information.defaultProps = {
	titleText: 'Pending',
	'data-test-id': 'information-status-panel'
};

var Success = function Success(_ref5) {
	var children = _ref5.children,
	    titleText = _ref5.titleText,
	    dataTestId = _ref5['data-test-id'];
	return React.createElement(
		InternalComponentFrame,
		{ packageJson: packageJson$m },
		React.createElement(
			BaseAccountPaymentStatusPanel,
			{ paymentStatus: 'success', titleText: titleText, dataTestId: dataTestId },
			children
		)
	);
};

Success.propTypes = _extends({}, baseProps$5);

Success.defaultProps = {
	titleText: 'Payment Submitted',
	'data-test-id': 'success-status-panel'
};

var AccountPaymentStatusPanel = {
	Authorisation: Authorisation,
	Failure: Failure,
	Information: Information,
	Success: Success
};

var main$n = "InternationalMoneyValue.js";
var variants$7 = ["UnitsOnly", "WithCents"];
var packageJson$n = {
	main: main$n,
	variants: variants$7,
	"component-id": null,
	"component-life-cycle": "active",
	"is-bespoke": false
};

var moneyFormatter$3 = regexes.moneyFormatter;


var UnitsOnly = function UnitsOnly(_ref) {
	var balance = _ref.balance,
	    currencySymbolPrefix = _ref.currencySymbolPrefix,
	    currencySymbolSuffix = _ref.currencySymbolSuffix;
	return React.createElement(
		InternalComponentFrame,
		{ isFlush: true, layout: 'inline', packageJson: packageJson$n },
		React.createElement(
			'span',
			null,
			'' + (balance < 0 ? '-' : '') + (currencySymbolPrefix ? currencySymbolPrefix : '') + Math.abs(balance).toString().replace(moneyFormatter$3, ',') + (currencySymbolSuffix ? ' ' + currencySymbolSuffix : '')
		)
	);
};

UnitsOnly.propTypes = baseProps$6;

UnitsOnly.defaultProps = {};

var moneyFormatter$4 = regexes.moneyFormatter;

var PENCE_DIVIDER$2 = 100;

var WithCents = function WithCents(_ref) {
	var balance = _ref.balance,
	    currencySymbolPrefix = _ref.currencySymbolPrefix,
	    currencySymbolSuffix = _ref.currencySymbolSuffix;
	return React.createElement(
		InternalComponentFrame,
		{ isFlush: true, layout: 'inline', packageJson: packageJson$n },
		React.createElement(
			'span',
			null,
			'' + (balance < 0 ? '-' : '') + (currencySymbolPrefix ? currencySymbolPrefix : '') + (Math.abs(balance) / PENCE_DIVIDER$2).toFixed(2).toString().replace(moneyFormatter$4, ',') + (currencySymbolSuffix ? ' ' + currencySymbolSuffix : '')
		)
	);
};

WithCents.propTypes = baseProps$6;

WithCents.defaultProps = {
	hasPrefix: true
};

var baseProps$6 = {
	/** Balance to be formatted and displayed, as a number. */
	balance: PropTypes.number.isRequired,
	/** An optional currency symbol to be prepended to the rendered balance. */
	currencySymbolPrefix: PropTypes.string,
	/** An optional currency symbol to be appended to the rendered balance. */
	currencySymbolSuffix: PropTypes.string
};

var InternationalMoneyValue = {
	UnitsOnly: UnitsOnly,
	WithCents: WithCents
};

var main$o = "NavigationButton.js";
var variants$8 = ["Back", "Cancel", "Confirm", "Continue", "Next", "Primary", "Secondary", "Submit", "Tertiary"];
var deprecations$1 = [{
	variants: ["Confirm", "Continue", "Next", "Submit"],
	replacements: {
		name: "NavigationButton",
		path: "Navigation/Buttons",
		variant: "Primary"
	}
}, {
	variants: ["Back"],
	replacements: {
		name: "NavigationButton",
		path: "Navigation/Buttons",
		variant: "Secondary"
	}
}, {
	variants: ["Cancel"],
	replacements: {
		name: "NavigationButton",
		path: "Navigation/Buttons",
		variant: "Tertiary"
	}
}];
var packageJson$o = {
	main: main$o,
	variants: variants$8,
	"component-id": 812,
	"component-life-cycle": "active",
	"is-bespoke": false,
	deprecations: deprecations$1
};

var getLabelText = function getLabelText(label, labelText) {
	if (label === undefined) {
		return labelText;
	}

	DeprecationWarnings.logProp(packageJson$o, 'label prop deprecated in favour of labelText prop.');
	return label;
};

var _extends$h = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$g(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var LoadingOutlineSmallIcon = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$g(_ref, ["styles"]);

  return React.createElement("svg", _extends$h({ xmlns: "http://www.w3.org/2000/svg", width: "24", height: "24", viewBox: "0 0 24 24" }, props), React.createElement("path", { d: "M17.62 6.306L15.406 8.52a4.87 4.87 0 1 0 0 6.96l2.214 2.214a8 8 0 1 1 0-11.388z" }));
});

var _extends$i = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$h(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var VMIcon$5 = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$h(_ref, ["styles"]);

  return React.createElement("svg", _extends$i({ height: "96", viewBox: "0 0 96 96", width: "96", xmlns: "http://www.w3.org/2000/svg" }, props), React.createElement("path", { d: "M84 96H56c-.238 0-.475-.02-.709-.062a31.449 31.449 0 0 1-2.518-.56A17.923 17.923 0 0 1 48 93.325a18.772 18.772 0 0 1-7.377 2.63c-.168.019-.453.046-.623.046H12a4 4 0 0 1-4-4V44a8.21 8.21 0 0 1 8-8h8V24C24 10.745 34.745 0 48 0s24 10.745 24 24v8h-8v-8c0-8.837-7.163-16-16-16s-16 7.163-16 16v16a3.999 3.999 0 0 1-4 4H16v44h23.74a10.522 10.522 0 0 0 2.153-.55 21.577 21.577 0 0 1-.825-1.317L34.23 74.246a15.892 15.892 0 0 1 13.846-23.754h.002a15.866 15.866 0 0 1 13.793 23.781l-6.91 11.899c-.252.437-.52.86-.8 1.273.216.075.435.141.655.2.504.132 1.022.254 1.555.355H80V44H36v-8h44a8.21 8.21 0 0 1 8 8v48a4 4 0 0 1-4 4zM48.074 58.492a7.937 7.937 0 0 0-6.135 2.89 7.824 7.824 0 0 0-.775 8.872l6.838 11.886.025.043.016-.027 6.908-11.898a7.825 7.825 0 0 0-.736-8.875 7.95 7.95 0 0 0-6.14-2.891z" }));
});

var _extends$j = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$i(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var GenericIcon$5 = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$i(_ref, ["styles"]);

  return React.createElement("svg", _extends$j({ width: "16", height: "16", viewBox: "0 0 16 16", xmlns: "http://www.w3.org/2000/svg" }, props), React.createElement("path", { d: "M7.932 9c-.305 0-.552.223-.552.5v3c0 .276.247.5.552.5.305 0 .553-.224.553-.5v-3c0-.277-.248-.5-.553-.5zm6.078 5c0 .552-.495 1-1.105 1H2.96c-.61 0-1.105-.448-1.105-1V8c0-.552.494-1 1.105-1h9.945c.61 0 1.105.448 1.105 1v6zM4.065 4.5c0-1.933 1.732-3.5 3.867-3.5C10.068 1 11.8 2.567 11.8 4.5V6H4.065V4.5zm8.84 1.5V4.5c0-2.485-2.226-4.5-4.973-4.5C5.186 0 2.96 2.015 2.96 4.5V6C1.74 6 .75 6.895.75 8v6c0 1.104.99 2 2.21 2h9.945c1.22 0 2.21-.896 2.21-2V8c0-1.105-.99-2-2.21-2z" }));
});

var getLockOutlineLarge = getThemeIcon(VMIcon$5, GenericIcon$5);

var _templateObject$z = taggedTemplateLiteral(['\n\tmargin-right: ', ';\n\n\tsvg {\n\t\tfill: ', ';\n\t\theight: 24px;\n\t\twidth: 24px;\n\t}\n'], ['\n\tmargin-right: ', ';\n\n\tsvg {\n\t\tfill: ', ';\n\t\theight: 24px;\n\t\twidth: 24px;\n\t}\n']),
    _templateObject2$i = taggedTemplateLiteral(['\n\talign-items: center;\n\tbackground: ', ';\n\tborder: 1px solid ', ';\n\tborder-radius: ', ';\n\tdisplay: inline-flex;\n\tpadding: ', ' ', ';\n\tposition: fixed;\n\tright: ', ';\n\ttop: ', ';\n\ttransition: right 0.5s ease-in-out;\n'], ['\n\talign-items: center;\n\tbackground: ', ';\n\tborder: 1px solid ', ';\n\tborder-radius: ', ';\n\tdisplay: inline-flex;\n\tpadding: ', ' ', ';\n\tposition: fixed;\n\tright: ', ';\n\ttop: ', ';\n\ttransition: right 0.5s ease-in-out;\n']);

var StyledIconWrapper$1 = styled$1('div')(_templateObject$z, spacing.SINGLE, function (props) {
	return props.iconColour;
});

var StyledWrapper$b = styled$1('div')(_templateObject2$i, colours.component.background, function (props) {
	return props.borderColour;
}, function (props) {
	return props.theme.borderRadiusLarger;
}, spacing.DOUBLE, spacing.TRIPLE, function (props) {
	return props.isVisible ? spacing.DOUBLE : '-75vw';
}, spacing.DOUBLE);

var BaseToast = function BaseToast(_ref) {
	var borderColour = _ref.borderColour,
	    icon = _ref.icon,
	    iconColour = _ref.iconColour,
	    isVisible = _ref.isVisible,
	    messageText = _ref.messageText;
	return React.createElement(
		StyledWrapper$b,
		{ borderColour: borderColour, isVisible: isVisible },
		icon && React.createElement(
			StyledIconWrapper$1,
			{ iconColour: iconColour },
			icon
		),
		React.createElement(
			ProminentLabel,
			{ isFlush: true },
			React.createElement(
				'span',
				null,
				messageText
			)
		)
	);
};

BaseToast.propTypes = {
	/** Border colour. */
	borderColour: PropTypes.string,
	/** Icon shown to the left of the message text. */
	icon: PropTypes.node,
	/** Icon fill colour. */
	iconColour: PropTypes.string,
	/** Character count as number. */
	isVisible: PropTypes.bool.isRequired,
	/** Message text. */
	messageText: PropTypes.string.isRequired
};

BaseToast.defaultProps = {
	borderColour: 'hsl(0, 0%, 0%)'
};

var InternalLockedToast = function InternalLockedToast(_ref) {
	var isVisible = _ref.isVisible,
	    theme = _ref.theme;

	var PadlockIcon = getLockOutlineLarge(theme.name);

	return React.createElement(BaseToast, {
		borderColour: colours.component.locked,
		icon: React.createElement(PadlockIcon, null),
		iconColour: colours.component.locked,
		isVisible: isVisible,
		messageText: 'Feature is locked.'
	});
};

InternalLockedToast.propTypes = {
	/** Makes the toast visible. */
	isVisible: PropTypes.bool.isRequired
};

InternalLockedToast.defaultProps = {
	borderColour: 'hsl(0, 0%, 0%)'
};

var WrappedInternalLockedToast = withTheme(InternalLockedToast);

var _templateObject$A = taggedTemplateLiteral(['\n\tsvg {\n\t\t', '\n\t\tfill: ', ';\n\t\theight: 24px;\n\t\tmargin-right: ', ';\n\t\ttransition: fill 0.2s ease-in-out;\n\t\twidth: 24px;\n}\n'], ['\n\tsvg {\n\t\t', '\n\t\tfill: ', ';\n\t\theight: 24px;\n\t\tmargin-right: ', ';\n\t\ttransition: fill 0.2s ease-in-out;\n\t\twidth: 24px;\n}\n']),
    _templateObject2$j = taggedTemplateLiteral(['\n\tdisplay: inline-flex;\n\tmargin-left: ', ';\n\n\t> svg {\n\t\tfill: ', ';\n\t\theight: 16px;\n\t\tmargin-right: 0;\n\t\twidth: 16px;\n\t}\n'], ['\n\tdisplay: inline-flex;\n\tmargin-left: ', ';\n\n\t> svg {\n\t\tfill: ', ';\n\t\theight: 16px;\n\t\tmargin-right: 0;\n\t\twidth: 16px;\n\t}\n']),
    _templateObject3$f = taggedTemplateLiteral(['\n\talign-items: center;\n\tborder-radius: ', ';\n\tbox-sizing: border-box;\n\tcursor: pointer;\n\tdisplay: inline-flex;\n\t', '\n\tmax-width: 100%;\n\tpadding: ', ' ', ';\n\ttransition: all 0.15s;\n\ttext-align: left;\n\t', '\n\t', '\n\t', '\n\t', ';\n'], ['\n\talign-items: center;\n\tborder-radius: ', ';\n\tbox-sizing: border-box;\n\tcursor: pointer;\n\tdisplay: inline-flex;\n\t', '\n\tmax-width: 100%;\n\tpadding: ', ' ', ';\n\ttransition: all 0.15s;\n\ttext-align: left;\n\t', '\n\t', '\n\t', '\n\t', ';\n']);

var getPrimaryHoverStyles = function getPrimaryHoverStyles(props) {
	if (!props.isLoading && !props.isLocked) {
		return '&:hover {\n\t\t\tbackground-color: ' + props.theme.colours.secondaryAccent + ' ' + INTERNET_BANKING_CSS_OVERRIDE + ';\n\t\t\tborder-color: ' + props.theme.colours.secondaryAccent + ' ' + INTERNET_BANKING_CSS_OVERRIDE + ';\n\t\t}';
	}
	return '';
};

var getPrimaryBackgroundColour = function getPrimaryBackgroundColour(props) {
	var colour = props.theme.colours.primary;
	if (props.isLoading) {
		colour = props.theme.colours.disabledNavigationButton;
	} else if (props.isLocked) {
		colour = colours.component.locked;
	}
	return colour;
};

var primaryStyles = function primaryStyles(props) {
	return '\n\tbackground-color: ' + getPrimaryBackgroundColour(props) + ' ' + INTERNET_BANKING_CSS_OVERRIDE + ';\n\tborder: 2px solid ' + getPrimaryBackgroundColour(props) + ' ' + INTERNET_BANKING_CSS_OVERRIDE + ';\n\tborder-bottom-color: ' + (props.isLoading ? props.theme.colours.disabledNavigationButton + ' ' + INTERNET_BANKING_CSS_OVERRIDE : !props.isLocked && props.theme.colours.secondaryAccent + ' ' + INTERNET_BANKING_CSS_OVERRIDE) + ';\n\tcolor: ' + colours.generalPalette.white + ';\n\t' + getPrimaryHoverStyles(props) + '\n';
};

var getSecondaryHoverStyles = function getSecondaryHoverStyles(props) {
	if (!props.isLoading && !props.isLocked) {
		return '&:hover {\n            background-color: ' + props.theme.colours.primary + ' ' + INTERNET_BANKING_CSS_OVERRIDE + ';\n            color: ' + colours.generalPalette.white + ';\n\t\t}';
	}
	return '';
};

var getSecondaryBackgroundColour = function getSecondaryBackgroundColour(props) {
	var colour = colours.generalPalette.white;
	if (props.isLoading) {
		colour = props.theme.colours.disabledNavigationButton;
	} else if (props.isLocked) {
		colour = colours.component.locked;
	}
	return colour;
};

var getSecondaryBorderColour = function getSecondaryBorderColour(props) {
	var colour = props.theme.colours.primary;
	if (props.isLoading) {
		colour = props.theme.colours.disabledNavigationButton;
	} else if (props.isLocked) {
		colour = colours.component.locked;
	}
	return colour;
};

var getSecondaryColour = function getSecondaryColour(_ref) {
	var isLocked = _ref.isLocked,
	    isLoading = _ref.isLoading,
	    theme = _ref.theme;

	if (isLocked || isLoading) {
		return colours.generalPalette.white;
	}
	return theme.colours.primary;
};

var secondaryStyles = function secondaryStyles(props) {
	return '\n\tbackground-color: ' + getSecondaryBackgroundColour(props) + ' ' + INTERNET_BANKING_CSS_OVERRIDE + ';\n\tborder: 2px solid ' + getSecondaryBorderColour(props) + ' ' + INTERNET_BANKING_CSS_OVERRIDE + ';\n\tcolor: ' + getSecondaryColour(props) + ';\n\t' + getSecondaryHoverStyles(props) + '\n';
};

var getTertiaryHoverStyles = function getTertiaryHoverStyles(props) {
	if (!props.isLoading && !props.isLocked) {
		return '&:hover {\n            color: ' + props.theme.colours.secondaryAccent + ';\n\t\t}';
	}
	return '';
};

var getTertiaryColour = function getTertiaryColour(_ref2) {
	var isLocked = _ref2.isLocked,
	    isMonotone = _ref2.isMonotone,
	    theme = _ref2.theme;

	if (isLocked) {
		return colours.component.locked;
	}
	return isMonotone ? colours.generalPalette.black : theme.colours.primary;
};

var tertiaryStyles = function tertiaryStyles(props) {
	return '\n\tbackground: none ' + INTERNET_BANKING_CSS_OVERRIDE + ';;\n\tborder: 0 ' + INTERNET_BANKING_CSS_OVERRIDE + ';;\n\tcolor: ' + getTertiaryColour(props) + ';\n\tpadding: 0 ' + INTERNET_BANKING_CSS_OVERRIDE + ';;\n\ttext-decoration: underline;\n\theight: ' + (props.theme.isCompact ? 'auto' : '48px') + ';\n\n\t> div > div {\n\t\tfont-family: ' + props.theme.fonts.text.regular + ';\n\t}\n\n\t' + getTertiaryHoverStyles(props) + '\n';
};

var StyledLoadingIcon = styled('div')(_templateObject$A, function (props) {
	return props.isLoading && 'animation: spin 0.75s linear infinite;';
}, function (props) {
	return props.displayType === 'primary' || props.isLoading ? colours.generalPalette.white : props.theme.colours.primary;
}, spacing.SINGLE);

var StyledPadlockIcon = styled('div')(_templateObject2$j, spacing.HALF, function (props) {
	return props.displayType !== 'tertiary' ? colours.generalPalette.white : colours.component.locked;
});

var StyledButton$3 = styled('button')(_templateObject3$f, function (props) {
	return props.theme.borderRadius;
}, function (props) {
	return !props.isInline && '\n\t\t\tmargin-bottom: ' + (props.theme.isCompact ? spacing.SINGLE : spacing.DOUBLE) + ' ' + INTERNET_BANKING_CSS_OVERRIDE + ';\n\t\t\tmargin-right: ' + (props.theme.isCompact ? spacing.ONE_AND_HALF : spacing.TRIPLE) + ' ' + INTERNET_BANKING_CSS_OVERRIDE + ';\n\t';
}, function (props) {
	return props.theme.isCompact ? spacing.QUARTER + ' ' + spacing.SINGLE : spacing.SINGLE + ' ' + spacing.TRIPLE;
}, INTERNET_BANKING_CSS_OVERRIDE, function (props) {
	return props.displayType === 'primary' && primaryStyles(props);
}, function (props) {
	return props.displayType === 'secondary' && secondaryStyles(props);
}, function (props) {
	return props.displayType === 'tertiary' && tertiaryStyles(props);
}, function (props) {
	return props.hasFluidHeight && 'height: auto';
});

// eslint-disable-next-line react/prop-types

var UnwrappedNavigationButtonBase = function (_Component) {
	inherits(UnwrappedNavigationButtonBase, _Component);

	function UnwrappedNavigationButtonBase(props) {
		classCallCheck(this, UnwrappedNavigationButtonBase);

		var _this = possibleConstructorReturn(this, (UnwrappedNavigationButtonBase.__proto__ || Object.getPrototypeOf(UnwrappedNavigationButtonBase)).call(this, props));

		_this.state = {
			isVisible: false
		};
		return _this;
	}

	createClass(UnwrappedNavigationButtonBase, [{
		key: 'render',
		value: function render() {
			var _this2 = this;

			var _props = this.props,
			    dataTestId = _props['data-test-id'],
			    display = _props.display,
			    hasFluidHeight = _props.hasFluidHeight,
			    isInline = _props.isInline,
			    isLoading = _props.isLoading,
			    isLocked = _props.isLocked,
			    isMonotone = _props.isMonotone,
			    labelText = _props.labelText,
			    loadingText = _props.loadingText,
			    onClick = _props.onClick,
			    theme = _props.theme,
			    willSubmitForm = _props.willSubmitForm,
			    ariaLabelledBy = _props['aria-labelledby'],
			    ariaLabel = _props['aria-label'];
			var isVisible = this.state.isVisible;

			var PadlockIcon = getLockOutlineLarge(theme.name);
			var threeSeconds = 3000;

			var popToast = function popToast() {
				_this2.setState(function () {
					return { isVisible: true };
				});

				// Load data / make the call. Spoofed here for demo purposes.
				setTimeout(function () {
					_this2.setState(function () {
						return { isVisible: false };
					});
				}, threeSeconds);
			};

			return React.createElement(
				'div',
				null,
				React.createElement(
					StyledButton$3,
					{
						'data-test-id': dataTestId,
						disabled: isLoading,
						displayType: display,
						hasFluidHeight: hasFluidHeight,
						isInline: isInline,
						isLoading: isLoading,
						isLocked: isLocked,
						isMonotone: isMonotone,
						loadingText: true,
						onClick: isLocked ? popToast : onClick,
						type: willSubmitForm ? 'submit' : 'button',
						'aria-labelledby': ariaLabelledBy,
						'aria-label': ariaLabel
					},
					isLoading && React.createElement(
						StyledLoadingIcon,
						{ isLoading: isLoading },
						React.createElement(LoadingOutlineSmallIcon, null)
					),
					React.createElement(
						StandardLabel,
						{ isFlush: true },
						React.createElement(
							'span',
							null,
							isLoading ? loadingText : labelText
						)
					),
					isLocked && React.createElement(
						StyledPadlockIcon,
						{ displayType: display, isLocked: isLocked },
						React.createElement(PadlockIcon, null)
					)
				),
				React.createElement(WrappedInternalLockedToast, { isVisible: isVisible })
			);
		}
	}]);
	return UnwrappedNavigationButtonBase;
}(Component);

UnwrappedNavigationButtonBase.propTypes = _extends({}, baseProps$7);

var NavigationButtonBase = withTheme(UnwrappedNavigationButtonBase);

var baseProps$7 = {
	/** Data attribute available for automated test targeting. */
	'data-test-id': PropTypes.string,
	/** Locks the component with associated toast message on click. For Advisor system use only. */
	isLocked: PropTypes.bool,
	/** Button text. */
	labelText: PropTypes.string.isRequired,
	/** Callback function triggered on click. */
	onClick: PropTypes.func.isRequired,
	/** Aria-labelledby */
	'aria-labelledby': PropTypes.string,
	/** Aria-label */
	'aria-label': PropTypes.string
};

NavigationButtonBase.propTypes = _extends({}, baseProps$7, {
	/** Sets the display type, controls the styling. */
	display: PropTypes.oneOf(['primary', 'secondary', 'tertiary']).isRequired,
	/** Boolean to override the static button height. */
	hasFluidHeight: PropTypes.bool,
	/** Removed margins. */
	isInline: PropTypes.bool,
	/** Shows the loading spinner and loading text when true. */
	isLoading: PropTypes.bool,
	/** Changes the component colour to be monotone. For Advisor system use only. */
	isMonotone: PropTypes.bool,
	/** Sets the text when the isLoading prop is set to true. */
	loadingText: PropTypes.string,
	/** When set, will change button type from 'button' to 'submit'. */
	willSubmitForm: PropTypes.bool
});

NavigationButtonBase.defaultProps = {
	hasFluidHeight: false,
	isInline: false,
	isLoading: false,
	isLocked: false,
	isMonotone: false,
	loadingText: 'Loading',
	willSubmitForm: false
};

var primaryVariantProps = _extends({}, baseProps$7, {
	/** Shows the loading spinner and loading text when true. */
	isLoading: PropTypes.bool,
	/** Sets the text when the isLoading prop is set to true. */
	loadingText: PropTypes.string,
	/** Changes button type from 'button' to 'submit'. */
	willSubmitForm: PropTypes.bool
});

var Primary = function Primary(_ref) {
	var dataTestId = _ref['data-test-id'],
	    isLoading = _ref.isLoading,
	    isLocked = _ref.isLocked,
	    loadingText = _ref.loadingText,
	    label = _ref.label,
	    labelText = _ref.labelText,
	    onClick = _ref.onClick,
	    willSubmitForm = _ref.willSubmitForm,
	    variant = _ref.variant,
	    ariaLabelledBy = _ref['aria-labelledby'],
	    ariaLabel = _ref['aria-label'];

	var finalLabelText = getLabelText(label, labelText);
	return React.createElement(
		InternalComponentFrame,
		{ variant: variant, packageJson: packageJson$o, hasCustomMargins: true, layout: 'inline-block' },
		React.createElement(NavigationButtonBase, {
			'data-test-id': dataTestId,
			display: 'primary',
			isLoading: isLoading,
			isLocked: isLocked,
			labelText: finalLabelText,
			loadingText: loadingText,
			onClick: onClick,
			willSubmitForm: willSubmitForm,
			'aria-labelledby': ariaLabelledBy,
			'aria-label': ariaLabel
		})
	);
};

Primary.propTypes = _extends({}, primaryVariantProps, {
	/** legacy button text prop. */
	label: PropTypes.string,
	variant: PropTypes.string
});

Primary.defaultProps = {
	'data-test-id': 'navigation-button-primary',
	variant: 'Primary'
};

var secondaryVariantProps = _extends({}, baseProps$7, {
	/** Shows the loading spinner and loading text when true. */
	isLoading: PropTypes.bool,
	/** Sets the text when the isLoading prop is set to true. */
	loadingText: PropTypes.string
});

var Secondary = function Secondary(_ref) {
	var dataTestId = _ref['data-test-id'],
	    isLoading = _ref.isLoading,
	    isLocked = _ref.isLocked,
	    loadingText = _ref.loadingText,
	    label = _ref.label,
	    labelText = _ref.labelText,
	    onClick = _ref.onClick,
	    variant = _ref.variant,
	    ariaLabelledBy = _ref['aria-labelledby'],
	    ariaLabel = _ref['aria-label'];

	var finalLabelText = getLabelText(label, labelText);
	return React.createElement(
		InternalComponentFrame,
		{ variant: variant, packageJson: packageJson$o, hasCustomMargins: true, layout: 'inline-block' },
		React.createElement(NavigationButtonBase, {
			'data-test-id': dataTestId,
			display: 'secondary',
			isLoading: isLoading,
			isLocked: isLocked,
			labelText: finalLabelText,
			loadingText: loadingText,
			onClick: onClick,
			'aria-labelledby': ariaLabelledBy,
			'aria-label': ariaLabel
		})
	);
};

Secondary.propTypes = _extends({}, secondaryVariantProps, {
	/** legacy button text prop. */
	label: PropTypes.string,
	variant: PropTypes.string
});

Secondary.defaultProps = {
	'data-test-id': 'navigation-button-secondary',
	variant: 'Secondary'
};

var tertiaryVariantProps = _extends({}, baseProps$7, {
	/** Removed margins. */
	isInline: PropTypes.bool,
	/** Changes the component colour to be monotone. For Advisor system use only. */
	isMonotone: PropTypes.bool
});

var Tertiary = function Tertiary(_ref) {
	var dataTestId = _ref['data-test-id'],
	    isInline = _ref.isInline,
	    isLocked = _ref.isLocked,
	    isMonotone = _ref.isMonotone,
	    label = _ref.label,
	    labelText = _ref.labelText,
	    onClick = _ref.onClick,
	    willSubmitForm = _ref.willSubmitForm,
	    variant = _ref.variant,
	    ariaLabelledBy = _ref['aria-labelledby'],
	    ariaLabel = _ref['aria-label'];

	var finalLabelText = getLabelText(label, labelText);
	return React.createElement(
		InternalComponentFrame,
		{ variant: variant, packageJson: packageJson$o, hasCustomMargins: true, layout: 'inline-block' },
		React.createElement(NavigationButtonBase, {
			'data-test-id': dataTestId,
			display: 'tertiary',
			hasFluidHeight: true,
			isInline: isInline,
			isLocked: isLocked,
			isMonotone: isMonotone,
			labelText: finalLabelText,
			onClick: onClick,
			willSubmitForm: willSubmitForm,
			'aria-labelledby': ariaLabelledBy,
			'aria-label': ariaLabel
		})
	);
};

Tertiary.propTypes = _extends({}, tertiaryVariantProps, {
	/** legacy button text prop. */
	label: PropTypes.string
});

Tertiary.defaultProps = {
	'data-test-id': 'navigation-button-tertiary',
	variant: 'Tertiary'
};

var Back = function Back(_ref) {
	var dataTestId = _ref['data-test-id'],
	    isLoading = _ref.isLoading,
	    labelText = _ref.labelText,
	    loadingText = _ref.loadingText,
	    onClick = _ref.onClick,
	    ariaLabelledBy = _ref['aria-labelledby'],
	    ariaLabel = _ref['aria-label'];
	return React.createElement(NavigationButton.Secondary, {
		variant: 'Back',
		'data-test-id': dataTestId,
		display: 'secondary',
		isLoading: isLoading,
		labelText: labelText,
		loadingText: loadingText,
		onClick: onClick,
		'aria-label': ariaLabel,
		'aria-labelledby': ariaLabelledBy
	});
};

Back.propTypes = _extends({}, secondaryVariantProps);

Back.defaultProps = {
	'data-test-id': 'navigation-button-back',
	labelText: 'Back',
	variant: 'Back'
};

var Cancel = function Cancel(_ref2) {
	var dataTestId = _ref2['data-test-id'],
	    labelText = _ref2.labelText,
	    onClick = _ref2.onClick,
	    ariaLabelledBy = _ref2['aria-labelledby'],
	    ariaLabel = _ref2['aria-label'];
	return React.createElement(NavigationButton.Tertiary, {
		variant: 'Cancel',
		'data-test-id': dataTestId,
		display: 'tertiary',
		labelText: labelText,
		onClick: onClick,
		'aria-labelledby': ariaLabelledBy,
		'aria-label': ariaLabel
	});
};

Cancel.propTypes = _extends({}, tertiaryVariantProps);

Cancel.defaultProps = {
	'data-test-id': 'navigation-button-cancel',
	labelText: 'Cancel',
	variant: 'Cancel'
};

var Confirm = function Confirm(_ref3) {
	var dataTestId = _ref3['data-test-id'],
	    isLoading = _ref3.isLoading,
	    isLocked = _ref3.isLocked,
	    labelText = _ref3.labelText,
	    loadingText = _ref3.loadingText,
	    onClick = _ref3.onClick,
	    willSubmitForm = _ref3.willSubmitForm,
	    ariaLabelledBy = _ref3['aria-labelledby'],
	    ariaLabel = _ref3['aria-label'];
	return React.createElement(NavigationButton.Primary, {
		variant: 'Confirm',
		'data-test-id': dataTestId,
		display: 'primary',
		isLoading: isLoading,
		isLocked: isLocked,
		labelText: labelText,
		loadingText: loadingText,
		onClick: onClick,
		willSubmitForm: willSubmitForm,
		'aria-labelledby': ariaLabelledBy,
		'aria-label': ariaLabel
	});
};

Confirm.propTypes = _extends({}, primaryVariantProps);

Confirm.defaultProps = {
	'data-test-id': 'navigation-button-confirm',
	labelText: 'Confirm',
	variant: 'Confirm'
};

var Continue = function Continue(_ref4) {
	var dataTestId = _ref4['data-test-id'],
	    isLoading = _ref4.isLoading,
	    isLocked = _ref4.isLocked,
	    labelText = _ref4.labelText,
	    loadingText = _ref4.loadingText,
	    onClick = _ref4.onClick,
	    willSubmitForm = _ref4.willSubmitForm,
	    ariaLabelledBy = _ref4['aria-labelledby'],
	    ariaLabel = _ref4['aria-label'];
	return React.createElement(NavigationButton.Primary, {
		variant: 'Continue',
		'data-test-id': dataTestId,
		display: 'primary',
		isLoading: isLoading,
		isLocked: isLocked,
		labelText: labelText,
		loadingText: loadingText,
		onClick: onClick,
		willSubmitForm: willSubmitForm,
		'aria-labelledby': ariaLabelledBy,
		'aria-label': ariaLabel
	});
};

Continue.propTypes = _extends({}, primaryVariantProps);

Continue.defaultProps = {
	'data-test-id': 'navigation-button-continue',
	labelText: 'Continue',
	variant: 'Continue'
};

var Next = function Next(_ref5) {
	var dataTestId = _ref5['data-test-id'],
	    isLoading = _ref5.isLoading,
	    isLocked = _ref5.isLocked,
	    labelText = _ref5.labelText,
	    loadingText = _ref5.loadingText,
	    onClick = _ref5.onClick,
	    willSubmitForm = _ref5.willSubmitForm,
	    ariaLabelledBy = _ref5['aria-labelledby'],
	    ariaLabel = _ref5['aria-label'];
	return React.createElement(NavigationButton.Primary, {
		variant: 'Next',
		'data-test-id': dataTestId,
		display: 'primary',
		isLoading: isLoading,
		isLocked: isLocked,
		labelText: labelText,
		loadingText: loadingText,
		onClick: onClick,
		willSubmitForm: willSubmitForm,
		'aria-labelledby': ariaLabelledBy,
		'aria-label': ariaLabel
	});
};

Next.propTypes = _extends({}, primaryVariantProps);

Next.defaultProps = {
	'data-test-id': 'navigation-button-next',
	labelText: 'Next',
	variant: 'Next'
};

var Submit = function Submit(_ref6) {
	var dataTestId = _ref6['data-test-id'],
	    isLoading = _ref6.isLoading,
	    isLocked = _ref6.isLocked,
	    labelText = _ref6.labelText,
	    loadingText = _ref6.loadingText,
	    onClick = _ref6.onClick,
	    willSubmitForm = _ref6.willSubmitForm,
	    ariaLabelledBy = _ref6['aria-labelledby'],
	    ariaLabel = _ref6['aria-label'];
	return React.createElement(NavigationButton.Primary, {
		variant: 'Submit',
		'data-test-id': dataTestId,
		display: 'primary',
		isLoading: isLoading,
		isLocked: isLocked,
		labelText: labelText,
		loadingText: loadingText,
		onClick: onClick,
		willSubmitForm: willSubmitForm,
		'aria-labelledby': ariaLabelledBy,
		'aria-label': ariaLabel
	});
};

Submit.propTypes = _extends({}, primaryVariantProps);

Submit.defaultProps = {
	'data-test-id': 'navigation-button-submit',
	labelText: 'Submit',
	variant: 'Submit'
};

var NavigationButton = {
	Back: Back,
	Cancel: Cancel,
	Confirm: Confirm,
	Continue: Continue,
	Next: Next,
	Primary: Primary,
	Secondary: Secondary,
	Submit: Submit,
	Tertiary: Tertiary
};

var _templateObject$B = taggedTemplateLiteral(['\n\tborder: none;\n\tborder-collapse: collapse;\n\t', ';\n\n\t@media only print {\n\t\tpadding: 0;\n\t}\n'], ['\n\tborder: none;\n\tborder-collapse: collapse;\n\t', ';\n\n\t@media only print {\n\t\tpadding: 0;\n\t}\n']),
    _templateObject2$k = taggedTemplateLiteral(['\n\ttd {\n\t\tpadding-bottom: 0;\n\t}\n\n\ttr {\n\t\tborder-bottom: none;\n\t}\n'], ['\n\ttd {\n\t\tpadding-bottom: 0;\n\t}\n\n\ttr {\n\t\tborder-bottom: none;\n\t}\n']),
    _templateObject3$g = taggedTemplateLiteral(['\n\tborder-bottom: 1px solid ', ';\n'], ['\n\tborder-bottom: 1px solid ', ';\n']),
    _templateObject4$8 = taggedTemplateLiteral(['\n\tbackground: ', ';\n\tborder-collapse: collapse;\n\tmargin: 0;\n\ttext-align: left;\n\twidth: 100%;\n'], ['\n\tbackground: ', ';\n\tborder-collapse: collapse;\n\tmargin: 0;\n\ttext-align: left;\n\twidth: 100%;\n']),
    _templateObject5$7 = taggedTemplateLiteral(['\n\tborder: none;\n\t', ';\n'], ['\n\tborder: none;\n\t', ';\n']),
    _templateObject6$7 = taggedTemplateLiteral(['\n\toverflow-x: visible;\n'], ['\n\toverflow-x: visible;\n']);

var cellPadding = 'padding: ' + spacing.DOUBLE + ' ' + spacing.DOUBLE + ' ' + spacing.DOUBLE + ' 0;';

var StyledCell = styled('td')(_templateObject$B, function (props) {
	return props.isAccountName ? '\n\t\t\tpadding: ' + spacing.DOUBLE + ' 0 0 0;\n\n\t\t\tbutton {\n\t\t\t\tmargin-right: ' + spacing.DOUBLE + ' !important;\n\t\t\t}\n\t\t' : cellPadding;
});

var StyledFooter = styled('tfoot')(_templateObject2$k);

var StyledRow = styled('tr')(_templateObject3$g, colours.component.border);

var StyledTable = styled('table')(_templateObject4$8, colours.component.background);

var StyledTableHeader = styled('th')(_templateObject5$7, cellPadding);

var StyledWrapper$c = styled('div')(_templateObject6$7);

var formatCurrencySymbol = function formatCurrencySymbol(currencySymbol) {
	return currencySymbol.toUpperCase();
};

var AccountPoolTable = function AccountPoolTable(_ref) {
	var currencySymbol = _ref.currencySymbol,
	    data = _ref.data,
	    totalValues = _ref.totalValues;
	return React.createElement(
		StyledWrapper$c,
		null,
		React.createElement(
			StyledTable,
			null,
			React.createElement(
				'thead',
				null,
				React.createElement(
					StyledRow,
					null,
					React.createElement(
						StyledTableHeader,
						null,
						React.createElement(
							StandardLabel,
							{ isFlush: true },
							React.createElement(
								'span',
								null,
								'Account'
							)
						)
					),
					React.createElement(
						StyledTableHeader,
						null,
						React.createElement(
							StandardLabel,
							{ isFlush: true },
							React.createElement(
								'span',
								null,
								'Account number'
							)
						)
					),
					React.createElement(
						StyledTableHeader,
						null,
						React.createElement(
							StandardLabel,
							{ isFlush: true },
							React.createElement(
								'span',
								null,
								'Last business day balance'
							)
						)
					),
					React.createElement(
						StyledTableHeader,
						null,
						React.createElement(
							StandardLabel,
							{ isFlush: true },
							React.createElement(
								'span',
								null,
								'Current balance'
							)
						)
					),
					React.createElement(
						StyledTableHeader,
						null,
						React.createElement(
							StandardLabel,
							{ isFlush: true },
							React.createElement(
								'span',
								null,
								'Cleared balance'
							)
						)
					),
					React.createElement(
						StyledTableHeader,
						null,
						React.createElement(
							StandardLabel,
							{ isFlush: true },
							React.createElement(
								'span',
								null,
								'Available balance'
							)
						)
					)
				)
			),
			React.createElement(
				'tbody',
				null,
				data.map(function (_ref2, index) {
					var accountLink = _ref2.accountLink,
					    accountNumber = _ref2.accountNumber,
					    currencySymbol = _ref2.currencySymbol,
					    lastBusinessDayBalance = _ref2.lastBusinessDayBalance,
					    currentBalance = _ref2.currentBalance,
					    clearedBalance = _ref2.clearedBalance,
					    availableBalance = _ref2.availableBalance;
					return currencySymbol.toUpperCase() !== 'GBP' ? React.createElement(
						StyledRow,
						{ key: index },
						React.createElement(
							StyledCell,
							{ isAccountName: true },
							React.createElement(
								StandardBody,
								{ isFlush: true },
								React.createElement(NavigationButton.Tertiary, { labelText: accountLink.accountName, onClick: accountLink.onClick })
							)
						),
						React.createElement(
							StyledCell,
							null,
							React.createElement(
								StandardBody,
								{ isFlush: true },
								React.createElement(
									'span',
									null,
									BankingUtils.accountNumberFormat(accountNumber)
								)
							)
						),
						React.createElement(
							StyledCell,
							null,
							React.createElement(
								StandardBody,
								{ isFlush: true },
								React.createElement(
									'span',
									null,
									React.createElement(InternationalMoneyValue.WithCents, {
										balance: lastBusinessDayBalance,
										currencySymbolSuffix: formatCurrencySymbol(currencySymbol)
									})
								)
							)
						),
						React.createElement(
							StyledCell,
							null,
							React.createElement(
								StandardBody,
								{ isFlush: true },
								React.createElement(
									'span',
									null,
									React.createElement(InternationalMoneyValue.WithCents, {
										balance: currentBalance,
										currencySymbolSuffix: formatCurrencySymbol(currencySymbol)
									})
								)
							)
						),
						React.createElement(
							StyledCell,
							null,
							React.createElement(
								StandardBody,
								{ isFlush: true },
								React.createElement(
									'span',
									null,
									React.createElement(InternationalMoneyValue.WithCents, {
										balance: clearedBalance,
										currencySymbolSuffix: formatCurrencySymbol(currencySymbol)
									})
								)
							)
						),
						React.createElement(
							StyledCell,
							null,
							React.createElement(
								StandardBody,
								{ isFlush: true },
								React.createElement(
									'span',
									null,
									React.createElement(InternationalMoneyValue.WithCents, {
										balance: availableBalance,
										currencySymbolSuffix: formatCurrencySymbol(currencySymbol)
									})
								)
							)
						)
					) : React.createElement(
						StyledRow,
						{ key: index },
						React.createElement(
							StyledCell,
							null,
							React.createElement(
								StandardBody,
								{ isFlush: true },
								React.createElement(NavigationButton.Tertiary, { labelText: accountLink.accountName, onClick: accountLink.onClick })
							)
						),
						React.createElement(
							StyledCell,
							null,
							React.createElement(
								StandardBody,
								{ isFlush: true },
								React.createElement(
									'span',
									null,
									BankingUtils.accountNumberFormat(accountNumber)
								)
							)
						),
						React.createElement(
							StyledCell,
							null,
							React.createElement(
								StandardBody,
								{ isFlush: true },
								React.createElement(MoneyValue.WithPence, { balance: lastBusinessDayBalance })
							)
						),
						React.createElement(
							StyledCell,
							null,
							React.createElement(
								StandardBody,
								{ isFlush: true },
								React.createElement(MoneyValue.WithPence, { balance: currentBalance })
							)
						),
						React.createElement(
							StyledCell,
							null,
							React.createElement(
								StandardBody,
								{ isFlush: true },
								React.createElement(MoneyValue.WithPence, { balance: clearedBalance })
							)
						),
						React.createElement(
							StyledCell,
							null,
							React.createElement(
								StandardBody,
								{ isFlush: true },
								React.createElement(MoneyValue.WithPence, { balance: availableBalance })
							)
						)
					);
				})
			),
			React.createElement(
				StyledFooter,
				null,
				React.createElement(
					StyledRow,
					null,
					React.createElement(StyledCell, null),
					React.createElement(
						StyledCell,
						null,
						React.createElement(
							StandardLabel,
							{ isFlush: true },
							React.createElement(
								'span',
								null,
								'Pool total'
							)
						)
					),
					totalValues.map(function (total, index) {
						return React.createElement(
							StyledCell,
							{ key: index },
							React.createElement(
								StandardLabel,
								{ isFlush: true },
								currencySymbol.toUpperCase() === 'GBP' ? React.createElement(MoneyValue.WithPence, { balance: total }) : React.createElement(
									'span',
									null,
									React.createElement(InternationalMoneyValue.WithCents, {
										balance: total,
										currencySymbolSuffix: formatCurrencySymbol(currencySymbol)
									})
								)
							)
						);
					})
				)
			)
		)
	);
};

AccountPoolTable.propTypes = {
	/** Currency symbol. */
	currencySymbol: PropTypes.string.isRequired,
	/** Table data object, structured as defined. */
	data: PropTypes.arrayOf(PropTypes.shape({
		/** Account link. */
		accountLink: PropTypes.shape({
			/** Account name. */
			accountName: PropTypes.string.isRequired,
			/** Callback function triggered on click. */
			onClick: PropTypes.func.isRequired
		}),
		/** Notional currency symbol. */
		currencySymbol: PropTypes.string.isRequired,
		/** Account number. */
		accountNumber: PropTypes.number.isRequired,
		/** Last business day balance. */
		lastBusinessDayBalance: PropTypes.number.isRequired,
		/** Current balance. */
		currentBalance: PropTypes.number.isRequired,
		/** Cleared balance. */
		clearedBalance: PropTypes.number.isRequired,
		/** Available balance. */
		availableBalance: PropTypes.number.isRequired
	})).isRequired,
	/** Total values. */
	totalValues: PropTypes.arrayOf(PropTypes.number).isRequired
};

var main$p = "AccountPoolTablePanel.js";
var packageJson$p = {
	main: main$p,
	"component-id": null,
	"component-life-cycle": "active",
	"is-bespoke": true
};

var _templateObject$C = taggedTemplateLiteral(['\n\t@media only screen {\n\t\toverflow: auto;\n\t\tpadding: ', ';\n\t}\n'], ['\n\t@media only screen {\n\t\toverflow: auto;\n\t\tpadding: ', ';\n\t}\n']),
    _templateObject2$l = taggedTemplateLiteral(['\n\talign-items: center;\n\tbackground: none;\n\tborder: none;\n\tborder-radius: ', ';\n\tcolor: ', ';\n\tdisplay: inline-flex;\n\tjustify-content: space-between;\n\tpadding: 0 ', ';\n\ttext-decoration: ', ';\n\n\tsvg {\n\t\tfill: ', ';\n\t\theight: 16px;\n\t\tmargin-left: ', ';\n\t\t', ' transition: transform 0.15s;\n\t\twidth: 16px;\n\t}\n'], ['\n\talign-items: center;\n\tbackground: none;\n\tborder: none;\n\tborder-radius: ', ';\n\tcolor: ', ';\n\tdisplay: inline-flex;\n\tjustify-content: space-between;\n\tpadding: 0 ', ';\n\ttext-decoration: ', ';\n\n\tsvg {\n\t\tfill: ', ';\n\t\theight: 16px;\n\t\tmargin-left: ', ';\n\t\t', ' transition: transform 0.15s;\n\t\twidth: 16px;\n\t}\n']),
    _templateObject3$h = taggedTemplateLiteral(['\n\tfont-family: ', ';\n'], ['\n\tfont-family: ', ';\n']),
    _templateObject4$9 = taggedTemplateLiteral(['\n\toverflow: auto;\n\tpadding: 0 ', '\n\t\t', ';\n'], ['\n\toverflow: auto;\n\tpadding: 0 ', '\n\t\t', ';\n']),
    _templateObject5$8 = taggedTemplateLiteral(['\n\t@media only screen {\n\t\tbackground: ', ';\n\t\tborder: 1px solid ', ';\n\t\tborder-radius: ', ';\n\t\tbox-sizing: border-box;\n\t\tcolor: ', ';\n\t\tposition: relative;\n\n\t\t', ';\n\t}\n'], ['\n\t@media only screen {\n\t\tbackground: ', ';\n\t\tborder: 1px solid ', ';\n\t\tborder-radius: ', ';\n\t\tbox-sizing: border-box;\n\t\tcolor: ', ';\n\t\tposition: relative;\n\n\t\t', ';\n\t}\n']);

var StyledLeftAndRightWrapper = styled('div')(_templateObject$C, function (props) {
	return props.theme.components.accountPoolTablePanel.root.padding;
});

var StyledMoreButton$2 = styled('button')(_templateObject2$l, function (props) {
	return props.theme.borderRadius;
}, function (props) {
	return props.theme.colours.primary;
}, spacing.HALF, function (props) {
	return props.theme.components.accountPoolTablePanel.root.textDecoration;
}, function (props) {
	return props.theme.colours.primary;
}, spacing.HALF, function (props) {
	return props.isExpanded && 'transform: rotate(180deg);';
});

var StyledMoreText$2 = styled('span')(_templateObject3$h, function (props) {
	return props.theme.fonts.display.bold;
});

var StyledMoreWrapper = styled('div')(_templateObject4$9, function (props) {
	return props.theme.components.accountPoolTablePanel.root.padding;
}, function (props) {
	return props.theme.components.accountPoolTablePanel.root.padding;
});

var StyledWrapper$d = styled('div')(_templateObject5$8, colours.component.background, function (props) {
	return props.theme.colours.nonInteractive;
}, function (props) {
	return props.theme.borderRadiusLarger;
}, function (props) {
	return props.theme.colours.bodyText;
}, function (props) {
	return getCardStripeStyles(props.theme);
});

var AccountPoolTablePanel = function AccountPoolTablePanel(_ref) {
	var accountBalance = _ref.accountBalance,
	    accountAvailable = _ref.accountAvailable,
	    totalAccounts = _ref.totalAccounts,
	    currencySymbol = _ref.currencySymbol,
	    data = _ref.data,
	    moreOnClick = _ref.moreOnClick,
	    isExpanded = _ref.isExpanded,
	    poolName = _ref.poolName,
	    tableBody = _ref.tableBody,
	    totalValues = _ref.totalValues,
	    theme = _ref.theme;

	var accountBalanceFont = theme.components.accountPoolTablePanel.fonts.accountBalance;
	var totalAccountsFont = theme.components.accountPoolTablePanel.fonts.totalAccounts;
	var poolNameFont = theme.components.accountPoolTablePanel.fonts.poolName;
	var accountNameFont = theme.components.accountPoolTablePanel.fonts.accountName;
	var accountAvailableFont = theme.components.accountPoolTablePanel.fonts.accountAvailable;

	var ChevronDownIcon = getChevronDownSolidLarge(theme.name);

	var formattedCurrencySymbol = currencySymbol.toUpperCase();

	var getMoneyValue = function getMoneyValue(balance) {
		return formattedCurrencySymbol === 'GBP' ? React.createElement(MoneyValue.WithPence, { balance: balance }) : React.createElement(InternationalMoneyValue.WithCents, { balance: balance, currencySymbolSuffix: formattedCurrencySymbol });
	};

	return React.createElement(
		InternalComponentFrame,
		{ packageJson: packageJson$p },
		React.createElement(
			StyledWrapper$d,
			null,
			React.createElement(
				StyledLeftAndRightWrapper,
				null,
				React.createElement(Inline.Justified, {
					isNonWrapping: true,
					nodes: [poolNameFont(React.createElement(
						'span',
						null,
						poolName
					)), accountBalanceFont(React.createElement(
						'span',
						null,
						getMoneyValue(accountBalance)
					))]
				}),
				React.createElement(Inline.Justified, {
					isNonWrapping: true,
					nodes: [accountNameFont(React.createElement(
						'span',
						null,
						'Notional currency: ',
						formattedCurrencySymbol
					)), accountAvailableFont(React.createElement(
						'span',
						null,
						getMoneyValue(accountAvailable),
						' available'
					))]
				}),
				React.createElement(Inline.Justified, {
					isNonWrapping: true,
					nodes: [totalAccountsFont(React.createElement(
						'span',
						null,
						totalAccounts,
						' accounts'
					)), React.createElement(
						StyledMoreButton$2,
						{ key: 'more-button', isExpanded: isExpanded, onClick: moreOnClick },
						React.createElement(
							StandardBody,
							{ isFlush: true },
							React.createElement(
								StyledMoreText$2,
								null,
								isExpanded ? 'Hide' : 'More Information'
							)
						),
						React.createElement(ChevronDownIcon, null)
					)]
				})
			),
			isExpanded && React.createElement(
				StyledMoreWrapper,
				null,
				tableBody && React.createElement(
					StandardBody,
					null,
					tableBody
				),
				React.createElement(AccountPoolTable, { currencySymbol: formattedCurrencySymbol, data: data, totalValues: totalValues })
			)
		)
	);
};

AccountPoolTablePanel.propTypes = {
	/** Account available. */
	accountAvailable: PropTypes.number.isRequired,
	/** Account balance in pence. */
	accountBalance: PropTypes.number.isRequired,
	/** Notional currency symbol. */
	currencySymbol: PropTypes.string.isRequired,
	/** Table data object, structured as defined. */
	data: PropTypes.arrayOf(PropTypes.shape({
		/** Account link. */
		accountLink: PropTypes.shape({
			/** Account name. */
			accountName: PropTypes.string.isRequired,
			/** Callback function triggered on click. */
			onClick: PropTypes.func.isRequired
		}),
		/** Currency symbol. */
		currencySymbol: PropTypes.string.isRequired,
		/** Account number. */
		accountNumber: PropTypes.number.isRequired,
		/** Last business day balance. */
		lastBusinessDayBalance: PropTypes.number.isRequired,
		/** Current balance. */
		currentBalance: PropTypes.number.isRequired,
		/** Cleared balance. */
		clearedBalance: PropTypes.number.isRequired,
		/** Available balance. */
		availableBalance: PropTypes.number.isRequired
	})).isRequired,
	/** Shows table when set to true. */
	isExpanded: PropTypes.bool,
	/** Callback function triggered on click of 'More' buttom. */
	moreOnClick: PropTypes.func.isRequired,
	/** Pool name. */
	poolName: PropTypes.string.isRequired,
	/** Text displayed in the exapanded content above the table. */
	tableBody: PropTypes.string,
	/** Total number of accounts in the table. */
	totalAccounts: PropTypes.number.isRequired,
	/** Total values. */
	totalValues: PropTypes.arrayOf(PropTypes.number).isRequired
};

AccountPoolTablePanel.defaultProps = {
	isExpanded: false
};

var WrappedAccountPoolTablePanel = withTheme(AccountPoolTablePanel);

var _extends$k = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$j(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var GenericIcon$6 = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$j(_ref, ["styles"]);

  return React.createElement("svg", _extends$k({ width: "16", height: "16", viewBox: "0 0 16 16", xmlns: "http://www.w3.org/2000/svg" }, props), React.createElement("path", { d: "M5.953 16a1.7 1.7 0 0 1-1.331-.632L.34 9.972c-.558-.7-.413-1.698.323-2.23.737-.534 1.784-.393 2.34.31l2.82 3.547L12.908.75c.487-.745 1.518-.974 2.302-.51.783.465 1.024 1.448.535 2.195L7.373 15.247c-.29.447-.792.726-1.343.75-.025.002-.05.002-.076.002V16z" }));
});

var _extends$l = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$k(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var VMIcon$6 = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$k(_ref, ["styles"]);

  return React.createElement("svg", _extends$l({ height: "96", viewBox: "0 0 96 96", width: "96", xmlns: "http://www.w3.org/2000/svg" }, props), React.createElement("path", { d: "M29.254 86.8a6.295 6.295 0 0 1-4.394-1.776L0 60.784l8.788-8.57 20.25 19.75L86.805 10 96 18.155 33.851 84.817a6.289 6.289 0 0 1-4.449 1.983z" }));
});

var getTickSolidLarge = getThemeIcon(VMIcon$6, GenericIcon$6);

var main$q = "AccountRadioCard.js";
var variants$9 = ["BankAccount", "CreditCard", "Group"];
var packageJson$q = {
	main: main$q,
	variants: variants$9,
	"component-id": null,
	"component-life-cycle": "active",
	"is-bespoke": true
};

var _templateObject$D = taggedTemplateLiteral(['\n\tbackground-color: ', ';\n\tborder-color: ', ';\n\tborder-radius: ', ';\n\tborder-style: solid;\n\tborder-width: ', ';\n\tbox-shadow: ', ';\n\tdisplay: inline-block;\n\tmargin: 0 ', ' ', ' 0;\n\tpadding: ', ';\n\tposition: relative;\n\ttext-align: left;\n\ttransition: all 0.2s ease-in-out;\n\n\t@media (min-width: ', ') {\n\t\tmin-width: ', ';\n\t}\n\n\t', ';\n\t', ';\n'], ['\n\tbackground-color: ', ';\n\tborder-color: ', ';\n\tborder-radius: ', ';\n\tborder-style: solid;\n\tborder-width: ', ';\n\tbox-shadow: ', ';\n\tdisplay: inline-block;\n\tmargin: 0 ', ' ', ' 0;\n\tpadding: ', ';\n\tposition: relative;\n\ttext-align: left;\n\ttransition: all 0.2s ease-in-out;\n\n\t@media (min-width: ', ') {\n\t\tmin-width: ', ';\n\t}\n\n\t', ';\n\t', ';\n']),
    _templateObject2$m = taggedTemplateLiteral(['\n\tcolor: ', ';\n\tfont-family: ', ';\n\tmargin-bottom: ', ';\n\tpadding-right: 40px;\n'], ['\n\tcolor: ', ';\n\tfont-family: ', ';\n\tmargin-bottom: ', ';\n\tpadding-right: 40px;\n']),
    _templateObject3$i = taggedTemplateLiteral(['\n\tcolor: ', ';\n\tmargin-bottom: ', ';\n'], ['\n\tcolor: ', ';\n\tmargin-bottom: ', ';\n']),
    _templateObject4$a = taggedTemplateLiteral(['\n\tcolor: ', ';\n\tfont-family: ', ';\n\tfont-weight: bold;\n\tmargin-bottom: ', ';\n'], ['\n\tcolor: ', ';\n\tfont-family: ', ';\n\tfont-weight: bold;\n\tmargin-bottom: ', ';\n']),
    _templateObject5$9 = taggedTemplateLiteral(['\n\tcolor: ', ';\n'], ['\n\tcolor: ', ';\n']),
    _templateObject6$8 = taggedTemplateLiteral(['\n\tborder-top-left-radius: ', ';\n\tborder-top-right-radius: calc(', ' - 1px);\n\tborder-bottom-right-radius: ', ';\n\tborder-bottom-left-radius: ', ';\n\tbackground: ', ';\n\tmin-height: ', ';\n\tmin-width: ', ';\n\tposition: absolute;\n\tright: 0;\n\ttop: 0;\n\tvisibility: hidden;\n\n\t', ';\n\n\t@keyframes SlideIn {\n\t\tfrom {\n\t\t\tright: -5em;\n\t\t\ttop: -5em;\n\t\t}\n\n\t\tto {\n\t\t\tright: 0em;\n\t\t\ttop: 0em;\n\t\t}\n\t}\n\n\t@keyframes SlideOut {\n\t\tfrom {\n\t\t\tright: 0em;\n\t\t\ttop: 0em;\n\t\t}\n\n\t\tto {\n\t\t\tright: -5em;\n\t\t\ttop: -5em;\n\t\t}\n\t}\n'], ['\n\tborder-top-left-radius: ', ';\n\tborder-top-right-radius: calc(', ' - 1px);\n\tborder-bottom-right-radius: ', ';\n\tborder-bottom-left-radius: ', ';\n\tbackground: ', ';\n\tmin-height: ', ';\n\tmin-width: ', ';\n\tposition: absolute;\n\tright: 0;\n\ttop: 0;\n\tvisibility: hidden;\n\n\t', ';\n\n\t@keyframes SlideIn {\n\t\tfrom {\n\t\t\tright: -5em;\n\t\t\ttop: -5em;\n\t\t}\n\n\t\tto {\n\t\t\tright: 0em;\n\t\t\ttop: 0em;\n\t\t}\n\t}\n\n\t@keyframes SlideOut {\n\t\tfrom {\n\t\t\tright: 0em;\n\t\t\ttop: 0em;\n\t\t}\n\n\t\tto {\n\t\t\tright: -5em;\n\t\t\ttop: -5em;\n\t\t}\n\t}\n']),
    _templateObject7$5 = taggedTemplateLiteral(['\n\tborder-top-left-radius: ', ';\n\tborder-top-right-radius: calc(', ' - 1px);\n\tborder-bottom-right-radius: ', ';\n\tborder-bottom-left-radius: ', ';\n\tmin-height: ', ';\n\tmin-width: ', ';\n\toverflow: hidden;\n\tposition: absolute;\n\tright: 0;\n\ttop: 0;\n\tvisibility: hidden;\n'], ['\n\tborder-top-left-radius: ', ';\n\tborder-top-right-radius: calc(', ' - 1px);\n\tborder-bottom-right-radius: ', ';\n\tborder-bottom-left-radius: ', ';\n\tmin-height: ', ';\n\tmin-width: ', ';\n\toverflow: hidden;\n\tposition: absolute;\n\tright: 0;\n\ttop: 0;\n\tvisibility: hidden;\n']),
    _templateObject8$4 = taggedTemplateLiteral(['\n\topacity: ', ';\n\tposition: absolute;\n\tright: ', ';\n\ttop: ', ';\n\t', ';\n\tsvg {\n\t\tfill: ', ';\n\t\theight: 16px;\n\t\twidth: 16px;\n\t}\n'], ['\n\topacity: ', ';\n\tposition: absolute;\n\tright: ', ';\n\ttop: ', ';\n\t', ';\n\tsvg {\n\t\tfill: ', ';\n\t\theight: 16px;\n\t\twidth: 16px;\n\t}\n']),
    _templateObject9$2 = taggedTemplateLiteral(['\n\tdisplay: inline-grid;\n'], ['\n\tdisplay: inline-grid;\n']);

var StyledAccountCard$3 = styled('button')(_templateObject$D, function (props) {
	return props.isSelected ? props.theme.colours.interaction : colours.component.background;
}, function (props) {
	return props.isSelected ? props.theme.colours.interaction : colours.component.border;
}, function (props) {
	return props.theme.borderRadiusLarger;
}, function (props) {
	return props.theme.components.accountRadioCard.root.borderWidth;
}, function (props) {
	return props.isSelected ? '0' : function (props) {
		return props.theme.boxShadow;
	};
}, spacing.SINGLE, spacing.DOUBLE, function (props) {
	return props.theme.components.accountRadioCard.root.padding;
}, breakpoint('md1'), function (props) {
	return props.theme.components.accountRadioCard.root.wrapperMinWidth;
}, function (props) {
	return props.theme.name === 'vm' && getCardStripeStyles(props.theme);
}, function (props) {
	return getCardHoverStyles(props.theme);
});

var StyledAccountName$4 = styled('div')(_templateObject2$m, function (props) {
	return props.isSelected ? colours.generalPalette.white : props.theme.components.accountRadioCard.colours.accountNameColour;
}, function (props) {
	return props.theme.fonts.display.regular;
}, function (props) {
	return props.theme.components.accountRadioCard.root.marginBottom;
});

var StyledAccountDetails$3 = styled('div')(_templateObject3$i, function (props) {
	return props.isSelected ? colours.generalPalette.white : props.theme.colours.bodyText;
}, function (props) {
	return props.theme.components.accountRadioCard.root.marginBottomLarger;
});

var StyledAccountBalance$1 = styled('div')(_templateObject4$a, function (props) {
	return props.isSelected ? colours.generalPalette.white : props.theme.colours.bodyText;
}, function (props) {
	return props.theme.fonts.display.regular;
}, function (props) {
	return props.theme.components.accountRadioCard.root.marginBottom;
});

var StyledAccountAvailable = styled('div')(_templateObject5$9, function (props) {
	return props.isSelected ? colours.generalPalette.white : props.theme.colours.bodyText;
});

var StyledSquare = styled('div')(_templateObject6$8, function (props) {
	return props.theme.components.accountRadioCard.root.borderRadiusTopLeft;
}, function (props) {
	return props.theme.components.accountRadioCard.root.borderRadiusTopRight;
}, function (props) {
	return props.theme.components.accountRadioCard.root.borderRadiusBottomRight;
}, function (props) {
	return props.theme.components.accountRadioCard.root.borderRadiusBottomLeft;
}, function (props) {
	return props.theme.components.accountRadioCard.colours.gradient;
}, function (props) {
	return props.theme.components.accountRadioCard.root.squareMinHeight;
}, function (props) {
	return props.theme.components.accountRadioCard.root.squareMinWidth;
}, function (props) {
	return props.isSelected ? 'animation: SlideIn 0.4s linear; visibility: visible' : 'animation: SlideOut 0.2s linear 0.2s; transition: visibility 0.4s ease-in-out';
});

var StyledSquareWrapper = styled('div')(_templateObject7$5, function (props) {
	return props.theme.components.accountRadioCard.root.borderRadiusTopLeft;
}, function (props) {
	return props.theme.components.accountRadioCard.root.borderRadiusTopRight;
}, function (props) {
	return props.theme.components.accountRadioCard.root.borderRadiusBottomRight;
}, function (props) {
	return props.theme.components.accountRadioCard.root.borderRadiusBottomLeft;
}, function (props) {
	return props.theme.components.accountRadioCard.root.squareMinHeight;
}, function (props) {
	return props.theme.components.accountRadioCard.root.squareMinWidth;
});

var StyledTick = styled('div')(_templateObject8$4, function (props) {
	return props.isSelected ? 1 : 0;
}, function (props) {
	return props.theme.components.accountRadioCard.root.svgRight;
}, function (props) {
	return props.theme.components.accountRadioCard.root.svgTop;
}, function (props) {
	return props.isSelected ? 'transition: 0.4s ease-in-out 0.6s' : 'transition: 0.2s ease-in-out';
}, function (props) {
	return props.theme.colours.interaction + ' !important';
});

var StyledGroup = styled('div')(_templateObject9$2);

var isAmountPresentOrEqualToZero = function isAmountPresentOrEqualToZero(amount) {
	return amount || amount === 0;
};

var AccountRadioCardInternal = function AccountRadioCardInternal(_ref) {
	var accountAvailable = _ref.accountAvailable,
	    accountBalance = _ref.accountBalance,
	    accountName = _ref.accountName,
	    children = _ref.children,
	    currentSelectedId = _ref.currentSelectedId,
	    id = _ref.id,
	    internationalAccountAvailable = _ref.internationalAccountAvailable,
	    internationalAccountBalance = _ref.internationalAccountBalance,
	    onClick = _ref.onClick,
	    theme = _ref.theme;

	var accountAvailableString = BankingUtils.penceCurrencyFormat(accountAvailable);
	var accountBalanceString = BankingUtils.penceCurrencyFormat(accountBalance);
	var isSelected = currentSelectedId === id;
	var TickSolidLargeIcon = getTickSolidLarge(theme.name);

	var accountAvailableFont = theme.components.accountRadioCard.fonts.accountAvailable;
	var accountBalanceFont = theme.components.accountRadioCard.fonts.accountBalance;
	var accountNameFont = theme.components.accountRadioCard.fonts.accountName;

	var hasAccountBalance = isAmountPresentOrEqualToZero(accountBalance);
	var hasAccountAvailable = isAmountPresentOrEqualToZero(accountAvailable);

	return React.createElement(
		StyledAccountCard$3,
		{ id: id, isSelected: isSelected, onClick: onClick, role: 'radio', 'aria-checked': isSelected },
		React.createElement(
			StyledSquareWrapper,
			null,
			React.createElement(StyledSquare, { isSelected: isSelected })
		),
		React.createElement(
			StyledTick,
			{ isSelected: isSelected },
			React.createElement(TickSolidLargeIcon, null)
		),
		React.createElement(
			StyledAccountName$4,
			{ isSelected: isSelected },
			accountNameFont(React.createElement(
				'span',
				{ id: id + '-label' },
				accountName
			))
		),
		children,
		React.createElement(
			StyledAccountBalance$1,
			{ 'aria-label': 'Account Balance: ' + accountBalanceString, isSelected: isSelected },
			internationalAccountBalance && accountBalanceFont(React.createElement(
				'span',
				null,
				internationalAccountBalance,
				' current'
			)),
			!internationalAccountBalance && hasAccountBalance && accountBalanceFont(React.createElement(
				'span',
				null,
				accountBalanceString,
				' current'
			))
		),
		React.createElement(
			StyledAccountAvailable,
			{ 'aria-label': 'Available: ' + accountAvailableString, isSelected: isSelected },
			internationalAccountAvailable && accountAvailableFont(React.createElement(
				'span',
				null,
				internationalAccountAvailable,
				' available'
			)),
			!internationalAccountBalance && hasAccountAvailable && accountAvailableFont(React.createElement(
				'span',
				null,
				accountAvailableString,
				' available'
			))
		)
	);
};

var WrappedAccountRadioCardInternal = withTheme(AccountRadioCardInternal);

AccountRadioCardInternal.propTypes = {
	/** Account available funds amount in pence */
	accountAvailable: PropTypes.number,
	/** Account balance in pence */
	accountBalance: PropTypes.number,
	/** Account name */
	accountName: PropTypes.string.isRequired,
	/** Account specific details */
	children: PropTypes.node.isRequired,
	/** Holds the currently selected RadioCard id */
	currentSelectedId: PropTypes.string.isRequired,
	/** Sets a unique id for the component */
	id: PropTypes.string.isRequired,
	/** The available international balance of the account in pence. Overrides the accountBalance prop. */
	internationalAccountAvailable: PropTypes.string,
	/** Provide an international balance as string. Overrides accountAvailable prop. */
	internationalAccountBalance: PropTypes.string,
	/** Callback function triggered on click. */
	onClick: PropTypes.func.isRequired
};

var UnthemedBankAccount = function UnthemedBankAccount(_ref2) {
	var accountAvailable = _ref2.accountAvailable,
	    accountBalance = _ref2.accountBalance,
	    accountName = _ref2.accountName,
	    accountNumber = _ref2.accountNumber,
	    currentSelectedId = _ref2.currentSelectedId,
	    id = _ref2.id,
	    internationalAccountAvailable = _ref2.internationalAccountAvailable,
	    internationalAccountBalance = _ref2.internationalAccountBalance,
	    onClick = _ref2.onClick,
	    sortCode = _ref2.sortCode,
	    theme = _ref2.theme;

	var accountDetailsFont = theme.components.accountRadioCard.fonts.accountDetails;
	return React.createElement(
		InternalComponentFrame,
		{ variant: 'BankAccount', packageJson: packageJson$q, hasCustomMargins: true },
		React.createElement(
			WrappedAccountRadioCardInternal,
			{
				accountAvailable: accountAvailable,
				accountBalance: accountBalance,
				accountNumber: accountNumber,
				accountName: accountName,
				currentSelectedId: currentSelectedId,
				id: id,
				internationalAccountAvailable: internationalAccountAvailable,
				internationalAccountBalance: internationalAccountBalance,
				onClick: onClick,
				sortCode: sortCode
			},
			React.createElement(
				StyledAccountDetails$3,
				{ isSelected: currentSelectedId === id },
				accountDetailsFont(React.createElement(SortCodeAndAccountNumber, { accountNumber: accountNumber, sortCode: sortCode }))
			)
		)
	);
};

var BankAccount$3 = withTheme(UnthemedBankAccount);

UnthemedBankAccount.propTypes = {
	/** Account available funds amount */
	accountAvailable: PropTypes.number,
	/** Account balance */
	accountBalance: PropTypes.number,
	/** Account name */
	accountName: PropTypes.string.isRequired,
	/** Account number */
	accountNumber: PropTypes.number.isRequired,
	/** Holds the currently selected RadioCard id */
	currentSelectedId: PropTypes.string.isRequired,
	/** Sets a unique id for the component */
	id: PropTypes.string.isRequired,
	/** The available international balance of the account in pence. Overrides the accountBalance prop. */
	internationalAccountAvailable: PropTypes.string,
	/** Provide an international balance as string. Overrides accountAvailable prop. */
	internationalAccountBalance: PropTypes.string,
	/** Callback function triggered on click. */
	onClick: PropTypes.func.isRequired,
	/** Account sort code */
	sortCode: PropTypes.number.isRequired
};

// eslint-disable-next-line react/prop-types
var UnThemedCreditCard = function UnThemedCreditCard(_ref3) {
	var accountAvailable = _ref3.accountAvailable,
	    accountBalance = _ref3.accountBalance,
	    accountName = _ref3.accountName,
	    currentSelectedId = _ref3.currentSelectedId,
	    cardNumber = _ref3.cardNumber,
	    id = _ref3.id,
	    internationalAccountAvailable = _ref3.internationalAccountAvailable,
	    internationalAccountBalance = _ref3.internationalAccountBalance,
	    onClick = _ref3.onClick,
	    theme = _ref3.theme;

	var LAST_FOUR = 4;
	var cardNumberString = cardNumber.toString().length === LAST_FOUR ? 'Card Ending ' + cardNumber : BankingUtils.cardNumberFormat(cardNumber);
	var accountAvailableFont = theme.components.accountRadioCard.fonts.accountAvailable;

	return React.createElement(
		InternalComponentFrame,
		{ variant: 'CreditCard', packageJson: packageJson$q, hasCustomMargins: true },
		React.createElement(
			WrappedAccountRadioCardInternal,
			{
				accountAvailable: accountAvailable,
				accountBalance: accountBalance,
				accountName: accountName,
				cardNumber: cardNumber,
				currentSelectedId: currentSelectedId,
				id: id,
				internationalAccountAvailable: internationalAccountAvailable,
				internationalAccountBalance: internationalAccountBalance,
				onClick: onClick
			},
			React.createElement(
				StyledAccountDetails$3,
				{ isSelected: currentSelectedId === id },
				React.createElement(
					'span',
					{ 'aria-label': 'Card Number: ' + cardNumberString },
					accountAvailableFont(cardNumberString)
				)
			)
		)
	);
};

var CreditCard$3 = withTheme(UnThemedCreditCard);

UnThemedCreditCard.propTypes = {
	/** Account available funds amount */
	accountAvailable: PropTypes.number,
	/** Account balance */
	accountBalance: PropTypes.number,
	/** Account due */
	cardNumber: PropTypes.number.isRequired,
	/** Account name */
	accountName: PropTypes.string.isRequired,
	/** Holds the currently selected RadioCard id */
	currentSelectedId: PropTypes.string.isRequired,
	/** Sets a unique id for the component */
	id: PropTypes.string.isRequired,
	/** The available international balance of the account in pence. Overrides the accountBalance prop. */
	internationalAccountAvailable: PropTypes.string,
	/** Provide an international balance as string. Overrides accountAvailable prop. */
	internationalAccountBalance: PropTypes.string,
	/** Callback function triggered on click. */
	onClick: PropTypes.func.isRequired
};

var Group = function Group(_ref4) {
	var children = _ref4.children;
	return React.createElement(
		InternalComponentFrame,
		{ variant: 'Group', packageJson: packageJson$q, hasCustomMargins: true },
		React.createElement(
			StyledGroup,
			{ role: 'radiogroup' },
			children
		)
	);
};

Group.propTypes = {
	/** Array of AccountRadioCard components */
	children: PropTypes.arrayOf(PropTypes.node)
};

var AccountRadioCard = {
	BankAccount: BankAccount$3,
	CreditCard: CreditCard$3,
	Group: Group
};

var WrappedAccountRadioCard = withTheme(AccountRadioCard);

var _templateObject$E = taggedTemplateLiteral(['\n\twidth: 100%;\n\t@media (min-width: ', ') {\n\t\twidth: 33.3333%;\n\t}\n'], ['\n\twidth: 100%;\n\t@media (min-width: ', ') {\n\t\twidth: 33.3333%;\n\t}\n']),
    _templateObject2$n = taggedTemplateLiteral([''], ['']),
    _templateObject3$j = taggedTemplateLiteral(['\n\tdisplay: block;\n\tfont-family: ', ';\n\ttext-transform: uppercase;\n\t', ';\n'], ['\n\tdisplay: block;\n\tfont-family: ', ';\n\ttext-transform: uppercase;\n\t', ';\n']);

var StyledCellWrapper = styled('td')(_templateObject$E, breakpoint('md1'));

var StyledCellBox = styled('div')(_templateObject2$n);

var StyledCellBoxHeader = styled('span')(_templateObject3$j, function (props) {
	return props.theme.fonts.display.bold;
}, useFontSize.of.uist());

var Cell = function Cell(_ref) {
	var accountHolder = _ref.accountHolder,
	    body = _ref.body,
	    footer = _ref.footer,
	    header = _ref.header,
	    titleText = _ref.titleText,
	    type = _ref.type,
	    isHighlighted = _ref.isHighlighted;

	var contentBody = isHighlighted ? React.createElement(
		IndicativeHighlight.value,
		null,
		body
	) : body;
	var colspan = type === 'reason' ? 2 : 1;
	return React.createElement(
		StyledCellWrapper,
		{ colSpan: colspan },
		React.createElement(
			StyledCellBox,
			null,
			React.createElement(
				StyledCellBoxHeader,
				null,
				titleText
			),
			React.createElement(
				'div',
				null,
				accountHolder
			),
			React.createElement(
				'div',
				null,
				header
			),
			React.createElement(
				'div',
				null,
				React.createElement(
					Identifier.Breaking,
					null,
					contentBody
				)
			),
			React.createElement(
				'div',
				null,
				footer
			)
		)
	);
};
Cell.propTypes = {
	/** Account holder details */
	accountHolder: PropTypes.string,
	/** String body */
	body: PropTypes.string,
	/** String footer */
	footer: PropTypes.string,
	/** String header */
	header: PropTypes.string,
	/** String title */
	titleText: PropTypes.string,
	/** String type */
	type: PropTypes.string,
	/** Boolean isHighlighted */
	isHighlighted: PropTypes.bool
};

Cell.defaultProps = {
	isHighlighted: false
};

var main$r = "AccountPaymentReviewTable.js";
var variants$a = ["Authorisation", "Default", "Failed"];
var packageJson$r = {
	main: main$r,
	variants: variants$a,
	"component-id": null,
	"component-life-cycle": "active",
	"is-bespoke": true
};

var _templateObject$F = taggedTemplateLiteral(['\n\tbackground-color: ', ';\n\t@media (min-width: ', ') {\n\t\tpadding: ', ';\n\t}\n'], ['\n\tbackground-color: ', ';\n\t@media (min-width: ', ') {\n\t\tpadding: ', ';\n\t}\n']),
    _templateObject2$o = taggedTemplateLiteral(['\n\twidth: 100%;\n\tborder-spacing: 0;\n\tthead {\n\t\tdisplay: none;\n\t\t@media (min-width: ', ') {\n\t\t\tdisplay: table-header-group;\n\t\t}\n\t}\n\n\ttd {\n\t\tborder: 0;\n\t\tdisplay: block;\n\t\tvertical-align: top;\n\t\t&:first-child {\n\t\t\tborder-bottom-left-radius: ', ';\n\t\t\tborder-top-left-radius: ', ';\n\t\t}\n\t\t&:last-child {\n\t\t\tborder-bottom-right-radius: ', ';\n\t\t\tborder-top-right-radius: ', ';\n\t\t}\n\t\t@media (min-width: ', ') {\n\t\t\tdisplay: table-cell;\n\t\t}\n\t}\n'], ['\n\twidth: 100%;\n\tborder-spacing: 0;\n\tthead {\n\t\tdisplay: none;\n\t\t@media (min-width: ', ') {\n\t\t\tdisplay: table-header-group;\n\t\t}\n\t}\n\n\ttd {\n\t\tborder: 0;\n\t\tdisplay: block;\n\t\tvertical-align: top;\n\t\t&:first-child {\n\t\t\tborder-bottom-left-radius: ', ';\n\t\t\tborder-top-left-radius: ', ';\n\t\t}\n\t\t&:last-child {\n\t\t\tborder-bottom-right-radius: ', ';\n\t\t\tborder-top-right-radius: ', ';\n\t\t}\n\t\t@media (min-width: ', ') {\n\t\t\tdisplay: table-cell;\n\t\t}\n\t}\n']),
    _templateObject3$k = taggedTemplateLiteral(['\n\tmargin-right: ', ';\n'], ['\n\tmargin-right: ', ';\n']),
    _templateObject4$b = taggedTemplateLiteral(['\n\tborder-radius: 8px;\n\tbackground-color: ', ';\n\tpadding: ', ';\n\ttext-align: center ', ';\n\tsvg {\n\t\tdisplay: block;\n\t\t', ' ', '\n\t\theight: 24px;\n\t\tmargin-bottom: ', ';\n\t\twidth: 24px;\n\t\t@media (min-width: 768px) {\n\t\t\tmargin-left: auto;\n\t\t\tmargin-right: auto;\n\t\t}\n\t}\n'], ['\n\tborder-radius: 8px;\n\tbackground-color: ', ';\n\tpadding: ', ';\n\ttext-align: center ', ';\n\tsvg {\n\t\tdisplay: block;\n\t\t', ' ', '\n\t\theight: 24px;\n\t\tmargin-bottom: ', ';\n\t\twidth: 24px;\n\t\t@media (min-width: 768px) {\n\t\t\tmargin-left: auto;\n\t\t\tmargin-right: auto;\n\t\t}\n\t}\n']),
    _templateObject5$a = taggedTemplateLiteral(['\n\tcolor: ', ';\n\tmargin-top: 0;\n\ttext-decoration: underline;\n'], ['\n\tcolor: ', ';\n\tmargin-top: 0;\n\ttext-decoration: underline;\n']),
    _templateObject6$9 = taggedTemplateLiteral(['\n\tcolor: ', ';\n\ttext-align: center;\n\t', ';\n'], ['\n\tcolor: ', ';\n\ttext-align: center;\n\t', ';\n']);

var StyledTableWrapper = styled('div')(_templateObject$F, colours.component.tableCell, breakpoint('md1'), spacing.TRIPLE);

var StyledTable$1 = styled('table')(_templateObject2$o, breakpoint('md1'), function (props) {
	return props.theme.borderRadius;
}, function (props) {
	return props.theme.borderRadius;
}, function (props) {
	return props.theme.borderRadius;
}, function (props) {
	return props.theme.borderRadius;
}, breakpoint('md1'));

var StyledAuthorisePanelContent = styled('span')(_templateObject3$k, spacing.SINGLE);

var StyledAuthoriseCell = styled('td')(_templateObject4$b, colours.generalPalette.white, spacing.DOUBLE, INTERNET_BANKING_CSS_OVERRIDE, function (props) {
	return props.type === 'authorisation' && 'fill: ' + colours.utility.guidance + ';';
}, function (props) {
	return props.type === 'failure' && 'fill: ' + colours.utility.errorUpdated + ';';
}, spacing.THREE_QUARTERS);

var StyledAuthoriseButton = styled('button')(_templateObject5$a, function (props) {
	return props.theme.colours.primary;
});

var StyledErrorMessage = styled('span')(_templateObject6$9, colours.utility.error, useFontSize.of.bute());

var getCellData = function getCellData(data) {
	var newObj = {};

	data.forEach(function (item) {
		newObj[item.type] = item;
	});

	return newObj;
};

var sharedPropTypes = {
	/** Table cell data array. */
	tableData: PropTypes.arrayOf(PropTypes.shape({
		/** Account holder details */
		accountHolder: PropTypes.string,
		/** body string. */
		body: PropTypes.string,
		/** footer string. */
		footer: PropTypes.string,
		/** header string. */
		header: PropTypes.string,
		/** type string. */
		type: PropTypes.oneOf(['from', 'to', 'amountSent', 'debitAmount', 'exchangeRate', 'fees', 'subDate', 'settlementDate', 'reason']).isRequired,
		/** boolean isHighlighted */
		isHighlighted: PropTypes.bool
	})).isRequired,
	/** Partial Data attribute targeting panel for automation test purposes - appended by -table. */
	'data-test-id': PropTypes.string
};

var sharedDefaultPropTypes = {
	'data-test-id': 'AccountPaymentReviewTable'
};

var Default$1 = function Default(_ref) {
	var tableData = _ref.tableData,
	    dataTestId = _ref['data-test-id'];

	var cellData = getCellData(tableData);

	var from = React.createElement(Cell, _extends({ titleText: 'From', key: 'from-cell' }, cellData.from));
	var to = React.createElement(Cell, _extends({ titleText: 'To', key: 'to-cell' }, cellData.to));
	var amountSent = React.createElement(Cell, _extends({ titleText: 'Amount being sent', key: 'amountSent-cell' }, cellData.amountSent));
	var debit = React.createElement(Cell, _extends({ titleText: 'Debit Amount', key: 'debitAmount-cell' }, cellData.debitAmount));
	var exchangeRate = React.createElement(Cell, _extends({ titleText: 'Exchange rate', key: 'exchangeRate-cell' }, cellData.exchangeRate));
	var fees = React.createElement(Cell, _extends({ titleText: 'Payment fees', key: 'fees-cell' }, cellData.fees));
	var subDate = React.createElement(Cell, _extends({ titleText: 'Payment submission date', key: 'subDate-cell' }, cellData.subDate));
	var settlementDate = React.createElement(Cell, _extends({ titleText: 'Est. Earliest settlement date', key: 'setllementDate-cell' }, cellData.settlementDate));
	var reason = React.createElement(Cell, _extends({ titleText: 'Reason for payment', key: 'setllementDate-cell' }, cellData.reason));

	return React.createElement(
		InternalComponentFrame,
		{ variant: 'Default', packageJson: packageJson$r },
		React.createElement(
			StyledTableWrapper,
			null,
			React.createElement(
				StyledTable$1,
				{ 'data-test-id': dataTestId + '-table' },
				React.createElement(
					'tbody',
					null,
					React.createElement(
						'tr',
						null,
						from,
						to,
						amountSent
					),
					React.createElement(
						'tr',
						null,
						debit,
						exchangeRate,
						fees
					),
					React.createElement(
						'tr',
						null,
						subDate,
						settlementDate,
						React.createElement('td', null)
					),
					React.createElement(
						'tr',
						null,
						reason
					)
				)
			)
		)
	);
};

Default$1.propTypes = _extends({}, sharedPropTypes);

Default$1.defaultProps = _extends({}, sharedDefaultPropTypes);

var selectAuthorisersPanel = function selectAuthorisersPanel(statusContent, selectAuthorisersOnClick) {
	return React.createElement(
		'div',
		null,
		statusContent && React.createElement(
			SmallestBody,
			{ isFlush: true },
			React.createElement(
				'span',
				null,
				statusContent
			)
		),
		selectAuthorisersOnClick && React.createElement(
			StyledAuthoriseButton,
			{ onClick: selectAuthorisersOnClick },
			'Select Authoriser'
		)
	);
};

var changeAuthorisersPanel = function changeAuthorisersPanel(statusContent, changeAuthorisersOnClick) {
	return React.createElement(
		'div',
		null,
		statusContent ? React.createElement(
			SmallestBody,
			{ isFlush: true },
			React.createElement(
				StyledAuthorisePanelContent,
				null,
				statusContent
			),
			React.createElement(
				StyledAuthoriseButton,
				{ onClick: changeAuthorisersOnClick },
				'Change'
			)
		) : React.createElement(
			StyledAuthoriseButton,
			{ onClick: changeAuthorisersOnClick },
			'Change'
		)
	);
};

var viewAuthorisersPanel = function viewAuthorisersPanel(statusContent, viewAuthorisersOnClick, viewAuthorisersButtonLabel) {
	return React.createElement(
		'div',
		null,
		statusContent && React.createElement(
			SmallestBody,
			{ isFlush: true },
			React.createElement(
				'span',
				null,
				statusContent
			)
		),
		viewAuthorisersOnClick && React.createElement(
			StyledAuthoriseButton,
			{ onClick: viewAuthorisersOnClick },
			viewAuthorisersButtonLabel
		)
	);
};

var getAuthorised = function getAuthorised(authorisers, dataTestId, statusTitle, statusContent, statusErrorContent, viewAuthorisersButtonLabel, viewAuthorisersOnClick, changeAuthorisersOnClick, selectAuthorisersOnClick) {
	var authoriserLength = authorisers.length;
	return React.createElement(
		StyledAuthoriseCell,
		{ 'data-test-id': dataTestId + '-authorise', type: 'authorisation' },
		React.createElement(AuthorisationLarge, null),
		React.createElement(
			StandardLabel,
			{ isFlush: true },
			statusTitle
		),
		statusErrorContent ? React.createElement(
			StyledErrorMessage,
			null,
			statusErrorContent
		) : viewAuthorisersOnClick ? viewAuthorisersPanel(statusContent, viewAuthorisersOnClick, viewAuthorisersButtonLabel) : changeAuthorisersOnClick && authoriserLength ? changeAuthorisersPanel(statusContent, changeAuthorisersOnClick) : selectAuthorisersPanel(statusContent, selectAuthorisersOnClick)
	);
};

var Authorisation$1 = function Authorisation(_ref2) {
	var authorisers = _ref2.authorisers,
	    changeAuthorisersOnClick = _ref2.changeAuthorisersOnClick,
	    selectAuthorisersOnClick = _ref2.selectAuthorisersOnClick,
	    viewAuthorisersOnClick = _ref2.viewAuthorisersOnClick,
	    viewAuthorisersButtonLabel = _ref2.viewAuthorisersButtonLabel,
	    tableData = _ref2.tableData,
	    statusContent = _ref2.statusContent,
	    statusErrorContent = _ref2.statusErrorContent,
	    statusTitle = _ref2.statusTitle,
	    dataTestId = _ref2['data-test-id'];

	var cellData = getCellData(tableData);

	var from = React.createElement(Cell, _extends({ titleText: 'From', key: 'from-cell' }, cellData.from));
	var to = React.createElement(Cell, _extends({ titleText: 'To', key: 'to-cell' }, cellData.to));
	var amountSent = React.createElement(Cell, _extends({ titleText: 'Amount being sent', key: 'amountSent-cell' }, cellData.amountSent));
	var debit = React.createElement(Cell, _extends({ titleText: 'Debit Amount', key: 'debitAmount-cell' }, cellData.debitAmount));
	var exchangeRate = React.createElement(Cell, _extends({ titleText: 'Exchange rate', key: 'exchangeRate-cell' }, cellData.exchangeRate));
	var fees = React.createElement(Cell, _extends({ titleText: 'Payment fees', key: 'fees-cell' }, cellData.fees));
	var subDate = React.createElement(Cell, _extends({ titleText: 'Payment submission date', key: 'subDate-cell' }, cellData.subDate));
	var settlementDate = React.createElement(Cell, _extends({ titleText: 'Est. Earliest settlement date', key: 'setllementDate-cell' }, cellData.settlementDate));
	var reason = React.createElement(Cell, _extends({ titleText: 'Reason for payment', key: 'setllementDate-cell' }, cellData.reason));

	var authorised = getAuthorised(authorisers, dataTestId, statusTitle, statusContent, statusErrorContent, viewAuthorisersButtonLabel, viewAuthorisersOnClick, changeAuthorisersOnClick, selectAuthorisersOnClick);

	return React.createElement(
		InternalComponentFrame,
		{ variant: 'Authorisation', packageJson: packageJson$r },
		React.createElement(
			StyledTableWrapper,
			null,
			React.createElement(
				StyledTable$1,
				{ 'data-test-id': dataTestId + '-table' },
				React.createElement(
					'tbody',
					null,
					React.createElement(
						'tr',
						null,
						from,
						to,
						amountSent
					),
					React.createElement(
						'tr',
						null,
						debit,
						exchangeRate,
						fees
					),
					React.createElement(
						'tr',
						null,
						subDate,
						settlementDate,
						React.createElement('td', null)
					),
					React.createElement(
						'tr',
						null,
						reason,
						authorised
					)
				)
			)
		)
	);
};

Authorisation$1.propTypes = _extends({}, sharedPropTypes, {
	/** An array of selected authoriser names. */
	authorisers: PropTypes.arrayOf(PropTypes.string),
	/** Callback function triggered on click of 'Change authoriser' button.
  * Specifying this prop will trigger display of the authorisation panel. */
	changeAuthorisersOnClick: PropTypes.func,
	/** Callback function triggered on click of 'Select authoriser' button.
  * Specifying this prop will trigger display of the authorisation panel. */
	selectAuthorisersOnClick: PropTypes.func,
	/** Callback function triggered on click of 'View authoriser' button.
  * Specifying this prop will trigger display of the authorisation panel. */
	viewAuthorisersOnClick: PropTypes.func,
	/** 'View authorisers' button's label. Defualts to 'View users who can authorise'. */
	viewAuthorisersButtonLabel: PropTypes.string,
	/** Status panel title. */
	statusTitle: PropTypes.string.isRequired,
	/** Status panel content. */
	statusContent: PropTypes.string,
	/** Status panel error content. */
	statusErrorContent: PropTypes.string
});

Authorisation$1.defaultProps = _extends({}, sharedDefaultPropTypes, {
	viewAuthorisersButtonLabel: 'View users who can authorise',
	authorisers: []
});

var Failed = function Failed(_ref3) {
	var statusContent = _ref3.statusContent,
	    statusTitle = _ref3.statusTitle,
	    tableData = _ref3.tableData,
	    dataTestId = _ref3['data-test-id'];

	var cellData = getCellData(tableData);

	var from = React.createElement(Cell, _extends({ titleText: 'From', key: 'from-cell' }, cellData.from));
	var to = React.createElement(Cell, _extends({ titleText: 'To', key: 'to-cell' }, cellData.to));
	var amountSent = React.createElement(Cell, _extends({ titleText: 'Amount being sent', key: 'amountSent-cell' }, cellData.amountSent));
	var debit = React.createElement(Cell, _extends({ titleText: 'Debit Amount', key: 'debitAmount-cell' }, cellData.debitAmount));
	var exchangeRate = React.createElement(Cell, _extends({ titleText: 'Exchange rate', key: 'exchangeRate-cell' }, cellData.exchangeRate));
	var fees = React.createElement(Cell, _extends({ titleText: 'Payment fees', key: 'fees-cell' }, cellData.fees));
	var subDate = React.createElement(Cell, _extends({ titleText: 'Payment submission date', key: 'subDate-cell' }, cellData.subDate));
	var settlementDate = React.createElement(Cell, _extends({ titleText: 'Est. Earliest settlement date', key: 'settlementDate-cell' }, cellData.settlementDate));
	var reason = React.createElement(Cell, _extends({ titleText: 'Reason for payment', key: 'settlementDate-cell' }, cellData.reason));

	var failedPanel = React.createElement(
		StyledAuthoriseCell,
		{ 'data-test-id': dataTestId + '-failed', type: 'failure' },
		React.createElement(BlockedIcon, null),
		React.createElement(
			StandardLabel,
			{ isFlush: true },
			statusTitle
		),
		statusContent && React.createElement(
			SmallestBody,
			{ isFlush: true },
			React.createElement(
				'span',
				null,
				statusContent
			)
		)
	);

	return React.createElement(
		InternalComponentFrame,
		{ variant: 'Failed', packageJson: packageJson$r },
		React.createElement(
			StyledTableWrapper,
			null,
			React.createElement(
				StyledTable$1,
				{ 'data-test-id': dataTestId + '-table' },
				React.createElement(
					'tbody',
					null,
					React.createElement(
						'tr',
						null,
						from,
						to,
						amountSent
					),
					React.createElement(
						'tr',
						null,
						debit,
						exchangeRate,
						fees
					),
					React.createElement(
						'tr',
						null,
						subDate,
						settlementDate,
						React.createElement('td', null)
					),
					React.createElement(
						'tr',
						null,
						reason,
						failedPanel
					)
				)
			)
		)
	);
};

Failed.propTypes = _extends({}, sharedPropTypes, {
	/** Status panel title as string. */
	statusTitle: PropTypes.string.isRequired,
	/** Status panel content as string. */
	statusContent: PropTypes.string
});

Failed.defaultProps = _extends({}, sharedDefaultPropTypes);

var AccountPaymentReviewTable = {
	Authorisation: Authorisation$1,
	Default: Default$1,
	Failed: Failed
};

var _templateObject$G = taggedTemplateLiteral(['\n\tbackground-color: ', ' !important;\n\t@media (min-width: ', '), print {\n\t\ttext-align: left;\n\t\tcolor: ', ';\n\t}\n'], ['\n\tbackground-color: ', ' !important;\n\t@media (min-width: ', '), print {\n\t\ttext-align: left;\n\t\tcolor: ', ';\n\t}\n']),
    _templateObject2$p = taggedTemplateLiteral(['\n\twhite-space: ', ';\n\t@media only screen {\n\t\tword-break: ', ';\n\t}\n'], ['\n\twhite-space: ', ';\n\t@media only screen {\n\t\tword-break: ', ';\n\t}\n']),
    _templateObject3$l = taggedTemplateLiteral(['\n\t@media (min-width: ', '), print {\n\t\tdisplay: none;\n\t}\n'], ['\n\t@media (min-width: ', '), print {\n\t\tdisplay: none;\n\t}\n']),
    _templateObject4$c = taggedTemplateLiteral(['\n\tcolor: ', ';\n'], ['\n\tcolor: ', ';\n']),
    _templateObject5$b = taggedTemplateLiteral(['\n\tborder-radius: 8px;\n\tbackground-color: ', ';\n\tpadding:  ', ';\n\twidth: 200px;\n\ttext-align: center;\n\tsvg {\n\t\tdisplay: block;\n\t\t', '\n\t\t', '\n\t\t', '\n\t\t', '\n\t\theight: 24px;\n\t\tmargin-bottom: ', ';\n\t\twidth: 24px;\n\t\t@media (min-width: 768px) {\n\t\t\tmargin-left: auto;\n\t\t\tmargin-right: auto;\n\t\t}\n\t}\n'], ['\n\tborder-radius: 8px;\n\tbackground-color: ', ';\n\tpadding:  ', ';\n\twidth: 200px;\n\ttext-align: center;\n\tsvg {\n\t\tdisplay: block;\n\t\t', '\n\t\t', '\n\t\t', '\n\t\t', '\n\t\theight: 24px;\n\t\tmargin-bottom: ', ';\n\t\twidth: 24px;\n\t\t@media (min-width: 768px) {\n\t\t\tmargin-left: auto;\n\t\t\tmargin-right: auto;\n\t\t}\n\t}\n']),
    _templateObject6$a = taggedTemplateLiteral(['\n\tcolor: ', ';\n\tmargin-top: 0;\n\ttext-decoration: underline;\n'], ['\n\tcolor: ', ';\n\tmargin-top: 0;\n\ttext-decoration: underline;\n']),
    _templateObject7$6 = taggedTemplateLiteral(['\n\tcolor: ', ';\n\ttext-align: center;\n\t', ';\n'], ['\n\tcolor: ', ';\n\ttext-align: center;\n\t', ';\n']);

var StyledCellWrapper$1 = styled('td')(_templateObject$G, function (props) {
	return props.hasError ? colours.utility.errorLightest : colours.component.tableCell;
}, breakpoint('lg2'), function (props) {
	return props.theme.colours.bodyText;
});

var StyledCellBox$1 = styled('div')(_templateObject2$p, function (props) {
	return props.hasTextwrap ? 'normal' : 'nowrap';
}, function (props) {
	return props.wordBreak ? 'break-word' : 'normal';
});

var StyledMobileLabel = styled('div')(_templateObject3$l, breakpoint('lg2'));

var StyledAccountLabel = styled('span')(_templateObject4$c, colours.typography.body);

var StyledAuthoriseCell$1 = styled('div')(_templateObject5$b, colours.generalPalette.white, spacing.DOUBLE, function (props) {
	return props.type === 'authorisation' && 'fill: ' + colours.utility.guidance + ';';
}, function (props) {
	return props.type === 'failure' && 'fill: ' + colours.utility.errorUpdated + ';';
}, function (props) {
	return props.type === 'information' && 'fill: ' + colours.utility.informationUpdated + ';';
}, function (props) {
	return props.type === 'success' && 'fill: ' + colours.utility.success + ';';
}, spacing.THREE_QUARTERS);

var StyledAuthoriseButton$1 = styled('button')(_templateObject6$a, function (props) {
	return props.theme.colours.primary;
});

var StyledErrorMessage$1 = styled('span')(_templateObject7$6, colours.utility.error, useFontSize.of.bute());

var typeObj = {
	account: { alignment: 'left' },
	iban: { alignment: 'left' },
	date: { alignment: 'left' },
	currency: { alignment: 'right' },
	type: { alignment: 'left' },
	authorisation: { alignment: 'center' }
};

var Cell$1 = function Cell(_ref) {
	var accountHolder = _ref.accountHolder,
	    id = _ref.id,
	    type = _ref.type,
	    label = _ref.label,
	    subLabel = _ref.subLabel,
	    errorLabel = _ref.errorLabel,
	    isHighlighted = _ref.isHighlighted,
	    hasError = _ref.hasError,
	    headerLabel = _ref.headerLabel,
	    changeAuthorisers = _ref.changeAuthorisers,
	    selectAuthoriser = _ref.selectAuthoriser,
	    viewAuthorisers = _ref.viewAuthorisers,
	    changeAuthorisersOnClick = _ref.changeAuthorisersOnClick,
	    paymentStatus = _ref.paymentStatus,
	    selectAuthoriserOnClick = _ref.selectAuthoriserOnClick,
	    viewAuthorisersOnClick = _ref.viewAuthorisersOnClick,
	    viewAuthorisersButtonLabel = _ref.viewAuthorisersButtonLabel;

	var cellLabel = isHighlighted ? React.createElement(
		IndicativeHighlight.value,
		null,
		label
	) : label;

	var alignment = typeObj[type].alignment;

	var hasTextwrap = type !== 'actions';
	var wordBreak = type === 'iban' || type === 'account';

	var getCellIcon = function getCellIcon() {
		if (paymentStatus === 'authorisation') {
			return React.createElement(AuthorisationLarge, null);
		}
		if (paymentStatus === 'failure') {
			return React.createElement(BlockedIcon, null);
		}
		if (paymentStatus === 'information') {
			return React.createElement(ExclamationCircleLarge, null);
		}
		if (paymentStatus === 'success') {
			return React.createElement(TickOutlineCircleLarge, null);
		}
	};

	var defaultCell = function defaultCell() {
		return React.createElement(
			'div',
			null,
			accountHolder && React.createElement(
				StandardBody,
				{ isFlush: true },
				React.createElement(
					'span',
					null,
					accountHolder
				)
			),
			label && React.createElement(
				StandardBody,
				{ isFlush: true },
				type === 'date' ? React.createElement(
					Identifier.NonWrapping,
					null,
					cellLabel
				) : React.createElement(
					'span',
					null,
					cellLabel
				)
			),
			subLabel && React.createElement(
				StyledAccountLabel,
				null,
				React.createElement(
					SubBody,
					{ isFlush: true },
					React.createElement(
						'span',
						null,
						subLabel
					)
				)
			)
		);
	};

	var changeAuthorisersPanel = React.createElement(
		SmallestBody,
		{ isFlush: true },
		subLabel,
		' ',
		changeAuthorisers && React.createElement(
			StyledAuthoriseButton$1,
			{ onClick: function onClick() {
					return changeAuthorisersOnClick(id);
				}, type: 'button' },
			'Change'
		)
	);

	var selectAuthoriserPanel = React.createElement(
		StyledAuthoriseButton$1,
		{ onClick: function onClick() {
				return selectAuthoriserOnClick(id);
			}, type: 'button' },
		'Select authoriser'
	);

	var viewAuthorisersPanel = React.createElement(
		StyledAuthoriseButton$1,
		{ onClick: function onClick() {
				return viewAuthorisersOnClick(id);
			}, type: 'button' },
		viewAuthorisersButtonLabel
	);

	var authorisationCell = function authorisationCell(type) {
		return React.createElement(
			StyledAuthoriseCell$1,
			{ type: type },
			getCellIcon(),
			label && React.createElement(
				StandardLabel,
				{ isFlush: true },
				label
			),
			(subLabel || changeAuthorisers) && changeAuthorisersPanel,
			errorLabel && React.createElement(
				StyledErrorMessage$1,
				null,
				errorLabel
			),
			selectAuthoriser && !changeAuthorisers && selectAuthoriserPanel,
			viewAuthorisers && viewAuthorisersPanel
		);
	};

	return React.createElement(
		StyledCellWrapper$1,
		{ hasError: hasError, align: alignment },
		React.createElement(
			StyledCellBox$1,
			{ hasTextwrap: hasTextwrap, wordBreak: wordBreak },
			headerLabel && React.createElement(
				StyledMobileLabel,
				null,
				React.createElement(
					StandardLabel,
					{ isFlush: true },
					React.createElement(
						'span',
						null,
						headerLabel
					)
				)
			),
			paymentStatus ? authorisationCell(paymentStatus) : defaultCell()
		)
	);
};

Cell$1.propTypes = {
	/** Account holder details */
	accountHolder: PropTypes.string,
	/** String ID */
	id: PropTypes.string.isRequired,
	/** String type */
	type: PropTypes.string.isRequired,
	/** String label */
	label: PropTypes.string,
	/** Node subLabel */
	subLabel: PropTypes.node,
	/** Node subLabel */
	errorLabel: PropTypes.node,
	/** Boolean highlighted text */
	isHighlighted: PropTypes.bool,
	/** Boolean contols error styles */
	hasError: PropTypes.bool,
	/** String headerlabel function */
	headerLabel: PropTypes.string,
	/** Boolean controls display of select button */
	selectAuthoriser: PropTypes.bool,
	/** Boolean controls display of change link */
	changeAuthorisers: PropTypes.bool,
	/** Boolean controls display of view authorisers button */
	viewAuthorisers: PropTypes.bool,
	/** 'View authorisers' button's label. */
	viewAuthorisersButtonLabel: PropTypes.string,
	/** Callback function triggered on click of 'Change authoriser' button. */
	changeAuthorisersOnClick: PropTypes.func,
	/** Callback function triggered on click of 'Select authoriser' button. */
	selectAuthoriserOnClick: PropTypes.func,
	/** Callback function triggered on click of 'View authorisers' button. */
	viewAuthorisersOnClick: PropTypes.func,
	/** Payment status as string. */
	paymentStatus: PropTypes.oneOf(['authorisation', 'failure', 'information', 'success'])
};

Cell$1.defaultProps = {
	isHighlighted: false,
	hasError: false
};

var main$s = "AccountPaymentSubmittedTable";
var packageJson$s = {
	main: main$s,
	"component-id": null,
	"component-life-cycle": "active",
	"is-bespoke": true
};

var _templateObject$H = taggedTemplateLiteral(['\n\twidth: 100%;\n\tborder-spacing: 0;\n\t', ' thead {\n\t\tdisplay: none;\n\t\t@media (min-width: ', '), print {\n\t\t\tdisplay: table-header-group;\n\t\t}\n\t}\n\n\ttr {\n\t\tborder-bottom: 8px solid ', ';\n\t\t:last-child {\n\t\t\tborder-bottom: 0;\n\t\t}\n\t}\n\n\tth {\n\t\tborder: 0 !important;\n\t\tbackground-color: ', ';\n\t}\n\n\ttd {\n\t\tborder: 0 !important;\n\t\tbackground-color: ', ';\n\t\tdisplay: block;\n\t\tvertical-align: top;\n\t\t&:first-child {\n\t\t\tborder-bottom-left-radius: ', ';\n\t\t\tborder-top-left-radius: ', ';\n\t\t}\n\t\t&:last-child {\n\t\t\tborder-bottom-right-radius: ', ';\n\t\t\tborder-top-right-radius: ', ';\n\t\t}\n\t\t@media (min-width: ', '), print {\n\t\t\tdisplay: table-cell;\n\t\t}\n\t}\n'], ['\n\twidth: 100%;\n\tborder-spacing: 0;\n\t', ' thead {\n\t\tdisplay: none;\n\t\t@media (min-width: ', '), print {\n\t\t\tdisplay: table-header-group;\n\t\t}\n\t}\n\n\ttr {\n\t\tborder-bottom: 8px solid ', ';\n\t\t:last-child {\n\t\t\tborder-bottom: 0;\n\t\t}\n\t}\n\n\tth {\n\t\tborder: 0 !important;\n\t\tbackground-color: ', ';\n\t}\n\n\ttd {\n\t\tborder: 0 !important;\n\t\tbackground-color: ', ';\n\t\tdisplay: block;\n\t\tvertical-align: top;\n\t\t&:first-child {\n\t\t\tborder-bottom-left-radius: ', ';\n\t\t\tborder-top-left-radius: ', ';\n\t\t}\n\t\t&:last-child {\n\t\t\tborder-bottom-right-radius: ', ';\n\t\t\tborder-top-right-radius: ', ';\n\t\t}\n\t\t@media (min-width: ', '), print {\n\t\t\tdisplay: table-cell;\n\t\t}\n\t}\n']),
    _templateObject2$q = taggedTemplateLiteral(['\n\t@media (min-width: ', '), print {\n\t\ttext-align: ', ';\n\t}\n'], ['\n\t@media (min-width: ', '), print {\n\t\ttext-align: ', ';\n\t}\n']);

var typeObj$1 = {
	account: { alignment: 'left' },
	iban: { alignment: 'left' },
	date: { alignment: 'left' },
	currency: { alignment: 'left' },
	type: { alignment: 'left' },
	authorisation: { alignment: 'center' }
};

var StyledTable$2 = styled('table')(_templateObject$H, externalMarginRegular, breakpoint('lg2'), colours.component.background, colours.component.background, colours.component.tableCell, function (props) {
	return props.theme.borderRadius;
}, function (props) {
	return props.theme.borderRadius;
}, function (props) {
	return props.theme.borderRadius;
}, function (props) {
	return props.theme.borderRadius;
}, breakpoint('lg2'));

var StyledHeaderCell = styled('th')(_templateObject2$q, breakpoint('lg2'), function (props) {
	return props.alignment;
});

var addCellTypes = function addCellTypes(data, headers) {
	var newRows = [];

	data.forEach(function (row, index) {
		newRows[index] = {
			isValid: row.isValid,
			id: row.id,
			cells: row.cells.map(function (cell, index) {
				var newCell = cell;
				newCell.type = headers[index].type;
				newCell.headerLabel = headers[index].label;
				newCell.hasError = row.isValid;
				return newCell;
			})
		};
	});

	return newRows;
};

var activeRow = function activeRow(row, errorRows) {
	return errorRows.indexOf(row) !== -1;
};

var getRows = function getRows(data, headers, rowsWithError) {
	var rowIds = [].concat(toConsumableArray(new Set(data.map(function (cell) {
		return cell.rowId;
	}))));
	var rows = rowIds.map(function (row) {
		return {
			id: row,
			isValid: rowsWithError ? activeRow(row, rowsWithError) : false,
			cells: data.filter(function (cell) {
				return cell.rowId === row;
			})
		};
	});

	rows = addCellTypes(rows, headers);
	return rows;
};

var AccountPaymentSubmittedTable = function AccountPaymentSubmittedTable(_ref) {
	var headerData = _ref.headerData,
	    tableData = _ref.tableData,
	    rowsWithError = _ref.rowsWithError,
	    _changeAuthorisersOnClick = _ref.changeAuthorisersOnClick,
	    _selectAuthoriserOnClick = _ref.selectAuthoriserOnClick,
	    _viewAuthorisersOnClick = _ref.viewAuthorisersOnClick,
	    viewAuthorisersButtonLabel = _ref.viewAuthorisersButtonLabel;

	var tableRows = getRows(tableData, headerData, rowsWithError);

	return React.createElement(
		InternalComponentFrame,
		{ packageJson: packageJson$s, hasCustomMargins: true },
		React.createElement(
			StyledTable$2,
			null,
			React.createElement(
				'thead',
				null,
				React.createElement(
					'tr',
					null,
					headerData.map(function (headerItem, index) {
						var align = typeObj$1[headerItem.type].alignment;
						var headerCellIndex = 'header-cell-' + index;
						return React.createElement(
							StyledHeaderCell,
							{ key: headerCellIndex, alignment: align },
							headerItem.label && React.createElement(
								StandardLabel,
								{ isFlush: true },
								React.createElement(
									'span',
									null,
									headerItem.label
								)
							)
						);
					})
				)
			),
			React.createElement(
				'tbody',
				null,
				tableRows.map(function (row) {
					return React.createElement(
						'tr',
						{ key: row.id },
						row.cells.map(function (cell, cellIndex) {
							var cellKey = 'table-cell-' + cellIndex;
							return React.createElement(Cell$1, {
								key: cellKey,
								id: cell.rowId,
								type: cell.type,
								headerLabel: cell.headerLabel,
								accountHolder: cell.accountHolder,
								label: cell.label,
								subLabel: cell.subLabel,
								errorLabel: cell.errorLabel,
								isHighlighted: cell.isHighlighted,
								hasError: cell.hasError,
								selectAuthoriser: cell.selectAuthoriser,
								changeAuthorisers: cell.changeAuthorisers,
								viewAuthorisers: cell.viewAuthorisers,
								changeAuthorisersOnClick: function changeAuthorisersOnClick(id) {
									return _changeAuthorisersOnClick(id);
								},
								paymentStatus: cell.paymentStatus,
								selectAuthoriserOnClick: function selectAuthoriserOnClick(id) {
									return _selectAuthoriserOnClick(id);
								},
								viewAuthorisersOnClick: function viewAuthorisersOnClick(id) {
									return _viewAuthorisersOnClick(id);
								},
								viewAuthorisersButtonLabel: viewAuthorisersButtonLabel
							});
						})
					);
				})
			)
		)
	);
};

AccountPaymentSubmittedTable.propTypes = {
	/** Array of headers */
	headerData: PropTypes.arrayOf(PropTypes.shape({
		/** Header types */
		type: PropTypes.oneOf(['actions', 'account', 'currency', 'date', 'iban', 'type', 'authorisation']),
		/** String label */
		label: PropTypes.string
	})).isRequired,
	tableData: PropTypes.arrayOf(PropTypes.shape({
		/** Account holder details */
		accountHolder: PropTypes.string,
		/** String id of row */
		rowId: PropTypes.string.isRequired,
		/** String label */
		label: PropTypes.string,
		/** Node sub label */
		subLabel: PropTypes.node,
		/** Node sub label */
		errorLabel: PropTypes.node,
		/** Boolean highlighted text */
		isHighlighted: PropTypes.bool,
		/** Payment status as string. */
		paymentStatus: PropTypes.oneOf(['authorisation', 'failure', 'success', 'information'])
	})).isRequired,
	/** Array of rowIds with errors */
	rowsWithError: PropTypes.arrayOf(PropTypes.string),
	/** Callback function triggered on click when 'Change authoriser' button is clicked. */
	changeAuthorisersOnClick: PropTypes.func,
	/** Callback function triggered on click when 'Select authoriser' button is clicked. */
	selectAuthoriserOnClick: PropTypes.func,
	/** Callback function triggered on click when 'View authoriser' button is clicked. */
	viewAuthorisersOnClick: PropTypes.func,
	/** 'View authorisers' button's label. Defualts to 'View users who can authorise'. */
	viewAuthorisersButtonLabel: PropTypes.string
};

AccountPaymentSubmittedTable.defaultProps = {
	viewAuthorisersButtonLabel: 'View users who can authorise'
};

var _templateObject$I = taggedTemplateLiteral(['\n\tbackground-color: ', ' !important;\n\tpadding: ', ';\n\n\t@media (min-width: ', ') {\n\t\ttext-align: ', ';\n\t\tcolor: ', ';\n\t\t', '\n\t\t', '\n\t\t', '\n\t\t', '\n\t\t', '\n\t}\n'], ['\n\tbackground-color: ', ' !important;\n\tpadding: ', ';\n\n\t@media (min-width: ', ') {\n\t\ttext-align: ', ';\n\t\tcolor: ', ';\n\t\t', '\n\t\t', '\n\t\t', '\n\t\t', '\n\t\t', '\n\t}\n']),
    _templateObject2$r = taggedTemplateLiteral(['\n\tposition: relative;\n'], ['\n\tposition: relative;\n']),
    _templateObject3$m = taggedTemplateLiteral([''], ['']),
    _templateObject4$d = taggedTemplateLiteral(['\n\tborder: none;\n\tbackground: none;\n\tborder-radius: ', ';\n\tcolor: ', ';\n\tmargin-right: ', ';\n\tpadding: ', ' ', ';\n'], ['\n\tborder: none;\n\tbackground: none;\n\tborder-radius: ', ';\n\tcolor: ', ';\n\tmargin-right: ', ';\n\tpadding: ', ' ', ';\n']),
    _templateObject5$c = taggedTemplateLiteral(['\n\t@media (min-width: ', ') {\n\t\tdisplay: none;\n\t}\n'], ['\n\t@media (min-width: ', ') {\n\t\tdisplay: none;\n\t}\n']),
    _templateObject6$b = taggedTemplateLiteral(['\n\tcolor: ', ';\n'], ['\n\tcolor: ', ';\n']),
    _templateObject7$7 = taggedTemplateLiteral(['\n\twhite-space: normal;\n\tbackground-color: ', ';\n\tborder: 1px solid hsl(0, 100%, 43%);\n\tcolor: hsl(0, 100%, 43%);\n\tpadding: 10px;\n\tmax-width: 100%;\n\tfont-size: 14px;\n\ttext-align: left;\n\tline-height: 1.4;\n\tborder-radius: 4px;\n'], ['\n\twhite-space: normal;\n\tbackground-color: ', ';\n\tborder: 1px solid hsl(0, 100%, 43%);\n\tcolor: hsl(0, 100%, 43%);\n\tpadding: 10px;\n\tmax-width: 100%;\n\tfont-size: 14px;\n\ttext-align: left;\n\tline-height: 1.4;\n\tborder-radius: 4px;\n']);

var wrappingPoint = 'lg1';

var StyledCellWrapper$2 = styled('td')(_templateObject$I, function (props) {
	return props.hasError ? colours.utility.errorLightest : colours.component.tableCell;
}, spacing.SINGLE, breakpoint(wrappingPoint), function (props) {
	return props.align;
}, function (props) {
	return props.theme.colours.bodyText;
}, function (props) {
	return props.type === 'account' && 'width: 20%;';
}, function (props) {
	return props.type === 'amount' && 'width: 15%;';
}, function (props) {
	return props.type === 'iban' && 'width: 25%;';
}, function (props) {
	return props.type === 'date' && 'width: 15%;';
}, function (props) {
	return props.type === 'actions' && 'width: 10%;';
});

var StyledCellBox$2 = styled('div')(_templateObject2$r);

var StyledCellFooter = styled('div')(_templateObject3$m);

var StyledButton$4 = styled('button')(_templateObject4$d, function (props) {
	return props.theme.borderRadius;
}, function (props) {
	return props.theme.colours.primary;
}, spacing.HALF, spacing.QUARTER, spacing.HALF);

var StyledMobileLabel$1 = styled('div')(_templateObject5$c, breakpoint(wrappingPoint));

var StyledAccountLabel$1 = styled('span')(_templateObject6$b, colours.typography.supplementaryBody);

var StyledErrorLabel = styled('div')(_templateObject7$7, colours.utility.errorLightest);

var typeObj$2 = {
	account: { alignment: 'left' },
	iban: { alignment: 'left' },
	date: { alignment: 'left' },
	currency: { alignment: 'right' },
	actions: { alignment: 'left' }
};

var getAccountPaymentTableActions = function getAccountPaymentTableActions(hasEdit, hasDelete, editOnClick, deleteOnClick, id) {
	return React.createElement(
		'div',
		null,
		hasEdit && React.createElement(
			StyledButton$4,
			{ type: 'button', onClick: function onClick() {
					return editOnClick(id);
				} },
			React.createElement(
				SubBody,
				{ isFlush: true },
				React.createElement(
					'span',
					null,
					'Edit'
				)
			)
		),
		hasDelete && React.createElement(
			StyledButton$4,
			{ type: 'button', onClick: function onClick() {
					return deleteOnClick(id);
				} },
			React.createElement(
				SubBody,
				{ isFlush: true },
				React.createElement(
					'span',
					null,
					'Delete'
				)
			)
		)
	);
};

var getCellLabel = function getCellLabel(isHighlighted, label) {
	return isHighlighted ? React.createElement(
		IndicativeHighlight.value,
		null,
		label
	) : label;
};

var getCellAmount = function getCellAmount(type, isHighlighted, label) {
	return type === 'currency' ? React.createElement(
		Identifier.NonWrapping,
		null,
		getCellLabel(isHighlighted, label)
	) : React.createElement(
		Identifier.Breaking,
		null,
		getCellLabel(isHighlighted, label)
	);
};

var Cell$2 = function Cell(_ref) {
	var accountHolder = _ref.accountHolder,
	    id = _ref.id,
	    type = _ref.type,
	    label = _ref.label,
	    subLabel = _ref.subLabel,
	    error = _ref.error,
	    isHighlighted = _ref.isHighlighted,
	    hasEdit = _ref.hasEdit,
	    hasDelete = _ref.hasDelete,
	    hasError = _ref.hasError,
	    editOnClick = _ref.editOnClick,
	    deleteOnClick = _ref.deleteOnClick,
	    headerLabel = _ref.headerLabel,
	    dataTestId = _ref['data-test-id'];

	var hasActions = hasEdit || hasDelete;

	var alignment = typeObj$2[type].alignment;


	return React.createElement(
		StyledCellWrapper$2,
		{ hasError: hasError, align: alignment, type: type, 'data-test-id': dataTestId + '-td-' + type },
		React.createElement(
			StyledCellBox$2,
			null,
			headerLabel && React.createElement(
				StyledMobileLabel$1,
				null,
				React.createElement(
					StandardLabel,
					{ isFlush: true },
					React.createElement(
						'span',
						null,
						headerLabel
					)
				)
			),
			accountHolder && React.createElement(
				StandardBody,
				{ isFlush: true },
				React.createElement(
					'span',
					null,
					accountHolder
				)
			),
			label && React.createElement(
				StandardBody,
				{ isFlush: true },
				getCellAmount(type, isHighlighted, label)
			),
			subLabel && React.createElement(
				StyledAccountLabel$1,
				null,
				React.createElement(
					StandardBody,
					{ isFlush: true },
					React.createElement(
						'span',
						null,
						subLabel
					)
				)
			),
			hasActions && getAccountPaymentTableActions(hasEdit, hasDelete, editOnClick, deleteOnClick, id)
		),
		React.createElement(
			StyledCellFooter,
			null,
			error && React.createElement(
				StyledErrorLabel,
				null,
				React.createElement(
					SubBody,
					{ isFlush: true },
					React.createElement(
						'span',
						null,
						error
					)
				)
			)
		)
	);
};

Cell$2.propTypes = {
	/** String account holder */
	accountHolder: PropTypes.string,
	/** String row id */
	id: PropTypes.string.isRequired,
	/** String type */
	type: PropTypes.string.isRequired,
	/** String label */
	label: PropTypes.string,
	/** String subLabel */
	subLabel: PropTypes.string,
	/** String error */
	error: PropTypes.string,
	/** Boolean highlighted text */
	isHighlighted: PropTypes.bool,
	/** Boolean controls display of edit button */
	hasEdit: PropTypes.bool,
	/** Boolean controls display of delete button */
	hasDelete: PropTypes.bool,
	/** Boolean contols error styles */
	hasError: PropTypes.bool,
	/** Callback function triggered on click of 'Edit'. */
	editOnClick: PropTypes.func,
	/** Callback function triggered on click of 'Delete'. */
	deleteOnClick: PropTypes.func,
	/** String headerlabel function */
	headerLabel: PropTypes.string,
	/** Partial Data attribute targeting panel for automation test purposes - appended by -td-{cell.type}. */
	'data-test-id': PropTypes.string
};

Cell$2.defaultProps = {
	isHighlighted: false,
	hasEdit: false,
	hasDelete: false,
	hasError: false,
	'data-test-id': 'account-payment-cell'
};

var main$t = "AccountPaymentTable.js";
var packageJson$t = {
	main: main$t,
	"component-id": null,
	"component-life-cycle": "active",
	"is-bespoke": true
};

var _templateObject$J = taggedTemplateLiteral(['\n\tborder-collapse: collapse;\n\tborder-spacing: 0;\n\twidth: 100%;\n\n\tthead {\n\t\tdisplay: none;\n\t\t@media (min-width: ', ') {\n\t\t\tdisplay: table-header-group;\n\t\t}\n\t}\n\n\ttr {\n\t\tborder-bottom: 8px solid ', ';\n\t\t:last-child {\n\t\t\tborder-bottom: 0;\n\t\t}\n\t}\n\n\tth {\n\t\tborder: 0 !important;\n\t\tbackground-color: ', ';\n\t}\n\n\ttd {\n\t\tborder: 0 !important;\n\t\tbackground-color: ', ';\n\t\tdisplay: block;\n\t\tvertical-align: top;\n\t\t&:first-child {\n\t\t\tborder-bottom-left-radius: ', ';\n\t\t}\n\t\t&:last-child {\n\t\t\tborder-bottom-right-radius: ', ';\n\t\t}\n\t\t@media (min-width: ', ') {\n\t\t\tdisplay: table-cell;\n\t\t}\n\t}\n'], ['\n\tborder-collapse: collapse;\n\tborder-spacing: 0;\n\twidth: 100%;\n\n\tthead {\n\t\tdisplay: none;\n\t\t@media (min-width: ', ') {\n\t\t\tdisplay: table-header-group;\n\t\t}\n\t}\n\n\ttr {\n\t\tborder-bottom: 8px solid ', ';\n\t\t:last-child {\n\t\t\tborder-bottom: 0;\n\t\t}\n\t}\n\n\tth {\n\t\tborder: 0 !important;\n\t\tbackground-color: ', ';\n\t}\n\n\ttd {\n\t\tborder: 0 !important;\n\t\tbackground-color: ', ';\n\t\tdisplay: block;\n\t\tvertical-align: top;\n\t\t&:first-child {\n\t\t\tborder-bottom-left-radius: ', ';\n\t\t}\n\t\t&:last-child {\n\t\t\tborder-bottom-right-radius: ', ';\n\t\t}\n\t\t@media (min-width: ', ') {\n\t\t\tdisplay: table-cell;\n\t\t}\n\t}\n']),
    _templateObject2$s = taggedTemplateLiteral(['\n\tpadding: ', ';\n\n\t@media (min-width: ', ') {\n\t\ttext-align: ', ';\n\t}\n'], ['\n\tpadding: ', ';\n\n\t@media (min-width: ', ') {\n\t\ttext-align: ', ';\n\t}\n']);

var wrappingPoint$1 = 'lg1';

var typeObj$3 = {
	account: { alignment: 'left' },
	iban: { alignment: 'left' },
	date: { alignment: 'left' },
	currency: { alignment: 'right' },
	actions: { alignment: 'left' }
};

var StyledTable$3 = styled('table')(_templateObject$J, breakpoint(wrappingPoint$1), colours.component.background, colours.component.background, colours.component.tableCell, function (props) {
	return props.theme.borderRadius;
}, function (props) {
	return props.theme.borderRadius;
}, breakpoint(wrappingPoint$1));

var StyledHeaderCell$1 = styled('th')(_templateObject2$s, spacing.SINGLE, breakpoint(wrappingPoint$1), function (props) {
	return props.alignment;
});

var getHeaders = function getHeaders(data, hasActions) {
	var headers = data;

	if (hasActions) {
		headers.push({ type: 'actions', label: '' });
	}

	return headers;
};

var addCellTypes$1 = function addCellTypes(data, headers) {
	var newRows = [];

	data.forEach(function (row, index) {
		newRows[index] = {
			isValid: row.isValid,
			id: row.id,
			cells: row.cells.map(function (cell, index) {
				var newCell = cell;
				newCell.type = headers[index].type;
				newCell.headerLabel = headers[index].label;
				// 	newCell.id = row.id;
				newCell.hasError = row.isValid;

				return newCell;
			})
		};
	});

	return newRows;
};

var activeRow$1 = function activeRow(row, errorRows) {
	return errorRows.indexOf(row) !== -1;
};

var getRows$1 = function getRows(data, headers, rowsWithError) {
	var rows = [].concat(toConsumableArray(new Set(data.map(function (cell) {
		return cell.rowId;
	})))).map(function (row) {
		return {
			id: row,
			isValid: rowsWithError ? activeRow$1(row, rowsWithError) : false,
			cells: data.filter(function (cell) {
				return cell.rowId === row;
			})
		};
	});

	return addCellTypes$1(rows, headers);
};

var AccountPaymentTable = function AccountPaymentTable(_ref) {
	var headerData = _ref.headerData,
	    tableData = _ref.tableData,
	    _editOnClick = _ref.editOnClick,
	    _deleteOnClick = _ref.deleteOnClick,
	    rowsWithError = _ref.rowsWithError,
	    dataTestId = _ref['data-test-id'];

	var hasActions = _editOnClick || _deleteOnClick;
	var headers = getHeaders(headerData, hasActions);

	var tableRows = getRows$1(tableData, headers, rowsWithError);

	return React.createElement(
		InternalComponentFrame,
		{ packageJson: packageJson$t },
		React.createElement(
			StyledTable$3,
			{ 'data-test-id': dataTestId + '-table' },
			React.createElement(
				'thead',
				null,
				React.createElement(
					'tr',
					{ 'data-test-id': dataTestId + '-header' },
					headers.map(function (headerItem, index) {
						var align = typeObj$3[headerItem.type].alignment;
						var headerCellIndex = 'header-cell-' + index;
						return React.createElement(
							StyledHeaderCell$1,
							{ key: headerCellIndex, alignment: align },
							headerItem.label && React.createElement(
								StandardLabel,
								{ isFlush: true },
								React.createElement(
									'span',
									null,
									headerItem.label
								)
							)
						);
					})
				)
			),
			React.createElement(
				'tbody',
				null,
				tableRows.map(function (row) {
					return React.createElement(
						'tr',
						{ key: row.id, 'data-test-id': dataTestId + '-tr-' + row.id },
						row.cells.map(function (cell, cellIndex) {
							var cellKey = 'table-cell-' + cellIndex;
							return React.createElement(Cell$2, {
								key: cellKey,
								id: cell.rowId,
								type: cell.type,
								headerLabel: cell.headerLabel,
								accountHolder: cell.accountHolder,
								label: cell.label,
								subLabel: cell.subLabel,
								error: cell.error,
								hasEdit: cell.hasEdit,
								hasDelete: cell.hasDelete,
								isHighlighted: cell.isHighlighted,
								hasError: cell.hasError,
								editOnClick: function editOnClick(id) {
									return _editOnClick(id);
								},
								deleteOnClick: function deleteOnClick(id) {
									return _deleteOnClick(id);
								}
							});
						})
					);
				})
			)
		)
	);
};

AccountPaymentTable.propTypes = {
	/** Array of headers */
	headerData: PropTypes.arrayOf(PropTypes.shape({
		/** Header types */
		type: PropTypes.oneOf(['actions', 'account', 'currency', 'date', 'iban']),
		/** String label */
		label: PropTypes.string
	})).isRequired,
	tableData: PropTypes.arrayOf(PropTypes.shape({
		/** name of account holder */
		accountHolder: PropTypes.string,
		/** error message text */
		error: PropTypes.string,
		/** display of delete button */
		hasDelete: PropTypes.bool,
		/** display of edit button */
		hasEdit: PropTypes.bool,
		/** is text highlighted */
		isHighlighted: PropTypes.bool,
		/** main label (eg account name / product name) */
		label: PropTypes.string,
		/** id of row */
		rowId: PropTypes.string.isRequired,
		/** sub label (eg SCAN / IBAN / Credit card number) */
		subLabel: PropTypes.string
	})).isRequired,
	/** Callback function triggered on click of 'Edit'.  */
	editOnClick: PropTypes.func,
	/** Callback function triggered on click of 'Delete'.  */
	deleteOnClick: PropTypes.func,
	/** Array of rowIds with errors */
	rowsWithError: PropTypes.arrayOf(PropTypes.string),
	/** Partial Data attribute targeting panel for automation test purposes - appended by -table -header, -tr-{row.id}. */
	'data-test-id': PropTypes.string
};

AccountPaymentTable.defaultProps = {
	'data-test-id': 'AccountPaymentTable'
};

var main$u = "AccountSummaryTile.js";
var variants$b = ["DebitCard"];
var packageJson$u = {
	main: main$u,
	variants: variants$b,
	"component-id": 1031,
	"component-life-cycle": "active",
	"is-bespoke": true
};

var _templateObject$K = taggedTemplateLiteral(['\n\tmargin-right: ', ';\n'], ['\n\tmargin-right: ', ';\n']),
    _templateObject2$t = taggedTemplateLiteral(['\n\tdisplay: inline-flex;\n\tflex-direction: column;\n\tflex-wrap: wrap;\n\tmargin-bottom: ', ';\n\tmargin-right: ', ';\n\n\t@media (min-width: ', ') {\n\t\tflex-direction: row;\n\t}\n'], ['\n\tdisplay: inline-flex;\n\tflex-direction: column;\n\tflex-wrap: wrap;\n\tmargin-bottom: ', ';\n\tmargin-right: ', ';\n\n\t@media (min-width: ', ') {\n\t\tflex-direction: row;\n\t}\n']),
    _templateObject3$n = taggedTemplateLiteral(['\n\tmargin-top: ', ';\n\n\t@media (min-width: ', ') {\n\t\tmargin-top: 0;\n\t}\n'], ['\n\tmargin-top: ', ';\n\n\t@media (min-width: ', ') {\n\t\tmargin-top: 0;\n\t}\n']);

var StyledCardWrapper = styled('div')(_templateObject$K, spacing.TRIPLE);

var StyledWrapper$e = styled('div')(_templateObject2$t, spacing.TRIPLE, spacing.DOUBLE, breakpoints.sm2);

var StyledAccountDetails$4 = styled('div')(_templateObject3$n, spacing.SINGLE, breakpoints.sm2);

var BaseAccountSummaryTile = function BaseAccountSummaryTile(_ref) {
	var accountName = _ref.accountName,
	    cardNumber = _ref.cardNumber,
	    accountDetails = _ref.accountDetails,
	    sortCode = _ref.sortCode,
	    accountNumber = _ref.accountNumber,
	    cardType = _ref.cardType,
	    imageInfo = _ref.imageInfo,
	    dataTestId = _ref['data-test-id'];

	var LAST_FOUR_DIGITS = 4;
	var isFinalFourDigits = cardNumber.toString().length === LAST_FOUR_DIGITS;
	var formattedCardNumber = isFinalFourDigits ? 'Card Ending ' + cardNumber : BankingUtils.cardNumberFormat(cardNumber);
	return React.createElement(
		StyledWrapper$e,
		{ 'data-test-id': dataTestId + '-wrapper' },
		React.createElement(
			StyledCardWrapper,
			{ 'data-test-id': dataTestId + '-image' },
			React.createElement(InternalPlaceholderCard, { height: 126, imageInfo: imageInfo, width: 200 })
		),
		React.createElement(
			StyledAccountDetails$4,
			null,
			React.createElement(
				SubHeading,
				{ 'data-test-id': dataTestId + '-accountname' },
				React.createElement(
					'span',
					null,
					accountName
				)
			),
			React.createElement(
				LargeBody,
				{ 'data-test-id': dataTestId + '-cardnumber' },
				React.createElement(
					'span',
					null,
					formattedCardNumber
				)
			),
			accountDetails && React.createElement(
				StandardBody,
				{ isFlush: true, 'data-test-id': dataTestId + '-accountdetails' },
				React.createElement(
					'span',
					null,
					cardType && cardType + ' |',
					' ',
					sortCode && sortCode + ' |',
					' ',
					accountNumber
				)
			)
		)
	);
};

var baseProps$8 = {
	/** Account name. */
	accountName: PropTypes.string.isRequired,
	/** Card number. */
	cardNumber: PropTypes.number.isRequired,
	/** Account details included */
	accountDetails: PropTypes.bool,
	/** Card type. */
	cardType: PropTypes.string,
	/** Sort code. */
	sortCode: PropTypes.number,
	/** Account number. */
	accountNumber: PropTypes.number,
	/** Partial Data attribute targeting table for automation test purposes - appended by -wrapper , -image, -accountname, -cardnumber, -accountdetails. */
	'data-test-id': PropTypes.string,
	/* Card image information. */
	imageInfo: PropTypes.shape({
		/** Card brand. */
		brandId: PropTypes.oneOf(['cb', 'yb', 'vm']).isRequired,
		/** Image type. Used in the aria-label. */
		cardStatus: PropTypes.oneOf(['active', 'deactivated', 'frozen']).isRequired,
		/** Image url. */
		imageUrl: PropTypes.string.isRequired
	}).isRequired
};

BaseAccountSummaryTile.propTypes = _extends({}, baseProps$8);

BaseAccountSummaryTile.defaultProps = {
	'data-test-id': 'account-summary-tile'
};

var DebitCard$2 = function DebitCard(_ref2) {
	var accountName = _ref2.accountName,
	    cardNumber = _ref2.cardNumber,
	    imageInfo = _ref2.imageInfo,
	    accountDetails = _ref2.accountDetails,
	    sortCode = _ref2.sortCode,
	    accountNumber = _ref2.accountNumber,
	    cardType = _ref2.cardType,
	    dataTestId = _ref2['data-test-id'];
	return React.createElement(
		InternalComponentFrame,
		{ variant: 'DebitCard', packageJson: packageJson$u, hasCustomMargins: true },
		React.createElement(BaseAccountSummaryTile, {
			accountName: accountName,
			cardNumber: cardNumber,
			imageInfo: imageInfo,
			accountDetails: accountDetails,
			sortCode: sortCode,
			accountNumber: accountNumber,
			cardType: cardType,
			'data-test-id': dataTestId
		})
	);
};

DebitCard$2.propTypes = _extends({}, baseProps$8);

var AccountSummaryTile = {
	DebitCard: DebitCard$2
};

export { AccountAuthorisationPanel, WrappedAccountBalancesSelectPanel as AccountBalancesSelectPanel, AccountCheckboxCard, WrappedAccountLegacyPanel as AccountLegacyPanel, WrappedAccountLegacyUpdateCard as AccountLegacyUpdateCard, AccountLinkCard, AccountPaymentReviewTable, AccountPaymentStatusPanel, AccountPaymentSubmittedTable, AccountPaymentTable, AccountPoolCard, WrappedAccountPoolTablePanel as AccountPoolTablePanel, WrappedAccountRadioCard as AccountRadioCard, WrappedAccountSelectCard as AccountSelectCard, AccountStaticCard, AccountSummaryTile };
